function actionBot() {
  var path = window.location.pathname;
  if (
    path == "/" ||
    path.indexOf("knowmore") > -1 ||
    path.indexOf("benefits") > -1 ||
    path.indexOf("tipsandtricks") > -1 ||
    path.indexOf("pricing") > -1 ||
    path.indexOf("tasilplus") > -1 ||
    path.indexOf("faq") > -1 ||
    path.indexOf("aboutus") > -1 ||
    path.indexOf("terms") > -1 ||
    path.indexOf("loginpage") > -1 ||
    path.indexOf("userregistration") > -1
  ) {
    !(function (e, t) {
      if ("object" == typeof exports && "object" == typeof module)
        module.exports = t();
      else if ("function" == typeof define && define.amd) define([], t);
      else {
        var n = t();
        for (var r in n) ("object" == typeof exports ? exports : e)[r] = n[r];
      }
    })(window, function () {
      return (function (e) {
        function t(r) {
          if (n[r]) return n[r].exports;
          var o = (n[r] = { i: r, l: !1, exports: {} });
          return e[r].call(o.exports, o, o.exports, t), (o.l = !0), o.exports;
        }
        var n = {};
        return (
          (t.m = e),
          (t.c = n),
          (t.d = function (e, n, r) {
            t.o(e, n) ||
              Object.defineProperty(e, n, { enumerable: !0, get: r });
          }),
          (t.r = function (e) {
            "undefined" != typeof Symbol &&
              Symbol.toStringTag &&
              Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
              Object.defineProperty(e, "__esModule", { value: !0 });
          }),
          (t.t = function (e, n) {
            if ((1 & n && (e = t(e)), 8 & n)) return e;
            if (4 & n && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (
              (t.r(r),
              Object.defineProperty(r, "default", { enumerable: !0, value: e }),
              2 & n && "string" != typeof e)
            )
              for (var o in e)
                t.d(
                  r,
                  o,
                  function (t) {
                    return e[t];
                  }.bind(null, o)
                );
            return r;
          }),
          (t.n = function (e) {
            var n =
              e && e.__esModule
                ? function () {
                    return e.default;
                  }
                : function () {
                    return e;
                  };
            return t.d(n, "a", n), n;
          }),
          (t.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }),
          (t.p = "https://tasil.omantel.om/"),
          t((t.s = "mdyV"))
        );
      })({
        "+TSP": function (e, t, n) {
          e.exports =
            self.fetch || (self.fetch = n("Cf1v").default || n("Cf1v"));
        },
        "/Px3": function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              return (r =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            var o = n("keud"),
              i = n("l8WD"),
              a = n("hosL"),
              c = n("2UUl"),
              s = n.n(c),
              u = n("LO0j"),
              l = n.n(u),
              f = n("ITsB"),
              p = n("5Twf"),
              d = n("IX3v"),
              h = ["actionName", "actionname"];
            t.a = function (t) {
              function n(e, t) {
                O ||
                  (function (e) {
                    if (e && e.onClick) {
                      switch (e.onClick.type) {
                        case "action":
                          var t = e.onClick.data,
                            n = t.actionName,
                            r = t.actionname,
                            o = (function (e, t) {
                              if (null == e) return {};
                              var n,
                                r,
                                o = {},
                                i = Object.keys(e);
                              for (r = 0; r < i.length; r++)
                                t.indexOf((n = i[r])) >= 0 || (o[n] = e[n]);
                              return o;
                            })(t, h),
                            i = n || r;
                          if (i && E.exists(i)) {
                            var a = new p.a({ isAction: !0, content: o });
                            E.getCaseInsensitiveProp(i)(a);
                            break;
                          }
                        default:
                          g(e.onClick.data);
                      }
                    }
                  })(t);
              }
              var c = t.slides,
                u = t.sliderConfig,
                g = t.onOptionSelect,
                m = Object(a.createRef)(),
                b = Object(o.b)().config,
                y = (u || b.PUBLIC.carousel).settings,
                v = Object(i.useState)(!1),
                O = v[0],
                w = v[1],
                x = Object(i.useState)(!1),
                _ = x[0],
                j = x[1],
                S = Object(i.useState)(!0),
                k = S[0],
                C = S[1],
                P = !y.arrows && "hidden",
                A = Object(f.b)(),
                I = A.ActionsService,
                T = new (0, A.MarkdownService)(),
                E = new I(),
                B = {
                  beforeChange: function () {
                    w(!0);
                  },
                  afterChange: function (e) {
                    w(!1),
                      (function (e) {
                        j(0 !== e), C(e !== c.length - 1);
                      })(e);
                  },
                };
              if (c) {
                var M = c.map(function (t) {
                  var r,
                    o,
                    i =
                      null == (r = t.text)
                        ? void 0
                        : r.map(function (t) {
                            if (t) {
                              var n = t.key;
                              return e(
                                "tr",
                                null,
                                n && e("td", null, n),
                                e(
                                  "td",
                                  null,
                                  e(l.a, {
                                    renderers: T.getRenderers(),
                                    source: t.value,
                                    escapeHtml: !1,
                                  })
                                )
                              );
                            }
                          }),
                    a =
                      null == (o = t.buttons)
                        ? void 0
                        : o.map(function (t) {
                            if (t)
                              return e(
                                d.a,
                                {
                                  style: t.style,
                                  onClick: function () {
                                    return n(0, t);
                                  },
                                },
                                e(l.a, {
                                  renderers: T.getRenderers(),
                                  source: t.text,
                                  escapeHtml: !1,
                                })
                              );
                          }),
                    c = (function (t) {
                      if (t) return e(d.d, { src: t });
                    })(t.image);
                  return e(
                    d.h,
                    {
                      onClick: function () {
                        return n(0, t.value);
                      },
                    },
                    c && e(d.e, null, c),
                    i && e(d.i, null, i),
                    a && e(d.b, null, a)
                  );
                });
                return e(
                  d.c,
                  null,
                  e(s.a, r({}, y, B, { ref: m }), M),
                  _ &&
                    e(
                      d.f,
                      {
                        className: P,
                        onClick: function () {
                          return m.current.slickPrev();
                        },
                      },
                      "<"
                    ),
                  k &&
                    e(
                      d.g,
                      {
                        className: P,
                        onClick: function () {
                          return m.current.slickNext();
                        },
                      },
                      ">"
                    )
                );
              }
            };
          }).call(this, n("hosL").h);
        },
        "/ce7": function (e, t, n) {
          "use strict";
          t.a = n.p + "5bc3b24f3278a62a58fc9803e646590c.svg";
        },
        "/hs+": function (e, t, n) {
          "use strict";
          n.r(t),
            function (e) {
              function t(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                  var r = Object.getOwnPropertySymbols(e);
                  t &&
                    (r = r.filter(function (t) {
                      return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })),
                    n.push.apply(n, r);
                }
                return n;
              }
              function r(e) {
                for (var n = 1; n < arguments.length; n++) {
                  var r = null != arguments[n] ? arguments[n] : {};
                  n % 2
                    ? t(Object(r), !0).forEach(function (t) {
                        o(e, t, r[t]);
                      })
                    : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(
                        e,
                        Object.getOwnPropertyDescriptors(r)
                      )
                    : t(Object(r)).forEach(function (t) {
                        Object.defineProperty(
                          e,
                          t,
                          Object.getOwnPropertyDescriptor(r, t)
                        );
                      });
                }
                return e;
              }
              function o(e, t, n) {
                return (
                  t in e
                    ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                      })
                    : (e[t] = n),
                  e
                );
              }
              function i() {
                Object(a.render)(e(c.a, null), p);
              }
              var a = n("hosL"),
                c = n("ut2F"),
                s = n("ICoq"),
                u = n("TLkM"),
                l = (n("Ve17"), document.createElement("link"));
              (l.type = "text/css"),
                (l.rel = "stylesheet"),
                (l.href = u.a.publicPath + "actionbot-styles.css"),
                document.head.appendChild(l);
              var f = document.createElement("div");
              f.classList.add("actionBotWindow"),
                document
                  .querySelector(
                    (function () {
                      try {
                        return s.a.PUBLIC.rootElement;
                      } catch (e) {
                        return "body";
                      }
                    })()
                  )
                  .appendChild(f);
              var p = document.querySelector(".actionBotWindow");
              (window.__actionBot = r(
                r({}, window.__actionBot),
                {},
                {
                  mounting: {
                    root: p,
                    mount: i,
                    unmount: function () {
                      try {
                        clearInterval(window.__actionBot.pingInterval);
                      } catch (e) {}
                      Object(a.render)(null, p);
                    },
                  },
                }
              )),
                s.a.PUBLIC.mountByDefault && i();
            }.call(this, n("hosL").h);
        },
        "/liA": function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            for (
              var r, i, a, c, s, u, l, f, p = t.length, d = 0, h = "", g = "";
              d < p && "`" === t.charAt(d);

            )
              (h += "`"), d++;
            if (h) {
              for (s = h, c = d, h = "", f = t.charAt(d), a = 0; d < p; ) {
                if (
                  ((u = f),
                  (f = t.charAt(d + 1)),
                  "`" === u ? (a++, (g += u)) : ((a = 0), (h += u)),
                  a && "`" !== f)
                ) {
                  if (a === c) {
                    (s += h + g), (l = !0);
                    break;
                  }
                  (h += g), (g = "");
                }
                d++;
              }
              if (!l) {
                if (c % 2 != 0) return;
                h = "";
              }
              if (n) return !0;
              for (r = "", i = "", p = h.length, d = -1; ++d < p; )
                (u = h.charAt(d)),
                  o(u) ? (i += u) : (i && (r && (r += i), (i = "")), (r += u));
              return e(s)({ type: "inlineCode", value: r });
            }
          }
          var o = n("U/Op"),
            i = n("EbZa");
          (e.exports = r), (r.locator = i);
        },
        "0Q8B": function (e) {
          e.exports = JSON.parse(
            '{"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}'
          );
        },
        "0rCs": function (e) {
          "use strict";
          e.exports = function (e) {
            return n.test("number" == typeof e ? t(e) : e.charAt(0));
          };
          var t = String.fromCharCode,
            n = /\w/;
        },
        "1Pp1": function (e) {
          e.exports = JSON.parse(
            '["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]'
          );
        },
        "1hwd": function (e) {
          e.exports = function () {
            for (var e = {}, n = 0; n < arguments.length; n++) {
              var r = arguments[n];
              for (var o in r) t.call(r, o) && (e[o] = r[o]);
            }
            return e;
          };
          var t = Object.prototype.hasOwnProperty;
        },
        "1khK": function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("mNya"),
              o = n("QRet"),
              i = n("OV23"),
              a = n("ITsB"),
              c = n("keud");
            t.a = function (t) {
              var n = t.menu,
                s = t.onOptionSelect,
                u = t.clickHandler,
                l = Object(o.k)(!0),
                f = l[0],
                p = l[1],
                d = new (Object(a.b)("ActionsService"))(),
                h = n || Object(c.b)().mainMenu.value;
              if (h) {
                var g = h.map(function (t) {
                  return e(
                    r.b,
                    null,
                    e(
                      r.a,
                      {
                        onClick: function () {
                          return (
                            f &&
                            (function (e) {
                              var t = e.action,
                                n = e.command;
                              if (
                                (p(!1),
                                u && u({ action: t, command: n }),
                                t && d.exists(t))
                              ) {
                                var r = new i.a({ isAction: !0 });
                                d.getCaseInsensitiveProp(t)(r);
                              } else s(n);
                              setTimeout(function () {
                                return p(!0);
                              }, 1e3);
                            })(t)
                          );
                        },
                      },
                      e("img", { src: t.img }),
                      e("p", null, t.text)
                    )
                  );
                });
                return e(r.c, null, g);
              }
            };
          }).call(this, n("hosL").h);
        },
        "26+u": function (e) {
          "use strict";
          e.exports = function e(t) {
            var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            return (t.children || []).reduce(function (t, n) {
              return (
                "definition" === n.type &&
                  (t[n.identifier] = { href: n.url, title: n.title }),
                e(n, t)
              );
            }, n);
          };
        },
        "2DlW": function (e, t, n) {
          "use strict";
          (function (e, r) {
            var o = n("645H"),
              i = n("eDmY"),
              a = n("ITsB"),
              c = n("OV23"),
              s = n("6naU");
            t.a = function (t) {
              var n = t.message,
                u = t.isDisabled,
                l = Object(a.b)(),
                f = l.MessageService,
                p = new (0, l.ConnectionService)(),
                d = new f(),
                h = new c.a({
                  owner: s.a.bot,
                  content: n.content.suggestionDescription,
                  type: "text",
                });
              return e(
                r,
                null,
                e(i.b, { message: h }),
                e(o.a, {
                  message: n,
                  onOptionSelect: function (e) {
                    var t = p.convertResponseMessageByAdapter({
                        response: e,
                        request: null,
                      }),
                      n = t.group,
                      r = t.delayed,
                      o = new c.a({
                        owner: s.a.user,
                        type: "text",
                        content: e.label,
                      });
                    d.addMessage(o),
                      setTimeout(function () {
                        d.addMessageGroup(n),
                          r.length && p.resolveDelayedMessages(r);
                      }, 0);
                  },
                  isDisabled: u,
                })
              );
            };
          }).call(this, n("hosL").h, n("hosL").Fragment);
        },
        "2UUl": function (e, t, n) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.default = void 0);
          var r,
            o = (r = n("Ht6y")) && r.__esModule ? r : { default: r };
          t.default = o.default;
        },
        "2sHR": function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r = this.path,
              i = new o(e, t, n);
            return (
              r && ((i.name = r + ":" + i.name), (i.file = r)),
              (i.fatal = !1),
              this.messages.push(i),
              i
            );
          }
          var o = n("ucf/"),
            i = n("h0R3");
          e.exports = i;
          var a = i.prototype;
          (a.message = r),
            (a.info = function () {
              var e = this.message.apply(this, arguments);
              return (e.fatal = null), e;
            }),
            (a.fail = function () {
              var e = this.message.apply(this, arguments);
              throw ((e.fatal = !0), e);
            }),
            (a.warn = r);
        },
        "2shm": function (e, t, n) {
          "use strict";
          function r(e) {
            delete e.position;
          }
          function o(e) {
            e.position = void 0;
          }
          var i = n("BN5T");
          e.exports = function (e, t) {
            return i(e, t ? r : o), e;
          };
        },
        "3d/4": function (e, t, n) {
          "use strict";
          function r(e, t) {
            return s(e, o(t), t.children);
          }
          function o(e) {
            return e["data-sourcepos"]
              ? { "data-sourcepos": e["data-sourcepos"] }
              : {};
          }
          var i = n("1hwd"),
            a = n("l8WD"),
            c = parseInt((a.version || "16").slice(0, 2), 10) >= 16,
            s = a.createElement;
          e.exports = {
            break: "br",
            paragraph: "p",
            emphasis: "em",
            strong: "strong",
            thematicBreak: "hr",
            blockquote: "blockquote",
            delete: "del",
            link: "a",
            image: "img",
            linkReference: "a",
            imageReference: "img",
            table: r.bind(null, "table"),
            tableHead: r.bind(null, "thead"),
            tableBody: r.bind(null, "tbody"),
            tableRow: r.bind(null, "tr"),
            tableCell: function (e) {
              var t = e.align ? { textAlign: e.align } : void 0,
                n = o(e);
              return s(
                e.isHeader ? "th" : "td",
                t ? i({ style: t }, n) : n,
                e.children
              );
            },
            root: function (e) {
              var t = !e.className;
              return s((t && a.Fragment) || "div", t ? null : e, e.children);
            },
            text: function (e) {
              return c ? e.children : s("span", null, e.children);
            },
            list: function (e) {
              var t = o(e);
              return (
                null !== e.start &&
                  1 !== e.start &&
                  void 0 !== e.start &&
                  (t.start = e.start.toString()),
                s(e.ordered ? "ol" : "ul", t, e.children)
              );
            },
            listItem: function (e) {
              var t = null;
              return (
                null != e.checked &&
                  (t = s("input", {
                    type: "checkbox",
                    checked: e.checked,
                    readOnly: !0,
                  })),
                s("li", o(e), t, e.children)
              );
            },
            definition: function () {
              return null;
            },
            heading: function (e) {
              return s("h".concat(e.level), o(e), e.children);
            },
            inlineCode: function (e) {
              return s("code", o(e), e.children);
            },
            code: function (e) {
              var t = e.language && "language-".concat(e.language),
                n = s("code", t ? { className: t } : null, e.value);
              return s("pre", o(e), n);
            },
            html: function (e) {
              if (e.skipHtml) return null;
              var t = e.isBlock ? "div" : "span";
              return e.escapeHtml
                ? s(a.Fragment || t, null, e.value)
                : s(t, { dangerouslySetInnerHTML: { __html: e.value } });
            },
            virtualHtml: function (e) {
              return s(e.tag, o(e), e.children);
            },
            parsedHtml: function (e) {
              return e["data-sourcepos"]
                ? a.cloneElement(e.element, {
                    "data-sourcepos": e["data-sourcepos"],
                  })
                : e.element;
            },
          };
        },
        "3rof": function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("WhRf"),
              o = n("keud");
            t.a = function (t) {
              var n = t.message.content.value,
                i = Object(o.b)().fullScreen.value;
              return e(r.a, { src: n, className: i ? "fullscreen" : "" });
            };
          }).call(this, n("hosL").h);
        },
        "3xEr": function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("QRet"),
              o = n("Tcmg"),
              i = n("aTGq"),
              a = n("LO0j"),
              c = n.n(a);
            t.a = function (t) {
              var n = t.className,
                a = t.minimized,
                s = t.botIcon,
                u = Object(i.b)().unread.value,
                l = u.unreadMessages,
                f = (Object(i.b)(), Object(r.k)(!0)),
                p = f[0],
                d = Object(r.k)(!1),
                h = d[0],
                g = Object(r.k)(!1),
                m = g[0],
                b = g[1];
              Object(r.d)(
                function () {
                  (window.innerWidth <= 576 || a) &&
                    (a
                      ? ((document.body.style.overflowY = "unset"),
                        (document.body.style.overflowX = "hidden"),
                        (document.documentElement.style.overflowY = "unset"),
                        (document.documentElement.style.overflowX = "hidden"))
                      : ((document.body.style.overflow = "hidden"),
                        (document.documentElement.style.overflow = "hidden")));
                },
                [a]
              );
              var y = Object(r.h)(
                function () {
                  return function () {
                    if (l.length && a)
                      return e(
                        o.f,
                        null,
                        l.map(function (t) {
                          if ((console.log(t.content), "text" === t.type))
                            return e(
                              o.e,
                              { key: t.id },
                              e(c.a, { source: t.content, escapeHtml: !1 })
                            );
                        })
                      );
                  };
                },
                [l]
              );
              return e(
                o.b,
                {
                  onMouseEnter: function () {
                    return b(!0);
                  },
                  onMouseLeave: function () {
                    return b(!1);
                  },
                  onClick: function () {
                    var e = Object(i.b)().minimized.set;
                    e(!a);
                  },
                  src: s,
                  className: n,
                },
                e(y, null),
                e(
                  o.c,
                  { active: p, userSentMessage: h, minimized: a },
                  e(o.d, { hover: m, active: p, delay: 0 }),
                  e(o.d, { hover: m, active: p, delay: 200 }),
                  e(o.d, { hover: m, active: p, delay: 400 })
                ),
                !a && e(o.a, null)
              );
            };
          }).call(this, n("hosL").h);
        },
        "441o": function (e, t, n) {
          "use strict";
          var r = n("1hwd"),
            o = n("XeXk"),
            i = n("aHIe");
          e.exports = function (e) {
            var t,
              n,
              a = this.options;
            if (null == e) e = {};
            else {
              if ("object" != typeof e)
                throw new Error(
                  "Invalid value `" + e + "` for setting `options`"
                );
              e = r(e);
            }
            for (t in i) {
              if (
                (null == (n = e[t]) && (n = a[t]),
                ("blocks" !== t && "boolean" != typeof n) ||
                  ("blocks" === t && "object" != typeof n))
              )
                throw new Error(
                  "Invalid value `" + n + "` for setting `options." + t + "`"
                );
              e[t] = n;
            }
            return (this.options = e), (this.escape = o(e)), this;
          };
        },
        "495I": function (e, t, n) {
          var r = n("tJXC");
          e.exports = new r();
        },
        "4Zz8": function (e, t, n) {
          "use strict";
          (function (e, r) {
            var o = n("QRet"),
              i = n("6GRQ");
            t.a = function (t) {
              var n = t.message,
                a = Object(o.k)(!1),
                c = a[0],
                s = a[1],
                u = n.content,
                l = u.source,
                f = u.title,
                p = u.description,
                d = n.owner;
              return e(
                i.b,
                {
                  image: l,
                  owner: d,
                  onClick: function () {
                    return s(function (e) {
                      return !e;
                    });
                  },
                  fullScreen: c,
                },
                e(
                  i.e,
                  null,
                  e(i.a, { owner: d, fullScreen: c, src: l }),
                  !c &&
                    e(r, null, !!f && e(i.d, null, f), !!p && e(i.c, null, p))
                )
              );
            };
          }).call(this, n("hosL").h, n("hosL").Fragment);
        },
        "4hQ3": function (e, t, n) {
          "use strict";
          t.a = n.p + "b82df7e7dbae8e82b345f358e4a7baaa.svg";
        },
        "4ohi": function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("KJEC"),
              o = n("JcKE"),
              i = n("htCv"),
              a = n("N0Yk"),
              c = n("q8xz"),
              s = n("keud"),
              u = n("QRet"),
              l = n("ITsB"),
              f = n("OV23"),
              p = (n("tMe+"), n("9cs3"), n("y10/")),
              d = n("uydO"),
              h = n("nbD9"),
              g = n("6naU"),
              m = n("GtCE"),
              b = n("lKdC");
            t.a = function (t) {
              function n(e) {
                if ("function" == typeof Y)
                  try {
                    Y(e);
                  } catch (e) {
                    Object(h.a)().log({ _setInputText: Y, inputText: V }),
                      Object(h.a)().error("catched", e);
                  }
              }
              function y() {
                q(!1), M.dispatchEvent("maximize");
              }
              function v() {
                Object(s.b)().minimizeAvailable.value &&
                  (q(!0), M.dispatchEvent("minimize"));
              }
              function O(e) {
                w({
                  message: new f.a({
                    type: "text",
                    content: e,
                    owner: g.a.user,
                  }),
                  messageRequest: { text: e },
                });
              }
              function w(e) {
                var t = void 0 === e ? {} : e,
                  r = t.message,
                  o = t.messageRequest;
                if ((Object(h.a)().log("send"), r && o))
                  R.addMessage(r), N.sendMessage(o).catch(console.error);
                else if (V) {
                  if (V.replace(/\s/g, "").length) {
                    var i = F.doAnonymizationOnMessage({ text: V });
                    i
                      ? (function () {
                          var e = i.anonymizedText,
                            t = i.values,
                            n = e,
                            r = e,
                            o = function (e) {
                              var o = t[e],
                                i = D.getAnonymizedVariableName(e).placeholder;
                              o.valueToSend.forEach(function (e) {
                                var t = e.replace(/\$\$/g, "$$$$$");
                                n = n.replace(i, t);
                              }),
                                o.valueToShow.forEach(function (e) {
                                  var t = e.replace(/\$\$/g, "$$$$$");
                                  r = r.replace(i, t);
                                });
                            };
                          for (var a in t) o(a);
                          R.addMessage(
                            new f.a({
                              type: "text",
                              content: r,
                              owner: g.a.user,
                            })
                          ),
                            N.sendMessage({ text: n }).catch(console.error);
                        })()
                      : (R.addMessage(
                          new f.a({ type: "text", content: V, owner: g.a.user })
                        ),
                        N.sendMessage({ text: V }).catch(console.error));
                  }
                  !(function () {
                    if ((n(""), window.innerWidth <= H.getMobileBreakpoint())) {
                      var e = document.activeElement;
                      e instanceof HTMLElement && e.blur();
                    }
                  })();
                }
              }
              var x = t.MinimizedComponent,
                _ = void 0 === x ? p.a : x,
                j = t.MessagesCustomContainer,
                S = t.components,
                k = void 0 === S ? {} : S,
                C = Object(s.b)(),
                P = C.messages.value,
                A = C.config,
                I = Object(l.b)(),
                T = I.ConnectionService,
                E = I.HistoryService,
                B = I.RedirectService,
                M = I.BehaviorService,
                D = I.AnonymizeService,
                L = I.ThemeService,
                R = new (0, I.MessageService)(),
                N = new T(),
                z = new E(),
                W = new B(),
                F = new D(),
                H = new L(),
                U = C.minimized.value,
                q = C.minimized.set,
                G = C.input,
                V = G.value,
                Y = G.set,
                $ = Object(u.k)(!1),
                J = $[0];
              Object(u.d)(function () {
                var e = W.checkRedirectStatus();
                Object(h.a)().log("wasRedirected", typeof e, e);
                var t = C.sessionId.value;
                (window.__actionBot = window.__actionBot || {}),
                  (window.__actionBot.minimize = v),
                  (window.__actionBot.maximize = y);
                var n = z.loadHistory();
                if (e && C.config.PROTECTED.agent.available)
                  try {
                    window.__actionBot.getWebSocket().openWS();
                  } catch (e) {
                    console.error(e);
                  }
                n && t
                  ? (Object(h.a)().log("if (historyMessages && sessionId)", {
                      historyMessages: n,
                      sessionId: t,
                    }),
                    R.setMessage(n))
                  : e ||
                    (Object(h.a)().log("else if (!wasRedirected)"),
                    A.PUBLIC.skipGetSessionOnLoad ||
                      (Object(h.a)().log("!config.PUBLIC.skipGetSessionOnLoad"),
                      N.getSessionId().then(function () {
                        n
                          ? R.setMessage(n)
                          : C.config.PROTECTED.connection.getSessionId
                              .withWelcomeMessage || N.getWelcomeMessage();
                      })));
              }, []),
                Object(u.d)(
                  function () {
                    A.PUBLIC.disablePageScrollOnMobileWhenMaximized &&
                      (window.innerWidth <= H.getMobileBreakpoint() || U) &&
                      (U
                        ? ((document.body.style.overflow = "unset"),
                          (document.documentElement.style.overflow = "unset"))
                        : ((document.body.style.overflow = "hidden"),
                          (document.documentElement.style.overflow =
                            "hidden")));
                  },
                  [U]
                ),
                Object(u.j)(Object(d.a)()),
                Object(u.d)(function () {}, [V]),
                Object(u.d)(
                  function () {
                    P.forEach(function (e, t) {
                      t < P.length - 1 && (e.isLastGroup = !1),
                        e.messages.forEach(function (n, r) {
                          n.existsWhenLast &&
                            ((t === P.length - 1 &&
                              r === e.messages.length - 1) ||
                              R.removeMessageById(n.id));
                        });
                    }),
                      M.dispatchEvent("messagesChanged", P);
                  },
                  [P]
                );
              var K = U ? "minimized" : "maximized",
                Q = k.MessageInput || a.a,
                X = Object(s.b)().fullScreen.value;
              return e(
                c.b,
                { className: "ActionBot" },
                e(_, {
                  className: K,
                  minimized: U,
                  botIcon: r.a,
                  maximize: y,
                  onOptionSelect: O,
                }),
                e(
                  c.a,
                  {
                    className:
                      (C.rtl.value ? "rtl " + K : K) +
                      " " +
                      (X ? "fullscreen" : ""),
                  },
                  e(o.a, { minimized: U, minimize: v }),
                  e(i.a, {
                    onOptionSelect: O,
                    MessagesCustomContainer: j,
                    components: k,
                  }),
                  e(Q, {
                    value: V,
                    onKeyPress: function (e) {
                      "Enter" === e.key &&
                        (e.preventDefault(),
                        e.target.value.length > 0 && !J && w());
                    },
                    onSubmit: w,
                    onChange: function (e) {
                      n(e.target.value || "");
                    },
                    onOptionSelect: O,
                  }),
                  e(m.a, null)
                ),
                e(b.a, null)
              );
            };
          }).call(this, n("hosL").h);
        },
        "5+HP": function (e, t, n) {
          "use strict";
          function r(e) {
            return Boolean(e && void 0 !== e.length);
          }
          function o() {}
          function i(e) {
            if (!(this instanceof i))
              throw new TypeError("Promises must be constructed via new");
            if ("function" != typeof e) throw new TypeError("not a function");
            (this._state = 0),
              (this._handled = !1),
              (this._value = void 0),
              (this._deferreds = []),
              f(e, this);
          }
          function a(e, t) {
            for (; 3 === e._state; ) e = e._value;
            0 !== e._state
              ? ((e._handled = !0),
                i._immediateFn(function () {
                  var n = 1 === e._state ? t.onFulfilled : t.onRejected;
                  if (null !== n) {
                    var r;
                    try {
                      r = n(e._value);
                    } catch (e) {
                      return void s(t.promise, e);
                    }
                    c(t.promise, r);
                  } else (1 === e._state ? c : s)(t.promise, e._value);
                }))
              : e._deferreds.push(t);
          }
          function c(e, t) {
            try {
              if (t === e)
                throw new TypeError(
                  "A promise cannot be resolved with itself."
                );
              if (t && ("object" == typeof t || "function" == typeof t)) {
                var n = t.then;
                if (t instanceof i)
                  return (e._state = 3), (e._value = t), void u(e);
                if ("function" == typeof n)
                  return void f(
                    ((r = n),
                    (o = t),
                    function () {
                      r.apply(o, arguments);
                    }),
                    e
                  );
              }
              (e._state = 1), (e._value = t), u(e);
            } catch (t) {
              s(e, t);
            }
            var r, o;
          }
          function s(e, t) {
            (e._state = 2), (e._value = t), u(e);
          }
          function u(e) {
            2 === e._state &&
              0 === e._deferreds.length &&
              i._immediateFn(function () {
                e._handled || i._unhandledRejectionFn(e._value);
              });
            for (var t = 0, n = e._deferreds.length; t < n; t++)
              a(e, e._deferreds[t]);
            e._deferreds = null;
          }
          function l(e, t, n) {
            (this.onFulfilled = "function" == typeof e ? e : null),
              (this.onRejected = "function" == typeof t ? t : null),
              (this.promise = n);
          }
          function f(e, t) {
            var n = !1;
            try {
              e(
                function (e) {
                  n || ((n = !0), c(t, e));
                },
                function (e) {
                  n || ((n = !0), s(t, e));
                }
              );
            } catch (e) {
              if (n) return;
              (n = !0), s(t, e);
            }
          }
          n.r(t);
          var p = function (e) {
              var t = this.constructor;
              return this.then(
                function (n) {
                  return t.resolve(e()).then(function () {
                    return n;
                  });
                },
                function (n) {
                  return t.resolve(e()).then(function () {
                    return t.reject(n);
                  });
                }
              );
            },
            d = function (e) {
              return new this(function (t, n) {
                function r(e, n) {
                  if (n && ("object" == typeof n || "function" == typeof n)) {
                    var a = n.then;
                    if ("function" == typeof a)
                      return void a.call(
                        n,
                        function (t) {
                          r(e, t);
                        },
                        function (n) {
                          (o[e] = { status: "rejected", reason: n }),
                            0 == --i && t(o);
                        }
                      );
                  }
                  (o[e] = { status: "fulfilled", value: n }), 0 == --i && t(o);
                }
                if (!e || void 0 === e.length)
                  return n(
                    new TypeError(
                      typeof e +
                        " " +
                        e +
                        " is not iterable(cannot read property Symbol(Symbol.iterator))"
                    )
                  );
                var o = Array.prototype.slice.call(e);
                if (0 === o.length) return t([]);
                for (var i = o.length, a = 0; a < o.length; a++) r(a, o[a]);
              });
            },
            h = setTimeout,
            g = "undefined" != typeof setImmediate ? setImmediate : null;
          (i.prototype.catch = function (e) {
            return this.then(null, e);
          }),
            (i.prototype.then = function (e, t) {
              var n = new this.constructor(o);
              return a(this, new l(e, t, n)), n;
            }),
            (i.prototype.finally = p),
            (i.all = function (e) {
              return new i(function (t, n) {
                function o(e, r) {
                  try {
                    if (r && ("object" == typeof r || "function" == typeof r)) {
                      var c = r.then;
                      if ("function" == typeof c)
                        return void c.call(
                          r,
                          function (t) {
                            o(e, t);
                          },
                          n
                        );
                    }
                    (i[e] = r), 0 == --a && t(i);
                  } catch (e) {
                    n(e);
                  }
                }
                if (!r(e))
                  return n(new TypeError("Promise.all accepts an array"));
                var i = Array.prototype.slice.call(e);
                if (0 === i.length) return t([]);
                for (var a = i.length, c = 0; c < i.length; c++) o(c, i[c]);
              });
            }),
            (i.allSettled = d),
            (i.resolve = function (e) {
              return e && "object" == typeof e && e.constructor === i
                ? e
                : new i(function (t) {
                    t(e);
                  });
            }),
            (i.reject = function (e) {
              return new i(function (t, n) {
                n(e);
              });
            }),
            (i.race = function (e) {
              return new i(function (t, n) {
                if (!r(e))
                  return n(new TypeError("Promise.race accepts an array"));
                for (var o = 0, a = e.length; o < a; o++)
                  i.resolve(e[o]).then(t, n);
              });
            }),
            (i._immediateFn =
              ("function" == typeof g &&
                function (e) {
                  g(e);
                }) ||
              function (e) {
                h(e, 0);
              }),
            (i._unhandledRejectionFn = function (e) {
              "undefined" != typeof console &&
                console &&
                console.warn("Possible Unhandled Promise Rejection:", e);
            });
          t.default = i;
        },
        "5IsQ": function (e) {
          function t() {
            throw new Error("setTimeout has not been defined");
          }
          function n() {
            throw new Error("clearTimeout has not been defined");
          }
          function r(e) {
            if (s === setTimeout) return setTimeout(e, 0);
            if ((s === t || !s) && setTimeout)
              return (s = setTimeout), setTimeout(e, 0);
            try {
              return s(e, 0);
            } catch (t) {
              try {
                return s.call(null, e, 0);
              } catch (t) {
                return s.call(this, e, 0);
              }
            }
          }
          function o() {
            d &&
              f &&
              ((d = !1),
              f.length ? (p = f.concat(p)) : (h = -1),
              p.length && i());
          }
          function i() {
            if (!d) {
              var e = r(o);
              d = !0;
              for (var t = p.length; t; ) {
                for (f = p, p = []; ++h < t; ) f && f[h].run();
                (h = -1), (t = p.length);
              }
              (f = null),
                (d = !1),
                (function (e) {
                  if (u === clearTimeout) return clearTimeout(e);
                  if ((u === n || !u) && clearTimeout)
                    return (u = clearTimeout), clearTimeout(e);
                  try {
                    u(e);
                  } catch (t) {
                    try {
                      return u.call(null, e);
                    } catch (t) {
                      return u.call(this, e);
                    }
                  }
                })(e);
            }
          }
          function a(e, t) {
            (this.fun = e), (this.array = t);
          }
          function c() {}
          var s,
            u,
            l = (e.exports = {});
          !(function () {
            try {
              s = "function" == typeof setTimeout ? setTimeout : t;
            } catch (e) {
              s = t;
            }
            try {
              u = "function" == typeof clearTimeout ? clearTimeout : n;
            } catch (e) {
              u = n;
            }
          })();
          var f,
            p = [],
            d = !1,
            h = -1;
          (l.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1)
              for (var n = 1; n < arguments.length; n++)
                t[n - 1] = arguments[n];
            p.push(new a(e, t)), 1 !== p.length || d || r(i);
          }),
            (a.prototype.run = function () {
              this.fun.apply(null, this.array);
            }),
            (l.title = "browser"),
            (l.browser = !0),
            (l.env = {}),
            (l.argv = []),
            (l.version = ""),
            (l.versions = {}),
            (l.on = c),
            (l.addListener = c),
            (l.once = c),
            (l.off = c),
            (l.removeListener = c),
            (l.removeAllListeners = c),
            (l.emit = c),
            (l.prependListener = c),
            (l.prependOnceListener = c),
            (l.listeners = function () {
              return [];
            }),
            (l.binding = function () {
              throw new Error("process.binding is not supported");
            }),
            (l.cwd = function () {
              return "/";
            }),
            (l.chdir = function () {
              throw new Error("process.chdir is not supported");
            }),
            (l.umask = function () {
              return 0;
            });
        },
        "5JIT": function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r, a, s, u, l, f, p, d, h, g, m;
            if ("<" === t.charAt(0)) {
              for (
                this,
                  r = "",
                  a = t.length,
                  s = 0,
                  u = "",
                  f = !1,
                  p = "",
                  s++,
                  r = "<";
                s < a &&
                ((l = t.charAt(s)),
                !(
                  o(l) ||
                  ">" === l ||
                  "@" === l ||
                  (":" === l && "/" === t.charAt(s + 1))
                ));

              )
                (u += l), s++;
              if (u) {
                if (
                  ((p += u), (u = ""), (p += l = t.charAt(s)), s++, "@" === l)
                )
                  f = !0;
                else {
                  if (":" !== l || "/" !== t.charAt(s + 1)) return;
                  (p += "/"), s++;
                }
                for (; s < a && ((l = t.charAt(s)), !o(l) && ">" !== l); )
                  (u += l), s++;
                if (((l = t.charAt(s)), u && ">" === l))
                  return (
                    !!n ||
                    ((h = p += u),
                    (r += p + l),
                    (d = e.now()).column++,
                    d.offset++,
                    f &&
                      ("mailto:" === p.slice(0, c).toLowerCase()
                        ? ((h = h.substr(c)), (d.column += c), (d.offset += c))
                        : (p = "mailto:" + p)),
                    (this.inlineTokenizers = {
                      text: (g = this.inlineTokenizers).text,
                    }),
                    (m = this.enterLink()),
                    (h = this.tokenizeInline(h, d)),
                    (this.inlineTokenizers = g),
                    m(),
                    e(r)({
                      type: "link",
                      title: null,
                      url: i(p, { nonTerminated: !1 }),
                      children: h,
                    }))
                  );
              }
            }
          }
          var o = n("U/Op"),
            i = n("bb/9"),
            a = n("yYTt");
          (e.exports = r), (r.locator = a), (r.notInLink = !0);
          var c = "mailto:".length;
        },
        "5MnT": function (e) {
          "use strict";
          e.exports = function (e, t, n) {
            return function () {
              var r = n || this,
                o = r[e];
              return (
                (r[e] = !t),
                function () {
                  r[e] = o;
                }
              );
            };
          };
        },
        "5Twf": function (e, t, n) {
          "use strict";
          n("uUgx");
          var r = n("OV23");
          n.d(t, "a", function () {
            return r.a;
          });
        },
        "5niG": function (e) {
          e.exports = (function e(t) {
            "use strict";
            function n(e, t, o, l, f) {
              for (
                var h,
                  g,
                  m = 0,
                  b = 0,
                  y = 0,
                  O = 0,
                  w = 0,
                  x = 0,
                  _ = 0,
                  C = 0,
                  P = 0,
                  A = 0,
                  I = 0,
                  E = 0,
                  M = 0,
                  D = 0,
                  L = 0,
                  R = 0,
                  N = 0,
                  W = 0,
                  F = 0,
                  $ = o.length,
                  X = $ - 1,
                  ee = "",
                  ae = "",
                  ce = "",
                  se = "",
                  ue = "",
                  le = "";
                L < $;

              ) {
                if (
                  ((_ = o.charCodeAt(L)),
                  L === X &&
                    b + O + y + m !== 0 &&
                    (0 !== b && (_ = 47 === b ? 10 : 47),
                    (O = y = m = 0),
                    $++,
                    X++),
                  b + O + y + m === 0)
                ) {
                  if (
                    L === X &&
                    (R > 0 && (ae = ae.replace(d, "")), ae.trim().length > 0)
                  ) {
                    switch (_) {
                      case 32:
                      case 9:
                      case 59:
                      case 13:
                      case 10:
                        break;
                      default:
                        ae += o.charAt(L);
                    }
                    _ = 59;
                  }
                  if (1 === N)
                    switch (_) {
                      case 123:
                      case 125:
                      case 59:
                      case 34:
                      case 39:
                      case 40:
                      case 41:
                      case 44:
                        N = 0;
                      case 9:
                      case 13:
                      case 10:
                      case 32:
                        break;
                      default:
                        for (N = 0, F = L, w = _, L--, _ = 59; F < $; )
                          switch (o.charCodeAt(F++)) {
                            case 10:
                            case 13:
                            case 59:
                              ++L, (_ = w), (F = $);
                              break;
                            case 58:
                              R > 0 && (++L, (_ = w));
                            case 123:
                              F = $;
                          }
                    }
                  switch (_) {
                    case 123:
                      for (
                        w = (ae = ae.trim()).charCodeAt(0), I = 1, F = ++L;
                        L < $;

                      ) {
                        switch ((_ = o.charCodeAt(L))) {
                          case 123:
                            I++;
                            break;
                          case 125:
                            I--;
                            break;
                          case 47:
                            switch ((x = o.charCodeAt(L + 1))) {
                              case 42:
                              case 47:
                                L = u(x, L, X, o);
                            }
                            break;
                          case 91:
                            _++;
                          case 40:
                            _++;
                          case 34:
                          case 39:
                            for (; L++ < X && o.charCodeAt(L) !== _; );
                        }
                        if (0 === I) break;
                        L++;
                      }
                      switch (
                        ((ce = o.substring(F, L)),
                        0 === w &&
                          (w = (ae = ae.replace(p, "").trim()).charCodeAt(0)),
                        w)
                      ) {
                        case 64:
                          switch (
                            (R > 0 && (ae = ae.replace(d, "")),
                            (x = ae.charCodeAt(1)))
                          ) {
                            case 100:
                            case 109:
                            case 115:
                            case 45:
                              h = t;
                              break;
                            default:
                              h = Q;
                          }
                          if (
                            ((F = (ce = n(t, h, ce, x, f + 1)).length),
                            K > 0 && 0 === F && (F = ae.length),
                            Z > 0 &&
                              ((g = s(
                                3,
                                ce,
                                (h = r(Q, ae, W)),
                                t,
                                U,
                                H,
                                F,
                                x,
                                f,
                                l
                              )),
                              (ae = h.join("")),
                              void 0 !== g &&
                                0 === (F = (ce = g.trim()).length) &&
                                ((x = 0), (ce = ""))),
                            F > 0)
                          )
                            switch (x) {
                              case 115:
                                ae = ae.replace(B, c);
                              case 100:
                              case 109:
                              case 45:
                                ce = ae + "{" + ce + "}";
                                break;
                              case 107:
                                (ce =
                                  (ae = ae.replace(
                                    j,
                                    "$1 $2" + (ne > 0 ? re : "")
                                  )) +
                                  "{" +
                                  ce +
                                  "}"),
                                  (ce =
                                    1 === V || (2 === V && a("@" + ce, 3))
                                      ? "@" + z + ce + "@" + ce
                                      : "@" + ce);
                                break;
                              default:
                                (ce = ae + ce),
                                  112 === l && ((se += ce), (ce = ""));
                            }
                          else ce = "";
                          break;
                        default:
                          ce = n(t, r(t, ae, W), ce, l, f + 1);
                      }
                      (ue += ce),
                        (E = 0),
                        (N = 0),
                        (D = 0),
                        (R = 0),
                        (W = 0),
                        (M = 0),
                        (ae = ""),
                        (ce = ""),
                        (_ = o.charCodeAt(++L));
                      break;
                    case 125:
                    case 59:
                      if (
                        (F = (ae = (R > 0 ? ae.replace(d, "") : ae).trim())
                          .length) > 1
                      )
                        switch (
                          (0 === D &&
                            (45 === (w = ae.charCodeAt(0)) ||
                              (w > 96 && w < 123)) &&
                            (F = (ae = ae.replace(" ", ":")).length),
                          Z > 0 &&
                            void 0 !==
                              (g = s(1, ae, t, e, U, H, se.length, l, f, l)) &&
                            0 === (F = (ae = g.trim()).length) &&
                            (ae = "\0\0"),
                          (w = ae.charCodeAt(0)),
                          (x = ae.charCodeAt(1)),
                          w)
                        ) {
                          case 0:
                            break;
                          case 64:
                            if (105 === x || 99 === x) {
                              le += ae + o.charAt(L);
                              break;
                            }
                          default:
                            if (58 === ae.charCodeAt(F - 1)) break;
                            se += i(ae, w, x, ae.charCodeAt(2));
                        }
                      (E = 0),
                        (N = 0),
                        (D = 0),
                        (R = 0),
                        (W = 0),
                        (ae = ""),
                        (_ = o.charCodeAt(++L));
                  }
                }
                switch (_) {
                  case 13:
                  case 10:
                    if (b + O + y + m + J === 0)
                      switch (A) {
                        case 41:
                        case 39:
                        case 34:
                        case 64:
                        case 126:
                        case 62:
                        case 42:
                        case 43:
                        case 47:
                        case 45:
                        case 58:
                        case 44:
                        case 59:
                        case 123:
                        case 125:
                          break;
                        default:
                          D > 0 && (N = 1);
                      }
                    47 === b
                      ? (b = 0)
                      : G + E === 0 &&
                        107 !== l &&
                        ae.length > 0 &&
                        ((R = 1), (ae += "\0")),
                      Z * te > 0 && s(0, ae, t, e, U, H, se.length, l, f, l),
                      (H = 1),
                      U++;
                    break;
                  case 59:
                  case 125:
                    if (b + O + y + m === 0) {
                      H++;
                      break;
                    }
                  default:
                    switch ((H++, (ee = o.charAt(L)), _)) {
                      case 9:
                      case 32:
                        if (O + m + b === 0)
                          switch (C) {
                            case 44:
                            case 58:
                            case 9:
                            case 32:
                              ee = "";
                              break;
                            default:
                              32 !== _ && (ee = " ");
                          }
                        break;
                      case 0:
                        ee = "\\0";
                        break;
                      case 12:
                        ee = "\\f";
                        break;
                      case 11:
                        ee = "\\v";
                        break;
                      case 38:
                        O + b + m === 0 &&
                          G > 0 &&
                          ((W = 1), (R = 1), (ee = "\f" + ee));
                        break;
                      case 108:
                        if (O + b + m + q === 0 && D > 0)
                          switch (L - D) {
                            case 2:
                              112 === C &&
                                58 === o.charCodeAt(L - 3) &&
                                (q = C);
                            case 8:
                              111 === P && (q = P);
                          }
                        break;
                      case 58:
                        O + b + m === 0 && (D = L);
                        break;
                      case 44:
                        b + y + O + m === 0 && ((R = 1), (ee += "\r"));
                        break;
                      case 34:
                      case 39:
                        0 === b && (O = O === _ ? 0 : 0 === O ? _ : O);
                        break;
                      case 91:
                        O + b + y === 0 && m++;
                        break;
                      case 93:
                        O + b + y === 0 && m--;
                        break;
                      case 41:
                        O + b + m === 0 && y--;
                        break;
                      case 40:
                        if (O + b + m === 0) {
                          if (0 === E)
                            switch (2 * C + 3 * P) {
                              case 533:
                                break;
                              default:
                                (I = 0), (E = 1);
                            }
                          y++;
                        }
                        break;
                      case 64:
                        b + y + O + m + D + M === 0 && (M = 1);
                        break;
                      case 42:
                      case 47:
                        if (O + m + y > 0) break;
                        switch (b) {
                          case 0:
                            switch (2 * _ + 3 * o.charCodeAt(L + 1)) {
                              case 235:
                                b = 47;
                                break;
                              case 220:
                                (F = L), (b = 42);
                            }
                            break;
                          case 42:
                            47 === _ &&
                              42 === C &&
                              F + 2 !== L &&
                              (33 === o.charCodeAt(F + 2) &&
                                (se += o.substring(F, L + 1)),
                              (ee = ""),
                              (b = 0));
                        }
                    }
                    if (0 === b) {
                      if (G + O + m + M === 0 && 107 !== l && 59 !== _)
                        switch (_) {
                          case 44:
                          case 126:
                          case 62:
                          case 43:
                          case 41:
                          case 40:
                            if (0 === E) {
                              switch (C) {
                                case 9:
                                case 32:
                                case 10:
                                case 13:
                                  ee += "\0";
                                  break;
                                default:
                                  ee = "\0" + ee + (44 === _ ? "" : "\0");
                              }
                              R = 1;
                            } else
                              switch (_) {
                                case 40:
                                  D + 7 === L && 108 === C && (D = 0),
                                    (E = ++I);
                                  break;
                                case 41:
                                  0 == (E = --I) && ((R = 1), (ee += "\0"));
                              }
                            break;
                          case 9:
                          case 32:
                            switch (C) {
                              case 0:
                              case 123:
                              case 125:
                              case 59:
                              case 44:
                              case 12:
                              case 9:
                              case 32:
                              case 10:
                              case 13:
                                break;
                              default:
                                0 === E && ((R = 1), (ee += "\0"));
                            }
                        }
                      (ae += ee), 32 !== _ && 9 !== _ && (A = _);
                    }
                }
                (P = C), (C = _), L++;
              }
              if (
                ((F = se.length),
                K > 0 &&
                  0 === F &&
                  0 === ue.length &&
                  (0 === t[0].length) == 0 &&
                  (109 !== l ||
                    (1 === t.length && (G > 0 ? oe : ie) === t[0])) &&
                  (F = t.join(",").length + 2),
                F > 0)
              ) {
                if (
                  ((h =
                    0 === G && 107 !== l
                      ? (function (e) {
                          for (
                            var t, n, r = 0, o = e.length, i = Array(o);
                            r < o;
                            ++r
                          ) {
                            for (
                              var a = e[r].split(v),
                                c = "",
                                s = 0,
                                u = 0,
                                l = 0,
                                f = 0,
                                p = a.length;
                              s < p;
                              ++s
                            )
                              if (!(0 === (u = (n = a[s]).length) && p > 1)) {
                                if (
                                  ((l = c.charCodeAt(c.length - 1)),
                                  (f = n.charCodeAt(0)),
                                  (t = ""),
                                  0 !== s)
                                )
                                  switch (l) {
                                    case 42:
                                    case 126:
                                    case 62:
                                    case 43:
                                    case 32:
                                    case 40:
                                      break;
                                    default:
                                      t = " ";
                                  }
                                switch (f) {
                                  case 38:
                                    n = t + oe;
                                  case 126:
                                  case 62:
                                  case 43:
                                  case 32:
                                  case 41:
                                  case 40:
                                    break;
                                  case 91:
                                    n = t + n + oe;
                                    break;
                                  case 58:
                                    switch (
                                      2 * n.charCodeAt(1) +
                                      3 * n.charCodeAt(2)
                                    ) {
                                      case 530:
                                        if (Y > 0) {
                                          n = t + n.substring(8, u - 1);
                                          break;
                                        }
                                      default:
                                        (s < 1 || a[s - 1].length < 1) &&
                                          (n = t + oe + n);
                                    }
                                    break;
                                  case 44:
                                    t = "";
                                  default:
                                    n =
                                      u > 1 && n.indexOf(":") > 0
                                        ? t + n.replace(T, "$1" + oe + "$2")
                                        : t + n + oe;
                                }
                                c += n;
                              }
                            i[r] = c.replace(d, "").trim();
                          }
                          return i;
                        })(t)
                      : t),
                  Z > 0 &&
                    void 0 !== (g = s(2, se, h, e, U, H, F, l, f, l)) &&
                    0 === (se = g).length)
                )
                  return le + se + ue;
                if (((se = h.join(",") + "{" + se + "}"), V * q != 0)) {
                  switch ((2 !== V || a(se, 2) || (q = 0), q)) {
                    case 111:
                      se = se.replace(k, ":-moz-$1") + se;
                      break;
                    case 112:
                      se =
                        se.replace(S, "::" + z + "input-$1") +
                        se.replace(S, "::-moz-$1") +
                        se.replace(S, ":-ms-input-$1") +
                        se;
                  }
                  q = 0;
                }
              }
              return le + se + ue;
            }
            function r(e, t, n) {
              var r = t.trim().split(O),
                i = r,
                a = r.length,
                c = e.length;
              switch (c) {
                case 0:
                case 1:
                  for (var s = 0, u = 0 === c ? "" : e[0] + " "; s < a; ++s)
                    i[s] = o(u, i[s], n, c).trim();
                  break;
                default:
                  s = 0;
                  var l = 0;
                  for (i = []; s < a; ++s)
                    for (var f = 0; f < c; ++f)
                      i[l++] = o(e[f] + " ", r[s], n, c).trim();
              }
              return i;
            }
            function o(e, t, n, r) {
              var o = t,
                i = o.charCodeAt(0);
              switch ((i < 33 && (i = (o = o.trim()).charCodeAt(0)), i)) {
                case 38:
                  switch (G + r) {
                    case 0:
                    case 1:
                      if (0 === e.trim().length) break;
                    default:
                      return o.replace(w, "$1" + e.trim());
                  }
                  break;
                case 58:
                  switch (o.charCodeAt(1)) {
                    case 103:
                      if (Y > 0 && G > 0)
                        return o.replace(x, "$1").replace(w, "$1" + ie);
                      break;
                    default:
                      return e.trim() + o.replace(w, "$1" + e.trim());
                  }
                default:
                  if (n * G > 0 && o.indexOf("\f") > 0)
                    return o.replace(
                      w,
                      (58 === e.charCodeAt(0) ? "" : "$1") + e.trim()
                    );
              }
              return e + o;
            }
            function i(e, t, n, r) {
              var o,
                c = 0,
                s = e + ";",
                u = 2 * t + 3 * n + 4 * r;
              if (944 === u)
                return (function (e) {
                  var t = e.length,
                    n = e.indexOf(":", 9) + 1,
                    r = e.substring(0, n).trim(),
                    o = e.substring(n, t - 1).trim();
                  switch (e.charCodeAt(9) * ne) {
                    case 0:
                      break;
                    case 45:
                      if (110 !== e.charCodeAt(10)) break;
                    default:
                      var i = o.split(((o = ""), b)),
                        c = 0;
                      for (n = 0, t = i.length; c < t; n = 0, ++c) {
                        for (var s = i[c], u = s.split(y); (s = u[n]); ) {
                          var l = s.charCodeAt(0);
                          if (
                            1 === ne &&
                            ((l > 64 && l < 90) ||
                              (l > 96 && l < 123) ||
                              95 === l ||
                              (45 === l && 45 !== s.charCodeAt(1)))
                          )
                            switch (
                              isNaN(parseFloat(s)) +
                              (-1 !== s.indexOf("("))
                            ) {
                              case 1:
                                switch (s) {
                                  case "infinite":
                                  case "alternate":
                                  case "backwards":
                                  case "running":
                                  case "normal":
                                  case "forwards":
                                  case "both":
                                  case "none":
                                  case "linear":
                                  case "ease":
                                  case "ease-in":
                                  case "ease-out":
                                  case "ease-in-out":
                                  case "paused":
                                  case "reverse":
                                  case "alternate-reverse":
                                  case "inherit":
                                  case "initial":
                                  case "unset":
                                  case "step-start":
                                  case "step-end":
                                    break;
                                  default:
                                    s += re;
                                }
                            }
                          u[n++] = s;
                        }
                        o += (0 === c ? "" : ",") + u.join(" ");
                      }
                  }
                  return (
                    (o = r + o + ";"),
                    1 === V || (2 === V && a(o, 1)) ? z + o + o : o
                  );
                })(s);
              if (0 === V || (2 === V && !a(s, 1))) return s;
              switch (u) {
                case 1015:
                  return 97 === s.charCodeAt(10) ? z + s + s : s;
                case 951:
                  return 116 === s.charCodeAt(3) ? z + s + s : s;
                case 963:
                  return 110 === s.charCodeAt(5) ? z + s + s : s;
                case 1009:
                  if (100 !== s.charCodeAt(4)) break;
                case 969:
                case 942:
                  return z + s + s;
                case 978:
                  return z + s + W + s + s;
                case 1019:
                case 983:
                  return z + s + W + s + F + s + s;
                case 883:
                  return 45 === s.charCodeAt(8)
                    ? z + s + s
                    : s.indexOf("image-set(", 11) > 0
                    ? s.replace(N, "$1" + z + "$2") + s
                    : s;
                case 932:
                  if (45 === s.charCodeAt(4))
                    switch (s.charCodeAt(5)) {
                      case 103:
                        return (
                          z +
                          "box-" +
                          s.replace("-grow", "") +
                          z +
                          s +
                          F +
                          s.replace("grow", "positive") +
                          s
                        );
                      case 115:
                        return z + s + F + s.replace("shrink", "negative") + s;
                      case 98:
                        return (
                          z + s + F + s.replace("basis", "preferred-size") + s
                        );
                    }
                  return z + s + F + s + s;
                case 964:
                  return z + s + F + "flex-" + s + s;
                case 1023:
                  if (99 !== s.charCodeAt(8)) break;
                  return (
                    (o = s
                      .substring(s.indexOf(":", 15))
                      .replace("flex-", "")
                      .replace("space-between", "justify")),
                    z + "box-pack" + o + z + s + F + "flex-pack" + o + s
                  );
                case 1005:
                  return g.test(s)
                    ? s.replace(h, ":" + z) + s.replace(h, ":" + W) + s
                    : s;
                case 1e3:
                  switch (
                    ((c = (o = s.substring(13).trim()).indexOf("-") + 1),
                    o.charCodeAt(0) + o.charCodeAt(c))
                  ) {
                    case 226:
                      o = s.replace(E, "tb");
                      break;
                    case 232:
                      o = s.replace(E, "tb-rl");
                      break;
                    case 220:
                      o = s.replace(E, "lr");
                      break;
                    default:
                      return s;
                  }
                  return z + s + F + o + s;
                case 1017:
                  if (-1 === s.indexOf("sticky", 9)) return s;
                case 975:
                  switch (
                    ((c = (s = e).length - 10),
                    (u =
                      (o = (33 === s.charCodeAt(c) ? s.substring(0, c) : s)
                        .substring(e.indexOf(":", 7) + 1)
                        .trim()).charCodeAt(0) +
                      (0 | o.charCodeAt(7))))
                  ) {
                    case 203:
                      if (o.charCodeAt(8) < 111) break;
                    case 115:
                      s = s.replace(o, z + o) + ";" + s;
                      break;
                    case 207:
                    case 102:
                      s =
                        s.replace(o, z + (u > 102 ? "inline-" : "") + "box") +
                        ";" +
                        s.replace(o, z + o) +
                        ";" +
                        s.replace(o, F + o + "box") +
                        ";" +
                        s;
                  }
                  return s + ";";
                case 938:
                  if (45 === s.charCodeAt(5))
                    switch (s.charCodeAt(6)) {
                      case 105:
                        return (
                          (o = s.replace("-items", "")),
                          z + s + z + "box-" + o + F + "flex-" + o + s
                        );
                      case 115:
                        return z + s + F + "flex-item-" + s.replace(D, "") + s;
                      default:
                        return (
                          z +
                          s +
                          F +
                          "flex-line-pack" +
                          s.replace("align-content", "").replace(D, "") +
                          s
                        );
                    }
                  break;
                case 973:
                case 989:
                  if (45 !== s.charCodeAt(3) || 122 === s.charCodeAt(4)) break;
                case 931:
                case 953:
                  if (!0 === R.test(e))
                    return 115 ===
                      (o = e.substring(e.indexOf(":") + 1)).charCodeAt(0)
                      ? i(
                          e.replace("stretch", "fill-available"),
                          t,
                          n,
                          r
                        ).replace(":fill-available", ":stretch")
                      : s.replace(o, z + o) +
                          s.replace(o, W + o.replace("fill-", "")) +
                          s;
                  break;
                case 962:
                  if (
                    ((s = z + s + (102 === s.charCodeAt(5) ? F + s : "") + s),
                    n + r === 211 &&
                      105 === s.charCodeAt(13) &&
                      s.indexOf("transform", 10) > 0)
                  )
                    return (
                      s
                        .substring(0, s.indexOf(";", 27) + 1)
                        .replace(m, "$1" + z + "$2") + s
                    );
              }
              return s;
            }
            function a(e, t) {
              var n = e.indexOf(1 === t ? ":" : "{"),
                r = e.substring(0, 3 !== t ? n : 10),
                o = e.substring(n + 1, e.length - 1);
              return ee(2 !== t ? r : r.replace(L, "$1"), o, t);
            }
            function c(e, t) {
              var n = i(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
              return n !== t + ";"
                ? n.replace(M, " or ($1)").substring(4)
                : "(" + t + ")";
            }
            function s(e, t, n, r, o, i, a, c, s, u) {
              for (var l, p = 0, d = t; p < Z; ++p)
                switch ((l = X[p].call(f, e, d, n, r, o, i, a, c, s, u))) {
                  case void 0:
                  case !1:
                  case !0:
                  case null:
                    break;
                  default:
                    d = l;
                }
              if (d !== t) return d;
            }
            function u(e, t, n, r) {
              for (var o = t + 1; o < n; ++o)
                switch (r.charCodeAt(o)) {
                  case 47:
                    if (42 === e && 42 === r.charCodeAt(o - 1) && t + 2 !== o)
                      return o + 1;
                    break;
                  case 10:
                    if (47 === e) return o + 1;
                }
              return o;
            }
            function l(e) {
              for (var t in e) {
                var n = e[t];
                switch (t) {
                  case "keyframe":
                    ne = 0 | n;
                    break;
                  case "global":
                    Y = 0 | n;
                    break;
                  case "cascade":
                    G = 0 | n;
                    break;
                  case "compress":
                    $ = 0 | n;
                    break;
                  case "semicolon":
                    J = 0 | n;
                    break;
                  case "preserve":
                    K = 0 | n;
                    break;
                  case "prefix":
                    (ee = null),
                      n
                        ? "function" != typeof n
                          ? (V = 1)
                          : ((V = 2), (ee = n))
                        : (V = 0);
                }
              }
              return l;
            }
            function f(t, r) {
              if (void 0 !== this && this.constructor === f) return e(t);
              var o = t,
                i = o.charCodeAt(0);
              i < 33 && (i = (o = o.trim()).charCodeAt(0)),
                ne > 0 && (re = o.replace(_, 91 === i ? "" : "-")),
                (i = 1),
                1 === G ? (ie = o) : (oe = o);
              var a,
                c = [ie];
              Z > 0 &&
                void 0 !== (a = s(-1, r, c, c, U, H, 0, 0, 0, 0)) &&
                "string" == typeof a &&
                (r = a);
              var u = n(Q, c, r, 0, 0);
              return (
                Z > 0 &&
                  void 0 !== (a = s(-2, u, c, c, U, H, u.length, 0, 0, 0)) &&
                  "string" != typeof (u = a) &&
                  (i = 0),
                (re = ""),
                (ie = ""),
                (oe = ""),
                (q = 0),
                (U = 1),
                (H = 1),
                $ * i == 0
                  ? u
                  : (function (e) {
                      return e
                        .replace(d, "")
                        .replace(C, "")
                        .replace(P, "$1")
                        .replace(A, "$1")
                        .replace(I, " ");
                    })(u)
              );
            }
            var p = /^\0+/g,
              d = /[\0\r\f]/g,
              h = /: */g,
              g = /zoo|gra/,
              m = /([,: ])(transform)/g,
              b = /,+\s*(?![^(]*[)])/g,
              y = / +\s*(?![^(]*[)])/g,
              v = / *[\0] */g,
              O = /,\r+?/g,
              w = /([\t\r\n ])*\f?&/g,
              x = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
              _ = /\W+/g,
              j = /@(k\w+)\s*(\S*)\s*/,
              S = /::(place)/g,
              k = /:(read-only)/g,
              C = /\s+(?=[{\];=:>])/g,
              P = /([[}=:>])\s+/g,
              A = /(\{[^{]+?);(?=\})/g,
              I = /\s{2,}/g,
              T = /([^\(])(:+) */g,
              E = /[svh]\w+-[tblr]{2}/,
              B = /\(\s*(.*)\s*\)/g,
              M = /([\s\S]*?);/g,
              D = /-self|flex-/g,
              L = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
              R = /stretch|:\s*\w+\-(?:conte|avail)/,
              N = /([^-])(image-set\()/,
              z = "-webkit-",
              W = "-moz-",
              F = "-ms-",
              H = 1,
              U = 1,
              q = 0,
              G = 1,
              V = 1,
              Y = 1,
              $ = 0,
              J = 0,
              K = 0,
              Q = [],
              X = [],
              Z = 0,
              ee = null,
              te = 0,
              ne = 1,
              re = "",
              oe = "",
              ie = "";
            return (
              (f.use = function e(t) {
                switch (t) {
                  case void 0:
                  case null:
                    Z = X.length = 0;
                    break;
                  default:
                    if ("function" == typeof t) X[Z++] = t;
                    else if ("object" == typeof t)
                      for (var n = 0, r = t.length; n < r; ++n) e(t[n]);
                    else te = 0 | !!t;
                }
                return e;
              }),
              (f.set = l),
              void 0 !== t && l(t),
              f
            );
          })(null);
        },
        "645H": function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("gGz3"),
              o = n("keud"),
              i = n("ITsB");
            t.a = function (t) {
              var n = t.message,
                a = t.onOptionSelect,
                c = t.isDisabled,
                s = Object(o.b)().config,
                u = new (0, Object(i.b)().MessageService)();
              if (
                n.content &&
                !n.isHidden &&
                Array.isArray(n.content.options)
              ) {
                var l = e(r.c, null, n.content.description),
                  f = n.content.options.map(function (t) {
                    return e(
                      r.a,
                      {
                        onClick: function () {
                          return (function (e) {
                            s.PUBLIC.option.hideOptionsAfterSelect &&
                              u.editMessageById(n.id, function (e) {
                                return (e.isHidden = !0), e;
                              }),
                              a(e.value);
                          })(t);
                        },
                        disabled: c,
                      },
                      t.label
                    );
                  });
                return e(
                  r.b,
                  { owner: n.owner },
                  e(r.d, null, n.content.description && l, f)
                );
              }
            };
          }).call(this, n("hosL").h);
        },
        "6GRQ": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "b", function () {
            return u;
          }),
            n.d(t, "e", function () {
              return l;
            }),
            n.d(t, "d", function () {
              return f;
            }),
            n.d(t, "c", function () {
              return p;
            }),
            n.d(t, "a", function () {
              return d;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = n("6naU"),
            u = Object(a.b)(c.a).withConfig({
              displayName: "Imagestyled__ImageContainer",
              componentId: "sc-1kjps30-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme,
                n = e.fullScreen,
                r = n
                  ? o(
                      {
                        position: "fixed",
                        left: 0,
                        top: 0,
                        width: "100vw",
                        height: "100vh",
                        justifyContent: "center",
                        backgroundColor: "black",
                        overflow: "auto",
                        zIndex: 999999999999,
                        borderRadius: 0,
                        backgroundImage: "url(" + e.image + ")",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                      },
                      t.elements.messages.ImageFullScreen
                    )
                  : {};
              return n
                ? o({}, r)
                : o({ marginTop: "0" }, t.elements.messages.ImageContainer);
            }),
            l = Object(a.b)(c.b).withConfig({
              displayName: "Imagestyled__ImageWrapper",
              componentId: "sc-1kjps30-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  backgroundColor: t.colors.veryLightPink,
                  padding: "0",
                  width: "100%",
                  maxWidth: "initial",
                  borderRadius: "10px",
                  overflow: "hidden",
                  background: "transparent",
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "16px",
                },
                t.elements.messages.ImageWrapper
              );
            }),
            f = a.b.p.withConfig({
              displayName: "Imagestyled__ImageTitle",
              componentId: "sc-1kjps30-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  fontWeight: "bold !important",
                  fontSize: "18px !important",
                  marginBottom: "10px",
                  marginTop: "10px",
                  textAlign: "center",
                },
                e.theme.elements.messages.ImageTitle
              );
            }),
            p = a.b.p.withConfig({
              displayName: "Imagestyled__ImageDescription",
              componentId: "sc-1kjps30-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { fontSize: "14px !important", marginBottom: "15px" },
                e.theme.elements.messages.ImageDescription
              );
            }),
            d = a.b.img.withConfig({
              displayName: "Imagestyled__Image",
              componentId: "sc-1kjps30-4",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  width: "100%",
                  maxWidth: e.owner === s.a.agent ? "150px" : "initial",
                  maxHeight: "initial",
                  borderRadius: "15px",
                  display: e.fullScreen ? "none" : "unset",
                },
                e.theme.elements.messages.Image
              );
            });
        },
        "6naU": function (e, t, n) {
          "use strict";
          var r;
          n.d(t, "a", function () {
            return r;
          }),
            (function (e) {
              (e.bot = "bot"),
                (e.user = "user"),
                (e.agent = "agent"),
                (e.system = "system");
            })(r || (r = {}));
        },
        "6oRp": function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            return (o =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function i(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function a(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function c(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function s(e, t) {
            return !t || ("object" !== o(t) && "function" != typeof t)
              ? (function (e) {
                  if (void 0 === e)
                    throw new ReferenceError(
                      "this hasn't been initialised - super() hasn't been called"
                    );
                  return e;
                })(e)
              : t;
          }
          function u(e) {
            return (u = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          function l(e, t) {
            return (l =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.Dots = void 0);
          var f = r(n("l8WD")),
            p = r(n("8Jek"));
          t.Dots = (function (e) {
            function t() {
              return s(this, u(t).apply(this, arguments));
            }
            var n, r, o;
            return (
              (function (e, t) {
                if ("function" != typeof t && null !== t)
                  throw new TypeError(
                    "Super expression must either be null or a function"
                  );
                (e.prototype = Object.create(t && t.prototype, {
                  constructor: { value: e, writable: !0, configurable: !0 },
                })),
                  t && l(e, t);
              })(t, e),
              (n = t),
              (r = [
                {
                  key: "clickHandler",
                  value: function (e, t) {
                    t.preventDefault(), this.props.clickHandler(e);
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var e,
                      t = this,
                      n = (e = {
                        slideCount: this.props.slideCount,
                        slidesToScroll: this.props.slidesToScroll,
                        slidesToShow: this.props.slidesToShow,
                        infinite: this.props.infinite,
                      }).infinite
                        ? Math.ceil(e.slideCount / e.slidesToScroll)
                        : Math.ceil(
                            (e.slideCount - e.slidesToShow) / e.slidesToScroll
                          ) + 1,
                      r = this.props,
                      o = {
                        onMouseEnter: r.onMouseEnter,
                        onMouseOver: r.onMouseOver,
                        onMouseLeave: r.onMouseLeave,
                      },
                      c = Array.apply(
                        null,
                        Array(n + 1)
                          .join("0")
                          .split("")
                      ).map(function (e, n) {
                        var r = (0, p.default)({
                            "slick-active":
                              t.props.currentSlide >=
                                n * t.props.slidesToScroll &&
                              t.props.currentSlide <=
                                n * t.props.slidesToScroll +
                                  (t.props.slidesToScroll - 1),
                          }),
                          o = t.clickHandler.bind(t, {
                            message: "dots",
                            index: n,
                            slidesToScroll: t.props.slidesToScroll,
                            currentSlide: t.props.currentSlide,
                          });
                        return f.default.createElement(
                          "li",
                          { key: n, className: r },
                          f.default.cloneElement(t.props.customPaging(n), {
                            onClick: o,
                          })
                        );
                      });
                    return f.default.cloneElement(
                      this.props.appendDots(c),
                      (function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                          var n = null != arguments[t] ? arguments[t] : {};
                          t % 2
                            ? i(n, !0).forEach(function (t) {
                                a(e, t, n[t]);
                              })
                            : Object.getOwnPropertyDescriptors
                            ? Object.defineProperties(
                                e,
                                Object.getOwnPropertyDescriptors(n)
                              )
                            : i(n).forEach(function (t) {
                                Object.defineProperty(
                                  e,
                                  t,
                                  Object.getOwnPropertyDescriptor(n, t)
                                );
                              });
                        }
                        return e;
                      })({ className: this.props.dotsClass }, o)
                    );
                  },
                },
              ]) && c(n.prototype, r),
              o && c(n, o),
              t
            );
          })(f.default.PureComponent);
        },
        "6t2U": function (e, t, n) {
          "use strict";
          function r(e, t) {
            return (r =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          n.d(t, "a", function () {
            return o;
          });
          var o = (function (e) {
            function t() {
              for (
                var t, n = arguments.length, r = new Array(n), o = 0;
                o < n;
                o++
              )
                r[o] = arguments[o];
              return (
                ((t =
                  e.call.apply(e, [this].concat(r)) || this).scrollToBottom =
                  function () {
                    var e = t.getAppStore().scrollToBottomRef.value;
                    e && e.scroll({ top: e.scrollHeight, behavior: "smooth" });
                  }),
                (t.changeRtl = function (e) {
                  t.getAppStore().rtl.set(e);
                }),
                t
              );
            }
            var n, o;
            return (
              (o = e),
              ((n = t).prototype = Object.create(o.prototype)),
              (n.prototype.constructor = n),
              r(n, o),
              (t.prototype.registerScrollToBottomRef = function (e) {
                var t = this.getAppStore().scrollToBottomRef,
                  n = t.value;
                (n && Object.keys(n).length && void 0 !== n.scrollTop) ||
                  t.set(e);
              }),
              t
            );
          })(n("knbI").a);
        },
        "7A+S": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "c", function () {
              return u;
            }),
            n.d(t, "b", function () {
              return l;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = a.b.button.withConfig({
              displayName: "Buttonstyled__Button",
              componentId: "sc-4egezh-0",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { "&:not(:disabled)": { cursor: "pointer" } },
                e.theme.elements.messages.Button
              );
            }),
            u = a.b.div.withConfig({
              displayName: "Buttonstyled__ButtonTitle",
              componentId: "sc-4egezh-1",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.ButtonTitle);
            }),
            l = Object(a.b)(c.a).withConfig({
              displayName: "Buttonstyled__ButtonContainer",
              componentId: "sc-4egezh-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "flex", alignItems: "flex-start" },
                e.theme.elements.messages.ButtonContainer
              );
            });
        },
        "7Wk+": function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              c,
              s,
              u,
              l,
              f,
              p,
              d,
              h,
              g,
              m,
              b,
              y = this.offset;
            if (this.options.footnotes) {
              for (
                r = 0, c = t.length, s = "", u = e.now(), l = u.line;
                r < c && ((h = t.charAt(r)), o(h));

              )
                (s += h), r++;
              if ("[" === t.charAt(r) && "^" === t.charAt(r + 1)) {
                for (
                  r = (s += "[^").length, p = "";
                  r < c && "]" !== (h = t.charAt(r));

                )
                  "\\" === h && ((p += h), r++, (h = t.charAt(r))),
                    (p += h),
                    r++;
                if (p && "]" === t.charAt(r) && ":" === t.charAt(r + 1)) {
                  if (n) return !0;
                  for (
                    g = i(p), r = (s += p + "]:").length;
                    r < c && ("\t" === (h = t.charAt(r)) || " " === h);

                  )
                    (s += h), r++;
                  for (
                    u.column += s.length,
                      u.offset += s.length,
                      p = "",
                      f = "",
                      d = "";
                    r < c;

                  ) {
                    if ("\n" === (h = t.charAt(r))) {
                      for (d = h, r++; r < c && "\n" === (h = t.charAt(r)); )
                        (d += h), r++;
                      for (p += d, d = ""; r < c && " " === (h = t.charAt(r)); )
                        (d += h), r++;
                      if (0 === d.length) break;
                      p += d;
                    }
                    p && ((f += p), (p = "")), (f += h), r++;
                  }
                  return (
                    (s += f),
                    (f = f.replace(a, function (e) {
                      return (y[l] = (y[l] || 0) + e.length), l++, "";
                    })),
                    (m = e(s)),
                    (b = this.enterBlock()),
                    (f = this.tokenizeBlock(f, u)),
                    b(),
                    m({
                      type: "footnoteDefinition",
                      identifier: g,
                      children: f,
                    })
                  );
                }
              }
            }
          }
          var o = n("U/Op"),
            i = n("QYzD");
          (e.exports = r), (r.notInList = !0), (r.notInBlock = !0);
          var a = /^( {4}|\t)?/gm;
        },
        "7gIX": function (e, t, n) {
          "use strict";
          var r = n("1hwd"),
            o = n("bb/9");
          e.exports = function (e) {
            function t(t) {
              for (var n = e.offset, r = t.line, o = []; ++r && r in n; )
                o.push((n[r] || 0) + 1);
              return { start: t, indent: o };
            }
            function n(t, n, r) {
              3 !== r && e.file.message(t, n);
            }
            function i(r, i, a) {
              o(r, {
                position: t(i),
                warning: n,
                text: a,
                reference: a,
                textContext: e,
                referenceContext: e,
              });
            }
            return (
              (i.raw = function (e, i, a) {
                return o(e, r(a, { position: t(i), warning: n }));
              }),
              i
            );
          };
        },
        "7kD2": function (e, t, n) {
          "use strict";
          function r(e) {
            var t = e.children;
            (e.children = [
              {
                type: "tableHead",
                align: e.align,
                children: [t[0]],
                position: t[0].position,
              },
            ]),
              t.length > 1 &&
                e.children.push({
                  type: "tableBody",
                  align: e.align,
                  children: t.slice(1),
                  position: {
                    start: t[1].position.start,
                    end: t[t.length - 1].position.end,
                  },
                });
          }
          var o = n("BN5T");
          e.exports = function (e) {
            return o(e, "table", r), e;
          };
        },
        "82qt": function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              var t = Object(o.b)();
              return e(
                i.a,
                null,
                e(
                  i.b,
                  null,
                  e("div", null),
                  e("div", null),
                  e("div", null),
                  e("div", null)
                ),
                e(i.c, null, t["busy_indicator.text"])
              );
            }
            n.d(t, "a", function () {
              return r;
            });
            var o = n("XAzd"),
              i = n("A6EE");
          }).call(this, n("hosL").h);
        },
        "8DMI": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "b", function () {
              return u;
            }),
            n.d(t, "c", function () {
              return l;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = Object(a.b)(c.a).withConfig({
              displayName: "Textstyled__TextContainer",
              componentId: "odqamk-0",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.TextContainer);
            }),
            u = Object(a.b)(c.b).withConfig({
              displayName: "Textstyled__TextWrapper",
              componentId: "odqamk-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  backgroundColor: n.colors.veryLightPink,
                  a: { wordBreak: "break-word" },
                  padding: "10px 25px",
                  borderRadius: "10px",
                  color: n.colors.colorSecondary,
                  background: n.colors.colorWhite,
                  boxShadow: "0 0 18px " + n.colors.boxShadow,
                  fontSize: "15px",
                  fontWeight: "light",
                  lineHeight: "130%",
                  maxWidth: "90%",
                  p: {
                    textAlign: "left",
                    overflowWrap: "anywhere",
                    margin: "10px 0",
                  },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  fontSize: "18px",
                }),
                t),
                n.elements.messages.TextWrapper
              );
            }),
            l = a.b.div.withConfig({
              displayName: "Textstyled__UserIndicator",
              componentId: "odqamk-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { fontSize: "13px", color: "#393a3b", marginBottom: "4px" },
                e.theme.elements.messages.UserIndicator
              );
            });
        },
        "8GnK": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return u;
          }),
            n.d(t, "b", function () {
              return l;
            });
          var a = n("UutA"),
            c = n("aTGq"),
            s = n("Q/RO"),
            u = a.b.button.withConfig({
              displayName: "SubmitButtonstyled__SubmitButton",
              componentId: "u23fwv-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme,
                r = {};
              try {
                Object(c.b)().rtl.value && (r = n.elements.SubmitButtonRtl);
              } catch (e) {}
              return o(
                o(
                  (((t = {
                    "&:hover": { opacity: 1 },
                    "&:focus": { outline: "none" },
                    border: "none",
                    cursor: "pointer",
                    width: "60px",
                    height: "60px",
                    backgroundColor: n.colors.colorLightBlue,
                    backgroundImage: "url(" + s.a + ")",
                    backgroundSize: "25px 25px",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    opacity: 1,
                    transition: "background-color 0.2s",
                    img: { display: "none" },
                  })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                    width: "80px",
                    backgroundSize: "30px 30px",
                    height: "70px",
                  }),
                  t),
                  n.elements.SubmitButton
                ),
                r
              );
            }),
            l = a.b.img.withConfig({
              displayName: "SubmitButtonstyled__SubmitButtonIcon",
              componentId: "u23fwv-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { margin: "0 10px", minWidth: "30px", minHeight: "30px" },
                e.theme.elements.SubmitButtonIcon
              );
            });
        },
        "8Jek": function (e, t) {
          var n;
          !(function () {
            "use strict";
            function r() {
              for (var e = [], t = 0; t < arguments.length; t++) {
                var n = arguments[t];
                if (n) {
                  var i = typeof n;
                  if ("string" === i || "number" === i) e.push(n);
                  else if (Array.isArray(n)) {
                    if (n.length) {
                      var a = r.apply(null, n);
                      a && e.push(a);
                    }
                  } else if ("object" === i)
                    if (n.toString === Object.prototype.toString)
                      for (var c in n) o.call(n, c) && n[c] && e.push(c);
                    else e.push(n.toString());
                }
              }
              return e.join(" ");
            }
            var o = {}.hasOwnProperty;
            e.exports
              ? ((r.default = r), (e.exports = r))
              : void 0 ===
                  (n = function () {
                    return r;
                  }.apply(t, [])) || (e.exports = n);
          })();
        },
        "8KfP": function (e, t, n) {
          "use strict";
          var r = n("FW+y"),
            o = /^ms-/;
          e.exports = function (e) {
            return r(e).replace(o, "-ms-");
          };
        },
        "8QZL": function (e, t, n) {
          "use strict";
          var r = n("VNWY"),
            o = n("RZNd"),
            i = n("H/Nm");
          e.exports = function (e, t) {
            var n,
              a,
              c,
              s,
              u = e.split("\n"),
              l = u.length + 1,
              f = 1 / 0,
              p = [];
            for (u.unshift(o(" ", t) + "!"); l--; )
              if (((a = i(u[l])), (p[l] = a.stops), 0 !== r(u[l]).length)) {
                if (!a.indent) {
                  f = 1 / 0;
                  break;
                }
                a.indent > 0 && a.indent < f && (f = a.indent);
              }
            if (f !== 1 / 0)
              for (l = u.length; l--; ) {
                for (c = p[l], n = f; n && !(n in c); ) n--;
                (s = 0 !== r(u[l]).length && f && n !== f ? "\t" : ""),
                  (u[l] = s + u[l].slice(n in c ? c[n] + 1 : 0));
              }
            return u.shift(), u.join("\n");
          };
        },
        "8UgC": function (e, t) {
          "use strict";
          t.HtmlParser =
            "undefined" == typeof Symbol
              ? "__RMD_HTML_PARSER__"
              : Symbol("__RMD_HTML_PARSER__");
        },
        "8khG": function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            for (
              var r,
                a,
                s,
                u,
                l,
                f,
                p,
                d,
                h = this.options.commonmark,
                g = 0,
                m = t.length,
                b = "";
              g < m && (" " === (u = t.charAt(g)) || "\t" === u);

            )
              (b += u), g++;
            if ("[" === (u = t.charAt(g))) {
              for (g++, b += u, s = ""; g < m && "]" !== (u = t.charAt(g)); )
                "\\" === u && ((s += u), g++, (u = t.charAt(g))), (s += u), g++;
              if (s && "]" === t.charAt(g) && ":" === t.charAt(g + 1)) {
                for (
                  f = s, g = (b += s + "]:").length, s = "";
                  g < m &&
                  ("\t" === (u = t.charAt(g)) || " " === u || "\n" === u);

                )
                  (b += u), g++;
                if (((s = ""), (r = b), "<" === (u = t.charAt(g)))) {
                  for (g++; g < m && o((u = t.charAt(g))); ) (s += u), g++;
                  if ((u = t.charAt(g)) === o.delimiter)
                    (b += "<" + s + u), g++;
                  else {
                    if (h) return;
                    (g -= s.length + 1), (s = "");
                  }
                }
                if (!s) {
                  for (; g < m && i((u = t.charAt(g))); ) (s += u), g++;
                  b += s;
                }
                if (s) {
                  for (
                    p = s, s = "";
                    g < m &&
                    ("\t" === (u = t.charAt(g)) || " " === u || "\n" === u);

                  )
                    (s += u), g++;
                  if (
                    ((l = null),
                    '"' === (u = t.charAt(g))
                      ? (l = '"')
                      : "'" === u
                      ? (l = "'")
                      : "(" === u && (l = ")"),
                    l)
                  ) {
                    if (!s) return;
                    for (
                      g = (b += s + u).length, s = "";
                      g < m && (u = t.charAt(g)) !== l;

                    ) {
                      if ("\n" === u) {
                        if ((g++, "\n" === (u = t.charAt(g)) || u === l))
                          return;
                        s += "\n";
                      }
                      (s += u), g++;
                    }
                    if ((u = t.charAt(g)) !== l) return;
                    (a = b), (b += s + u), g++, (d = s), (s = "");
                  } else (s = ""), (g = b.length);
                  for (; g < m && ("\t" === (u = t.charAt(g)) || " " === u); )
                    (b += u), g++;
                  return (u = t.charAt(g)) && "\n" !== u
                    ? void 0
                    : !!n ||
                        ((r = e(r).test().end),
                        (p = this.decode.raw(this.unescape(p), r, {
                          nonTerminated: !1,
                        })),
                        d &&
                          ((a = e(a).test().end),
                          (d = this.decode.raw(this.unescape(d), a))),
                        e(b)({
                          type: "definition",
                          identifier: c(f),
                          title: d || null,
                          url: p,
                        }));
                }
              }
            }
          }
          function o(e) {
            return ">" !== e && "[" !== e && "]" !== e;
          }
          function i(e) {
            return "[" !== e && "]" !== e && !a(e);
          }
          var a = n("U/Op"),
            c = n("QYzD");
          (e.exports = r), (r.notInList = !0), (r.notInBlock = !0);
          o.delimiter = ">";
        },
        "8xtm": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "g", function () {
            return c;
          }),
            n.d(t, "d", function () {
              return s;
            }),
            n.d(t, "b", function () {
              return l;
            }),
            n.d(t, "c", function () {
              return f;
            }),
            n.d(t, "e", function () {
              return p;
            }),
            n.d(t, "a", function () {
              return d;
            }),
            n.d(t, "f", function () {
              return h;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "PostcardCarouselstyled__PostcardSwipeItem",
              componentId: "beo0ex-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  position: "relative",
                  marginRight: "1.2rem",
                  marginLeft: "1.2rem",
                  "&:focus": { outline: "none" },
                  float: "none",
                  margin: "0",
                  borderRadius: "0",
                  border: "none",
                  background: n.colors.colorWhite,
                  color: n.colors.carousel,
                  cursor: "pointer",
                  boxShadow: "0 0 10px " + n.colors.boxShadow,
                  "> div:first-child": {
                    color: n.colors.colorPrimary,
                    fontSize: "20px",
                    fontWeight: "bold",
                    img: { margin: 0 },
                    div: { margin: 0 },
                  },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {}),
                t),
                n.elements.messages.PostcardSwipeItem
              );
            }),
            s = a.b.div.withConfig({
              displayName: "PostcardCarouselstyled__PostcardCarouselContainer",
              componentId: "beo0ex-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  position: "relative",
                  left: "-25px",
                  width: "calc(100% + 45px)",
                  margin: "0",
                  paddingBottom: "0",
                  borderRadius: "0",
                  ".slick-dots": { display: "none !important" },
                  ".slick-slider:before, .slick-slider:after": {
                    content: '""',
                    position: "absolute",
                    zIndex: 10,
                    top: "0",
                    bottom: "0",
                    width: "15px",
                    pointerEvents: "none",
                  },
                  ".slick-slider:before": {
                    left: "0",
                    background:
                      "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                  ".slick-slider:after": {
                    right: "0",
                    background:
                      "linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                  marginTop: "10px",
                  ".slick-track": { marginLeft: "35px", display: "flex" },
                  ".slick-slide": { height: "auto" },
                  ".slick-slide > div": {
                    margin: "10px 0 10px 10px",
                    height: "calc(100% - 20px)",
                  },
                  ".slick-slide > div > div": {
                    borderRadius: "0",
                    height: "100%",
                  },
                  ".slick-slide > div > div:hover": {
                    boxShadow: "0 0 0 2px " + t.colors.primary,
                  },
                  "@media (max-width: 576px)": {
                    ".slick-track": { marginLeft: "15px" },
                    ".slick-slide": { maxWidth: "240px !important" },
                  },
                },
                t.elements.messages.PostcardCarouselContainer
              );
            }),
            u = a.b.div.withConfig({
              displayName: "PostcardCarouselstyled__PostcardCarouselButton",
              componentId: "beo0ex-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  padding: "5px 15px",
                  borderRadius: "15px",
                  border: t.colors.white,
                  backgroundColor: t.colors.whiteGradient,
                  fontSize: "0.7rem",
                  transition: "background-color .3s, color .3s",
                  position: "absolute",
                  bottom: 0,
                  "&:not(:disabled):hover": {
                    color: t.colors.white,
                    backgroundColor: t.colors.veryLightPink,
                    borderColor: t.colors.veryLightPink,
                    cursor: "pointer",
                  },
                },
                t.elements.messages.PostcardCarouselButton
              );
            }),
            l = Object(a.b)(u).withConfig({
              displayName: "PostcardCarouselstyled__PostcardCarouselButtonLeft",
              componentId: "beo0ex-3",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  "@media (max-width: 576px)": { display: "none" },
                  fontSize: 0,
                  background: t.colors.white,
                  height: "36px",
                  borderRadius: "50px",
                  width: "36px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  left: "20px",
                  zIndex: 10,
                  transition: ".3s all",
                  boxShadow: "2px 2px 30px 0 rgba(61, 61, 61, 0.4)",
                  "&:hover": {
                    backgroundColor: t.colors.primary + "!important",
                    transition: ".3s all",
                    "&:after": {
                      borderColor: t.colors.white,
                      transition: "inherit",
                    },
                  },
                  "&:after": {
                    content: '""',
                    transition: "inherit",
                    width: "8px",
                    height: "8px",
                    borderLeft: "2px solid",
                    borderTop: "2px solid",
                    borderColor: t.colors.primary,
                    position: "absolute",
                    transform: "translateY(-50%) rotate(-45deg)",
                    top: "50%",
                    left: "14px",
                  },
                },
                t.elements.messages.PostcardCarouselButtonLeft
              );
            }),
            f = Object(a.b)(u).withConfig({
              displayName:
                "PostcardCarouselstyled__PostcardCarouselButtonRight",
              componentId: "beo0ex-4",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  right: "75px",
                  "@media (max-width: 576px)": { display: "none" },
                  fontSize: 0,
                  background: t.colors.white,
                  height: "36px",
                  borderRadius: "50px",
                  width: "36px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  transition: ".3s all",
                  boxShadow: "2px 2px 30px 0 rgba(61, 61, 61, 0.4)",
                  "&:hover": {
                    transition: ".3s all",
                    backgroundColor: t.colors.primary + "!important",
                    "&:after": {
                      transition: "inherit",
                      borderColor: t.colors.white,
                    },
                  },
                  "&:after": {
                    content: '""',
                    transition: "inherit",
                    width: "8px",
                    height: "8px",
                    borderLeft: "2px solid",
                    borderTop: "2px solid",
                    borderColor: t.colors.primary,
                    position: "absolute",
                    transform: "translateY(-50%) rotate(135deg)",
                    top: "50%",
                    right: "14px",
                  },
                },
                t.elements.messages.PostcardCarouselButtonRight
              );
            }),
            p = a.b.img.withConfig({
              displayName: "PostcardCarouselstyled__PostcardCarouselImage",
              componentId: "beo0ex-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "inline !important", width: "100%", height: "auto" },
                e.theme.elements.messages.PostcardCarouselImage
              );
            }),
            d =
              (a.b.div.withConfig({
                displayName: "PostcardCarouselstyled__PostcardCarouselValue",
                componentId: "beo0ex-6",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    display: "inline",
                    float: "right",
                    margin: "1rem",
                    fontWeight: "bold",
                  },
                  e.theme.elements.messages.PostcardCarouselValue
                );
              }),
              a.b.div.withConfig({
                displayName: "PostcardCarouselstyled__ClickField",
                componentId: "beo0ex-7",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "transparent",
                  },
                  e.theme.elements.messages.ClickField
                );
              })),
            h = a.b.div.withConfig({
              displayName: "PostcardCarouselstyled__PostcardCarouselTitle",
              componentId: "beo0ex-8",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  position: "relative",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  fontSize: "17px",
                  fontWeight: "600",
                  lineHeight: "1.3",
                  padding: "13px",
                },
                e.theme.elements.messages.PostcardCarouselTitle
              );
            });
        },
        "9J4p": function (e, t, n) {
          "use strict";
          var r = n("aTGq");
          t.a = Object(r.a)(function () {
            return {};
          });
        },
        "9K2m": function (e, t) {
          "use strict";
          function n(e) {
            if ("object" == typeof e && null !== e) {
              var t = e.$$typeof;
              switch (t) {
                case i:
                  switch ((e = e.type)) {
                    case p:
                    case d:
                    case c:
                    case u:
                    case s:
                    case g:
                      return e;
                    default:
                      switch ((e = e && e.$$typeof)) {
                        case f:
                        case h:
                        case y:
                        case b:
                        case l:
                          return e;
                        default:
                          return t;
                      }
                  }
                case a:
                  return t;
              }
            }
          }
          function r(e) {
            return n(e) === d;
          }
          var o = "function" == typeof Symbol && Symbol.for,
            i = o ? Symbol.for("react.element") : 60103,
            a = o ? Symbol.for("react.portal") : 60106,
            c = o ? Symbol.for("react.fragment") : 60107,
            s = o ? Symbol.for("react.strict_mode") : 60108,
            u = o ? Symbol.for("react.profiler") : 60114,
            l = o ? Symbol.for("react.provider") : 60109,
            f = o ? Symbol.for("react.context") : 60110,
            p = o ? Symbol.for("react.async_mode") : 60111,
            d = o ? Symbol.for("react.concurrent_mode") : 60111,
            h = o ? Symbol.for("react.forward_ref") : 60112,
            g = o ? Symbol.for("react.suspense") : 60113,
            m = o ? Symbol.for("react.suspense_list") : 60120,
            b = o ? Symbol.for("react.memo") : 60115,
            y = o ? Symbol.for("react.lazy") : 60116,
            v = o ? Symbol.for("react.block") : 60121,
            O = o ? Symbol.for("react.fundamental") : 60117,
            w = o ? Symbol.for("react.responder") : 60118,
            x = o ? Symbol.for("react.scope") : 60119;
          (t.AsyncMode = p),
            (t.ConcurrentMode = d),
            (t.ContextConsumer = f),
            (t.ContextProvider = l),
            (t.Element = i),
            (t.ForwardRef = h),
            (t.Fragment = c),
            (t.Lazy = y),
            (t.Memo = b),
            (t.Portal = a),
            (t.Profiler = u),
            (t.StrictMode = s),
            (t.Suspense = g),
            (t.isAsyncMode = function (e) {
              return r(e) || n(e) === p;
            }),
            (t.isConcurrentMode = r),
            (t.isContextConsumer = function (e) {
              return n(e) === f;
            }),
            (t.isContextProvider = function (e) {
              return n(e) === l;
            }),
            (t.isElement = function (e) {
              return "object" == typeof e && null !== e && e.$$typeof === i;
            }),
            (t.isForwardRef = function (e) {
              return n(e) === h;
            }),
            (t.isFragment = function (e) {
              return n(e) === c;
            }),
            (t.isLazy = function (e) {
              return n(e) === y;
            }),
            (t.isMemo = function (e) {
              return n(e) === b;
            }),
            (t.isPortal = function (e) {
              return n(e) === a;
            }),
            (t.isProfiler = function (e) {
              return n(e) === u;
            }),
            (t.isStrictMode = function (e) {
              return n(e) === s;
            }),
            (t.isSuspense = function (e) {
              return n(e) === g;
            }),
            (t.isValidElementType = function (e) {
              return (
                "string" == typeof e ||
                "function" == typeof e ||
                e === c ||
                e === d ||
                e === u ||
                e === s ||
                e === g ||
                e === m ||
                ("object" == typeof e &&
                  null !== e &&
                  (e.$$typeof === y ||
                    e.$$typeof === b ||
                    e.$$typeof === l ||
                    e.$$typeof === f ||
                    e.$$typeof === h ||
                    e.$$typeof === O ||
                    e.$$typeof === w ||
                    e.$$typeof === x ||
                    e.$$typeof === v))
              );
            }),
            (t.typeOf = n);
        },
        "9cs3": function () {},
        "9jBT": function (e) {
          "use strict";
          e.exports = function (e) {
            return String(e).replace(/\s+/g, " ");
          };
        },
        "A6/w": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a(e) {
            return e === c.a.bot ? "flex-start" : e ? "baseline" : "center";
          }
          n.d(t, "c", function () {
            return u;
          }),
            n.d(t, "a", function () {
              return l;
            }),
            n.d(t, "b", function () {
              return f;
            });
          var c = n("6naU"),
            s = n("UutA"),
            u = s.b.div.withConfig({
              displayName: "Messagesstyled__Messages",
              componentId: "p9nhtr-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  flex: "1",
                  overflowY: "auto",
                  marginTop: "0",
                  fontWeight: "normal",
                  padding: "20px 0",
                  background: t.colors.colorWhite,
                  scrollbarColor: "dark",
                  scrollbarWidth: "thin",
                  "&.fullscreen": {
                    padding:
                      "20px calc(50% - (" +
                      t.fullscreenParams.baseWidth / 2 +
                      "px))",
                  },
                  "&::-webkit-scrollbar": { width: "10px" },
                  "&::-webkit-scrollbar-thumb": {
                    background: t.colors.colorGray,
                    borderRadius: "4px",
                  },
                },
                t.elements.messages.Messages
              );
            }),
            l = s.b.div.withConfig({
              displayName: "Messagesstyled__MessageContainer",
              componentId: "p9nhtr-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "0.8rem",
                  alignItems: a(e.owner),
                  paddingRight: 0,
                  borderRadius: "10px",
                },
                t.elements.messages.MessageContainer
              );
            }),
            f = s.b.div.withConfig({
              displayName: "Messagesstyled__MessageWrapper",
              componentId: "p9nhtr-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  display: "flex",
                  margin: "5px 0",
                  padding: "8px 15px",
                  borderRadius: "10px",
                  position: "relative",
                  background: t.colors.brownGrayTwo,
                  "&:before,&:after": { display: "none" },
                },
                t.elements.messages.MessageWrapper
              );
            });
        },
        A6EE: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "b", function () {
            return s;
          }),
            n.d(t, "a", function () {
              return u;
            }),
            n.d(t, "c", function () {
              return l;
            });
          var a = n("UutA"),
            c = Object(a.c)([
              "0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}",
            ]),
            s = a.b.div.withConfig({
              displayName: "BusyIndicatorstyled__BusyIndicatorElement",
              componentId: "sc-1ahfc3h-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  display: "inline-block",
                  position: "relative",
                  width: "25px",
                  height: "25px",
                  marginBottom: "20px",
                  " div": {
                    margin: 0,
                    boxSizing: "border-box",
                    display: "block",
                    position: "absolute",
                    width: "25px",
                    height: "25px",
                    border: "3px solid " + t.colors.colorPrimary,
                    borderRadius: "50%",
                    animation:
                      c + " 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite",
                    borderColor:
                      t.colors.colorPrimary +
                      " transparent transparent transparent",
                    "&:nth-child(1)": { animationDelay: "-0.45s" },
                    "&:nth-child(2)": { animationDelay: "-0.3s" },
                    "&:nth-child(3)": { animationDelay: "-0.15s" },
                  },
                },
                t.elements.BusyIndicatorElement
              );
            }),
            u = a.b.div.withConfig({
              displayName: "BusyIndicatorstyled__BusyIndicatorContainer",
              componentId: "sc-1ahfc3h-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                },
                e.theme.elements.BusyIndicatorContainer
              );
            }),
            l = a.b.p.withConfig({
              displayName: "BusyIndicatorstyled__BusyIndicatorText",
              componentId: "sc-1ahfc3h-2",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.BusyIndicatorText);
            });
        },
        BEgE: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r, o;
            if (
              "\\" === t.charAt(0) &&
              ((r = t.charAt(1)), -1 !== this.escape.indexOf(r))
            )
              return (
                !!n ||
                ((o =
                  "\n" === r ? { type: "break" } : { type: "text", value: r }),
                e("\\" + r)(o))
              );
          }
          var o = n("Qx+S");
          (e.exports = r), (r.locator = o);
        },
        BN5T: function (e, t, n) {
          "use strict";
          function r(e, t, n, r) {
            "function" == typeof t &&
              "function" != typeof n &&
              ((r = n), (n = t), (t = null)),
              o(
                e,
                t,
                function (e, t) {
                  var r = t[t.length - 1],
                    o = r ? r.children.indexOf(e) : null;
                  return n(e, o, r);
                },
                r
              );
          }
          e.exports = r;
          var o = n("kqyo"),
            i = o.SKIP,
            a = o.EXIT;
          (r.CONTINUE = o.CONTINUE), (r.SKIP = i), (r.EXIT = a);
        },
        BNKq: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "h", function () {
            return c;
          }),
            n.d(t, "d", function () {
              return s;
            }),
            n.d(t, "b", function () {
              return l;
            }),
            n.d(t, "c", function () {
              return f;
            }),
            n.d(t, "e", function () {
              return p;
            }),
            n.d(t, "g", function () {
              return d;
            }),
            n.d(t, "a", function () {
              return h;
            }),
            n.d(t, "f", function () {
              return g;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "StandardCarouselstyled__SwipeItem",
              componentId: "eroknj-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n,
                r = e.theme;
              return o(
                (((n = {
                  position: "relative",
                  marginRight: "1.2rem",
                  marginLeft: "1.2rem",
                  "&:focus": { outline: "none" },
                  float: "none",
                  margin: "0",
                  height: "140px",
                  borderRadius: "10px",
                  border: "none",
                  background: r.colors.colorWhite,
                  color: r.colors.carousel,
                  cursor: "pointer",
                  boxShadow: "0 0 10px " + r.colors.boxShadow,
                  "> div:first-child": {
                    padding: "15px 15px 10px 15px",
                    color: r.colors.colorPrimary,
                    fontSize: "20px",
                    fontWeight: "bold",
                    div: { margin: 0 },
                  },
                  "> div:last-child":
                    ((t = {
                      padding: "10px",
                      textAlign: "left !important",
                      color: r.colors.colorDarkBlue,
                      fontWeight: "bold",
                      "> p:first-child": {
                        marginBottom: "6px",
                        fontSize: "12px",
                        lineHeight: "100%",
                      },
                      "> p:last-child": {
                        fontSize: "14px",
                        fontWeight: "normal",
                        lineHeight: "16px",
                      },
                    }),
                    (t["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      padding: "0 10px 10px 10px",
                    }),
                    t),
                })["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                  width: "130px !important",
                  height: "130px",
                }),
                n),
                r.elements.messages.SwipeItem
              );
            }),
            s = a.b.div.withConfig({
              displayName: "StandardCarouselstyled__StandardCarouselContainer",
              componentId: "eroknj-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n,
                r = e.theme;
              return o(
                {
                  position: "relative",
                  left: "-25px",
                  width: "calc(100% + 45px)",
                  margin: "0",
                  paddingBottom: "0",
                  borderRadius: "10px",
                  ".slick-dots": { display: "none !important" },
                  ".slick-track": { display: "flex", flexDirection: "row" },
                  ".slick-slide":
                    ((t = {}),
                    (t["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      maxWidth: "150px !important",
                    }),
                    t),
                  ".slick-slide > div":
                    ((n = {
                      margin: "10px",
                      height: "100%",
                      borderRadius: "10px",
                      transition: "box-shadow .3s",
                      "&:hover": {
                        boxShadow: "0 0 0 2px " + r.colors.colorPrimary,
                      },
                    }),
                    (n["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      width: "130px",
                    }),
                    n),
                  ".slick-slide > div > div": {
                    display: "flex !important",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  },
                  ".slick-slider:before, .slick-slider:after": {
                    content: '""',
                    position: "absolute",
                    zIndex: 10,
                    top: "0",
                    bottom: "0",
                    width: "15px",
                    pointerEvents: "none",
                  },
                  ".slick-slider:before": {
                    left: "0",
                    background:
                      "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                  ".slick-slider:after": {
                    right: "0",
                    background:
                      "linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                },
                r.elements.messages.CarouselContainer
              );
            }),
            u = a.b.div.withConfig({
              displayName: "StandardCarouselstyled__CarouselButton",
              componentId: "eroknj-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  padding: "5px 15px",
                  borderRadius: "15px",
                  border: t.colors.white,
                  backgroundColor: t.colors.whiteGradient,
                  fontSize: "0.7rem",
                  transition: "background-color .3s, color .3s",
                  position: "absolute",
                  bottom: 0,
                  "&:not(:disabled):hover": {
                    color: t.colors.white,
                    backgroundColor: t.colors.veryLightPink,
                    borderColor: t.colors.veryLightPink,
                    cursor: "pointer",
                  },
                },
                t.elements.messages.CarouselButton
              );
            }),
            l = Object(a.b)(u).withConfig({
              displayName: "StandardCarouselstyled__StandardCarouselButtonLeft",
              componentId: "eroknj-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { left: "2rem" },
                e.theme.elements.messages.StandardCarouselButtonLeft
              );
            }),
            f = Object(a.b)(u).withConfig({
              displayName:
                "StandardCarouselstyled__StandardCarouselButtonRight",
              componentId: "eroknj-4",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { right: "2rem" },
                e.theme.elements.messages.StandardCarouselButtonRight
              );
            }),
            p = a.b.img.withConfig({
              displayName: "StandardCarouselstyled__StandardCarouselImage",
              componentId: "eroknj-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  width: "3rem",
                  height: "3rem",
                  display: "inline !important",
                  margin: "5px 10px 0px 10px",
                },
                e.theme.elements.messages.StandardCarouselImage
              );
            }),
            d = a.b.div.withConfig({
              displayName: "StandardCarouselstyled__StandardCarouselValue",
              componentId: "eroknj-6",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "inline",
                  float: "right",
                  margin: "1rem",
                  fontWeight: "bold",
                },
                e.theme.elements.messages.StandardCarouselValue
              );
            }),
            h = a.b.div.withConfig({
              displayName: "StandardCarouselstyled__ClickFix",
              componentId: "eroknj-7",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { position: "absolute", left: 0, top: 0 },
                e.theme.elements.messages.ClickFix
              );
            }),
            g = a.b.div.withConfig({
              displayName: "StandardCarouselstyled__StandardCarouselTitle",
              componentId: "eroknj-8",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  float: "center",
                  textAlign: "center",
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-end",
                  paddingBottom: "20px",
                  p: { margin: "4px" },
                },
                e.theme.elements.messages.StandardCarouselTitle
              );
            });
        },
        Bk45: function (e) {
          var t = Object.prototype.toString;
          e.exports = function (e) {
            return "[object String]" === t.call(e);
          };
        },
        BoRb: function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            return (o =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function i() {
            return (i =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function a(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function c(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? a(n, !0).forEach(function (t) {
                    s(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : a(n).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function s(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function u(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function l(e, t, n) {
            return t && u(e.prototype, t), n && u(e, n), e;
          }
          function f(e, t) {
            return !t || ("object" !== o(t) && "function" != typeof t)
              ? (function (e) {
                  if (void 0 === e)
                    throw new ReferenceError(
                      "this hasn't been initialised - super() hasn't been called"
                    );
                  return e;
                })(e)
              : t;
          }
          function p(e) {
            return (p = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          function d(e, t) {
            if ("function" != typeof t && null !== t)
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            (e.prototype = Object.create(t && t.prototype, {
              constructor: { value: e, writable: !0, configurable: !0 },
            })),
              t && h(e, t);
          }
          function h(e, t) {
            return (h =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.NextArrow = t.PrevArrow = void 0);
          var g = r(n("l8WD")),
            m = r(n("8Jek")),
            b = n("iWpb");
          (t.PrevArrow = (function (e) {
            function t() {
              return f(this, p(t).apply(this, arguments));
            }
            return (
              d(t, e),
              l(t, [
                {
                  key: "clickHandler",
                  value: function (e, t) {
                    t && t.preventDefault(), this.props.clickHandler(e, t);
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var e = { "slick-arrow": !0, "slick-prev": !0 },
                      t = this.clickHandler.bind(this, { message: "previous" });
                    !this.props.infinite &&
                      (0 === this.props.currentSlide ||
                        this.props.slideCount <= this.props.slidesToShow) &&
                      ((e["slick-disabled"] = !0), (t = null));
                    var n = {
                      key: "0",
                      "data-role": "none",
                      className: (0, m.default)(e),
                      style: { display: "block" },
                      onClick: t,
                    };
                    return this.props.prevArrow
                      ? g.default.cloneElement(
                          this.props.prevArrow,
                          c(
                            {},
                            n,
                            {},
                            {
                              currentSlide: this.props.currentSlide,
                              slideCount: this.props.slideCount,
                            }
                          )
                        )
                      : g.default.createElement(
                          "button",
                          i({ key: "0", type: "button" }, n),
                          " ",
                          "Previous"
                        );
                  },
                },
              ]),
              t
            );
          })(g.default.PureComponent)),
            (t.NextArrow = (function (e) {
              function t() {
                return f(this, p(t).apply(this, arguments));
              }
              return (
                d(t, e),
                l(t, [
                  {
                    key: "clickHandler",
                    value: function (e, t) {
                      t && t.preventDefault(), this.props.clickHandler(e, t);
                    },
                  },
                  {
                    key: "render",
                    value: function () {
                      var e = { "slick-arrow": !0, "slick-next": !0 },
                        t = this.clickHandler.bind(this, { message: "next" });
                      (0, b.canGoNext)(this.props) ||
                        ((e["slick-disabled"] = !0), (t = null));
                      var n = {
                        key: "1",
                        "data-role": "none",
                        className: (0, m.default)(e),
                        style: { display: "block" },
                        onClick: t,
                      };
                      return this.props.nextArrow
                        ? g.default.cloneElement(
                            this.props.nextArrow,
                            c(
                              {},
                              n,
                              {},
                              {
                                currentSlide: this.props.currentSlide,
                                slideCount: this.props.slideCount,
                              }
                            )
                          )
                        : g.default.createElement(
                            "button",
                            i({ key: "1", type: "button" }, n),
                            " ",
                            "Next"
                          );
                    },
                  },
                ]),
                t
              );
            })(g.default.PureComponent));
        },
        CGuF: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return c;
          }),
            n.d(t, "b", function () {
              return s;
            });
          var a = n("UutA"),
            c = a.b.textarea.withConfig({
              displayName: "MessageInputstyled__Input",
              componentId: "qaxbn3-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  height: "100%",
                  resize: "none",
                  border: "none",
                  fontFamily: n.fonts.primary,
                  background: n.colors.brownGrayTwo,
                  overflow: "hidden",
                  "&:focus": { outline: "none" },
                  padding: "15px",
                  width: "calc(100% - 60px)",
                  maxHeight: "60px",
                  backgroundColor: "transparent",
                  color: n.colors.colorBlack,
                  fontSize: "14px",
                  lineHeight: "170%",
                  "&:not(:placeholder-shown) button": {
                    backgroundColor: n.colors.colorPrimary,
                  },
                  "&::placeholder": {
                    color: n.colors.colorBlack,
                    fontSize: "15px",
                    lineHeight: "30px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    opacity: ".6",
                    transition: "opacity .2s",
                  },
                  "&:focus::placeholder": { opacity: 0 },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  width: "calc(100% - 80px)",
                  fontSize: "18px",
                  "&::placeholder": { paddingLeft: "15px", fontSize: "18px" },
                }),
                t),
                n.elements.MessageInput
              );
            }),
            s = a.b.div.withConfig({
              displayName: "MessageInputstyled__InputContainer",
              componentId: "qaxbn3-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  display: "flex",
                  background: n.colors.brownGrayTwo,
                  alignItems: "center",
                  margin: "5px 12px 15px 12px",
                  height: "auto",
                  minHeight: "55px",
                  borderRadius: "15px",
                  overflow: "hidden",
                  backgroundColor: "transparent",
                  transition: "opacity 1s",
                  opacity: e.loading ? 0 : 1,
                  boxShadow: "0 0 5px " + n.colors.boxShadow,
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  minHeight: "70px",
                }),
                (t[
                  "@media (min-width: " + n.fullscreenParams.baseWidth + "px)"
                ] = {
                  "&.fullscreen": {
                    marginLeft:
                      "calc(50% - (" +
                      n.fullscreenParams.baseWidth / 2 +
                      "px - 30px))",
                    marginRight:
                      "calc(50% - (" +
                      n.fullscreenParams.baseWidth / 2 +
                      "px - 20px))",
                  },
                }),
                t),
                n.elements.InputContainer
              );
            });
          a.b.div.withConfig({
            displayName: "MessageInputstyled__AddAttachment",
            componentId: "qaxbn3-2",
          })([".ActionBot &{", "}"], function (e) {
            var t = e.theme;
            return o(
              {
                "&:after": {
                  content: "'+'",
                  color: t.colors.brownGrayTwo,
                  fontSize: "30px",
                },
                borderTop: 0,
                padding: "20px 15px",
                lineHeight: 0,
                cursor: "pointer",
                border: "unset",
              },
              t.elements.AddAttachment
            );
          }),
            a.b.input.withConfig({
              displayName: "MessageInputstyled__AddAttachmentInput",
              componentId: "qaxbn3-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "none" },
                e.theme.elements.AddAttachmentInput
              );
            });
        },
        Cf1v: function (e, t, n) {
          "use strict";
          n.r(t),
            (t.default = function (e, t) {
              return (
                (t = t || {}),
                new Promise(function (n, r) {
                  var o = new XMLHttpRequest(),
                    i = [],
                    a = [],
                    c = {};
                  for (var s in (o.open(t.method || "get", e, !0),
                  (o.onload = function () {
                    o
                      .getAllResponseHeaders()
                      .replace(
                        /^(.*?):[^\S\n]*([\s\S]*?)$/gm,
                        function (e, t, n) {
                          i.push((t = t.toLowerCase())),
                            a.push([t, n]),
                            (c[t] = c[t] ? c[t] + "," + n : n);
                        }
                      ),
                      n(
                        (function e() {
                          return {
                            ok: 2 == ((o.status / 100) | 0),
                            statusText: o.statusText,
                            status: o.status,
                            url: o.responseURL,
                            text: function () {
                              return Promise.resolve(o.responseText);
                            },
                            json: function () {
                              return Promise.resolve(o.responseText).then(
                                JSON.parse
                              );
                            },
                            blob: function () {
                              return Promise.resolve(new Blob([o.response]));
                            },
                            clone: e,
                            headers: {
                              keys: function () {
                                return i;
                              },
                              entries: function () {
                                return a;
                              },
                              get: function (e) {
                                return c[e.toLowerCase()];
                              },
                              has: function (e) {
                                return e.toLowerCase() in c;
                              },
                            },
                          };
                        })()
                      );
                  }),
                  (o.onerror = r),
                  (o.withCredentials = "include" == t.credentials),
                  t.headers))
                    o.setRequestHeader(s, t.headers[s]);
                  o.send(t.body || null);
                })
              );
            });
        },
        Ck5b: function (e) {
          "use strict";
          var t;
          e.exports = function (e) {
            var n,
              r = "&" + e + ";";
            return (
              ((t = t || document.createElement("i")).innerHTML = r),
              (59 !== (n = t.textContent).charCodeAt(n.length - 1) ||
                "semi" === e) &&
                n !== r &&
                n
            );
          };
        },
        CqQT: function (e, t, n) {
          "use strict";
          t.a = n.p + "1839140dd4f2f3c7ac7f90d7b6949478.svg";
        },
        CtzJ: function (e, t, n) {
          "use strict";
          t.a = n.p + "1d512c47c94cc155fc29deeb840245d1.svg";
        },
        "Df/I": function (e, t, n) {
          "use strict";
          t.a = n.p + "2a1e54796d23ef036f5874a782015d2d.svg";
        },
        "E/r5": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return c;
          }),
            n.d(t, "b", function () {
              return s;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "MessageInputAttachmentstyled__AddAttachment",
              componentId: "sc-1vq5bsf-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  "&:after": {
                    content: "'+'",
                    color: t.colors.brownGrayTwo,
                    fontSize: "30px",
                  },
                  borderTop: 0,
                  padding: "20px 15px",
                  lineHeight: 0,
                  cursor: "pointer",
                  border: "unset",
                },
                t.elements.AddAttachment
              );
            }),
            s = a.b.input.withConfig({
              displayName: "MessageInputAttachmentstyled__AddAttachmentInput",
              componentId: "sc-1vq5bsf-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "none" },
                e.theme.elements.AddAttachmentInput
              );
            });
        },
        E02R: function (e) {
          "use strict";
          e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        EbX1: function (e) {
          function t(e) {
            return (
              !!e.constructor &&
              "function" == typeof e.constructor.isBuffer &&
              e.constructor.isBuffer(e)
            );
          }
          e.exports = function (e) {
            return (
              null != e &&
              (t(e) ||
                (function (e) {
                  return (
                    "function" == typeof e.readFloatLE &&
                    "function" == typeof e.slice &&
                    t(e.slice(0, 0))
                  );
                })(e) ||
                !!e._isBuffer)
            );
          };
        },
        EbZa: function (e) {
          "use strict";
          e.exports = function (e, t) {
            return e.indexOf("`", t);
          };
        },
        EdTv: function (e, t, n) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.default = void 0);
          var r,
            o = (r = n("l8WD")) && r.__esModule ? r : { default: r };
          t.default = {
            accessibility: !0,
            adaptiveHeight: !1,
            afterChange: null,
            appendDots: function (e) {
              return o.default.createElement(
                "ul",
                { style: { display: "block" } },
                e
              );
            },
            arrows: !0,
            autoplay: !1,
            autoplaySpeed: 3e3,
            beforeChange: null,
            centerMode: !1,
            centerPadding: "50px",
            className: "",
            cssEase: "ease",
            customPaging: function (e) {
              return o.default.createElement("button", null, e + 1);
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: 0.35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: null,
            nextArrow: null,
            onEdge: null,
            onInit: null,
            onLazyLoadError: null,
            onReInit: null,
            pauseOnDotsHover: !1,
            pauseOnFocus: !1,
            pauseOnHover: !0,
            prevArrow: null,
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "div",
            slidesPerRow: 1,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 500,
            swipe: !0,
            swipeEvent: null,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            waitForAnimate: !0,
          };
        },
        "FW+y": function (e) {
          "use strict";
          var t = /([A-Z])/g;
          e.exports = function (e) {
            return e.replace(t, "-$1").toLowerCase();
          };
        },
        FYFc: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("FmVe");
            t.a = function (t) {
              var n = t.message.content;
              return e(r.a, {
                src: n.url,
                style: { backgroundSize: n.resizeMode },
              });
            };
          }).call(this, n("hosL").h);
        },
        FaEK: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a(e) {
            try {
              var t = e.toLowerCase().trim();
              return s[t] || "flex-start";
            } catch (e) {
              return "flex-start";
            }
          }
          n.d(t, "b", function () {
            return u;
          }),
            n.d(t, "c", function () {
              return l;
            }),
            n.d(t, "a", function () {
              return f;
            });
          var c = n("UutA"),
            s = { left: "flex-start", right: "flex-end", center: "center" },
            u = c.b.div.withConfig({
              displayName: "Surveystyled__SurveyContainer",
              componentId: "sc-1il10b8-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: a(e.position) + " !important",
                },
                t.elements.messages.Survey
              );
            }),
            l = c.b.p.withConfig({
              displayName: "Surveystyled__SurveyDescription",
              componentId: "sc-1il10b8-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  color: t.colors.colorBlack,
                  marginBottom: "10px",
                  opacity: 0.6,
                  fontSize: "12px !important",
                },
                t.elements.messages.SurveyDescription
              );
            }),
            f = c.b.span.withConfig({
              displayName: "Surveystyled__SurveyButton",
              componentId: "sc-1il10b8-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { cursor: "pointer", margin: "8px", marginLeft: 0 },
                e.theme.elements.messages.SurveyButton
              );
            });
        },
        FmVe: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return i;
          });
          var i = n("UutA").b.img.withConfig({
            displayName: "Gifstyled__GifImage",
            componentId: "sc-1hfozr0-0",
          })([".ActionBot &{", "}"], function (e) {
            return (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      o(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            })(
              { height: "300px", width: "100%" },
              e.theme.elements.messages.GifImage
            );
          });
        },
        GMTn: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
              t[n] = arguments[n];
            var r = function (e) {
                return e && null != e && "object" == typeof e;
              },
              i = t.filter(r),
              c = i[0],
              s = i.slice(1);
            t = s;
            try {
              return t.reduce(function (e, t) {
                return (
                  Object.keys(t).forEach(function (n) {
                    var o = e[n],
                      i = t[n];
                    if (Array.isArray(o) && Array.isArray(i)) {
                      var c = Array.from(new Set([].concat(o, i)));
                      e[n] = c;
                    } else e[n] = r(o) && r(i) ? a(o, i) : i;
                  }),
                  e
                );
              }, c);
            } catch (e) {
              return (
                console.error(e, { objects: t }),
                t.reduce(function (e, t) {
                  return o(o({}, e), t);
                })
              );
            }
          }
          n.d(t, "a", function () {
            return a;
          });
        },
        GTSi: function (e) {
          "use strict";
          e.exports = function (e, t) {
            return e.indexOf("~~", t);
          };
        },
        GZPr: function (e) {
          "use strict";
          var t = ["http", "https", "mailto", "tel"];
          e.exports = function (e) {
            var n = (e || "").trim(),
              r = n.charAt(0);
            if ("#" === r || "/" === r) return n;
            var o = n.indexOf(":");
            if (-1 === o) return n;
            for (var i = t.length, a = -1; ++a < i; ) {
              var c = t[a];
              if (o === c.length && n.slice(0, c.length).toLowerCase() === c)
                return n;
            }
            return (-1 !== (a = n.indexOf("?")) && o > a) ||
              (-1 !== (a = n.indexOf("#")) && o > a)
              ? n
              : "javascript:void(0)";
          };
        },
        GeWT: function (e, t, n) {
          "use strict";
          function r(e) {
            return o.isMemo(e) ? c : s[e.$$typeof] || i;
          }
          var o = n("xVO4"),
            i = {
              childContextTypes: !0,
              contextType: !0,
              contextTypes: !0,
              defaultProps: !0,
              displayName: !0,
              getDefaultProps: !0,
              getDerivedStateFromError: !0,
              getDerivedStateFromProps: !0,
              mixins: !0,
              propTypes: !0,
              type: !0,
            },
            a = {
              name: !0,
              length: !0,
              prototype: !0,
              caller: !0,
              callee: !0,
              arguments: !0,
              arity: !0,
            },
            c = {
              $$typeof: !0,
              compare: !0,
              defaultProps: !0,
              displayName: !0,
              propTypes: !0,
              type: !0,
            },
            s = {};
          (s[o.ForwardRef] = {
            $$typeof: !0,
            render: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0,
          }),
            (s[o.Memo] = c);
          var u = Object.defineProperty,
            l = Object.getOwnPropertyNames,
            f = Object.getOwnPropertySymbols,
            p = Object.getOwnPropertyDescriptor,
            d = Object.getPrototypeOf,
            h = Object.prototype;
          e.exports = function e(t, n, o) {
            if ("string" != typeof n) {
              if (h) {
                var i = d(n);
                i && i !== h && e(t, i, o);
              }
              var c = l(n);
              f && (c = c.concat(f(n)));
              for (var s = r(t), g = r(n), m = 0; m < c.length; ++m) {
                var b = c[m];
                if (!(a[b] || (o && o[b]) || (g && g[b]) || (s && s[b]))) {
                  var y = p(n, b);
                  try {
                    u(t, b, y);
                  } catch (e) {}
                }
              }
            }
            return t;
          };
        },
        GtCE: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("keud"),
              o = n("qj14");
            t.a = function () {
              return Object(r.b)().config.PROTECTED.poweredBy.enabled
                ? e(
                    o.a,
                    null,
                    "Powered by ",
                    e(
                      "a",
                      { target: "_blank", href: "https://action.bot/" },
                      "Actionbot"
                    )
                  )
                : null;
            };
          }).call(this, n("hosL").h);
        },
        GwwO: function (e) {
          e.exports = (function () {
            "use strict";
            return function (e) {
              function t(t) {
                if (t)
                  try {
                    e(t + "}");
                  } catch (e) {}
              }
              return function (n, r, o, i, a, c, s, u, l, f) {
                switch (n) {
                  case 1:
                    if (0 === l && 64 === r.charCodeAt(0))
                      return e(r + ";"), "";
                    break;
                  case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                  case 3:
                    switch (u) {
                      case 102:
                      case 112:
                        return e(o[0] + r), "";
                      default:
                        return r + (0 === f ? "/*|*/" : "");
                    }
                  case -2:
                    r.split("/*|*/}").forEach(t);
                }
              };
            };
          })();
        },
        "H/Nm": function (e) {
          "use strict";
          e.exports = function (e) {
            for (var n, r = 0, o = 0, i = e.charAt(r), a = {}; i in t; )
              (o += n = t[i]),
                n > 1 && (o = Math.floor(o / n) * n),
                (a[o] = r),
                (i = e.charAt(++r));
            return { indent: o, stops: a };
          };
          var t = { " ": 1, "\t": 4 };
        },
        H1yl: function (e, t) {
          "use strict";
          t.a = function (e) {
            function t(e) {
              return e > 9 ? e : "0" + e;
            }
            if (e instanceof Date) {
              var n = e.getHours(),
                r = e.getMinutes();
              return t(n) + ":" + t(r);
            }
            return e;
          };
        },
        Ht6y: function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            return (o =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function i() {
            return (i =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function a(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function c(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? a(n, !0).forEach(function (t) {
                    d(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : a(n).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function s(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function u(e, t) {
            return !t || ("object" !== o(t) && "function" != typeof t)
              ? f(e)
              : t;
          }
          function l(e) {
            return (l = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          function f(e) {
            if (void 0 === e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return e;
          }
          function p(e, t) {
            return (p =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function d(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.default = void 0);
          var h = r(n("l8WD")),
            g = n("lUS9"),
            m = r(n("drO/")),
            b = r(n("EdTv")),
            y = n("iWpb"),
            v = (0, y.canUseDOM)() && n("495I");
          t.default = (function (e) {
            function t(e) {
              var n;
              return (
                d(
                  f((n = u(this, l(t).call(this, e)))),
                  "innerSliderRefHandler",
                  function (e) {
                    return (n.innerSlider = e);
                  }
                ),
                d(f(n), "slickPrev", function () {
                  return n.innerSlider.slickPrev();
                }),
                d(f(n), "slickNext", function () {
                  return n.innerSlider.slickNext();
                }),
                d(f(n), "slickGoTo", function (e) {
                  var t =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1];
                  return n.innerSlider.slickGoTo(e, t);
                }),
                d(f(n), "slickPause", function () {
                  return n.innerSlider.pause("paused");
                }),
                d(f(n), "slickPlay", function () {
                  return n.innerSlider.autoPlay("play");
                }),
                (n.state = { breakpoint: null }),
                (n._responsiveMediaHandlers = []),
                n
              );
            }
            var n, r, o;
            return (
              (function (e, t) {
                if ("function" != typeof t && null !== t)
                  throw new TypeError(
                    "Super expression must either be null or a function"
                  );
                (e.prototype = Object.create(t && t.prototype, {
                  constructor: { value: e, writable: !0, configurable: !0 },
                })),
                  t && p(e, t);
              })(t, e),
              (n = t),
              (r = [
                {
                  key: "media",
                  value: function (e, t) {
                    v.register(e, t),
                      this._responsiveMediaHandlers.push({
                        query: e,
                        handler: t,
                      });
                  },
                },
                {
                  key: "UNSAFE_componentWillMount",
                  value: function () {
                    var e = this;
                    if (this.props.responsive) {
                      var t = this.props.responsive.map(function (e) {
                        return e.breakpoint;
                      });
                      t.sort(function (e, t) {
                        return e - t;
                      }),
                        t.forEach(function (n, r) {
                          var o;
                          (o = (0, m.default)(
                            0 === r
                              ? { minWidth: 0, maxWidth: n }
                              : { minWidth: t[r - 1] + 1, maxWidth: n }
                          )),
                            (0, y.canUseDOM)() &&
                              e.media(o, function () {
                                e.setState({ breakpoint: n });
                              });
                        });
                      var n = (0, m.default)({ minWidth: t.slice(-1)[0] });
                      (0, y.canUseDOM)() &&
                        this.media(n, function () {
                          e.setState({ breakpoint: null });
                        });
                    }
                  },
                },
                {
                  key: "componentWillUnmount",
                  value: function () {
                    this._responsiveMediaHandlers.forEach(function (e) {
                      v.unregister(e.query, e.handler);
                    });
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var e,
                      t,
                      n = this;
                    (e = this.state.breakpoint
                      ? "unslick" ===
                        (t = this.props.responsive.filter(function (e) {
                          return e.breakpoint === n.state.breakpoint;
                        }))[0].settings
                        ? "unslick"
                        : c({}, b.default, {}, this.props, {}, t[0].settings)
                      : c({}, b.default, {}, this.props)).centerMode &&
                      (e.slidesToScroll = 1),
                      e.fade && ((e.slidesToShow = 1), (e.slidesToScroll = 1));
                    var r = h.default.Children.toArray(this.props.children);
                    (r = r.filter(function (e) {
                      return "string" == typeof e ? !!e.trim() : !!e;
                    })),
                      e.variableWidth &&
                        (e.rows > 1 || e.slidesPerRow > 1) &&
                        (console.warn(
                          "variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"
                        ),
                        (e.variableWidth = !1));
                    for (
                      var o = [], a = null, s = 0;
                      s < r.length;
                      s += e.rows * e.slidesPerRow
                    ) {
                      for (
                        var u = [], l = s;
                        l < s + e.rows * e.slidesPerRow;
                        l += e.slidesPerRow
                      ) {
                        for (
                          var f = [], p = l;
                          p < l + e.slidesPerRow &&
                          (e.variableWidth &&
                            r[p].props.style &&
                            (a = r[p].props.style.width),
                          !(p >= r.length));
                          p += 1
                        )
                          f.push(
                            h.default.cloneElement(r[p], {
                              key: 100 * s + 10 * l + p,
                              tabIndex: -1,
                              style: {
                                width: "".concat(100 / e.slidesPerRow, "%"),
                                display: "inline-block",
                              },
                            })
                          );
                        u.push(
                          h.default.createElement("div", { key: 10 * s + l }, f)
                        );
                      }
                      o.push(
                        h.default.createElement(
                          "div",
                          e.variableWidth
                            ? { key: s, style: { width: a } }
                            : { key: s },
                          u
                        )
                      );
                    }
                    return "unslick" === e
                      ? h.default.createElement(
                          "div",
                          {
                            className:
                              "regular slider " + (this.props.className || ""),
                          },
                          r
                        )
                      : (o.length <= e.slidesToShow && (e.unslick = !0),
                        h.default.createElement(
                          g.InnerSlider,
                          i(
                            {
                              style: this.props.style,
                              ref: this.innerSliderRefHandler,
                            },
                            e
                          ),
                          o
                        ));
                  },
                },
              ]) && s(n.prototype, r),
              o && s(n, o),
              t
            );
          })(h.default.Component);
        },
        ICoq: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function c(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? a(Object(n), !0).forEach(function (t) {
                    s(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : a(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function s(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          var u,
            l = n("rOKC"),
            f = n("Q/RO"),
            p = n("QJ8L"),
            d = n("6naU"),
            h = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization:
                  "Basic YXBpa2V5OkRBRW9UOGNDeEp5Si1sLXdveUlBY1hoQ3Y4bnZ3aGtsbFpsMmNsVHBIT2VF",
              },
            },
            g = Object(l.a)("actionBot"),
            m = {
              PROTECTED: {
                projectId: "actionBot",
                anonymize: !1,
                agent: {
                  available: !1,
                  usernameVisibleToAgent: "Action Bot",
                  defaultSkipAgentConnection: !1,
                },
                debug: !1,
                history: {
                  enabled: !0,
                  storage: p.a.sessionStorage,
                  key: "actionbot",
                },
                messagesLimit: 150,
                sendMessageThreshold: 1e3,
                store: {
                  preventSavingStoreToBrowserStorageWhenRedirectKeys: [
                    "scrollToBottomRef",
                  ],
                },
                remoteConfig: { enabled: !1 },
                connection: {
                  engine: "watson",
                  watsonSource: "actionbot",
                  sendMessage: {
                    url: "https://api.eu-de.assistant.watson.cloud.ibm.com/instances/351fbbce-e145-4d23-8d65-6302bd798119/v2/assistants/3433dcb8-1454-4d58-a629-a7fe53c65437/sessions/{SESSION_ID}/message?version=2019-04-20",
                    options: h,
                  },
                  getSessionId: {
                    url: "https://api.eu-de.assistant.watson.cloud.ibm.com/instances/351fbbce-e145-4d23-8d65-6302bd798119/v2/assistants/3433dcb8-1454-4d58-a629-a7fe53c65437/sessions?version=2020-04-20",
                    withWelcomeMessage: !1,
                    forceGetSession: !1,
                    options: h,
                  },
                  sendMessageToAgent: {
                    url: "wss://ombot-test.eu-de.cf.appdomain.cloud/websocket",
                    departament: "asd",
                    queueDepartament: null,
                    department: null,
                    queueDepartment: null,
                    sendInitResponse: !0,
                  },
                  uploadFile: {
                    enabled: !1,
                    url: "",
                    showFileSize: !1,
                    maxFileSize: 2097152,
                  },
                  extraPayloadData: {},
                  history: {
                    url: "https://actionbot-demo.eu-de.mybluemix.net/history",
                  },
                },
                poweredBy: { enabled: !1 },
              },
              PUBLIC: {
                rootElement: "body",
                mountByDefault: !0,
                minimizeAvailableOnlyAfterFirstResponse: !1,
                skipGetSessionOnLoad: !1,
                minimized: !1,
                rtl: !1,
                input: { maxLength: 300 },
                header: { title: "chatbot" },
                carousel: {
                  settings: {
                    dots: !0,
                    infinite: !0,
                    speed: 300,
                    slidesToShow: 1,
                    centerMode: !0,
                    arrows: !1,
                    swipe: !0,
                  },
                },
                carouselPopup: {
                  settings: {
                    dots: !1,
                    infinite: !1,
                    speed: 300,
                    slidesToShow: 2.4,
                    centerMode: !1,
                    arrows: !1,
                    swipe: !0,
                  },
                },
                persistKeys: o(
                  o({}, g),
                  {},
                  ((u = {}),
                  (u[g.usernameVisibleToAgent] = { storage: p.a.localStorage }),
                  (u[g.agentConnection] = { storage: p.a.localStorage }),
                  (u[g.sessionId] = { storage: p.a.sessionStorage }),
                  (u[g.unread] = { storage: p.a.localStorage }),
                  (u[g.redirectStorage] = { storage: p.a.localStorage }),
                  u)
                ),
                welcomeMessage: { context: {}, text: "" },
                displayMessage: {
                  default: {
                    user: {
                      avatar:
                        "https://docs.atlassian.com/aui/8.6.0/docs/images/avatar-person.svg",
                    },
                    bot: {
                      name: "ActionBot",
                      avatar:
                        "https://cdn.icon-icons.com/icons2/1371/PNG/512/robot02_90810.png",
                    },
                    agent: {
                      name: "Agent",
                      avatar:
                        "https://media.istockphoto.com/photos/can-i-be-of-assistance-picture-id171406243",
                    },
                  },
                  avatar: { enabled: !0, blackList: [d.a.system] },
                  date: { enabled: !0, blackList: [d.a.system] },
                },
                submitButton: { icon: f.a },
                language: "en",
                unread: { enabled: !0, messageVisiblityDuration: 3500 },
                analytics: !1,
                disablePageScrollOnMobileWhenMaximized: !0,
                links: {
                  openPdfInNewTab: !0,
                  newTabWhenRegexpNotMatch: "generali.pl|staticdev",
                },
                externalLibs: { disableTwemoji: !0 },
                menu: { enabled: !1 },
                option: { hideOptionsAfterSelect: !1 },
                message: { showUserIndicator: !1 },
                thinkingAvatar: !0,
                fullscreen: { enabled: !1 },
                initialPopup: { oneTimeOnly: !0 },
              },
              proxy: {},
            },
            b = n("lpWF"),
            y = n("nbD9"),
            v = n("t0TX"),
            O = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization:
                  "Basic YXBpa2V5OnZKdkNwWlo5emZOc1RzeGg1R1E1cmlxaS1RSXR2LTMzVU9xcHVpNndZYm5z",
              },
            },
            w = "tasil.omantel.om" === location.hostname ? "api" : "api-dev";
          t.a = (function (e) {
            var t = void 0 === e ? {} : e,
              n = t.PROTECTED,
              r = t.PUBLIC,
              o = t.proxy;
            window.__actionBot &&
              (window.__actionBot = c(
                c({}, window.__actionBot),
                {},
                { version: v.version }
              )),
              !window.__actionBot &&
                (window.__actionBot = { version: v.version }),
              !window.__actionBot.config &&
                (window.__actionBot.config = { PUBLIC: {}, PROTECTED: {} }),
              !window.__actionBot.theme && (window.__actionBot.theme = {}),
              !window.__actionBot.dictionary &&
                (window.__actionBot.dictionary = {});
            var i = window.__actionBot.config.PUBLIC,
              a = { PROTECTED: n, PUBLIC: Object(b.a)(r, i) };
            return (
              "object" == typeof o &&
                Object.keys(o).forEach(function (e) {
                  try {
                    var t = o[e],
                      n = e.split("."),
                      r = n[0],
                      i = n[1],
                      c = t.split("."),
                      s = c[0],
                      u = c[1];
                    (a[r][i] = a[s][u]), delete a[s][u];
                  } catch (e) {
                    Object(y.a)().error(e);
                  }
                }),
              {
                PROTECTED: Object(b.a)(m.PROTECTED, a.PROTECTED),
                PUBLIC: Object(b.a)(m.PUBLIC, a.PUBLIC),
              }
            );
          })({
            PROTECTED: {
              agent: {
                available: !1,
                usernameVisibleToAgent: "TASIL Assistant",
              },
              debug: !1,
              history: {
                enabled: !0,
                storage: "sessionStorage",
                key: "tasil-new",
              },
              connection: {
                engine: "watson",
                sendMessage: {
                  url:
                    "https://actionbot-proxy-actionbot.12k7ipg0ukzd.eu-de.codeengine.appdomain.cloud/tasil/" +
                    w +
                    "/{SESSION_ID}/{LANG}?version=2020-02-01",
                  options: O,
                },
                getSessionId: {
                  withWelcomeMessage: !0,
                  url:
                    "https://actionbot-proxy-actionbot.12k7ipg0ukzd.eu-de.codeengine.appdomain.cloud/tasil/" +
                    w +
                    "?version=2020-02-01",
                  options: O,
                },
                sendMessageToAgent: {
                  url: "wss://actionbot-proxy-actionbot.12k7ipg0ukzd.eu-de.codeengine.appdomain.cloud/websocket/api-tasil",
                  departament: "b9EHsNuunkWALjPqF",
                  queueDepartament: "bS37ab3TgZwsasRmC",
                },
              },
              poweredBy: { enabled: !0 },
            },
            PUBLIC: {
              minimized: !0,
              rtl: !1,
              input: { maxLength: 300 },
              header: { title: "TASIL Assistant" },
              welcomeMessage: { context: {}, text: "" },
              carousel: {
                settings: {
                  dots: !1,
                  infinite: !0,
                  speed: 300,
                  slidesToShow: 1.5,
                  centerMode: !0,
                  arrows: !1,
                  swipe: !0,
                },
              },
              analytics: !0,
              displayMessage: {
                avatar: { enabled: !0, blackList: [d.a.system, d.a.user] },
              },
              language: "en",
              skipGetSessionOnLoad: null,
              disablePageScrollOnMobileWhenMaximized: !1,
            },
            proxy: {},
          });
        },
        IL5K: function (e) {
          "use strict";
          e.exports = function (e, t) {
            var n = e.indexOf("*", t),
              r = e.indexOf("_", t);
            return -1 === r ? n : -1 === n || r < n ? r : n;
          };
        },
        IO5D: function () {},
        IPT0: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r, a, u, l, f, p, d, h, g, m, b, y;
            if (this.options.gfm) {
              for (r = "", l = -1, h = s; ++l < h; )
                if ((d = t.slice(0, (p = c[l]).length)).toLowerCase() === p) {
                  r = d;
                  break;
                }
              if (r) {
                for (
                  l = r.length, h = t.length, g = "", m = 0;
                  l < h &&
                  ((u = t.charAt(l)), !i(u) && "<" !== u) &&
                  (("." !== u &&
                    "," !== u &&
                    ":" !== u &&
                    ";" !== u &&
                    '"' !== u &&
                    "'" !== u &&
                    ")" !== u &&
                    "]" !== u) ||
                    ((b = t.charAt(l + 1)) && !i(b))) &&
                  (("(" !== u && "[" !== u) || m++,
                  (")" !== u && "]" !== u) || !(--m < 0));

                )
                  (g += u), l++;
                if (g) {
                  if (((a = r += g), "mailto:" === p)) {
                    if (-1 === (f = g.indexOf("@")) || f === h - 1) return;
                    a = a.substr("mailto:".length);
                  }
                  return (
                    !!n ||
                    ((y = this.enterLink()),
                    (a = this.tokenizeInline(a, e.now())),
                    y(),
                    e(r)({
                      type: "link",
                      title: null,
                      url: o(r, { nonTerminated: !1 }),
                      children: a,
                    }))
                  );
                }
              }
            }
          }
          var o = n("bb/9"),
            i = n("U/Op"),
            a = n("bO4D");
          (e.exports = r), (r.locator = a), (r.notInLink = !0);
          var c = ["http://", "https://", "mailto:"],
            s = c.length;
        },
        ITsB: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r);
              }
              return n;
            }
            function o(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      i(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            }
            function i(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function a(e) {
              var t;
              try {
                t = Object(s.b)(f);
              } catch (e) {
                t = Object(l.a)("services");
              }
              return (e && t.hasOwnProperty(e)) || (e && t.hasOwnProperty(e))
                ? t[e]
                : t;
            }
            n.d(t, "b", function () {
              return a;
            }),
              n.d(t, "a", function () {
                return p;
              });
            var c = n("hosL"),
              s = n("QRet"),
              u = n("g1Zs"),
              l = n("c37Q"),
              f = Object(c.createContext)({}),
              p = function (t) {
                var n = t.children,
                  r = t.services;
                return e(f.Provider, { value: o(o({}, u), r) }, n);
              };
          }).call(this, n("hosL").h);
        },
        IX3v: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a(e) {
            var t = e.style,
              n = e.theme;
            return {
              primary: o(
                {},
                n.elements.messages.WithButtonsCarouselStylePrimary
              ),
              secondary: o(
                {},
                n.elements.messages.WithButtonsCarouselStyleSecondary
              ),
              title: o({}, n.elements.messages.WithButtonsCarouselTextTitle),
              subtitle: o(
                {},
                n.elements.messages.WithButtonsCarouselTextSubtitle
              ),
              description: o(
                {},
                n.elements.messages.WithButtonsCarouselTextDescription
              ),
            }[t];
          }
          n.d(t, "h", function () {
            return s;
          }),
            n.d(t, "c", function () {
              return u;
            }),
            n.d(t, "f", function () {
              return f;
            }),
            n.d(t, "g", function () {
              return p;
            }),
            n.d(t, "d", function () {
              return d;
            }),
            n.d(t, "e", function () {
              return h;
            }),
            n.d(t, "i", function () {
              return g;
            }),
            n.d(t, "b", function () {
              return m;
            }),
            n.d(t, "a", function () {
              return b;
            });
          var c = n("UutA"),
            s = c.b.div.withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselSwipeItem",
              componentId: "sc-11sxy2o-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  display: "flex !important",
                  flexDirection: "column",
                  position: "relative",
                  marginRight: "1.2rem",
                  height: "450px",
                  minHeight: "450px",
                  marginLeft: "1.2rem",
                  "&:focus": { outline: "none" },
                  float: "none",
                  margin: "0",
                  paddingBottom: "20px",
                  borderRadius: "10px",
                  border: "none",
                  background: t.colors.colorWhite,
                  color: t.colors.carousel,
                  boxShadow: "5px 5px 8px 2px rgba(233,0,143,0.15)",
                  "> div:first-child": {
                    padding: "15px 15px 10px 15px",
                    color: t.colors.colorPrimary,
                    fontSize: "20px",
                    fontWeight: "bold",
                    img: { margin: 0 },
                    div: { margin: 0 },
                  },
                },
                t.elements.messages.WithButtonsCarouselSwipeItem
              );
            }),
            u = c.b.div.withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselContainer",
              componentId: "sc-11sxy2o-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n,
                r = e.theme;
              return o(
                {
                  position: "relative",
                  left: "-23px",
                  width: "calc(100% + 95px)",
                  margin: "0",
                  paddingBottom: "0",
                  borderRadius: "10px",
                  ".slick-dots": { display: "none !important" },
                  ".slick-track": { display: "flex", flexDirection: "row" },
                  ".slick-slide":
                    ((t = {}),
                    (t["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      maxWidth: "150px !important",
                    }),
                    t),
                  ".slick-slide > div":
                    ((n = {
                      margin: "10px",
                      height: "100%",
                      borderRadius: "10px",
                      transition: "box-shadow .3s",
                    }),
                    (n["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      width: "130px",
                    }),
                    n),
                  ".slick-slide > div > div": {
                    display: "flex !important",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  },
                  ".slick-slider:before": {
                    left: "0",
                    background:
                      "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                  ".slick-slider:after": {
                    right: "0",
                    background:
                      "linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                },
                r.elements.messages.WithButtonsCarouselContainer
              );
            }),
            l = c.b.div.withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselCarouselButton",
              componentId: "sc-11sxy2o-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  "&.hidden": { overflow: "hidden" },
                  padding: "5px 15px",
                  borderRadius: "15px",
                  border: t.colors.white,
                  backgroundColor: t.colors.whiteGradient,
                  fontSize: "0.7rem",
                  transition: "background-color .3s, color .3s",
                  position: "absolute",
                  bottom: 0,
                },
                t.elements.messages.WithButtonsCarouselCarouselButton
              );
            }),
            f = Object(c.b)(l).withConfig({
              displayName: "WithButtonsCarouselstyled__WithButtonsCarouselLeft",
              componentId: "sc-11sxy2o-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { left: "2rem", cursor: "pointer" },
                e.theme.elements.messages.WithButtonsCarouselLeft
              );
            }),
            p = Object(c.b)(l).withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselRight",
              componentId: "sc-11sxy2o-4",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { right: "61px", cursor: "pointer" },
                e.theme.elements.messages.WithButtonsCarouselRight
              );
            }),
            d = c.b.img.withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselImage",
              componentId: "sc-11sxy2o-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  width: "70%",
                  height: "auto",
                  borderRadius: "16px 16px 0 0",
                  display: "inline !important",
                },
                e.theme.elements.messages.WithButtonsCarouselImage
              );
            }),
            h = c.b.div.withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselImageContainer",
              componentId: "sc-11sxy2o-6",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {},
                e.theme.elements.messages.WithButtonsCarouselImageContainer
              );
            }),
            g =
              (c.b.div.withConfig({
                displayName:
                  "WithButtonsCarouselstyled__WithButtonsCarouselValue",
                componentId: "sc-11sxy2o-7",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    display: "inline",
                    float: "right",
                    margin: "1rem",
                    fontWeight: "bold",
                  },
                  e.theme.elements.messages.WithButtonsCarouselValue
                );
              }),
              c.b.div.withConfig({
                displayName:
                  "WithButtonsCarouselstyled__WithButtonsCarouselText",
                componentId: "sc-11sxy2o-8",
              })([".ActionBot &{", "}"], function (e) {
                var t = e.theme,
                  n = e.style;
                return o(
                  o(
                    {
                      float: "center",
                      textAlign: "center",
                      position: "relative",
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      fontSize: "17px",
                      p: { margin: "4px" },
                    },
                    t.elements.messages.WithButtonsCarouselText
                  ),
                  a({ style: n, theme: t })
                );
              }),
              c.b.table.withConfig({
                displayName:
                  "WithButtonsCarouselstyled__WithButtonsCarouselTable",
                componentId: "sc-11sxy2o-9",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    borderSpacing: "5px 1px",
                    borderCollapse: "separate",
                    margin: "15px 12px",
                    "td, p": {
                      fontSize: "14px !important",
                      fontWeight: "normal !important",
                      lineHeight: "20px !important",
                      letterSpacing: "0",
                    },
                    tr: {
                      "td:first-child": {
                        fontWeight: "600 !important",
                        fontSize: "11px !important",
                        textTransform: "uppercase",
                        whiteSpace: "nowrap",
                      },
                      "td:nth-child(2)": {
                        paddingLeft: "5px",
                        lineHeight: "20px !important",
                      },
                    },
                  },
                  e.theme.elements.messages.WithButtonsCarouselTable
                );
              })),
            m = c.b.div.withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselButtonContainer",
              componentId: "sc-11sxy2o-10",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "flex",
                  flexGrow: "1",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  paddingBottom: "10px",
                  paddingTop: "7px",
                },
                e.theme.elements.messages.WithButtonsCarouselButtonContainer
              );
            }),
            b = c.b.div.withConfig({
              displayName:
                "WithButtonsCarouselstyled__WithButtonsCarouselButton",
              componentId: "sc-11sxy2o-11",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme,
                n = e.style;
              return o(
                o(
                  {
                    height: "32px",
                    borderRadius: "100px",
                    fontFamily: " Barlow",
                    fontWeight: "700",
                    fontSize: "12px",
                    color: "#2D63FB",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    cursor: "pointer",
                    margin: "5px 0",
                    width: "200px",
                    padding: "0 20px",
                    maxWidth: "calc(100% - 20px)",
                    p: { textAlign: "center", color: "#fff" },
                    "&:hover": { backgroundColor: "#182B60" },
                  },
                  t.elements.messages.WithButtonsCarouselButton
                ),
                a({ style: n, theme: t })
              );
            });
        },
        Iacx: function (e) {
          "use strict";
          var t = [].slice;
          e.exports = function (e, n) {
            function r() {
              i || ((i = !0), n.apply(null, arguments));
            }
            function o(e) {
              r(null, e);
            }
            var i;
            return function () {
              var n,
                a = t.call(arguments, 0),
                c = e.length > a.length;
              c && a.push(r);
              try {
                n = e.apply(null, a);
              } catch (e) {
                if (c && i) throw e;
                return r(e);
              }
              c ||
                (n && "function" == typeof n.then
                  ? n.then(o, r)
                  : n instanceof Error
                  ? r(n)
                  : o(n));
            };
          };
        },
        J9Ds: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          var a,
            c,
            s,
            u,
            l,
            f,
            p,
            d,
            h,
            g,
            m,
            b,
            y,
            v,
            O,
            w,
            x,
            _,
            j,
            S = {
              breakpoints: { tablet: "1000px", mobile: "576px" },
              fullscreenParams: { baseWidth: 1e3 },
              colors: o(
                {
                  brownGrayTwo: "#9b9b9b",
                  veryLightPink: "#dddddd",
                  white: "#ffffff",
                  whiteGradient: "#eeeeee",
                },
                {
                  colorWhite: "#fff",
                  colorBlack: "#333",
                  colorPrimary: "#1061f7",
                  colorSecondary: "#f20a8b",
                  colorDarkBlue: "#00154e",
                  colorLightBlue: "#6C91FB",
                  colorGray: "#ddd",
                  colorAvatarBg: "#f0f0f0",
                  mainShadow: "rgba(16,97,247,0.5)",
                  boxShadow: "#cccccc",
                }
              ),
              fonts: o({ primary: "Arial" }, { primaryFont: "Barlow" }),
              elements: {
                BotWindow: {},
                BotIcon: {},
                BotMinimizedContainer: {},
                UnreadCounter: {},
                NewMinimizedMessages: {},
                NewMinimizedMessage: {},
                BusyIndicatorElement: {},
                BusyIndicatorContainer: {},
                BusyIndicatorText: {},
                ActionIcon: {},
                HeaderTitle: {},
                HeaderContainer: {},
                HeaderIconContainer: {},
                InitialPopupContainer: {},
                InitialPopupClose: {},
                InitialPopupResize: {},
                InitialPopupHeader: {},
                InitialPopupButton: {},
                InitialPopupImage: {},
                MenuContainer: {},
                MenuIcon: {},
                MenuModal: {},
                MenuBoxContainer: {},
                MenuBox: {},
                MessageInput: {},
                InputContainer: {},
                AddAttachment: {},
                AddAttachmentInput: {},
                messages: {
                  AttachmentContainer: {},
                  AttachmentWrapper: {},
                  AttachmentImageWrapper: {},
                  AttachmentImage: {},
                  AttachmentImageFile: {},
                  AttachmentFileIcon: {},
                  AttachmentUrlWrapperComponentA: {},
                  AttachmentFileInfo: {},
                  AttachmentFileInfoName: {},
                  AttachmentFileInfoSize: {},
                  AttachmentSending: {},
                  AttachmentSendingAbort: {},
                  Button: {},
                  ButtonTitle: {},
                  ButtonContainer: {},
                  ModernSwipeItem: {},
                  ModernCarouselContainer: {},
                  ModernCarouselButton: {},
                  ModernCarouselButtonLeft: {},
                  ModernCarouselButtonRight: {},
                  ModernCarouselImage: {},
                  ModernCarouselValue: {},
                  ClickFix: {},
                  ModernCarouselTitle: {},
                  PostcardSwipeItem: {},
                  PostcardCarouselContainer: {},
                  PostcardCarouselButton: {},
                  PostcardCarouselButtonLeft: {},
                  PostcardCarouselButtonRight: {},
                  PostcardCarouselImage: {},
                  PostcardCarouselValue: {},
                  ClickField: {},
                  PostcardCarouselTitle: {},
                  ShopSwipeItem: {},
                  ShopCarouselContainer: {},
                  ShopCarouselButton: {},
                  ShopCarouselButtonLeft: {},
                  ShopCarouselButtonRight: {},
                  ShopCarouselImage: {},
                  ShopCarouselValue: {},
                  ShopCarouselTitle: {},
                  SwipeItem: {},
                  CarouselContainer: {},
                  CarouselButton: {},
                  StandardCarouselButtonLeft: {},
                  StandardCarouselButtonRight: {},
                  StandardCarouselImage: {},
                  StandardCarouselValue: {},
                  StandardCarouselTitle: {},
                  WithButtonsCarouselSwipeItem: {},
                  WithButtonsCarouselContainer: {},
                  WithButtonsCarouselCarouselButton: {},
                  WithButtonsCarouselLeft: {},
                  WithButtonsCarouselRight: {},
                  WithButtonsCarouselImage: {},
                  WithButtonsCarouselImageContainer: {},
                  WithButtonsCarouselValue: {},
                  WithButtonsCarouselText: {},
                  WithButtonsCarouselTable: {},
                  WithButtonsCarouselButtonContainer: {},
                  WithButtonsCarouselButton: {},
                  EmbeddedMapContainer: {},
                  FormContainer: {},
                  FormWrapper: {},
                  FormHeader: {},
                  FormButton: {},
                  FormLabel: {},
                  FormInput: {},
                  FormFields: {},
                  Form: {},
                  GifImage: {},
                  IconGrid: {
                    IconGridContainer: {},
                    GridLabel: {},
                    GridContainer: {},
                    GridItem: {},
                  },
                  ImageFullScreen: {},
                  ImageContainer: {},
                  ImageWrapper: {},
                  ImageTitle: {},
                  ImageDescription: {},
                  Image: {},
                  MessageMenu: {
                    MenuContainer: {},
                    MenuBoxContainer: {},
                    MenuBox: {},
                  },
                  Messages: {},
                  MessageContainer: {},
                  MessageWrapper: {},
                  MessagesGroupAvatar: {},
                  MessagesGroup: {},
                  MessagesWithAvatar: {},
                  MessagesGroupMessages: {},
                  MessagesGroupDate: {},
                  OptionButton: {},
                  OptionTitle: {},
                  OptionContainer: {},
                  OptionWrapper: {},
                  Survey: {},
                  SurveyDescription: {},
                  SurveyButton: {},
                  TextContainer: {},
                  TextWrapper: {},
                  UserIndicator: {},
                  ThinkingContainer: {},
                  ThinkingMessage: {},
                  VisitingCardButton: {},
                  VisitingCardContainer: {},
                  VisitingCardWrapper: {},
                  YouTubeIframe: {},
                  CalendarContainer: {},
                  CalendarSelectionDatesContainer: {},
                  CalendarNavigationDates: {},
                  CalendarNextDates: {},
                  CalendarPrevDates: {},
                  CalendarDateContainer: {},
                  CalendarHoursContainer: {},
                  CalendarHoursItem: {},
                  CalendarDateItem: {},
                  CalendarDateItemSelected: {},
                  CalendarHoursItemInactive: {},
                  CalendarHoursItemSelected: {},
                  CalendarContainerDisabled: {},
                  TextWithButtonsTextWrapper: {},
                  TextWithButtonsTextButton: {},
                  TextWithButtonsTextButtonList: {},
                  TextWithButtonsButtonWrapper: {},
                  TextWithButtonsUserIndicator: {},
                  TextWithButtonsButtonContent: {},
                  TextButtonListIsButtonActiveHover: {},
                  TextButtonListButtonInactive: {},
                  TextButtonListIsAnyButtonActive: {},
                  TextButtonListIsAnyButtonInactive: {},
                  TextButtonIsButtonActiveHover: {},
                  TextButtonButtonInactive: {},
                  TextButtonIsAnyButtonActive: {},
                  TextButtonIsAnyButtonInactive: {},
                },
                SubmitButtonRtl: {},
                SubmitButton: {},
                SubmitButtonIcon: {},
                PoweredBy: {},
                ModalBackground: {},
                ModalWrapper: {},
                Content: {},
                CloseModal: {},
              },
            },
            k = n("lpWF"),
            C =
              "url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 46 32' style='enable-background:new 0 0 46 32;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;enable-background:new ;%7D .st1%7Bfill:%2300BFB3;%7D .st2%7Bopacity:0.5;fill:%230085CA;enable-background:new ;%7D .st3%7Bopacity:0.5;fill:%235F259F;enable-background:new ;%7D%0A%3C/style%3E%3Cg%3E%3Cpath class='st0' d='M39.2,4.2c-2.6-1.5-5.5-1.9-8.2-1.6C28.7,1,26,0,23,0c-3,0-5.7,1-7.9,2.6c-2.8-0.4-5.7,0.1-8.3,1.6 C0.6,7.8-1.7,15.8,2,22c3.7,6.2,21,10,21,10s17.3-3.8,21-10C47.7,15.8,45.4,7.8,39.2,4.2z'/%3E%3Cg%3E%3Cpath class='st1' d='M36.1,12.9C36.1,20.1,23,32,23,32S9.9,20.1,9.9,12.9S15.8,0,23,0S36.1,5.8,36.1,12.9z'/%3E%3Cpath class='st2' d='M44,22c-3.7,6.2-21,10-21,10s-5.3-16.8-1.7-23S33,0.7,39.2,4.2S47.7,15.8,44,22z'/%3E%3Cpath class='st3' d='M24.8,9c3.6,6.2-1.7,23-1.7,23S5.7,28.2,2,22S0.6,7.8,6.9,4.2S21.1,2.8,24.8,9z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\");",
            P = {
              colorWhite: "#fff",
              colorBlack: "#333",
              colorPrimary: "#002d5c",
              colorSecondary: "#002857",
              colorDarkBlue: "#00154e",
              colorLightBlue: "#002d5c",
              colorGray: "#ddd",
              colorAvatarBg: "#e7e9ff",
              mainShadow: "#ccc",
              boxShadow: "#cccccc",
              buttonBackground: "#5f259f",
              text: "#5f259f",
              textBackground: "#e7e9ff",
            },
            A = "Stilu !important",
            I = "1000px",
            T = "576px";
          t.a =
            ((_ = {
              colors: P,
              fonts: { primary: A },
              elements: {
                BotWindow:
                  ((a = {
                    "&.maximized": { transform: "translateY(0px)", opacity: 1 },
                    "&.minimized": {
                      transform: "translateY(15px)",
                      opacity: 0,
                      visibility: "hidden",
                    },
                    transition: "all .3s",
                    transitionTimingFunction: "ease-in-out",
                    borderRadius: "20px",
                    overflow: "hidden",
                    background: P.colorWhite,
                    boxShadow: "10px 10px 18px rgb(87, 87, 87, 0.25)",
                    "p, ul, ol, li, span": {
                      fontFamily: A,
                      fontSize: "inherit",
                      fontWeight: "inherit",
                      lineHeight: "inherit",
                      color: "inherit",
                    },
                    "&.rtl": {
                      ".scroll--content": {
                        marginRight: "0",
                        "> div > div.bot > div.bot > div.bot": {
                          right: "10px",
                          left: "auto",
                        },
                        "> div > div.user > div.user > div.user": {
                          right: "auto",
                          left: "10px",
                        },
                      },
                      ".scroll--bar": { right: "auto", left: "0" },
                      "> div:first-child": {
                        "&:before": { left: "auto", right: "15px" },
                        "> div:first-child": { padding: "0 55px 0 0" },
                      },
                      iframe: { left: "auto", right: "-20px" },
                    },
                    zIndex: 2147483648,
                    bottom: "120px",
                    right: "40px",
                    width: "315px",
                    maxHeight: "605px",
                    height: "80%",
                  }),
                  (a["@media (max-width: " + I + ")"] = { bottom: "160px" }),
                  (a["@media (max-width: 576px)"] = {
                    position: "fixed",
                    top: "0",
                    left: "0",
                    right: "0",
                    width: "100%",
                    height: "100%",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    borderRadius: "0",
                    transform: "none",
                  }),
                  a),
                HeaderContainer:
                  ((c = {
                    position: "relative",
                    zIndex: "1",
                    minHeight: "50px",
                    boxShadow: "0 5px 10px rgba(0,0,0, .2)",
                    background: P.colorPrimary,
                    cursor: "default",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: "8px",
                      left: "20px",
                      display: "block",
                      height: "34px",
                      width: "34px",
                      backgroundImage: C,
                      backgroundSize: "contain",
                      backgroundPosition: "center center",
                      backgroundRepeat: "no-repeat",
                    },
                  }),
                  (c["@media (max-width: " + T + ")"] = {
                    minHeight: "30px",
                    "&::before": {
                      top: "20px",
                      left: "28px",
                      height: "40px",
                      width: "35px",
                    },
                  }),
                  c),
                HeaderTitle:
                  ((s = {
                    padding: "0 0 0 35px",
                    fontFamily: "dinpro !important",
                    fontSize: "20px",
                    fontWeight: "600",
                    lineHeight: "130%",
                    whiteSpace: "pre-wrap",
                    textAlign: "left",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    color: P.colorWhite,
                    marginLeft: "15px",
                  }),
                  (s["@media (max-width: " + T + ")"] = {
                    padding: "0 40px 0 40px",
                    fontSize: "18px",
                    lineHeight: "110%",
                  }),
                  s),
                ActionIcon:
                  ((u = {
                    position: "relative",
                    width: "15px",
                    height: "15px",
                    opacity: "1",
                    display: "none",
                    img: { display: "none" },
                    "&:after": {
                      content: '""',
                      position: "absolute",
                      top: "13px",
                      height: "2px",
                      width: "24px",
                      backgroundColor: "white",
                      left: "-8px",
                      color: P.colorWhite,
                      fontSize: "36px",
                      lineHeight: "15px",
                      fontWeight: "normal",
                      transition: "color .3s",
                    },
                    "&:hover:after": { opacity: 0.75 },
                  }),
                  (u["@media (max-width: " + T + ")"] = {
                    width: "25px",
                    height: "25px",
                    display: "block",
                    "&:after": { fontSize: "60px" },
                  }),
                  u),
                BotIcon: {},
                BotMinimizedContainer:
                  ((l = {
                    display: "block",
                    position: "fixed",
                    bottom: "44px",
                    right: "30px",
                    padding: "0",
                    width: "68px",
                    height: "68px",
                    cursor: "pointer",
                    backgroundColor: "white",
                    backgroundSize: "40px 40px",
                    backgroundPosition: "10px",
                    borderRadius: "50%",
                    boxShadow: "10px 10px 18px rgb(87, 87, 87, 0.25)",
                    transition: "opacity .3s",
                    zIndex: 9999999999,
                  }),
                  (l["@media (max-width: " + I + ")"] = { bottom: "65px" }),
                  (l.p = { display: "none" }),
                  (l.span = {
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                  }),
                  l),
                UnreadCounter: {},
                NewMinimizedMessages: {},
                NewMinimizedMessage: {},
                InputContainer:
                  ((f = {
                    height: "auto",
                    minHeight: "55px",
                    borderRadius: "15px",
                    zIndex: "1",
                    boxShadow: "0px -6px 22px rgb(87,87,87,0.25)",
                    overflow: "hidden",
                    backgroundColor: "transparent",
                    padding: "5px 12px 40px 12px",
                    margin: 0,
                  }),
                  (f.borderRadius = 0),
                  (f["@media (max-width: " + T + ")"] = {
                    minHeight: "51px",
                    padding: "5px 12px 34px 12px",
                  }),
                  f),
                SubmitButton:
                  ((p = {
                    width: "35px",
                    height: "35px",
                    backgroundColor: P.colorLightBlue,
                    backgroundImage:
                      "url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 23 23' style='enable-background:new 0 0 23 23;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D%0A%3C/style%3E%3Cg%3E%3Cpath class='st0' d='M21.6,1.4c-0.1-0.1-0.3-0.2-0.5-0.1L1.5,9.8c-0.2,0.1-0.3,0.4-0.2,0.6c0,0.1,0.1,0.2,0.2,0.2l7.8,3.1l3.1,7.8 c0.1,0.2,0.3,0.3,0.6,0.2c0.1,0,0.2-0.1,0.2-0.2l8.5-19.6C21.8,1.7,21.8,1.5,21.6,1.4z'/%3E%3Cline class='st0' x1='21.6' y1='1.4' x2='9.3' y2='13.7'/%3E%3Cline class='st0' x1='3.5' y1='19.5' x2='6.8' y2='16.2'/%3E%3Cline class='st0' x1='2.1' y1='16.4' x2='3.7' y2='14.8'/%3E%3Cline class='st0' x1='7.5' y1='20' x2='8.2' y2='19.3'/%3E%3C/g%3E%3C/svg%3E%0A\")",
                    backgroundSize: "20px 20px",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    opacity: 1,
                    transition: "background-color 0.2s",
                    borderRadius: "100%",
                    marginLeft: "18px",
                    marginTop: "10px",
                    img: { display: "none" },
                  }),
                  (p["@media (max-width: " + T + ")"] = {
                    width: "45px",
                    backgroundSize: "25px 25px",
                    height: "45px",
                    marginTop: "2px",
                  }),
                  p),
                PoweredBy: {
                  fontFamily: "Stilu !important",
                  color: "#858a8e",
                  marginTop: "95px !important",
                  padding: "8px !important",
                  backgroundColor: "#f7f7f7",
                  textAlign: " center",
                  fontSize: "10px !important",
                  position: "absolute",
                  width: "100%",
                  bottom: "0",
                  left: "0",
                  height: "30px",
                  borderTop: "unset",
                  zIndex: 99,
                  a: {
                    color: "#002d5c",
                    textDecoration: "none",
                    fontWeight: "500",
                    paddingLeft: "3px",
                  },
                },
                MessageInput:
                  ((d = {
                    padding: "7px",
                    width: "calc(100% - 60px)",
                    maxHeight: "45px",
                    backgroundColor: "transparent",
                    color: P.colorDarkBlue,
                    fontSize: "15px",
                    height: "45px",
                    paddingBottom: "0px",
                    lineHeight: 1.5,
                    paddingTop: "15px",
                    marginBottom: "0px",
                    "&:placeholder-shown + button": {
                      backgroundColor: P.boxShadow,
                    },
                    "&::placeholder": {
                      color: P.colorBlack,
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      opacity: ".6",
                      transition: "opacity .2s",
                      lineHeight: 1.4,
                    },
                    "&:focus::placeholder": { opacity: 0 },
                  }),
                  (d["@media (max-width: " + T + ")"] = {
                    width: "calc(100% - 80px)",
                    fontSize: "16px",
                    paddingTop: "12px",
                    lineHeight: 1.3,
                    "&::placeholder": { paddingLeft: "12px", fontSize: "16px" },
                  }),
                  d),
                messages: {
                  MessageContainer: { paddingRight: 0, borderRadius: "10px" },
                  Messages: {
                    marginTop: "0",
                    fontWeight: "normal",
                    padding: "20px 0",
                    background: P.colorWhite,
                    borderRight: "10px solid white",
                    scrollbarColor: "dark",
                    scrollbarWidth: "thin",
                    "&::-webkit-scrollbar": { width: "8px" },
                    "&::-webkit-scrollbar-thumb": {
                      background: P.colorGray,
                      borderRadius: "4px",
                    },
                  },
                  MessagesGroup: {
                    display: "block",
                    animationName: "showMessage",
                    animationDuration: ".3s",
                    animationIterationCount: "1",
                  },
                  MessagesWithAvatar: {
                    position: "relative",
                    display: "block",
                    padding: "10px 20px 10px 20px",
                    "&.bot, &.agent": {
                      marginLeft: "5px",
                      "> div > div": { alignItems: "flex-start" },
                    },
                    "&.user": {
                      marginRight: "5px",
                      textAlign: "right",
                      div: { color: P.colorPrimary },
                    },
                    "&.system": {
                      "div > div > div": {
                        fontSize: "14px",
                        color: "black",
                        backgroundColor: P.colorAvatarBg,
                        boxShadow: "0 0 4px#cccccc",
                        padding: "6px 16px",
                        lineHeight: "17px",
                        maxWidth: "270px",
                        p: {
                          paddingLeft: "28px",
                          "&::before": {
                            content: "''",
                            position: "absolute",
                            left: "10px",
                            top: "50%",
                            backgroundColor: P.colorPrimary,
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            fontSize: "18px",
                            transform: "translateY(-50%)",
                          },
                          "&::after": {
                            content: "''",
                            position: "absolute",
                            left: "20px",
                            top: "50%",
                            width: "6px",
                            height: "10px",
                            borderBottom: "2px solid white",
                            borderRight: "2px solid white",
                            transform: "translateY(-60%) rotate(45deg)",
                          },
                        },
                      },
                    },
                  },
                  MessagesGroupAvatar:
                    ((h = {
                      position: "absolute",
                      zIndex: "100",
                      top: "0px",
                      left: "0px",
                      width: "35px",
                      height: "35px",
                      minWidth: "35px",
                      minHeight: "35px",
                      margin: "0",
                      backgroundColor: P.colorAvatarBg,
                      backgroundPosition: "5px center",
                      backgroundSize: "26px 26px",
                      backgroundRepeat: "no-repeat",
                    }),
                    (h["@media (max-width: " + T + ")"] = {
                      width: "45px",
                      height: "45px",
                      backgroundSize: "25px 25px",
                      backgroundPosition: "9px center",
                    }),
                    (h["&:not(.agent)"] = { backgroundImage: C }),
                    (h["&.agent"] = {
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }),
                    (h["&.user"] = {
                      right: "10px",
                      left: "auto",
                      backgroundColor: P.colorAvatarBg,
                      backgroundImage: "none",
                      textAlign: "center",
                      "&:after": {
                        content: '"U"',
                        left: "auto",
                        backgroundImage: "none",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "25px",
                        lineHeight: "45px",
                        color: P.colorPrimary,
                      },
                    }),
                    h),
                  TextContainer: { alignItems: "end" },
                  MessagesGroupDate: { display: "none" },
                  TextWrapper:
                    ((g = {
                      padding: "7px 20px",
                      borderRadius: "20px 2px 20px 20px",
                      color: P.colorSecondary,
                      fontSize: "15px",
                      fontWeight: "light",
                      lineHeight: "130%",
                      maxWidth: "90%",
                      boxShadow: "10px 10px 18px rgb(87, 87, 87,0.25)",
                      p: {
                        textAlign: "left",
                        overflowWrap: "anywhere",
                        margin: "10px 0",
                      },
                      a: { textDecoration: "underline" },
                    }),
                    (g["@media (max-width: " + T + ")"] = { fontSize: "16px" }),
                    (g["&.user"] = { background: P.colorWhite }),
                    (g["&.agent"] = { background: P.colorAvatarBg }),
                    (g["&.bot"] = {
                      borderRadius: "2px 20px 20px 20px !important",
                      backgroundColor: P.textBackground + " !important",
                      boxShadow: "unset",
                      p: { color: P.text + " !important" },
                    }),
                    g),
                  ThinkingContainer: { marginTop: "0" },
                  ThinkingMessage: {
                    minWidth: "74px",
                    minHeight: "32px",
                    borderRadius: "0 10px 10px 15px",
                    color: P.colorPrimary,
                    background: P.textBackground,
                    boxShadow: "unset",
                    "&:after":
                      ((m = {
                        display: "inline-block",
                        animation: "dotty steps(1, end) 1s infinite",
                        content: '""',
                        letterSpacing: "2px",
                        color: "#5F259F",
                        fontWeight: "600",
                        fontSize: "16px",
                        marginLeft: "10px",
                      }),
                      (m["@media (max-width: " + T + ")"] = {
                        marginLeft: "15px",
                      }),
                      m),
                    "*": { display: "none" },
                  },
                  ImageContainer: { marginTop: "0" },
                  ImageWrapper: {
                    padding: "0",
                    width: "100%",
                    maxWidth: "initial",
                    borderRadius: "10px",
                    overflow: "hidden",
                    background: "transparent",
                  },
                  Image: {
                    width: "100%",
                    maxWidth: "initial",
                    maxHeight: "initial",
                  },
                  OptionContainer: {},
                  OptionWrapper: {
                    display: "flex",
                    flexWrap: "wrap",
                    margin: "0",
                    padding: "10px 0 0 0",
                    flexDirection: "column",
                    width: "auto",
                    alignSelf: "center",
                    borderRadius: "0",
                    background: "transparent",
                    transform: "translateX(-10px)",
                  },
                  OptionTitle: {
                    marginTop: "10px",
                    fontSize: "16px",
                    color: P.colorSecondary,
                    flex: "0 100%",
                  },
                  OptionButton:
                    ((b = {
                      flex: "0 calc(50% - 10px)",
                      margin: "4px 5px",
                      padding: "5px 18px",
                      borderRadius: "20px",
                      border: "2px solid " + P.text,
                      backgroundColor: P.colorWhite,
                      color: P.text,
                      fontFamily: A,
                      fontSize: "14px",
                      fontWeight: "light",
                      lineHeight: 1.3,
                      transition:
                        "background-color .3s, color .3s, opacity .3s",
                      boxShadow: "unset",
                      "&:not(:disabled):hover": {
                        color: P.colorWhite,
                        backgroundColor: P.text,
                      },
                      "&:disabled": { opacity: ".6" },
                    }),
                    (b["@media (max-width: " + T + ")"] = {
                      flex: "0 calc(50% - 30px)",
                      margin: "9px 15px",
                      fontSize: "16px",
                    }),
                    b),
                  VisitingCardContainer: {},
                  VisitingCardWrapper: {
                    display: "flex",
                    flexWrap: "wrap",
                    margin: "0",
                    padding: "10px 0",
                    width: "100%",
                    borderRadius: "0",
                    background: "transparent",
                  },
                  VisitingCardButton:
                    ((y = {
                      flex: "0 calc(50% - 10px)",
                      margin: "2px 5px",
                      padding: "5px 15px",
                      borderRadius: "15px",
                      border: "1px solid " + P.colorSecondary,
                      backgroundColor: P.colorWhite,
                      color: P.colorSecondary,
                      boxShadow: "0 0 10px " + P.boxShadow,
                      fontSize: "14px",
                      fontWeight: "light",
                      transition:
                        "background-color .3s, color .3s, opacity .3s",
                      "&:not(:disabled):hover": {
                        color: P.colorWhite,
                        backgroundColor: P.colorPrimary,
                        borderColor: P.colorPrimary,
                      },
                      "&:disabled": { opacity: ".6" },
                    }),
                    (y["@media (max-width: " + T + ")"] = {
                      flex: "0 calc(50% - 30px)",
                      margin: "5px 15px",
                      fontSize: "18px",
                    }),
                    y),
                  CarouselContainer: {
                    position: "relative",
                    left: "-25px",
                    width: "calc(100% + 45px)",
                    margin: "0",
                    paddingBottom: "0",
                    borderRadius: "10px",
                    ".slick-dots": { display: "none !important" },
                    ".slick-track": { display: "flex", flexDirection: "row" },
                    ".slick-slide":
                      ((v = {}),
                      (v["@media (max-width: " + T + ")"] = {
                        maxWidth: "150px !important",
                      }),
                      v),
                    ".slick-slide > div":
                      ((O = {
                        margin: "10px",
                        height: "100%",
                        borderRadius: "10px",
                        transition: "box-shadow .3s",
                        "&:hover": { boxShadow: "0 0 0 2px " + P.colorPrimary },
                      }),
                      (O["@media (max-width: " + T + ")"] = { width: "130px" }),
                      O),
                    ".slick-slide > div > div": {
                      display: "flex !important",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    },
                    ".slick-slider:before, .slick-slider:after": {
                      content: '""',
                      position: "absolute",
                      zIndex: 10,
                      top: "0",
                      bottom: "0",
                      width: "15px",
                      pointerEvents: "none",
                    },
                    ".slick-slider:before": {
                      left: "0",
                      background:
                        "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                    },
                    ".slick-slider:after": {
                      right: "0",
                      background:
                        "linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                    },
                  },
                  SwipeItem:
                    ((x = {
                      float: "none",
                      margin: "0",
                      height: "140px",
                      borderRadius: "10px",
                      border: "none",
                      background: P.colorWhite,
                      color: P.carousel,
                      cursor: "move",
                      boxShadow: "0 0 10px " + P.boxShadow,
                      "> div:first-child": {
                        padding: "15px 15px 10px 15px",
                        color: P.colorPrimary,
                        fontSize: "20px",
                        fontWeight: "bold",
                        img: { margin: 0 },
                        div: { margin: 0 },
                      },
                      "> div:last-child":
                        ((w = {
                          padding: "10px",
                          textAlign: "left !important",
                          color: P.colorDarkBlue,
                          fontWeight: "bold",
                          "> p:first-child": {
                            marginBottom: "6px",
                            fontSize: "12px",
                            lineHeight: "100%",
                          },
                          "> p:last-child": {
                            fontSize: "14px",
                            fontWeight: "normal",
                            lineHeight: "16px",
                          },
                        }),
                        (w["@media (max-width: " + T + ")"] = {
                          padding: "0 10px 10px 10px",
                        }),
                        w),
                    }),
                    (x["@media (max-width: " + T + ")"] = {
                      width: "130px !important",
                      height: "130px",
                    }),
                    x),
                  CarouselButton: { display: "none" },
                  StandardCarouselButtonLeft: {},
                  StandardCarouselButtonRight: {},
                  StandardCarouselImage: {},
                  StandardCarouselValue: {},
                  StandardCarouselTitle: {},
                  EmbeddedMapContainer: {
                    position: "relative",
                    left: "-25px",
                    width: "calc(100% + 45px)",
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                },
              },
            }),
            Object(k.a)(
              S,
              _,
              (null == (j = window.__actionBot) ? void 0 : j.theme) || {}
            ));
        },
        JAS9: function (e, t, n) {
          "use strict";
          var r = n("1hwd"),
            o = n("2shm");
          e.exports = function () {
            var e,
              t = String(this.file),
              n = { line: 1, column: 1, offset: 0 },
              a = r(n);
            return (
              65279 === (t = t.replace(i, "\n")).charCodeAt(0) &&
                ((t = t.slice(1)), a.column++, a.offset++),
              (e = {
                type: "root",
                children: this.tokenizeBlock(t, a),
                position: { start: n, end: this.eof || r(n) },
              }),
              this.options.position || o(e, !0),
              e
            );
          };
          var i = /\r\n|\r/g;
        },
        JODt: function (e, t, n) {
          "use strict";
          n.d(t, "a", function () {
            return o;
          });
          var r = n("UFfw"),
            o = function (e) {
              return [
                "ar",
                "ar-AE",
                "ar-BH",
                "ar-DZ",
                "ar-EG",
                "ar-IQ",
                "ar-JO",
                "ar-KW",
                "ar-LB",
                "ar-LY",
                "ar-MA",
                "ar-OM",
                "ar-QA",
                "ar-SA",
                "ar-SY",
                "ar-TN",
                "ar-YE",
                "az",
                "az-AZ",
                "dv",
                "dv-MV",
                "he",
                "he-IL",
                "syr",
                "syr-SY",
                "ur",
                "ur-PK",
              ].includes(e || Object(r.a)());
            };
        },
        JcKE: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("SzEY"),
              o = n("a0t2"),
              i = n("e9nE"),
              a = n("c5l3"),
              c = n("Pscf"),
              s = n("keud"),
              u = n("ITsB");
            t.a = function (t) {
              var n = t.minimize,
                l = Object(s.b)().config,
                f = l.PUBLIC.header.title,
                p = new (0, Object(u.b)().ThemeService)(),
                d = Object(s.b)().fullScreen.value;
              return e(
                a.a,
                null,
                e(a.c, null, f),
                e(
                  a.b,
                  null,
                  l.PUBLIC.fullscreen.enabled &&
                    e("img", {
                      onClick: function () {
                        return p.setFullScreen(!d);
                      },
                      src: d ? i.a : o.a,
                    }),
                  e(c.a, { onClick: n, src: r.a })
                )
              );
            };
          }).call(this, n("hosL").h);
        },
        JgMK: function (e) {
          "use strict";
          e.exports = function (e) {
            return String(e).replace(/\n+$/, "");
          };
        },
        "K/5M": function (e, t, n) {
          "use strict";
          t.a = n.p + "883fe1a405f7592757b6a97abe6c3ace.svg";
        },
        KJEC: function (e, t, n) {
          "use strict";
          t.a = n.p + "606904a2e81f0311ef91d7d1c32266db.svg";
        },
        KeAI: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            for (var r, o = t.length, i = -1, a = ""; ++i < o; ) {
              if ("\n" === (r = t.charAt(i))) {
                if (i < 2) return;
                return !!n || e((a += r))({ type: "break" });
              }
              if (" " !== r) return;
              a += r;
            }
          }
          var o = n("j+JB");
          (e.exports = r), (r.locator = o);
        },
        KhCN: function (e, t, n) {
          "use strict";
          var r = n("U/Op");
          e.exports = function (e, t, n) {
            var o,
              i,
              a,
              c,
              s = t.charAt(0);
            if ("\n" === s) {
              if (n) return !0;
              for (
                c = 1, o = t.length, i = s, a = "";
                c < o && ((s = t.charAt(c)), r(s));

              )
                (a += s), "\n" === s && ((i += a), (a = "")), c++;
              e(i);
            }
          };
        },
        Khqb: function () {},
        KsPC: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              c,
              s,
              u,
              l,
              f,
              p,
              d = 0,
              h = t.charAt(d);
            if (
              !(
                ("*" !== h && "_" !== h) ||
                ((l = h),
                (s = h),
                (f = t.length),
                d++,
                (u = ""),
                (h = ""),
                (c = this.options.pedantic) && a(t.charAt(d)))
              )
            )
              for (; d < f; ) {
                if (((p = h), !((h = t.charAt(d)) !== s || (c && a(p))))) {
                  if ((h = t.charAt(++d)) !== s) {
                    if (!o(u) || p === s) return;
                    if (!c && "_" === s && i(h)) {
                      u += s;
                      continue;
                    }
                    return (
                      !!n ||
                      ((r = e.now()).column++,
                      r.offset++,
                      e(l + u + s)({
                        type: "emphasis",
                        children: this.tokenizeInline(u, r),
                      }))
                    );
                  }
                  u += s;
                }
                c || "\\" !== h || ((u += h), (h = t.charAt(++d))),
                  (u += h),
                  d++;
              }
          }
          var o = n("VNWY"),
            i = n("0rCs"),
            a = n("U/Op"),
            c = n("IL5K");
          (e.exports = r), (r.locator = c);
        },
        L16Z: function (e, t, n) {
          "use strict";
          function r(e, t) {
            return (r =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function o(e, t) {
            return (o =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          n.r(t),
            n.d(t, "AdapterService", function () {
              return a;
            }),
            n.d(t, "MarkdownService", function () {
              return c.a;
            }),
            n.d(t, "ActionsService", function () {
              return s;
            });
          var i = n("bov0"),
            a = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t =
                    e.call.apply(e, [this].concat(r)) ||
                    this).resolveOptionBasedType = function (e) {
                    var t = e.message,
                      n = e.getOptionsAsObject;
                    switch (e.singleGeneric.title) {
                      case "sendEmail":
                        return (t.content = n()), (t.isAction = !0), t;
                      default:
                        return !1;
                    }
                  }),
                  t
                );
              }
              var n, o;
              return (
                (o = e),
                ((n = t).prototype = Object.create(o.prototype)),
                (n.prototype.constructor = n),
                r(n, o),
                t
              );
            })(i.b),
            c = n("aWFM"),
            s = (function (e) {
              function t() {
                return e.apply(this, arguments) || this;
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                o(n, r),
                (t.prototype.sendEmail = function (e) {
                  console.log("sendEmail", e);
                  var t = e.content;
                  fetch(window.location.href + "actionBotMessage", {
                    method: "POST",
                    body: JSON.stringify({
                      contactSubject: t.subject,
                      contactMessage: t.message,
                      contactEmail: t.email,
                    }),
                  });
                }),
                t
              );
            })(i.a);
        },
        L7zD: function (e) {
          function t(e) {
            (this.options = e), !e.deferSetup && this.setup();
          }
          (t.prototype = {
            constructor: t,
            setup: function () {
              this.options.setup && this.options.setup(),
                (this.initialised = !0);
            },
            on: function () {
              !this.initialised && this.setup(),
                this.options.match && this.options.match();
            },
            off: function () {
              this.options.unmatch && this.options.unmatch();
            },
            destroy: function () {
              this.options.destroy ? this.options.destroy() : this.off();
            },
            equals: function (e) {
              return this.options === e || this.options.match === e;
            },
          }),
            (e.exports = t);
        },
        LO0j: function (e, t, n) {
          "use strict";
          function r(e) {
            return (
              (function (e) {
                if (Array.isArray(e)) {
                  for (var t = 0, n = new Array(e.length); t < e.length; t++)
                    n[t] = e[t];
                  return n;
                }
              })(e) ||
              (function (e) {
                if (
                  Symbol.iterator in Object(e) ||
                  "[object Arguments]" === Object.prototype.toString.call(e)
                )
                  return Array.from(e);
              })(e) ||
              (function () {
                throw new TypeError(
                  "Invalid attempt to spread non-iterable instance"
                );
              })()
            );
          }
          function o(e, t) {
            return Array.isArray(t) ? e.use.apply(e, r(t)) : e.use(t);
          }
          var i = n("1hwd"),
            a = n("w6Nv"),
            c = n("yAYQ"),
            s = n("W0B4"),
            u = n("unVz"),
            l = n("gxcY"),
            f = n("N//3"),
            p = n("XmUT"),
            d = n("7kD2"),
            h = n("26+u"),
            g = n("GZPr"),
            m = n("3d/4"),
            b = n("8UgC"),
            y = Object.keys(m),
            v = function (e) {
              var t = e.source || e.children || "",
                n = e.parserOptions;
              if (e.allowedTypes && e.disallowedTypes)
                throw new Error(
                  "Only one of `allowedTypes` and `disallowedTypes` should be defined"
                );
              var r = i(m, e.renderers),
                s = [[c, n]].concat(e.plugins || []).reduce(o, a()),
                g = s.parse(t),
                v = i(e, { renderers: r, definitions: h(g) }),
                O = (function (e) {
                  var t = [d, u()],
                    n = e.disallowedTypes;
                  e.allowedTypes &&
                    (n = y.filter(function (t) {
                      return "root" !== t && -1 === e.allowedTypes.indexOf(t);
                    }));
                  var r = e.unwrapDisallowed ? "unwrap" : "remove";
                  n && n.length > 0 && t.push(f.ofType(n, r)),
                    e.allowNode && t.push(f.ifNotMatch(e.allowNode, r));
                  var o = !e.escapeHtml && !e.skipHtml,
                    i = (e.astPlugins || []).some(function (e) {
                      return (
                        (Array.isArray(e) ? e[0] : e).identity === b.HtmlParser
                      );
                    });
                  return (
                    o && !i && t.push(l),
                    e.astPlugins ? t.concat(e.astPlugins) : t
                  );
                })(e),
                w = s.runSync(g),
                x = O.reduce(function (e, t) {
                  return t(e, v);
                }, w);
              return p(x, v);
            };
          (v.defaultProps = {
            renderers: {},
            escapeHtml: !0,
            skipHtml: !1,
            sourcePos: !1,
            rawSourcePos: !1,
            transformLinkUri: g,
            astPlugins: [],
            plugins: [],
            parserOptions: {},
          }),
            (v.propTypes = {
              className: s.string,
              source: s.string,
              children: s.string,
              sourcePos: s.bool,
              rawSourcePos: s.bool,
              escapeHtml: s.bool,
              skipHtml: s.bool,
              allowNode: s.func,
              allowedTypes: s.arrayOf(s.oneOf(y)),
              disallowedTypes: s.arrayOf(s.oneOf(y)),
              transformLinkUri: s.oneOfType([s.func, s.bool]),
              linkTarget: s.oneOfType([s.func, s.string]),
              transformImageUri: s.func,
              astPlugins: s.arrayOf(s.func),
              unwrapDisallowed: s.bool,
              renderers: s.object,
              plugins: s.array,
              parserOptions: s.object,
            }),
            (v.types = y),
            (v.renderers = m),
            (v.uriTransformer = g),
            (e.exports = v);
        },
        LVvd: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return i;
          });
          var i = n("UutA").b.iframe.withConfig({
            displayName: "YouTubestyled__YouTubeIframe",
            componentId: "sc-1dwsomm-0",
          })([".ActionBot &{", "}"], function (e) {
            return (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      o(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            })(
              { height: "200px", width: "100%" },
              e.theme.elements.messages.YouTubeIframe
            );
          });
        },
        LoPn: function (e, t, n) {
          "use strict";
          function r() {
            var e = new Date().getTime(),
              t =
                (performance && performance.now && 1e3 * performance.now()) ||
                0;
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
              /[xy]/g,
              function (n) {
                var r = 16 * Math.random();
                return (
                  e > 0
                    ? ((r = (e + r) % 16 | 0), (e = Math.floor(e / 16)))
                    : ((r = (t + r) % 16 | 0), (t = Math.floor(t / 16))),
                  ("x" === n ? r : (3 & r) | 8).toString(16)
                );
              }
            );
          }
          function o() {
            return (
              s.getItem("actionbot_uid") || s.setItem("actionbot_uid", r()),
              s.getItem("actionbot_uid")
            );
          }
          function i() {
            Object(c.d)(function () {
              o() || s.setItem("actionbot_uid", r());
            }, []);
          }
          n.d(t, "b", function () {
            return o;
          }),
            n.d(t, "a", function () {
              return i;
            });
          var a = n("svqz"),
            c = n("QRet"),
            s = Object(a.a)("cookies");
        },
        MIYG: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("QRet"),
              o = n("Q2Xs");
            t.a = function (t) {
              var n = t.message,
                i = t.onOptionSelects,
                a = Object(r.k)(!1),
                c = a[0],
                s = a[1];
              if (n.content) {
                var u = n.content,
                  l = Object.keys(u),
                  f = [];
                return (
                  l.forEach(function (t) {
                    var n = u[t];
                    if ("newTab" === t) s("true" === n);
                    else {
                      var r = t.split(";"),
                        a = r.shift(),
                        l = n,
                        p = {};
                      r.forEach(function (e) {
                        var t = e.split("=");
                        p[t[0]] = t[1];
                      }),
                        f.push(
                          e(
                            o.a,
                            {
                              onClick: function () {
                                return (function (e) {
                                  var t = e.url,
                                    n = e.config,
                                    r = !1,
                                    o = !1,
                                    a = n.newTab,
                                    s = n.intent;
                                  a
                                    ? ["true", "false"].includes(a) &&
                                      (r = "true" === a)
                                    : s
                                    ? ["true", "false"].includes(s) &&
                                      (o = "true" === s)
                                    : (r = c),
                                    r
                                      ? window.open(t, "_blank")
                                      : o
                                      ? i(t)
                                      : window.location.assign(t);
                                })({ url: l, config: p });
                              },
                            },
                            a
                          )
                        );
                    }
                  }),
                  e(o.b, { owner: n.owner }, e(o.c, null, f))
                );
              }
            };
          }).call(this, n("hosL").h);
        },
        Me7t: function (e, t, n) {
          "use strict";
          var r = n("YMuc");
          t.a = r.a;
        },
        "N//3": function (e, t, n) {
          "use strict";
          function r(e, t, n, r) {
            if ("remove" === r) n.children.splice(t, 1);
            else if ("unwrap" === r) {
              var o = [t, 1];
              e.children && (o = o.concat(e.children)),
                Array.prototype.splice.apply(n.children, o);
            }
          }
          var o = n("BN5T");
          (t.ofType = function (e, t) {
            function n(e, n, o) {
              o && r(e, n, o, t);
            }
            return function (t) {
              return (
                e.forEach(function (e) {
                  return o(t, e, n, !0);
                }),
                t
              );
            };
          }),
            (t.ifNotMatch = function (e, t) {
              function n(n, o, i) {
                i && !e(n, o, i) && r(n, o, i, t);
              }
              return function (e) {
                return o(e, n, !0), e;
              };
            });
        },
        N0Yk: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("OgK9"),
              o = n("CGuF"),
              i = n("WcAn"),
              a = n("keud"),
              c = n("XAzd"),
              s = n("ITsB"),
              u = n("j5Tj"),
              l = n("QRet");
            t.a = function (t) {
              var n = t.value,
                f = t.onKeyPress,
                p = t.onSubmit,
                d = t.onChange,
                h = t.onOptionSelect,
                g = Object(a.b)().config,
                m = g.PUBLIC.input.maxLength,
                b = g.PUBLIC.menu.enabled,
                y = Object(c.b)(),
                v = Object(a.b)().isInputDisabled.value,
                O = Object(a.b)().remoteConfig.value,
                w = Object(s.b)(),
                x = w.ThemeService,
                _ = w.RemoteConfigService,
                j = new (0, w.ControlService)(),
                S = new x(),
                k = new _(),
                C = Object(l.k)(!0),
                P = C[0],
                A = C[1];
              Object(l.d)(
                function () {
                  A(k.isLoadingActive);
                },
                [O]
              );
              var I = Object(a.b)().fullScreen.value;
              return e(
                o.b,
                { loading: P, className: I ? "fullscreen" : "" },
                e(u.a, null),
                b && e(i.a, { onOptionSelect: h }),
                e(o.a, {
                  type: "text",
                  placeholder: y["messageInput.textarea.placeholder"],
                  maxLength: m,
                  value: n,
                  onChange: d,
                  onKeyDown: f,
                  onPaste: function (e) {
                    d(e);
                  },
                  disabled: v,
                  onFocus: function () {
                    var e = Object(a.b)().scrollToBottomRef.value;
                    window.innerWidth <= S.getMobileBreakpoint() &&
                      e.scrollTop + 200 > e.scrollTopMax &&
                      j.scrollToBottom();
                  },
                }),
                e(r.a, { onClick: p })
              );
            };
          }).call(this, n("hosL").h);
        },
        NFJw: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "c", function () {
            return c;
          }),
            n.d(t, "d", function () {
              return s;
            }),
            n.d(t, "b", function () {
              return u;
            }),
            n.d(t, "a", function () {
              return l;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "MessagesGroupstyled__MessagesGroup",
              componentId: "sc-2c3x5x-0",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  flexDirection: "column",
                  display: "block",
                  animationName: "showMessage",
                  animationDuration: ".3s",
                  animationIterationCount: "1",
                  p: { whiteSpace: "break-spaces" },
                  ul: { listStyle: "disc", paddingLeft: "30px" },
                  ol: { paddingLeft: "30px" },
                },
                e.theme.elements.messages.MessagesGroup
              );
            }),
            s = a.b.div.withConfig({
              displayName: "MessagesGroupstyled__MessagesWithAvatar",
              componentId: "sc-2c3x5x-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  flexDirection: "row",
                  textAlign: "left",
                  position: "relative",
                  display: "block",
                  padding: "20px 20px 10px 20px",
                  "&.bot, &.agent": {
                    marginLeft: "5px",
                    "> div > div": { alignItems: "flex-start" },
                  },
                  "&.user": {
                    flexDirection: "row-reverse",
                    marginRight: "5px",
                    textAlign: "right",
                    div: { color: t.colors.colorPrimary },
                  },
                  "&.system": {
                    justifyContent: "center",
                    "div > div > div": {
                      fontSize: "14px",
                      color: "black",
                      backgroundColor: "#ebebeb",
                      boxShadow: "0 0 4px#cccccc",
                      padding: "6px 16px",
                      lineHeight: "17px",
                      maxWidth: "270px",
                      p: {
                        paddingLeft: "28px",
                        "&::before": {
                          content: "''",
                          position: "absolute",
                          left: "10px",
                          top: "50%",
                          backgroundColor: "#e9008f",
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          fontSize: "18px",
                          transform: "translateY(-50%)",
                        },
                        "&::after": {
                          content: "''",
                          position: "absolute",
                          left: "20px",
                          top: "50%",
                          width: "6px",
                          height: "10px",
                          borderBottom: "2px solid white",
                          borderRight: "2px solid white",
                          transform: "translateY(-60%) rotate(45deg)",
                        },
                      },
                    },
                  },
                },
                t.elements.messages.MessagesWithAvatar
              );
            }),
            u = a.b.div.withConfig({
              displayName: "MessagesGroupstyled__Messages",
              componentId: "sc-2c3x5x-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "flex", flexDirection: "column" },
                e.theme.elements.messages.MessagesGroupMessages
              );
            }),
            l = a.b.p.withConfig({
              displayName: "MessagesGroupstyled__Date",
              componentId: "sc-2c3x5x-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { fontSize: "11px", marginLeft: "15px", marginTop: 0 },
                e.theme.elements.messages.MessagesGroupDate
              );
            });
        },
        NS33: function (e, t, n) {
          "use strict";
          function r() {}
          function o() {}
          var i = n("E02R");
          (o.resetWarningCache = r),
            (e.exports = function () {
              function e(e, t, n, r, o, a) {
                if (a !== i) {
                  var c = new Error(
                    "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
                  );
                  throw ((c.name = "Invariant Violation"), c);
                }
              }
              function t() {
                return e;
              }
              e.isRequired = e;
              var n = {
                array: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                elementType: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t,
                checkPropTypes: o,
                resetWarningCache: r,
              };
              return (n.PropTypes = n), n;
            });
        },
        NgIc: function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.default = void 0);
          t.default = {
            animating: !1,
            autoplaying: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            dragging: !1,
            edgeDragged: !1,
            initialized: !1,
            lazyLoadedList: [],
            listHeight: null,
            listWidth: null,
            scrolling: !1,
            slideCount: null,
            slideHeight: null,
            slideWidth: null,
            swipeLeft: null,
            swiped: !1,
            swiping: !1,
            touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
            trackStyle: {},
            trackWidth: 0,
          };
        },
        Nsjb: function (e, t, n) {
          "use strict";
          var r = n("U/Op");
          e.exports = function (e, t, n) {
            var o,
              i,
              a,
              c,
              s,
              u,
              l,
              f,
              p,
              d,
              h,
              g,
              m,
              b,
              y,
              v,
              O,
              w,
              x,
              _,
              j,
              S,
              k,
              C;
            if (this.options.gfm) {
              for (o = 0, w = 0, u = t.length + 1, l = []; o < u; ) {
                if (
                  ((S = t.indexOf("\n", o)),
                  (k = t.indexOf("|", o + 1)),
                  -1 === S && (S = t.length),
                  -1 === k || k > S)
                ) {
                  if (w < 2) return;
                  break;
                }
                l.push(t.slice(o, S)), w++, (o = S + 1);
              }
              for (
                c = l.join("\n"),
                  o = 0,
                  u = (i = l.splice(1, 1)[0] || []).length,
                  w--,
                  a = !1,
                  h = [];
                o < u;

              ) {
                if ("|" === (p = i.charAt(o))) {
                  if (((d = null), !1 === a)) {
                    if (!1 === C) return;
                  } else h.push(a), (a = !1);
                  C = !1;
                } else if ("-" === p) (d = !0), (a = a || null);
                else if (":" === p)
                  a =
                    "left" === a
                      ? "center"
                      : d && null === a
                      ? "right"
                      : "left";
                else if (!r(p)) return;
                o++;
              }
              if ((!1 !== a && h.push(a), !(h.length < 1))) {
                if (n) return !0;
                for (
                  O = -1,
                    _ = [],
                    j = e(c).reset({ type: "table", align: h, children: _ });
                  ++O < w;

                ) {
                  for (
                    x = l[O],
                      s = { type: "tableRow", children: [] },
                      O && e("\n"),
                      e(x).reset(s, j),
                      u = x.length + 1,
                      o = 0,
                      f = "",
                      g = "",
                      m = !0,
                      b = null,
                      y = null;
                    o < u;

                  )
                    if ("\t" !== (p = x.charAt(o)) && " " !== p) {
                      if ("" === p || "|" === p)
                        if (m) e(p);
                        else {
                          if (p && y) {
                            (f += p), o++;
                            continue;
                          }
                          (!g && !p) ||
                            m ||
                            ((c = g),
                            f.length > 1 &&
                              (p
                                ? ((c += f.slice(0, f.length - 1)),
                                  (f = f.charAt(f.length - 1)))
                                : ((c += f), (f = ""))),
                            (v = e.now()),
                            e(c)(
                              {
                                type: "tableCell",
                                children: this.tokenizeInline(g, v),
                              },
                              s
                            )),
                            e(f + p),
                            (f = ""),
                            (g = "");
                        }
                      else if (
                        (f && ((g += f), (f = "")),
                        (g += p),
                        "\\" === p &&
                          o !== u - 2 &&
                          ((g += x.charAt(o + 1)), o++),
                        "`" === p)
                      ) {
                        for (b = 1; x.charAt(o + 1) === p; ) (g += p), o++, b++;
                        y ? b >= y && (y = 0) : (y = b);
                      }
                      (m = !1), o++;
                    } else g ? (f += p) : e(p), o++;
                  O || e("\n" + i);
                }
                return j;
              }
            }
          };
        },
        O4yG: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              i,
              a,
              c = "",
              s = "",
              u = "",
              l = "";
            if (
              this.options.gfm &&
              "~" === t.charAt(0) &&
              "~" === t.charAt(1) &&
              !o(t.charAt(2))
            )
              for (
                r = 1, i = t.length, (a = e.now()).column += 2, a.offset += 2;
                ++r < i;

              ) {
                if (!("~" !== (c = t.charAt(r)) || "~" !== s || (u && o(u))))
                  return (
                    !!n ||
                    e("~~" + l + "~~")({
                      type: "delete",
                      children: this.tokenizeInline(l, a),
                    })
                  );
                (l += s), (u = s), (s = c);
              }
          }
          var o = n("U/Op"),
            i = n("GTSi");
          (e.exports = r), (r.locator = i);
        },
        OV23: function (e, t, n) {
          "use strict";
          n.d(t, "a", function () {
            return o;
          }),
            n.d(t, "b", function () {
              return i;
            });
          var r = 1,
            o = function (e) {
              var t = e.owner,
                n = e.type,
                o = e.content,
                i = e.isAction,
                a = void 0 !== i && i,
                c = e.id;
              (this.date = void 0),
                (this.owner = void 0),
                (this.type = void 0),
                (this.content = void 0),
                (this.isAction = void 0),
                (this.id = void 0),
                (this.isMessageWithAction = void 0),
                (this.isMessageWithActionDone = void 0),
                (this.description = void 0),
                (this.date = new Date()),
                (this.owner = t),
                (this.type = n),
                (this.content = o),
                (this.isAction = a),
                (this.id = c || new Date().getTime() + ++r);
            },
            i = function (e) {
              var t = e.messages,
                n = e.owner,
                r = e.agentInfo;
              (this.owner = void 0),
                (this.messages = void 0),
                (this.isLastGroup = void 0),
                (this.agentInfo = void 0),
                (this.owner = n),
                (this.messages = t),
                (this.isLastGroup = !0),
                (this.agentInfo = r);
            };
        },
        OgK9: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("8GnK"),
              o = n("keud");
            t.a = function (t) {
              var n = t.onClick,
                i = Object(o.b)();
              return e(
                r.a,
                {
                  onClick: n,
                  disabled: i.isInputDisabled.value || !i.input.value,
                },
                e(r.b, { src: i.config.PUBLIC.submitButton.icon })
              );
            };
          }).call(this, n("hosL").h);
        },
        Ono3: function (e) {
          e.exports = function (e) {
            if (!e.webpackPolyfill) {
              var t = Object.create(e);
              t.children || (t.children = []),
                Object.defineProperty(t, "loaded", {
                  enumerable: !0,
                  get: function () {
                    return t.l;
                  },
                }),
                Object.defineProperty(t, "id", {
                  enumerable: !0,
                  get: function () {
                    return t.i;
                  },
                }),
                Object.defineProperty(t, "exports", { enumerable: !0 }),
                (t.webpackPolyfill = 1);
            }
            return t;
          };
        },
        Oprn: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return c;
          });
          var i = n("UutA"),
            a = n("4hQ3"),
            c = i.b.div.withConfig({
              displayName: "Avatarstyled__Avatar",
              componentId: "sc-10oscv0-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return (function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2
                    ? r(Object(n), !0).forEach(function (t) {
                        o(e, t, n[t]);
                      })
                    : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(
                        e,
                        Object.getOwnPropertyDescriptors(n)
                      )
                    : r(Object(n)).forEach(function (t) {
                        Object.defineProperty(
                          e,
                          t,
                          Object.getOwnPropertyDescriptor(n, t)
                        );
                      });
                }
                return e;
              })(
                (((t = {
                  borderRadius: "100%",
                  backgroundImage: "url(" + e.avatarUrl + ")",
                  position: "absolute",
                  zIndex: "100",
                  top: "0",
                  left: "8px",
                  width: "45px",
                  height: "45px",
                  minWidth: "40px",
                  minHeight: "40px",
                  margin: "0",
                  backgroundColor: n.colors.colorAvatarBg,
                  backgroundPosition: "9px center",
                  backgroundSize: "25px 25px",
                  backgroundRepeat: "no-repeat",
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  width: "45px",
                  height: "45px",
                  backgroundSize: "25px 25px",
                  backgroundPosition: "9px center",
                }),
                (t["&:not(.agent)"] = { backgroundImage: "url(" + a.a + ")" }),
                (t["&.agent"] = {
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }),
                (t["&.user"] = {
                  right: "10px",
                  left: "auto",
                  backgroundColor: n.colors.colorAvatarBg,
                  backgroundImage: "none",
                  textAlign: "center",
                  "&:after": {
                    content: '"U"',
                    left: "auto",
                    backgroundImage: "none",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "25px",
                    lineHeight: "45px",
                    color: n.colors.colorPrimary,
                  },
                }),
                t),
                n.elements.messages.MessagesGroupAvatar
              );
            });
        },
        "Oy/O": function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              a,
              c = e.offset,
              s = e.options.pedantic ? o : i,
              u = null;
            return (
              (t = s.apply(null, arguments)),
              e.options.gfm &&
                (r = t.match(d)) &&
                ((a = r[0].length),
                (u = "x" === r[1].toLowerCase()),
                (c[n.line] += a),
                (t = t.slice(a))),
              {
                type: "listItem",
                loose: p.test(t) || "\n" === t.charAt(t.length - 1),
                checked: u,
                children: e.tokenizeBlock(t, n),
              }
            );
          }
          function o(e, t, n) {
            function r(e) {
              return (o[i] = (o[i] || 0) + e.length), i++, "";
            }
            var o = e.offset,
              i = n.line;
            return (t = t.replace(g, r)), (i = n.line), t.replace(m, r);
          }
          function i(e, t, n) {
            var r,
              o,
              i,
              a,
              s,
              f,
              p,
              d = e.offset,
              g = n.line;
            for (
              a = (t = t.replace(h, function (e, t, n, a, s) {
                return (
                  (o = t + n + a),
                  (i = s),
                  Number(n) < 10 && o.length % 2 == 1 && (n = " " + n),
                  (r = t + c(" ", n.length) + a) + i
                );
              })).split("\n"),
                (s = l(t, u(r).indent).split("\n"))[0] = i,
                d[g] = (d[g] || 0) + o.length,
                g++,
                f = 0,
                p = a.length;
              ++f < p;

            )
              (d[g] = (d[g] || 0) + a[f].length - s[f].length), g++;
            return s.join("\n");
          }
          var a = n("VNWY"),
            c = n("RZNd"),
            s = n("Qfee"),
            u = n("H/Nm"),
            l = n("8QZL"),
            f = n("xZZo");
          e.exports = function (e, t, n) {
            for (
              var o,
                i,
                c,
                u,
                l,
                p,
                d,
                h,
                g,
                m,
                O,
                w,
                x,
                _,
                j,
                S,
                k,
                C,
                P,
                A,
                I,
                T,
                E,
                B,
                M = this.options.commonmark,
                D = this.options.pedantic,
                L = this.blockTokenizers,
                R = this.interruptList,
                N = 0,
                z = t.length,
                W = null,
                F = 0;
              N < z;

            ) {
              if ("\t" === (u = t.charAt(N))) F += 4 - (F % 4);
              else {
                if (" " !== u) break;
                F++;
              }
              N++;
            }
            if (!(F >= 4)) {
              if (((u = t.charAt(N)), (o = M ? v : y), !0 === b[u]))
                (l = u), (c = !1);
              else {
                for (c = !0, i = ""; N < z && ((u = t.charAt(N)), s(u)); )
                  (i += u), N++;
                if (((u = t.charAt(N)), !i || !0 !== o[u])) return;
                (W = parseInt(i, 10)), (l = u);
              }
              if (" " === (u = t.charAt(++N)) || "\t" === u) {
                if (n) return !0;
                for (N = 0, _ = [], j = [], S = []; N < z; ) {
                  for (
                    d = N,
                      h = !1,
                      B = !1,
                      -1 === (p = t.indexOf("\n", N)) && (p = z),
                      E = N + 4,
                      F = 0;
                    N < z;

                  ) {
                    if ("\t" === (u = t.charAt(N))) F += 4 - (F % 4);
                    else {
                      if (" " !== u) break;
                      F++;
                    }
                    N++;
                  }
                  if (
                    (F >= 4 && (B = !0),
                    k && F >= k.indent && (B = !0),
                    (u = t.charAt(N)),
                    (g = null),
                    !B)
                  ) {
                    if (!0 === b[u]) (g = u), N++, F++;
                    else {
                      for (i = ""; N < z && ((u = t.charAt(N)), s(u)); )
                        (i += u), N++;
                      (u = t.charAt(N)),
                        N++,
                        i && !0 === o[u] && ((g = u), (F += i.length + 1));
                    }
                    if (g)
                      if ("\t" === (u = t.charAt(N))) (F += 4 - (F % 4)), N++;
                      else if (" " === u) {
                        for (E = N + 4; N < E && " " === t.charAt(N); )
                          N++, F++;
                        N === E && " " === t.charAt(N) && ((N -= 3), (F -= 3));
                      } else "\n" !== u && "" !== u && (g = null);
                  }
                  if (g) {
                    if (!D && l !== g) break;
                    h = !0;
                  } else
                    M || B || " " !== t.charAt(d)
                      ? M && k && (B = F >= k.indent || F > 4)
                      : (B = !0),
                      (h = !1),
                      (N = d);
                  if (
                    ((O = t.slice(d, p)),
                    (m = d === N ? O : t.slice(N, p)),
                    ("*" === g || "_" === g || "-" === g) &&
                      L.thematicBreak.call(this, e, O, !0))
                  )
                    break;
                  if (((w = x), (x = !a(m).length), B && k))
                    (k.value = k.value.concat(S, O)),
                      (j = j.concat(S, O)),
                      (S = []);
                  else if (h)
                    0 !== S.length &&
                      (k.value.push(""), (k.trail = S.concat())),
                      _.push((k = { value: [O], indent: F, trail: [] })),
                      (j = j.concat(S, O)),
                      (S = []);
                  else if (x) {
                    if (w) break;
                    S.push(O);
                  } else {
                    if (w) break;
                    if (f(R, L, this, [e, O, !0])) break;
                    (k.value = k.value.concat(S, O)),
                      (j = j.concat(S, O)),
                      (S = []);
                  }
                  N = p + 1;
                }
                for (
                  I = e(j.join("\n")).reset({
                    type: "list",
                    ordered: c,
                    start: W,
                    loose: null,
                    children: [],
                  }),
                    C = this.enterList(),
                    P = this.enterBlock(),
                    A = !1,
                    N = -1,
                    z = _.length;
                  ++N < z;

                )
                  (k = _[N].value.join("\n")),
                    (T = e.now()),
                    (k = e(k)(r(this, k, T), I)).loose && (A = !0),
                    (k = _[N].trail.join("\n")),
                    N !== z - 1 && (k += "\n"),
                    e(k);
                return C(), P(), (I.loose = A), I;
              }
            }
          };
          var p = /\n\n(?!\s*$)/,
            d = /^\[([ \t]|x|X)][ \t]/,
            h = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/,
            g = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/,
            m = /^( {1,4}|\t)?/gm,
            b = { "*": !0, "+": !0, "-": !0 },
            y = { ".": !0 },
            v = { ".": !0, ")": !0 };
        },
        Pscf: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("n0FH");
            t.a = function (t) {
              return e(r.a, { onClick: t.onClick }, e("img", { src: t.src }));
            };
          }).call(this, n("hosL").h);
        },
        "Q/RO": function (e, t, n) {
          "use strict";
          t.a = n.p + "3e46d515b4581e29843f89d0bbc0d4ec.svg";
        },
        Q2Xs: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "b", function () {
              return u;
            }),
            n.d(t, "c", function () {
              return l;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = a.b.button.withConfig({
              displayName: "VisitingCardstyled__VisitingCardButton",
              componentId: "azdooy-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  flex: "0 calc(50% - 10px)",
                  margin: "2px 5px",
                  padding: "5px 15px",
                  borderRadius: "15px",
                  border: "1px solid " + n.colors.colorSecondary,
                  backgroundColor: n.colors.colorWhite,
                  color: n.colors.colorSecondary,
                  boxShadow: "0 0 10px " + n.colors.boxShadow,
                  fontSize: "14px",
                  fontWeight: "light",
                  transition: "background-color .3s, color .3s, opacity .3s",
                  "&:not(:disabled):hover": {
                    color: n.colors.colorWhite,
                    backgroundColor: n.colors.colorPrimary,
                    borderColor: n.colors.colorPrimary,
                  },
                  "&:disabled": { opacity: ".6" },
                  "&:not(:disabled)": { cursor: "pointer" },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  flex: "0 calc(50% - 30px)",
                  margin: "5px 15px",
                  fontSize: "18px",
                }),
                t),
                n.elements.messages.VisitingCardButton
              );
            }),
            u = Object(a.b)(c.a).withConfig({
              displayName: "VisitingCardstyled__VisitingCardContainer",
              componentId: "azdooy-1",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.VisitingCardContainer);
            }),
            l = Object(a.b)(c.b).withConfig({
              displayName: "VisitingCardstyled__VisitingCardWrapper",
              componentId: "azdooy-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "25%",
                  backgroundColor: t.colors.veryLightPink,
                  display: "flex",
                  flexWrap: "wrap",
                  margin: "0",
                  padding: "10px 0",
                  width: "100%",
                  borderRadius: "0",
                  background: "transparent",
                },
                t.elements.messages.VisitingCardWrapper
              );
            });
        },
        QJ8L: function (e, t, n) {
          "use strict";
          var r;
          n.d(t, "a", function () {
            return r;
          }),
            (function (e) {
              (e.sessionStorage = "sessionStorage"),
                (e.localStorage = "localStorage");
            })(r || (r = {}));
        },
        QRet: function (e, t, n) {
          "use strict";
          function r(e, t) {
            _.options.__h && _.options.__h(w, e, j || t), (j = 0);
            var n = w.__H || (w.__H = { __: [], __h: [] });
            return e >= n.__.length && n.__.push({}), n.__[e];
          }
          function o(e) {
            return (j = 1), i(v, e);
          }
          function i(e, t, n) {
            var o = r(O++, 2);
            return (
              (o.t = e),
              o.__c ||
                ((o.__ = [
                  n ? n(t) : v(void 0, t),
                  function (e) {
                    var t = o.t(o.__[0], e);
                    o.__[0] !== t &&
                      ((o.__ = [t, o.__[1]]), o.__c.setState({}));
                  },
                ]),
                (o.__c = w)),
              o.__
            );
          }
          function a(e, t) {
            var n = r(O++, 3);
            !_.options.__s &&
              y(n.__H, t) &&
              ((n.__ = e), (n.__H = t), w.__H.__h.push(n));
          }
          function c(e, t) {
            var n = r(O++, 4);
            !_.options.__s &&
              y(n.__H, t) &&
              ((n.__ = e), (n.__H = t), w.__h.push(n));
          }
          function s(e) {
            return (
              (j = 5),
              l(function () {
                return { current: e };
              }, [])
            );
          }
          function u(e, t, n) {
            (j = 6),
              c(
                function () {
                  "function" == typeof e ? e(t()) : e && (e.current = t());
                },
                null == n ? n : n.concat(e)
              );
          }
          function l(e, t) {
            var n = r(O++, 7);
            return (
              y(n.__H, t) && ((n.__ = e()), (n.__H = t), (n.__h = e)), n.__
            );
          }
          function f(e, t) {
            return (
              (j = 8),
              l(function () {
                return e;
              }, t)
            );
          }
          function p(e) {
            var t = w.context[e.__c],
              n = r(O++, 9);
            return (
              (n.c = e),
              t
                ? (null == n.__ && ((n.__ = !0), t.sub(w)), t.props.value)
                : e.__
            );
          }
          function d(e, t) {
            _.options.useDebugValue && _.options.useDebugValue(t ? t(e) : e);
          }
          function h(e) {
            var t = r(O++, 10),
              n = o();
            return (
              (t.__ = e),
              w.componentDidCatch ||
                (w.componentDidCatch = function (e) {
                  t.__ && t.__(e), n[1](e);
                }),
              [
                n[0],
                function () {
                  n[1](void 0);
                },
              ]
            );
          }
          function g() {
            S.forEach(function (e) {
              if (e.__P)
                try {
                  e.__H.__h.forEach(m), e.__H.__h.forEach(b), (e.__H.__h = []);
                } catch (t) {
                  (e.__H.__h = []), _.options.__e(t, e.__v);
                }
            }),
              (S = []);
          }
          function m(e) {
            var t = w;
            "function" == typeof e.__c && e.__c(), (w = t);
          }
          function b(e) {
            var t = w;
            (e.__c = e.__()), (w = t);
          }
          function y(e, t) {
            return (
              !e ||
              e.length !== t.length ||
              t.some(function (t, n) {
                return t !== e[n];
              })
            );
          }
          function v(e, t) {
            return "function" == typeof t ? t(e) : t;
          }
          n.d(t, "k", function () {
            return o;
          }),
            n.d(t, "i", function () {
              return i;
            }),
            n.d(t, "d", function () {
              return a;
            }),
            n.d(t, "g", function () {
              return c;
            }),
            n.d(t, "j", function () {
              return s;
            }),
            n.d(t, "f", function () {
              return u;
            }),
            n.d(t, "h", function () {
              return l;
            }),
            n.d(t, "a", function () {
              return f;
            }),
            n.d(t, "b", function () {
              return p;
            }),
            n.d(t, "c", function () {
              return d;
            }),
            n.d(t, "e", function () {
              return h;
            });
          var O,
            w,
            x,
            _ = n("hosL"),
            j = 0,
            S = [],
            k = _.options.__b,
            C = _.options.__r,
            P = _.options.diffed,
            A = _.options.__c,
            I = _.options.unmount;
          (_.options.__b = function (e) {
            (w = null), k && k(e);
          }),
            (_.options.__r = function (e) {
              C && C(e), (O = 0);
              var t = (w = e.__c).__H;
              t && (t.__h.forEach(m), t.__h.forEach(b), (t.__h = []));
            }),
            (_.options.diffed = function (e) {
              P && P(e);
              var t = e.__c;
              t &&
                t.__H &&
                t.__H.__h.length &&
                ((1 !== S.push(t) && x === _.options.requestAnimationFrame) ||
                  (
                    (x = _.options.requestAnimationFrame) ||
                    function (e) {
                      var t,
                        n = function () {
                          clearTimeout(r),
                            T && cancelAnimationFrame(t),
                            setTimeout(e);
                        },
                        r = setTimeout(n, 100);
                      T && (t = requestAnimationFrame(n));
                    }
                  )(g)),
                (w = void 0);
            }),
            (_.options.__c = function (e, t) {
              t.some(function (e) {
                try {
                  e.__h.forEach(m),
                    (e.__h = e.__h.filter(function (e) {
                      return !e.__ || b(e);
                    }));
                } catch (n) {
                  t.some(function (e) {
                    e.__h && (e.__h = []);
                  }),
                    (t = []),
                    _.options.__e(n, e.__v);
                }
              }),
                A && A(e, t);
            }),
            (_.options.unmount = function (e) {
              I && I(e);
              var t = e.__c;
              if (t && t.__H)
                try {
                  t.__H.__.forEach(m);
                } catch (e) {
                  _.options.__e(e, t.__v);
                }
            });
          var T = "function" == typeof requestAnimationFrame;
        },
        QYzD: function (e, t, n) {
          "use strict";
          var r = n("9jBT");
          e.exports = function (e) {
            return r(e).toLowerCase();
          };
        },
        Qfee: function (e) {
          "use strict";
          e.exports = function (e) {
            var t = "string" == typeof e ? e.charCodeAt(0) : e;
            return t >= 48 && t <= 57;
          };
        },
        Qvh3: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "g", function () {
            return c;
          }),
            n.d(t, "d", function () {
              return s;
            }),
            n.d(t, "b", function () {
              return l;
            }),
            n.d(t, "c", function () {
              return f;
            }),
            n.d(t, "e", function () {
              return p;
            }),
            n.d(t, "a", function () {
              return d;
            }),
            n.d(t, "f", function () {
              return h;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "ShopCarouselstyled__ShopSwipeItem",
              componentId: "sc-1bjrtvk-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n,
                r = e.theme;
              return o(
                (((n = {
                  position: "relative",
                  marginRight: "1.2rem",
                  marginLeft: "1.2rem",
                  "&:focus": { outline: "none" },
                  float: "none",
                  margin: "0",
                  height: "310px",
                  width: "190px",
                  borderRadius: "4px",
                  border: "none",
                  background: r.colors.colorWhite,
                  color: r.colors.carousel,
                  cursor: "pointer",
                  boxShadow: "0 0 10px " + r.colors.boxShadow,
                  "> div:first-child": {
                    padding: "15px 15px 10px 15px",
                    color: r.colors.colorPrimary,
                    fontSize: "20px",
                    fontWeight: "bold",
                    img: { margin: 0 },
                    div: { margin: 0 },
                  },
                  "> div:last-child":
                    ((t = {
                      padding: "10px",
                      textAlign: "left !important",
                      color: r.colors.colorDarkBlue,
                      fontWeight: "bold",
                      "> p:first-child": {
                        marginBottom: "6px",
                        fontSize: "12px",
                        lineHeight: "100%",
                      },
                      "> p:last-child": {
                        fontSize: "14px",
                        fontWeight: "normal",
                        lineHeight: "16px",
                      },
                    }),
                    (t["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      padding: "0 10px 10px 10px",
                    }),
                    t),
                })["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                  width: "130px !important",
                  height: "130px",
                }),
                n),
                r.elements.messages.ShopSwipeItem
              );
            }),
            s = a.b.div.withConfig({
              displayName: "ShopCarouselstyled__ShopCarouselContainer",
              componentId: "sc-1bjrtvk-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n,
                r = e.theme;
              return o(
                {
                  position: "relative",
                  left: "-25px",
                  width: "calc(100% + 45px)",
                  margin: "0",
                  paddingBottom: "0",
                  borderRadius: "10px",
                  ".slick-dots": { display: "none !important" },
                  ".slick-track": { display: "flex", flexDirection: "row" },
                  ".slick-slide":
                    ((t = { width: "200px" }),
                    (t["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      maxWidth: "150px !important",
                    }),
                    t),
                  ".slick-slide > div":
                    ((n = {
                      margin: "10px",
                      height: "100%",
                      borderRadius: "4px",
                      transition: "box-shadow .3s",
                      "&:hover": {
                        boxShadow: "0 0 0 2px " + r.colors.colorPrimary,
                      },
                    }),
                    (n["@media (max-width: " + r.breakpoints.mobile + ")"] = {
                      width: "130px",
                    }),
                    n),
                  ".slick-slide > div > div": {
                    display: "flex !important",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  },
                  ".slick-slider:before, .slick-slider:after": {
                    content: '""',
                    position: "absolute",
                    zIndex: 10,
                    top: "0",
                    bottom: "0",
                    width: "15px",
                    pointerEvents: "none",
                  },
                  ".slick-slider:before": {
                    left: "0",
                    background:
                      "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                  ".slick-slider:after": {
                    right: "0",
                    background:
                      "linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                },
                r.elements.messages.ShopCarouselContainer
              );
            }),
            u = a.b.div.withConfig({
              displayName: "ShopCarouselstyled__CarouselButton",
              componentId: "sc-1bjrtvk-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  padding: "5px 15px",
                  borderRadius: "15px",
                  border: t.colors.white,
                  fontSize: "0.7rem",
                  transition: "background-color .3s, color .3s",
                  position: "absolute",
                  bottom: 0,
                  "&:not(:disabled):hover": {
                    color: t.colors.white,
                    backgroundColor: t.colors.veryLightPink,
                    borderColor: t.colors.veryLightPink,
                    cursor: "pointer",
                  },
                },
                t.elements.messages.ShopCarouselButton
              );
            }),
            l = Object(a.b)(u).withConfig({
              displayName: "ShopCarouselstyled__ShopCarouselButtonLeft",
              componentId: "sc-1bjrtvk-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { left: "2rem" },
                e.theme.elements.messages.ShopCarouselButtonLeft
              );
            }),
            f = Object(a.b)(u).withConfig({
              displayName: "ShopCarouselstyled__ShopCarouselButtonRight",
              componentId: "sc-1bjrtvk-4",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { right: "2rem" },
                e.theme.elements.messages.ShopCarouselButtonRight
              );
            }),
            p = a.b.img.withConfig({
              displayName: "ShopCarouselstyled__ShopCarouselImage",
              componentId: "sc-1bjrtvk-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  height: "200px",
                  display: "inline !important",
                  margin: "5px 10px 0px 10px",
                },
                e.theme.elements.messages.ShopCarouselImage
              );
            }),
            d =
              (a.b.div.withConfig({
                displayName: "ShopCarouselstyled__ShopCarouselValue",
                componentId: "sc-1bjrtvk-6",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    display: "inline",
                    float: "right",
                    margin: "1rem",
                    fontWeight: "bold",
                  },
                  e.theme.elements.messages.ShopCarouselValue
                );
              }),
              a.b.div.withConfig({
                displayName: "ShopCarouselstyled__ClickFix",
                componentId: "sc-1bjrtvk-7",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  { position: "absolute", left: 0, top: 0 },
                  e.theme.elements.messages.ClickFix
                );
              })),
            h = a.b.div.withConfig({
              displayName: "ShopCarouselstyled__ShopCarouselTitle",
              componentId: "sc-1bjrtvk-8",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  float: "center",
                  textAlign: "center",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  p: { margin: "4px" },
                },
                e.theme.elements.messages.ShopCarouselTitle
              );
            });
        },
        "Qx+S": function (e) {
          "use strict";
          e.exports = function (e, t) {
            return e.indexOf("\\", t);
          };
        },
        R8iU: function (e, t, n) {
          (function (e) {
            function n(e, t) {
              for (var n = 0, r = e.length - 1; r >= 0; r--) {
                var o = e[r];
                "." === o
                  ? e.splice(r, 1)
                  : ".." === o
                  ? (e.splice(r, 1), n++)
                  : n && (e.splice(r, 1), n--);
              }
              if (t) for (; n--; n) e.unshift("..");
              return e;
            }
            function r(e, t) {
              if (e.filter) return e.filter(t);
              for (var n = [], r = 0; r < e.length; r++)
                t(e[r], r, e) && n.push(e[r]);
              return n;
            }
            (t.resolve = function () {
              for (
                var t = "", o = !1, i = arguments.length - 1;
                i >= -1 && !o;
                i--
              ) {
                var a = i >= 0 ? arguments[i] : e.cwd();
                if ("string" != typeof a)
                  throw new TypeError(
                    "Arguments to path.resolve must be strings"
                  );
                a && ((t = a + "/" + t), (o = "/" === a.charAt(0)));
              }
              return (
                (o ? "/" : "") +
                  (t = n(
                    r(t.split("/"), function (e) {
                      return !!e;
                    }),
                    !o
                  ).join("/")) || "."
              );
            }),
              (t.normalize = function (e) {
                var i = t.isAbsolute(e),
                  a = "/" === o(e, -1);
                return (
                  (e = n(
                    r(e.split("/"), function (e) {
                      return !!e;
                    }),
                    !i
                  ).join("/")) ||
                    i ||
                    (e = "."),
                  e && a && (e += "/"),
                  (i ? "/" : "") + e
                );
              }),
              (t.isAbsolute = function (e) {
                return "/" === e.charAt(0);
              }),
              (t.join = function () {
                var e = Array.prototype.slice.call(arguments, 0);
                return t.normalize(
                  r(e, function (e) {
                    if ("string" != typeof e)
                      throw new TypeError(
                        "Arguments to path.join must be strings"
                      );
                    return e;
                  }).join("/")
                );
              }),
              (t.relative = function (e, n) {
                function r(e) {
                  for (var t = 0; t < e.length && "" === e[t]; t++);
                  for (var n = e.length - 1; n >= 0 && "" === e[n]; n--);
                  return t > n ? [] : e.slice(t, n - t + 1);
                }
                (e = t.resolve(e).substr(1)), (n = t.resolve(n).substr(1));
                for (
                  var o = r(e.split("/")),
                    i = r(n.split("/")),
                    a = Math.min(o.length, i.length),
                    c = a,
                    s = 0;
                  s < a;
                  s++
                )
                  if (o[s] !== i[s]) {
                    c = s;
                    break;
                  }
                var u = [];
                for (s = c; s < o.length; s++) u.push("..");
                return (u = u.concat(i.slice(c))).join("/");
              }),
              (t.sep = "/"),
              (t.delimiter = ":"),
              (t.dirname = function (e) {
                if (("string" != typeof e && (e += ""), 0 === e.length))
                  return ".";
                for (
                  var t = e.charCodeAt(0),
                    n = 47 === t,
                    r = -1,
                    o = !0,
                    i = e.length - 1;
                  i >= 1;
                  --i
                )
                  if (47 === (t = e.charCodeAt(i))) {
                    if (!o) {
                      r = i;
                      break;
                    }
                  } else o = !1;
                return -1 === r
                  ? n
                    ? "/"
                    : "."
                  : n && 1 === r
                  ? "/"
                  : e.slice(0, r);
              }),
              (t.basename = function (e, t) {
                var n = (function (e) {
                  "string" != typeof e && (e += "");
                  var t,
                    n = 0,
                    r = -1,
                    o = !0;
                  for (t = e.length - 1; t >= 0; --t)
                    if (47 === e.charCodeAt(t)) {
                      if (!o) {
                        n = t + 1;
                        break;
                      }
                    } else -1 === r && ((o = !1), (r = t + 1));
                  return -1 === r ? "" : e.slice(n, r);
                })(e);
                return (
                  t &&
                    n.substr(-1 * t.length) === t &&
                    (n = n.substr(0, n.length - t.length)),
                  n
                );
              }),
              (t.extname = function (e) {
                "string" != typeof e && (e += "");
                for (
                  var t = -1, n = 0, r = -1, o = !0, i = 0, a = e.length - 1;
                  a >= 0;
                  --a
                ) {
                  var c = e.charCodeAt(a);
                  if (47 !== c)
                    -1 === r && ((o = !1), (r = a + 1)),
                      46 === c
                        ? -1 === t
                          ? (t = a)
                          : 1 !== i && (i = 1)
                        : -1 !== t && (i = -1);
                  else if (!o) {
                    n = a + 1;
                    break;
                  }
                }
                return -1 === t ||
                  -1 === r ||
                  0 === i ||
                  (1 === i && t === r - 1 && t === n + 1)
                  ? ""
                  : e.slice(t, r);
              });
            var o =
              "b" === "ab".substr(-1)
                ? function (e, t, n) {
                    return e.substr(t, n);
                  }
                : function (e, t, n) {
                    return t < 0 && (t = e.length + t), e.substr(t, n);
                  };
          }).call(this, n("5IsQ"));
        },
        RAL3: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              a,
              c,
              s,
              u,
              l,
              f,
              p = 0,
              d = t.charAt(p);
            if (
              !(
                ("*" !== d && "_" !== d) ||
                t.charAt(++p) !== d ||
                ((u = (c = d) + c),
                (l = t.length),
                p++,
                (s = ""),
                (d = ""),
                (a = this.options.pedantic) && i(t.charAt(p)))
              )
            )
              for (; p < l; ) {
                if (
                  ((f = d),
                  !(
                    (d = t.charAt(p)) !== c ||
                    t.charAt(p + 1) !== c ||
                    (a && i(f))
                  ) && (d = t.charAt(p + 2)) !== c)
                ) {
                  if (!o(s)) return;
                  return (
                    !!n ||
                    (((r = e.now()).column += 2),
                    (r.offset += 2),
                    e(u + s + u)({
                      type: "strong",
                      children: this.tokenizeInline(s, r),
                    }))
                  );
                }
                a || "\\" !== d || ((s += d), (d = t.charAt(++p))),
                  (s += d),
                  p++;
              }
          }
          var o = n("VNWY"),
            i = n("U/Op"),
            a = n("pZBa");
          (e.exports = r), (r.locator = a);
        },
        RYfs: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              i,
              u = t.length;
            if (
              !("<" !== t.charAt(0) || u < 3) &&
              ((r = t.charAt(1)),
              (o(r) || "?" === r || "!" === r || "/" === r) && (i = t.match(a)))
            )
              return (
                !!n ||
                ((i = i[0]),
                !this.inLink && c.test(i)
                  ? (this.inLink = !0)
                  : this.inLink && s.test(i) && (this.inLink = !1),
                e(i)({ type: "html", value: i }))
              );
          }
          var o = n("bz5S"),
            i = n("yYTt"),
            a = n("WE1I").tag;
          (e.exports = r), (r.locator = i);
          var c = /^<a /i,
            s = /^<\/a>/i;
        },
        RZNd: function (e) {
          "use strict";
          var t,
            n = "";
          e.exports = function (e, r) {
            if ("string" != typeof e) throw new TypeError("expected a string");
            if (1 === r) return e;
            if (2 === r) return e + e;
            var o = e.length * r;
            if (t !== e || void 0 === t) (t = e), (n = "");
            else if (n.length >= o) return n.substr(0, o);
            for (; o > n.length && r > 1; )
              1 & r && (n += e), (r >>= 1), (e += e);
            return (n = (n += e).substr(0, o));
          };
        },
        ReYd: function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              try {
                return Object(i.b)(c);
              } catch (e) {
                return Object(a.a)("emoji");
              }
            }
            n.d(t, "b", function () {
              return r;
            }),
              n.d(t, "a", function () {
                return s;
              });
            var o = n("hosL"),
              i = n("QRet"),
              a = n("c37Q"),
              c = Object(o.createContext)({}),
              s = function (t) {
                return e(c.Provider, { value: t.emoji }, t.children);
              };
          }).call(this, n("hosL").h);
        },
        RiBJ: function (e, t, n) {
          "use strict";
          (function (e) {
            n("hosL");
            var r = n("LO0j"),
              o = n.n(r),
              i = n("p4DT"),
              a = n("keud"),
              c = n("6naU");
            t.a = function () {
              return (
                Object(a.b)().thinking.value &&
                e(
                  i.a,
                  { owner: c.a.bot },
                  e(i.b, null, e(o.a, { escapeHtml: !1 }))
                )
              );
            };
          }).call(this, n("hosL").h);
        },
        RzIh: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("645H");
            t.a = function (t) {
              return e(r.a, {
                message: t.message,
                onOptionSelect: t.onOptionSelect,
                isDisabled: !1,
              });
            };
          }).call(this, n("hosL").h);
        },
        SrYG: function (e, t, n) {
          "use strict";
          t.a = n.p + "4b374b58dc36314e7266d9d4edc7dce5.svg";
        },
        SzEY: function (e, t, n) {
          "use strict";
          t.a = n.p + "ae614ec488cb3d500ec5bed55150ec12.svg";
        },
        T1QE: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("LVvd");
            t.a = function (t) {
              return e(r.a, {
                id: "ytplayer",
                type: "text/html",
                src: "https://www.youtube.com/embed/" + t.message.content.id,
                frameborder: "0",
                allowfullscreen: !0,
              });
            };
          }).call(this, n("hosL").h);
        },
        TLkM: function (e, t) {
          "use strict";
          t.a = {
            publicPath: "https://tasil.omantel.om/",
            filename: "actionbot.js",
            sourceMapOnProd: !1,
          };
        },
        Tcmg: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "b", function () {
            return c;
          }),
            n.d(t, "f", function () {
              return s;
            }),
            n.d(t, "e", function () {
              return u;
            }),
            n.d(t, "c", function () {
              return l;
            }),
            n.d(t, "d", function () {
              return f;
            }),
            n.d(t, "a", function () {
              return p;
            });
          var a = n("UutA"),
            c =
              (n("4hQ3"),
              a.b.div.withConfig({
                displayName: "BotMinimizedstyled__BotMinimizedContainer",
                componentId: "sc-1of6zoy-0",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    justifyContent: "space-between",
                    alignItems: "center",
                    overflow: "visible",
                    img: { display: "none" },
                    display: "block",
                    position: "fixed",
                    bottom: "5vh",
                    right: "5vw",
                    padding: "0",
                    width: "64px",
                    height: "64px",
                    cursor: "pointer",
                    background: "unset",
                    borderRadius: "50%",
                    boxShadow: "10px 10px 18px rgb(87, 87, 87,0.25)",
                    transition: "opacity .3s",
                    zIndex: 1,
                    p: { display: "none" },
                    span: { position: "absolute", top: "-8px", right: "-8px" },
                  },
                  e.theme.elements.BotMinimizedContainer
                );
              })),
            s =
              (a.b.span.withConfig({
                displayName: "BotMinimizedstyled__UnreadCounter",
                componentId: "sc-1of6zoy-1",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    background: "#FF314E",
                    borderRadius: "100%",
                    fontFamily: "dinpro",
                    width: "24px",
                    height: "24px",
                    textAlign: "center",
                    color: "white",
                    display: "flex",
                    opacity: e.unreadCount ? 1 : 0,
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "13px",
                    animationName: "show-message",
                    animationDuration: ".3s",
                    animationIterationCount: 1,
                    animationFillMode: "forwards",
                    fontWeight: "bold",
                    lineHeight: 2,
                  },
                  e.theme.elements.UnreadCounter
                );
              }),
              a.b.div.withConfig({
                displayName: "BotMinimizedstyled__NewMinimizedMessages",
                componentId: "sc-1of6zoy-2",
              })([".ActionBot &{", "}"], function (e) {
                var t = e.theme;
                return o(
                  {
                    position: "absolute",
                    bottom: "50px",
                    right: "60px",
                    borderRadius: "20px",
                    fontSize: "1.6rem",
                    color: t.colors.text,
                    minWidth: "200px",
                    "&.withAnimation": {
                      animationName: "show-message",
                      animationDuration: ".3s",
                      animationIterationCount: 1,
                      animationFillMode: "forwards",
                    },
                  },
                  t.elements.NewMinimizedMessages
                );
              })),
            u = a.b.div.withConfig({
              displayName: "BotMinimizedstyled__NewMinimizedMessage",
              componentId: "sc-1of6zoy-3",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  margin: "8px",
                  lineHeight: "18px",
                  background: "white",
                  boxShadow: "0 0 28px " + n.colors.boxShadow,
                  borderRadius: "10px",
                  borderBottomRightRadius: "0px",
                  padding: "15px 20px",
                  fontWeight: "700",
                  p: { display: "inline" },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  maxWidth: "160px",
                }),
                t),
                n.elements.NewMinimizedMessage
              );
            }),
            l =
              (a.b.img.withConfig({
                displayName: "BotMinimizedstyled__BotIcon",
                componentId: "sc-1of6zoy-4",
              })([".ActionBot &{", "}"], function () {
                return { width: "20px" };
              }),
              a.b.div.withConfig({
                displayName: "BotMinimizedstyled__BotTalkImage",
                componentId: "sc-1of6zoy-5",
              })([".ActionBot &{", "}"], function (e) {
                var t = e.theme,
                  n = e.minimized;
                var r = "%23333333";
                try {
                  r = t.colors.colorPrimary.replace("#", "%23");
                } catch (e) {}
                return {
                  width: "35px",
                  height: "35px",
                  display: "flex !important",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  bottom: "unset",
                  transform:
                    (n ? "scale(1) " : "scale(0) ") + "translate(-50%,-50%)",
                  color: t.colors.white,
                  fontSize: "30px",
                  lineHeight: ".5",
                  textAlign: "center",
                  transition: "width .3s, height .3s, left .1s",
                  transformOrigin: "top left",
                  backgroundImage:
                    'url("' +
                    ("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 50 50' style='enable-background:new 0 0 50 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:" +
                      r +
                      ";%7D%0A%3C/style%3E%3Cpath class='st0' d='M25,0c13.8,0,25,11.2,25,25c0,6.8-2.6,12.9-7,17.3l5.7,5.7c0.7,0.7,0.1,1.9-0.9,1.9H25.3c0,0-0.1,0-0.3,0 C11.2,50,0,38.8,0,25S11.2,0,25,0z'/%3E%3C/svg%3E") +
                    '")',
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundSize: "contain",
                  "@media (max-width: 576px)": {
                    width: "35px",
                    height: "35px",
                    left: "50%",
                    top: "50%",
                    bottom: "unset",
                    transform: "translate(-50%,-50%)",
                    fontSize: "30px",
                    transition: "unset",
                  },
                };
              })),
            f = a.b.div.withConfig({
              displayName: "BotMinimizedstyled__Dot",
              componentId: "sc-1of6zoy-6",
            })([".ActionBot &{", "}"], function (e) {
              return {
                width: "5px",
                height: "5px",
                borderRadius: "100%",
                background: e.theme.colors.white,
                margin: "2px",
                animationName: e.hover ? "dot" : "none",
                animationIterationCount: "infinite",
                animationDelay: e.delay / 1e3 + "s",
                animationDuration: "1s",
                animationTimingFunction: "ease-in-out",
              };
            }),
            p = a.b.div.withConfig({
              displayName: "BotMinimizedstyled__BotMinimize",
              componentId: "sc-1of6zoy-7",
            })([".ActionBot &{", "}"], function (e) {
              return {
                borderRadius: "100%",
                background: e.theme.colors.colorPrimary,
                width: "35px",
                height: "35px",
                left: "50%",
                position: "absolute",
                top: "50%",
                transform: "translate(-50%, -50%)",
                margin: 0,
                transformOrigin: "top left",
                scale: "all .3s",
                fontFamily: "dinpro",
                "&:before": {
                  content: "''",
                  position: "absolute",
                  top: "8px",
                  left: "11px",
                  border: "solid white",
                  transform: "rotate(45deg)",
                  borderWidth: "0 2px 2px 0",
                  display: "inline-block",
                  padding: "5px",
                },
              };
            });
        },
        TevG: function (e) {
          "use strict";
          e.exports = function (e, t) {
            return function (n) {
              for (
                var r, o = 0, i = n.indexOf("\\"), a = e[t], c = [];
                -1 !== i;

              )
                c.push(n.slice(o, i)),
                  ((r = n.charAt((o = i + 1))) && -1 !== a.indexOf(r)) ||
                    c.push("\\"),
                  (i = n.indexOf("\\", o));
              return c.push(n.slice(o)), c.join("");
            };
          };
        },
        "U/Op": function (e) {
          "use strict";
          e.exports = function (e) {
            return n.test("number" == typeof e ? t(e) : e.charAt(0));
          };
          var t = String.fromCharCode,
            n = /\s/;
        },
        U1eE: function (e, t, n) {
          "use strict";
          var r = n("RZNd"),
            o = n("JgMK");
          e.exports = function (e, t, n) {
            for (
              var r, a, c, s = -1, u = t.length, l = "", f = "", p = "", d = "";
              ++s < u;

            )
              if (((r = t.charAt(s)), c))
                if (
                  ((c = !1), (l += p), (f += d), (p = ""), (d = ""), "\n" === r)
                )
                  (p = r), (d = r);
                else
                  for (l += r, f += r; ++s < u; ) {
                    if (!(r = t.charAt(s)) || "\n" === r) {
                      (d = r), (p = r);
                      break;
                    }
                    (l += r), (f += r);
                  }
              else if (
                " " === r &&
                t.charAt(s + 1) === r &&
                t.charAt(s + 2) === r &&
                t.charAt(s + 3) === r
              )
                (p += i), (s += 3), (c = !0);
              else if ("\t" === r) (p += r), (c = !0);
              else {
                for (a = ""; "\t" === r || " " === r; )
                  (a += r), (r = t.charAt(++s));
                if ("\n" !== r) break;
                (p += a + r), (d += r);
              }
            if (f)
              return !!n || e(l)({ type: "code", lang: null, value: o(f) });
          };
          var i = r(" ", 4);
        },
        UFfw: function (e, t, n) {
          "use strict";
          function r() {
            var e = window.navigator.languages
                ? window.navigator.languages[0]
                : null,
              t = (e =
                e ||
                window.navigator.language ||
                window.navigator.browserLanguage ||
                window.navigator.userLanguage);
            return (
              -1 !== t.indexOf("-") && (t = t.split("-")[0]),
              -1 !== t.indexOf("_") && (t = t.split("_")[0]),
              t
            );
          }
          n.d(t, "a", function () {
            return r;
          });
        },
        UJrE: function (e, t, n) {
          "use strict";
          n.d(t, "a", function () {
            return r;
          });
          var r;
          new RegExp(
            "/((([A-Za-z]{3,9}:(?:\\/\\/)?)(?:[-;:&=\\+\\$,\\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\\+\\$,\\w]+@)[A-Za-z0-9.-]+)((?:\\/[\\+~%\\/.\\w-_]*)?\\??(?:[-\\+=&;%@.\\w_]*)#?(?:[\\w]*))?)/"
          );
          !(function (e) {
            (e.jpg = "image/jpg"),
              (e.jpeg = "image/jpeg"),
              (e.png = "image/png"),
              (e.gif = "image/gif"),
              (e.pdf = "application/pdf"),
              (e.doc = "application/doc"),
              (e.docx = "application/docx"),
              (e.txt = "text/plain"),
              (e.xml = "text/xml"),
              (e.odt = "application/vnd.oasis.opendocument.text"),
              (e.zip = "application/x-zip-compressed"),
              (e.rar = "application/x-rar-compressed"),
              (e.csv = ".csv"),
              (e.xls = "application/vnd.ms-excel"),
              (e.xlsx =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          })(r || (r = {}));
        },
        UWqJ: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("7A+S"),
              o = n("ITsB");
            t.a = function (t) {
              var n = t.message,
                i = n.content.value,
                a = new (Object(o.b)("ButtonMessageService"))({ message: n });
              return e(
                r.b,
                { owner: n.owner },
                e(r.a, { onClick: a.onClick }, e(r.c, null, i))
              );
            };
          }).call(this, n("hosL").h);
        },
        UutA: function (e, t, n) {
          "use strict";
          (function (e, r) {
            function o(e) {
              return (
                "function" == typeof e && "string" == typeof e.styledComponentId
              );
            }
            function i(e) {
              return e.replace(Oe, "-").replace(we, "");
            }
            function a(e) {
              return e.displayName || e.name || "Component";
            }
            function c(e) {
              return "string" == typeof e;
            }
            function s(e) {
              for (var t, n = 0 | e.length, r = 0 | n, o = 0; n >= 4; )
                (t =
                  1540483477 *
                    (65535 &
                      (t =
                        (255 & e.charCodeAt(o)) |
                        ((255 & e.charCodeAt(++o)) << 8) |
                        ((255 & e.charCodeAt(++o)) << 16) |
                        ((255 & e.charCodeAt(++o)) << 24))) +
                  (((1540483477 * (t >>> 16)) & 65535) << 16)),
                  (r =
                    (1540483477 * (65535 & r) +
                      (((1540483477 * (r >>> 16)) & 65535) << 16)) ^
                    (t =
                      1540483477 * (65535 & (t ^= t >>> 24)) +
                      (((1540483477 * (t >>> 16)) & 65535) << 16))),
                  (n -= 4),
                  ++o;
              switch (n) {
                case 3:
                  r ^= (255 & e.charCodeAt(o + 2)) << 16;
                case 2:
                  r ^= (255 & e.charCodeAt(o + 1)) << 8;
                case 1:
                  r =
                    1540483477 * (65535 & (r ^= 255 & e.charCodeAt(o))) +
                    (((1540483477 * (r >>> 16)) & 65535) << 16);
              }
              return (
                (r =
                  1540483477 * (65535 & (r ^= r >>> 13)) +
                  (((1540483477 * (r >>> 16)) & 65535) << 16)),
                (r ^= r >>> 15) >>> 0
              );
            }
            n.d(t, "c", function () {
              return He;
            }),
              n.d(t, "a", function () {
                return Ae;
              }),
              n.d(t, "d", function () {
                return Ne;
              });
            var u = n("8KfP"),
              l = n.n(u),
              f = n("l8WD"),
              p = n("5niG"),
              d = n.n(p),
              h = n("GwwO"),
              g = n.n(h),
              m = n("W0B4"),
              b = n.n(m),
              y = n("GeWT"),
              v = n.n(y),
              O = n("xVO4"),
              w =
                "function" == typeof Symbol &&
                "symbol" == typeof Symbol.iterator
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        "function" == typeof Symbol &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? "symbol"
                        : typeof e;
                    },
              x = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    (r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      "value" in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r);
                  }
                }
                return function (t, n, r) {
                  return n && e(t.prototype, n), r && e(t, r), t;
                };
              })(),
              _ =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                },
              j = function (e, t) {
                if ("function" != typeof t && null !== t)
                  throw new TypeError(
                    "Super expression must either be null or a function, not " +
                      typeof t
                  );
                (e.prototype = Object.create(t && t.prototype, {
                  constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                  t &&
                    (Object.setPrototypeOf
                      ? Object.setPrototypeOf(e, t)
                      : (e.__proto__ = t));
              },
              S = function (e, t) {
                var n = {};
                for (var r in e)
                  t.indexOf(r) >= 0 ||
                    (Object.prototype.hasOwnProperty.call(e, r) &&
                      (n[r] = e[r]));
                return n;
              },
              k = function (e, t) {
                if (!e)
                  throw new ReferenceError(
                    "this hasn't been initialised - super() hasn't been called"
                  );
                return !t || ("object" != typeof t && "function" != typeof t)
                  ? e
                  : t;
              },
              C = function (e) {
                return (
                  "object" === (void 0 === e ? "undefined" : w(e)) &&
                  e.constructor === Object
                );
              },
              P = (function (e) {
                function t(t) {
                  for (
                    var n = arguments.length,
                      r = Array(n > 1 ? n - 1 : 0),
                      o = 1;
                    o < n;
                    o++
                  )
                    r[o - 1] = arguments[o];
                  var i = k(
                    this,
                    e.call(
                      this,
                      "An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#" +
                        t +
                        " for more information. " +
                        (r ? "Additional arguments: " + r.join(", ") : "")
                    )
                  );
                  return k(i);
                }
                return j(t, e), t;
              })(Error),
              A = function e(t, n) {
                return t.reduce(function (t, r) {
                  if (null == r || !1 === r || "" === r) return t;
                  if (Array.isArray(r)) return t.push.apply(t, e(r, n)), t;
                  if (r.hasOwnProperty("styledComponentId"))
                    return t.push("." + r.styledComponentId), t;
                  if ("function" == typeof r) {
                    if (n) {
                      var o = r(n);
                      if (f.default.isValidElement(o))
                        throw new P(11, r.displayName || r.name);
                      t.push.apply(t, e([o], n));
                    } else t.push(r);
                    return t;
                  }
                  return (
                    t.push(
                      C(r)
                        ? (function e(t, n) {
                            var r = Object.keys(t)
                              .filter(function (e) {
                                var n = t[e];
                                return null != n && !1 !== n && "" !== n;
                              })
                              .map(function (n) {
                                return C(t[n])
                                  ? e(t[n], n)
                                  : l()(n) + ": " + t[n] + ";";
                              })
                              .join(" ");
                            return n ? n + " {\n  " + r + "\n}" : r;
                          })(r)
                        : r.toString()
                    ),
                    t
                  );
                }, []);
              },
              I = /^\s*\/\/.*$/gm,
              T = new d.a({
                global: !1,
                cascade: !0,
                keyframe: !1,
                prefix: !1,
                compress: !1,
                semicolon: !0,
              }),
              E = new d.a({
                global: !1,
                cascade: !0,
                keyframe: !1,
                prefix: !0,
                compress: !1,
                semicolon: !1,
              }),
              B = [],
              M = function (e) {
                if (-2 === e) {
                  var t = B;
                  return (B = []), t;
                }
              },
              D = g()(function (e) {
                B.push(e);
              });
            E.use([D, M]), T.use([D, M]);
            var L = function (e, t, n) {
                var r = e.join("").replace(I, "");
                return E(
                  n || !t ? "" : t,
                  t && n ? n + " " + t + " { " + r + " }" : r
                );
              },
              R = function (e) {
                return T("", e);
              },
              N = function (e) {
                return String.fromCharCode(e + (e > 25 ? 39 : 97));
              },
              z = function (e) {
                var t = "",
                  n = void 0;
                for (n = e; n > 52; n = Math.floor(n / 52)) t = N(n % 52) + t;
                return N(n % 52) + t;
              },
              W = function (e, t) {
                for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1)
                  n.push(t[r], e[r + 1]);
                return n;
              },
              F = Object.freeze([]),
              H = Object.freeze({}),
              U = function (e) {
                for (
                  var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1;
                  r < t;
                  r++
                )
                  n[r - 1] = arguments[r];
                return "function" == typeof e || C(e)
                  ? A(W(F, [e].concat(n)))
                  : A(W(e, n));
              },
              q = (void 0 !== e && e.env.SC_ATTR) || "data-styled-components",
              G = "__styled-components-stylesheet__",
              V = "undefined" != typeof window && "HTMLElement" in window,
              Y = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm,
              $ = function (e) {
                var t = "" + (e || ""),
                  n = [];
                return (
                  t.replace(Y, function (e, t, r) {
                    return n.push({ componentId: t, matchIndex: r }), e;
                  }),
                  n.map(function (e, r) {
                    var o = e.matchIndex,
                      i = n[r + 1];
                    return {
                      componentId: e.componentId,
                      cssFromDOM: i ? t.slice(o, i.matchIndex) : t.slice(o),
                    };
                  })
                );
              },
              J = function () {
                return n.nc;
              },
              K = function (e, t, n) {
                n && ((e[t] || (e[t] = Object.create(null)))[n] = !0);
              },
              Q = function (e, t) {
                e[t] = Object.create(null);
              },
              X = function (e) {
                return function (t, n) {
                  return void 0 !== e[t] && e[t][n];
                };
              },
              Z = function (e) {
                var t = "";
                for (var n in e) t += Object.keys(e[n]).join(" ") + " ";
                return t.trim();
              },
              ee = function (e) {
                if (e.sheet) return e.sheet;
                for (
                  var t = document.styleSheets.length, n = 0;
                  n < t;
                  n += 1
                ) {
                  var r = document.styleSheets[n];
                  if (r.ownerNode === e) return r;
                }
                throw new P(10);
              },
              te = function (e, t, n) {
                if (!t) return !1;
                var r = e.cssRules.length;
                try {
                  e.insertRule(t, n <= r ? n : r);
                } catch (e) {
                  return !1;
                }
                return !0;
              },
              ne = function (e) {
                return "\n/* sc-component-id: " + e + " */\n";
              },
              re = function (e, t) {
                for (var n = 0, r = 0; r <= t; r += 1) n += e[r];
                return n;
              },
              oe = function (e, t) {
                return function (n) {
                  var r = J();
                  return (
                    "<style " +
                    [r && 'nonce="' + r + '"', q + '="' + Z(t) + '"', n]
                      .filter(Boolean)
                      .join(" ") +
                    ">" +
                    e() +
                    "</style>"
                  );
                };
              },
              ie = function (e, t) {
                return function () {
                  var n,
                    r = (((n = {})[q] = Z(t)), n),
                    o = J();
                  return (
                    o && (r.nonce = o),
                    f.default.createElement(
                      "style",
                      _({}, r, { dangerouslySetInnerHTML: { __html: e() } })
                    )
                  );
                };
              },
              ae = function (e) {
                return function () {
                  return Object.keys(e);
                };
              },
              ce = function e(t, n) {
                var r = void 0 === t ? Object.create(null) : t,
                  o = void 0 === n ? Object.create(null) : n,
                  i = function (e) {
                    var t = o[e];
                    return void 0 !== t ? t : (o[e] = [""]);
                  },
                  a = function () {
                    var e = "";
                    for (var t in o) {
                      var n = o[t][0];
                      n && (e += ne(t) + n);
                    }
                    return e;
                  };
                return {
                  clone: function () {
                    var t = (function (e) {
                        var t = Object.create(null);
                        for (var n in e) t[n] = _({}, e[n]);
                        return t;
                      })(r),
                      n = Object.create(null);
                    for (var i in o) n[i] = [o[i][0]];
                    return e(t, n);
                  },
                  css: a,
                  getIds: ae(o),
                  hasNameForId: X(r),
                  insertMarker: i,
                  insertRules: function (e, t, n) {
                    (i(e)[0] += t.join(" ")), K(r, e, n);
                  },
                  removeRules: function (e) {
                    var t = o[e];
                    void 0 !== t && ((t[0] = ""), Q(r, e));
                  },
                  sealed: !1,
                  styleTag: null,
                  toElement: ie(a, r),
                  toHTML: oe(a, r),
                };
              },
              se = function (e, t, n, r, o) {
                if (V && !n) {
                  var i = (function (e, t, n) {
                    var r = document.createElement("style");
                    r.setAttribute(q, "");
                    var o = J();
                    if (
                      (o && r.setAttribute("nonce", o),
                      r.appendChild(document.createTextNode("")),
                      e && !t)
                    )
                      e.appendChild(r);
                    else {
                      if (!t || !e || !t.parentNode) throw new P(6);
                      t.parentNode.insertBefore(r, n ? t : t.nextSibling);
                    }
                    return r;
                  })(e, t, r);
                  return (function (e, t) {
                    var n = Object.create(null),
                      r = Object.create(null),
                      o = [],
                      i = void 0 !== t,
                      a = !1,
                      c = function (e) {
                        var t = r[e];
                        return void 0 !== t
                          ? t
                          : ((r[e] = o.length), o.push(0), Q(n, e), r[e]);
                      },
                      s = function () {
                        var t = ee(e).cssRules,
                          n = "";
                        for (var i in r) {
                          n += ne(i);
                          for (
                            var a = r[i], c = re(o, a), s = c - o[a];
                            s < c;
                            s += 1
                          ) {
                            var u = t[s];
                            void 0 !== u && (n += u.cssText);
                          }
                        }
                        return n;
                      };
                    return {
                      clone: function () {
                        throw new P(5);
                      },
                      css: s,
                      getIds: ae(r),
                      hasNameForId: X(n),
                      insertMarker: c,
                      insertRules: function (r, s, u) {
                        for (
                          var l = c(r),
                            f = ee(e),
                            p = re(o, l),
                            d = 0,
                            h = [],
                            g = s.length,
                            m = 0;
                          m < g;
                          m += 1
                        ) {
                          var b = s[m],
                            y = i;
                          y && -1 !== b.indexOf("@import")
                            ? h.push(b)
                            : te(f, b, p + d) && ((y = !1), (d += 1));
                        }
                        i &&
                          h.length > 0 &&
                          ((a = !0), t().insertRules(r + "-import", h)),
                          (o[l] += d),
                          K(n, r, u);
                      },
                      removeRules: function (c) {
                        var s = r[c];
                        if (void 0 !== s) {
                          var u = o[s];
                          !(function (e, t, n) {
                            for (var r = t - n, o = t; o > r; o -= 1)
                              e.deleteRule(o);
                          })(ee(e), re(o, s), u),
                            (o[s] = 0),
                            Q(n, c),
                            i && a && t().removeRules(c + "-import");
                        }
                      },
                      sealed: !1,
                      styleTag: e,
                      toElement: ie(s, n),
                      toHTML: oe(s, n),
                    };
                  })(i, o);
                }
                return ce();
              },
              ue = /\s+/,
              le = void 0;
            le = V ? 1e3 : -1;
            var fe,
              pe = 0,
              de = void 0,
              he = (function () {
                function e() {
                  var e = this,
                    t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : V
                        ? document.head
                        : null,
                    n =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1];
                  (this.getImportRuleTag = function () {
                    var t = e.importRuleTag;
                    if (void 0 !== t) return t;
                    var n = e.tags[0];
                    return (e.importRuleTag = se(
                      e.target,
                      n ? n.styleTag : null,
                      e.forceServer,
                      !0
                    ));
                  }),
                    (this.id = pe += 1),
                    (this.forceServer = n),
                    (this.target = n ? null : t),
                    (this.tagMap = {}),
                    (this.deferred = {}),
                    (this.rehydratedNames = {}),
                    (this.ignoreRehydratedNames = {}),
                    (this.tags = []),
                    (this.capacity = 1),
                    (this.clones = []);
                }
                return (
                  (e.prototype.rehydrate = function () {
                    if (!V || this.forceServer) return this;
                    var e = [],
                      t = [],
                      n = !1,
                      r = document.querySelectorAll("style[" + q + "]"),
                      o = r.length;
                    if (0 === o) return this;
                    for (var i = 0; i < o; i += 1) {
                      var a = r[i];
                      n || (n = !!a.getAttribute("data-styled-streamed"));
                      for (
                        var c = (a.getAttribute(q) || "").trim().split(ue),
                          s = c.length,
                          u = 0;
                        u < s;
                        u += 1
                      ) {
                        this.rehydratedNames[c[u]] = !0;
                      }
                      t.push.apply(t, $(a.textContent)), e.push(a);
                    }
                    var l = t.length;
                    if (0 === l) return this;
                    var f = (function (e, t, n, r) {
                      var o,
                        i,
                        a =
                          ((o = function () {
                            for (var r = 0, o = n.length; r < o; r += 1) {
                              var i = n[r],
                                a = i.componentId,
                                c = R(i.cssFromDOM);
                              e.insertRules(a, c);
                            }
                            for (var s = 0, u = t.length; s < u; s += 1) {
                              var l = t[s];
                              l.parentNode && l.parentNode.removeChild(l);
                            }
                          }),
                          (i = !1),
                          function () {
                            i || ((i = !0), o());
                          });
                      return (
                        r && a(),
                        _({}, e, {
                          insertMarker: function (t) {
                            return a(), e.insertMarker(t);
                          },
                          insertRules: function (t, n, r) {
                            return a(), e.insertRules(t, n, r);
                          },
                        })
                      );
                    })(this.makeTag(null), e, t, n);
                    (this.capacity = Math.max(1, le - l)), this.tags.push(f);
                    for (var p = 0; p < l; p += 1)
                      this.tagMap[t[p].componentId] = f;
                    return this;
                  }),
                  (e.reset = function () {
                    var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                    de = new e(void 0, t).rehydrate();
                  }),
                  (e.prototype.clone = function () {
                    var t = new e(this.target, this.forceServer);
                    return (
                      this.clones.push(t),
                      (t.tags = this.tags.map(function (e) {
                        for (
                          var n = e.getIds(), r = e.clone(), o = 0;
                          o < n.length;
                          o += 1
                        )
                          t.tagMap[n[o]] = r;
                        return r;
                      })),
                      (t.rehydratedNames = _({}, this.rehydratedNames)),
                      (t.deferred = _({}, this.deferred)),
                      t
                    );
                  }),
                  (e.prototype.sealAllTags = function () {
                    (this.capacity = 1),
                      this.tags.forEach(function (e) {
                        e.sealed = !0;
                      });
                  }),
                  (e.prototype.makeTag = function (e) {
                    return se(
                      this.target,
                      e ? e.styleTag : null,
                      this.forceServer,
                      !1,
                      this.getImportRuleTag
                    );
                  }),
                  (e.prototype.getTagForId = function (e) {
                    var t = this.tagMap[e];
                    if (void 0 !== t && !t.sealed) return t;
                    var n = this.tags[this.tags.length - 1];
                    return (
                      (this.capacity -= 1),
                      0 === this.capacity &&
                        ((this.capacity = le),
                        (n = this.makeTag(n)),
                        this.tags.push(n)),
                      (this.tagMap[e] = n)
                    );
                  }),
                  (e.prototype.hasId = function (e) {
                    return void 0 !== this.tagMap[e];
                  }),
                  (e.prototype.hasNameForId = function (e, t) {
                    if (
                      void 0 === this.ignoreRehydratedNames[e] &&
                      this.rehydratedNames[t]
                    )
                      return !0;
                    var n = this.tagMap[e];
                    return void 0 !== n && n.hasNameForId(e, t);
                  }),
                  (e.prototype.deferredInject = function (e, t) {
                    if (void 0 === this.tagMap[e]) {
                      for (var n = this.clones, r = 0; r < n.length; r += 1)
                        n[r].deferredInject(e, t);
                      this.getTagForId(e).insertMarker(e),
                        (this.deferred[e] = t);
                    }
                  }),
                  (e.prototype.inject = function (e, t, n) {
                    for (var r = this.clones, o = 0; o < r.length; o += 1)
                      r[o].inject(e, t, n);
                    var i = this.getTagForId(e);
                    if (void 0 !== this.deferred[e]) {
                      var a = this.deferred[e].concat(t);
                      i.insertRules(e, a, n), (this.deferred[e] = void 0);
                    } else i.insertRules(e, t, n);
                  }),
                  (e.prototype.remove = function (e) {
                    var t = this.tagMap[e];
                    if (void 0 !== t) {
                      for (var n = this.clones, r = 0; r < n.length; r += 1)
                        n[r].remove(e);
                      t.removeRules(e),
                        (this.ignoreRehydratedNames[e] = !0),
                        (this.deferred[e] = void 0);
                    }
                  }),
                  (e.prototype.toHTML = function () {
                    return this.tags
                      .map(function (e) {
                        return e.toHTML();
                      })
                      .join("");
                  }),
                  (e.prototype.toReactElements = function () {
                    var e = this.id;
                    return this.tags.map(function (t, n) {
                      var r = "sc-" + e + "-" + n;
                      return Object(f.cloneElement)(t.toElement(), { key: r });
                    });
                  }),
                  x(e, null, [
                    {
                      key: "master",
                      get: function () {
                        return de || (de = new e().rehydrate());
                      },
                    },
                    {
                      key: "instance",
                      get: function () {
                        return e.master;
                      },
                    },
                  ]),
                  e
                );
              })(),
              ge = (function (e) {
                function t() {
                  return k(this, e.apply(this, arguments));
                }
                return (
                  j(t, e),
                  (t.prototype.getChildContext = function () {
                    var e;
                    return ((e = {})[G] = this.sheetInstance), e;
                  }),
                  (t.prototype.componentWillMount = function () {
                    if (this.props.sheet) this.sheetInstance = this.props.sheet;
                    else {
                      if (!this.props.target) throw new P(4);
                      this.sheetInstance = new he(this.props.target);
                    }
                  }),
                  (t.prototype.render = function () {
                    return f.default.Children.only(this.props.children);
                  }),
                  t
                );
              })(f.Component);
            ge.childContextTypes =
              (((fe = {})[G] = b.a.oneOfType([
                b.a.instanceOf(he),
                b.a.instanceOf(ye),
              ]).isRequired),
              fe);
            var me,
              be,
              ye = (function () {
                function e() {
                  (this.masterSheet = he.master),
                    (this.instance = this.masterSheet.clone()),
                    (this.closed = !1);
                }
                return (
                  (e.prototype.complete = function () {
                    if (!this.closed) {
                      var e = this.masterSheet.clones.indexOf(this.instance);
                      this.masterSheet.clones.splice(e, 1), (this.closed = !0);
                    }
                  }),
                  (e.prototype.collectStyles = function (e) {
                    if (this.closed) throw new P(2);
                    return f.default.createElement(
                      ge,
                      { sheet: this.instance },
                      e
                    );
                  }),
                  (e.prototype.getStyleTags = function () {
                    return this.complete(), this.instance.toHTML();
                  }),
                  (e.prototype.getStyleElement = function () {
                    return this.complete(), this.instance.toReactElements();
                  }),
                  (e.prototype.interleaveWithNodeStream = function () {
                    throw new P(3);
                  }),
                  e
                );
              })(),
              ve = function (e, t, n) {
                return e.theme && !(n && e.theme === n.theme) ? e.theme : t;
              },
              Oe = /[[\].#*$><+~=|^:(),"'`-]+/g,
              we = /(^-|-$)/g,
              xe =
                /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/,
              _e = RegExp.prototype.test.bind(
                new RegExp(
                  "^(x|data|aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
                )
              ),
              je = "__styled-components__",
              Se = je + "next__",
              ke = b.a.shape({
                getTheme: b.a.func,
                subscribe: b.a.func,
                unsubscribe: b.a.func,
              }),
              Ce = (((me = {})[je] = b.a.func), (me[Se] = ke), me);
            var Pe,
              Ae = (function (e) {
                function t() {
                  var t = k(this, e.call(this));
                  return (
                    (t.unsubscribeToOuterId = -1),
                    (t.getTheme = t.getTheme.bind(t)),
                    t
                  );
                }
                return (
                  j(t, e),
                  (t.prototype.componentWillMount = function () {
                    var e,
                      t,
                      n,
                      r,
                      o = this,
                      i = this.context[Se];
                    void 0 !== i &&
                      (this.unsubscribeToOuterId = i.subscribe(function (e) {
                        (o.outerTheme = e),
                          void 0 !== o.broadcast && o.publish(o.props.theme);
                      })),
                      (this.broadcast =
                        ((e = this.getTheme()),
                        (t = {}),
                        (n = 0),
                        (r = e),
                        {
                          publish: function (e) {
                            for (var n in ((r = e), t)) {
                              var o = t[n];
                              void 0 !== o && o(r);
                            }
                          },
                          subscribe: function (e) {
                            var o = n;
                            return (t[o] = e), (n += 1), e(r), o;
                          },
                          unsubscribe: function (e) {
                            t[e] = void 0;
                          },
                        }));
                  }),
                  (t.prototype.getChildContext = function () {
                    var e,
                      t = this;
                    return _(
                      {},
                      this.context,
                      (((e = {})[Se] = {
                        getTheme: this.getTheme,
                        subscribe: this.broadcast.subscribe,
                        unsubscribe: this.broadcast.unsubscribe,
                      }),
                      (e[je] = function (e) {
                        var n = t.broadcast.subscribe(e);
                        return function () {
                          return t.broadcast.unsubscribe(n);
                        };
                      }),
                      e)
                    );
                  }),
                  (t.prototype.componentWillReceiveProps = function (e) {
                    this.props.theme !== e.theme && this.publish(e.theme);
                  }),
                  (t.prototype.componentWillUnmount = function () {
                    -1 !== this.unsubscribeToOuterId &&
                      this.context[Se].unsubscribe(this.unsubscribeToOuterId);
                  }),
                  (t.prototype.getTheme = function (e) {
                    var t = e || this.props.theme;
                    if ("function" == typeof t) return t(this.outerTheme);
                    if (
                      null === t ||
                      Array.isArray(t) ||
                      "object" !== (void 0 === t ? "undefined" : w(t))
                    )
                      throw new P(8);
                    return _({}, this.outerTheme, t);
                  }),
                  (t.prototype.publish = function (e) {
                    this.broadcast.publish(this.getTheme(e));
                  }),
                  (t.prototype.render = function () {
                    return this.props.children
                      ? f.default.Children.only(this.props.children)
                      : null;
                  }),
                  t
                );
              })(f.Component);
            (Ae.childContextTypes = Ce),
              (Ae.contextTypes = (((be = {})[Se] = ke), be));
            var Ie = {},
              Te = _(
                {},
                Ce,
                (((Pe = {})[G] = b.a.oneOfType([
                  b.a.instanceOf(he),
                  b.a.instanceOf(ye),
                ])),
                Pe)
              ),
              Ee = {};
            var Be = (function (e) {
                function t() {
                  for (
                    var t, n, r = arguments.length, o = Array(r), i = 0;
                    i < r;
                    i++
                  )
                    o[i] = arguments[i];
                  return (
                    (t = n = k(this, e.call.apply(e, [this].concat(o)))),
                    (n.attrs = {}),
                    (n.state = { theme: null, generatedClassName: "" }),
                    (n.unsubscribeId = -1),
                    k(n, t)
                  );
                }
                return (
                  j(t, e),
                  (t.prototype.unsubscribeFromContext = function () {
                    -1 !== this.unsubscribeId &&
                      this.context[Se].unsubscribe(this.unsubscribeId);
                  }),
                  (t.prototype.buildExecutionContext = function (e, t) {
                    var n = this.constructor.attrs,
                      r = _({}, t, { theme: e });
                    return void 0 === n
                      ? r
                      : ((this.attrs = Object.keys(n).reduce(function (e, t) {
                          var o = n[t];
                          return (
                            (e[t] =
                              "function" != typeof o ||
                              (function (e, t) {
                                for (var n = e; n; )
                                  if ((n = Object.getPrototypeOf(n)) && n === t)
                                    return !0;
                                return !1;
                              })(o, f.Component)
                                ? o
                                : o(r)),
                            e
                          );
                        }, {})),
                        _({}, r, this.attrs));
                  }),
                  (t.prototype.generateAndInjectStyles = function (e, t) {
                    var n = this.constructor,
                      r = n.componentStyle,
                      o = this.context[G] || he.master;
                    if (r.isStatic && void 0 === n.attrs)
                      return r.generateAndInjectStyles(Ie, o);
                    var i = this.buildExecutionContext(e, t);
                    return r.generateAndInjectStyles(i, o);
                  }),
                  (t.prototype.componentWillMount = function () {
                    var e = this,
                      t = this.context[Se];
                    if (this.constructor.componentStyle.isStatic) {
                      var n = this.generateAndInjectStyles(Ie, this.props);
                      this.setState({ generatedClassName: n });
                    } else if (void 0 !== t) {
                      this.unsubscribeId = (0, t.subscribe)(function (t) {
                        var n = ve(e.props, t, e.constructor.defaultProps),
                          r = e.generateAndInjectStyles(n, e.props);
                        e.setState({ theme: n, generatedClassName: r });
                      });
                    } else {
                      var r = this.props.theme || H,
                        o = this.generateAndInjectStyles(r, this.props);
                      this.setState({ theme: r, generatedClassName: o });
                    }
                  }),
                  (t.prototype.componentWillReceiveProps = function (e) {
                    var t = this;
                    this.constructor.componentStyle.isStatic ||
                      this.setState(function (n) {
                        var r = ve(e, n.theme, t.constructor.defaultProps);
                        return {
                          theme: r,
                          generatedClassName: t.generateAndInjectStyles(r, e),
                        };
                      });
                  }),
                  (t.prototype.componentWillUnmount = function () {
                    this.unsubscribeFromContext();
                  }),
                  (t.prototype.render = function () {
                    var e = this.props.innerRef,
                      t = this.state.generatedClassName,
                      n = this.constructor,
                      r = n.styledComponentId,
                      i = n.target,
                      a = c(i),
                      s = [this.props.className, r, this.attrs.className, t]
                        .filter(Boolean)
                        .join(" "),
                      u = _({}, this.attrs, { className: s });
                    o(i) ? (u.innerRef = e) : (u.ref = e);
                    var l,
                      p = u,
                      d = void 0;
                    for (d in this.props)
                      "innerRef" === d ||
                        "className" === d ||
                        (a && !xe.test((l = d)) && !_e(l.toLowerCase())) ||
                        (p[d] =
                          "style" === d && d in this.attrs
                            ? _({}, this.attrs[d], this.props[d])
                            : this.props[d]);
                    return Object(f.createElement)(i, p);
                  }),
                  t
                );
              })(f.Component),
              Me = V,
              De = r.hot && !1,
              Le = [
                "a",
                "abbr",
                "address",
                "area",
                "article",
                "aside",
                "audio",
                "b",
                "base",
                "bdi",
                "bdo",
                "big",
                "blockquote",
                "body",
                "br",
                "button",
                "canvas",
                "caption",
                "cite",
                "code",
                "col",
                "colgroup",
                "data",
                "datalist",
                "dd",
                "del",
                "details",
                "dfn",
                "dialog",
                "div",
                "dl",
                "dt",
                "em",
                "embed",
                "fieldset",
                "figcaption",
                "figure",
                "footer",
                "form",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "head",
                "header",
                "hgroup",
                "hr",
                "html",
                "i",
                "iframe",
                "img",
                "input",
                "ins",
                "kbd",
                "keygen",
                "label",
                "legend",
                "li",
                "link",
                "main",
                "map",
                "mark",
                "marquee",
                "menu",
                "menuitem",
                "meta",
                "meter",
                "nav",
                "noscript",
                "object",
                "ol",
                "optgroup",
                "option",
                "output",
                "p",
                "param",
                "picture",
                "pre",
                "progress",
                "q",
                "rp",
                "rt",
                "ruby",
                "s",
                "samp",
                "script",
                "section",
                "select",
                "small",
                "source",
                "span",
                "strong",
                "style",
                "sub",
                "summary",
                "sup",
                "table",
                "tbody",
                "td",
                "textarea",
                "tfoot",
                "th",
                "thead",
                "time",
                "title",
                "tr",
                "track",
                "u",
                "ul",
                "var",
                "video",
                "wbr",
                "circle",
                "clipPath",
                "defs",
                "ellipse",
                "foreignObject",
                "g",
                "image",
                "line",
                "linearGradient",
                "mask",
                "path",
                "pattern",
                "polygon",
                "polyline",
                "radialGradient",
                "rect",
                "stop",
                "svg",
                "text",
                "tspan",
              ],
              Re = function (e) {
                return e.replace(/\s|\\n/g, "");
              },
              Ne = function (e) {
                var t =
                    "function" == typeof e &&
                    !(e.prototype && "isReactComponent" in e.prototype),
                  n = o(e) || t,
                  r = (function (t) {
                    function r() {
                      for (
                        var e, n, r = arguments.length, o = Array(r), i = 0;
                        i < r;
                        i++
                      )
                        o[i] = arguments[i];
                      return (
                        (e = n = k(this, t.call.apply(t, [this].concat(o)))),
                        (n.state = H),
                        (n.unsubscribeId = -1),
                        k(n, e)
                      );
                    }
                    return (
                      j(r, t),
                      (r.prototype.componentWillMount = function () {
                        var e = this,
                          t = this.constructor.defaultProps,
                          n = this.context[Se],
                          r = ve(this.props, void 0, t);
                        void 0 === n && void 0 !== r
                          ? this.setState({ theme: r })
                          : (this.unsubscribeId = (0, n.subscribe)(function (
                              n
                            ) {
                              var r = ve(e.props, n, t);
                              e.setState({ theme: r });
                            }));
                      }),
                      (r.prototype.componentWillReceiveProps = function (e) {
                        var t = this.constructor.defaultProps;
                        this.setState(function (n) {
                          return { theme: ve(e, n.theme, t) };
                        });
                      }),
                      (r.prototype.componentWillUnmount = function () {
                        -1 !== this.unsubscribeId &&
                          this.context[Se].unsubscribe(this.unsubscribeId);
                      }),
                      (r.prototype.render = function () {
                        var t = _({ theme: this.state.theme }, this.props);
                        return (
                          n || ((t.ref = t.innerRef), delete t.innerRef),
                          f.default.createElement(e, t)
                        );
                      }),
                      r
                    );
                  })(f.default.Component);
                return (
                  (r.contextTypes = Ce),
                  (r.displayName = "WithTheme(" + a(e) + ")"),
                  (r.styledComponentId = "withTheme"),
                  v()(r, e)
                );
              };
            var ze = (function (e, t, n) {
                var r = function (t) {
                  return e(s(t));
                };
                return (function () {
                  function e(e, t, n) {
                    ((this.rules = e),
                    (this.isStatic =
                      !De &&
                      (function e(t, n) {
                        for (var r = 0, i = t.length; r < i; r += 1) {
                          var a = t[r];
                          if (Array.isArray(a) && !e(a)) return !1;
                          if ("function" == typeof a && !o(a)) return !1;
                        }
                        if (void 0 !== n)
                          for (var c in n)
                            if ("function" == typeof n[c]) return !1;
                        return !0;
                      })(e, t)),
                    (this.componentId = n),
                    he.master.hasId(n)) || he.master.deferredInject(n, []);
                  }
                  return (
                    (e.prototype.generateAndInjectStyles = function (e, o) {
                      var i = this.componentId,
                        a = this.lastClassName;
                      if (
                        Me &&
                        this.isStatic &&
                        void 0 !== a &&
                        o.hasNameForId(i, a)
                      )
                        return a;
                      var c = t(this.rules, e),
                        s = r(this.componentId + c.join(""));
                      return (
                        o.hasNameForId(i, s) ||
                          o.inject(this.componentId, n(c, "." + s), s),
                        (this.lastClassName = s),
                        s
                      );
                    }),
                    (e.generateName = function (e) {
                      return r(e);
                    }),
                    e
                  );
                })();
              })(z, A, L),
              We = (function (e) {
                return function t(n, r) {
                  var o =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : H;
                  if (!Object(O.isValidElementType)(r))
                    throw new P(1, String(r));
                  var i = function () {
                    return n(r, o, e.apply(void 0, arguments));
                  };
                  return (
                    (i.withConfig = function (e) {
                      return t(n, r, _({}, o, e));
                    }),
                    (i.attrs = function (e) {
                      return t(
                        n,
                        r,
                        _({}, o, { attrs: _({}, o.attrs || H, e) })
                      );
                    }),
                    i
                  );
                };
              })(U),
              Fe = (function (e, t) {
                return function n(r, o, s) {
                  var u = o.isClass,
                    l = void 0 === u ? !c(r) : u,
                    f = o.displayName,
                    p =
                      void 0 === f
                        ? (function (e) {
                            return c(e)
                              ? "styled." + e
                              : "Styled(" + a(e) + ")";
                          })(r)
                        : f,
                    d = o.componentId,
                    h =
                      void 0 === d
                        ? (function (e, t, n) {
                            var r = "string" != typeof t ? "sc" : i(t),
                              o = (Ee[r] || 0) + 1;
                            Ee[r] = o;
                            var a = r + "-" + e.generateName(r + o);
                            return void 0 !== n ? n + "-" + a : a;
                          })(e, o.displayName, o.parentComponentId)
                        : d,
                    g = o.ParentComponent,
                    m = void 0 === g ? Be : g,
                    b = o.rules,
                    y = o.attrs,
                    O =
                      o.displayName && o.componentId
                        ? i(o.displayName) + "-" + o.componentId
                        : o.componentId || h,
                    w = new e(void 0 === b ? s : b.concat(s), y, O),
                    C = (function (e) {
                      function u() {
                        return k(this, e.apply(this, arguments));
                      }
                      return (
                        j(u, e),
                        (u.withComponent = function (e) {
                          var t = o.componentId,
                            r = S(o, ["componentId"]),
                            l = t && t + "-" + (c(e) ? e : i(a(e))),
                            f = _({}, r, {
                              componentId: l,
                              ParentComponent: u,
                            });
                          return n(e, f, s);
                        }),
                        x(u, null, [
                          {
                            key: "extend",
                            get: function () {
                              var e = o.rules,
                                i = o.componentId,
                                a = S(o, ["rules", "componentId"]),
                                c = void 0 === e ? s : e.concat(s),
                                l = _({}, a, {
                                  rules: c,
                                  parentComponentId: i,
                                  ParentComponent: u,
                                });
                              return t(n, r, l);
                            },
                          },
                        ]),
                        u
                      );
                    })(m);
                  return (
                    (C.attrs = y),
                    (C.componentStyle = w),
                    (C.contextTypes = Te),
                    (C.displayName = p),
                    (C.styledComponentId = O),
                    (C.target = r),
                    l &&
                      v()(C, r, {
                        attrs: !0,
                        componentStyle: !0,
                        displayName: !0,
                        extend: !0,
                        styledComponentId: !0,
                        target: !0,
                        warnTooManyClasses: !0,
                        withComponent: !0,
                      }),
                    C
                  );
                };
              })(ze, We),
              He = (function (e, t, n) {
                return function () {
                  var r = he.master,
                    o = n.apply(void 0, arguments),
                    i = e(s(Re(JSON.stringify(o)))),
                    a = "sc-keyframes-" + i;
                  return (
                    r.hasNameForId(a, i) ||
                      r.inject(a, t(o, i, "@keyframes"), i),
                    i
                  );
                };
              })(z, L, U),
              Ue =
                ((function (e, t) {})(L, U),
                (function (e, t) {
                  var n = function (n) {
                    return t(e, n);
                  };
                  return (
                    Le.forEach(function (e) {
                      n[e] = n(e);
                    }),
                    n
                  );
                })(Fe, We));
            t.b = Ue;
          }).call(this, n("5IsQ"), n("Ono3")(e));
        },
        UvJv: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("Oprn"),
              o = n("keud"),
              i = n("6naU");
            t.a = function (t) {
              var n,
                a = t.owner,
                c = t.agentInfo,
                s = Object(o.b)(),
                u = s.botInfo,
                l = s.config.PUBLIC.displayMessage.default.user.avatar,
                f = "";
              switch (a) {
                case i.a.bot:
                  f = u.value && u.value.avatar;
                  break;
                case i.a.agent:
                  f =
                    (null == c ? void 0 : c.avatar) ||
                    (null == (n = s.agentInfo.value) ? void 0 : n.avatar);
                  break;
                case i.a.user:
                  f = l;
              }
              return e(r.a, { className: a, avatarUrl: f });
            };
          }).call(this, n("hosL").h);
        },
        VNWY: function (e, t) {
          ((t = e.exports =
            function (e) {
              return e.replace(/^\s*|\s*$/g, "");
            }).left = function (e) {
            return e.replace(/^\s*/, "");
          }),
            (t.right = function (e) {
              return e.replace(/\s*$/, "");
            });
        },
        "VVj+": function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "d", function () {
              return u;
            }),
            n.d(t, "c", function () {
              return l;
            }),
            n.d(t, "b", function () {
              return f;
            });
          var a = n("UutA"),
            c = n("4hQ3"),
            s = a.b.div.withConfig({
              displayName: "BotMinimizedstyled__BotMinimizedContainer",
              componentId: "sc-1ai90vp-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  justifyContent: "space-between",
                  alignItems: "center",
                  overflow: "visible",
                  img: { display: "none" },
                  display: "block",
                  position: "fixed",
                  bottom: "5vh",
                  right: "5vw",
                  padding: "0",
                  width: "64px",
                  height: "64px",
                  cursor: "pointer",
                  background:
                    t.colors.colorWhite +
                    " url(" +
                    c.a +
                    ") no-repeat center center",
                  backgroundSize: "40px 40px",
                  backgroundPosition: "10px",
                  borderRadius: "50%",
                  boxShadow: "0 0 10px " + t.colors.boxShadow,
                  transition: "opacity .3s",
                  zIndex: 1,
                  "&:hover": { opacity: 0.75 },
                  p: { display: "none" },
                  span: { position: "absolute", top: "-5px", right: "-5px" },
                },
                t.elements.BotMinimizedContainer
              );
            }),
            u = a.b.span.withConfig({
              displayName: "BotMinimizedstyled__UnreadCounter",
              componentId: "sc-1ai90vp-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  background: "#F44336",
                  borderRadius: "100%",
                  width: "24px",
                  height: "24px",
                  textAlign: "center",
                  color: "white",
                  display: "flex",
                  opacity: e.unreadCount ? 1 : 0,
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "11px",
                  animationName: "show-message",
                  animationDuration: ".3s",
                  animationIterationCount: 1,
                  animationFillMode: "forwards",
                },
                e.theme.elements.UnreadCounter
              );
            }),
            l = a.b.div.withConfig({
              displayName: "BotMinimizedstyled__NewMinimizedMessages",
              componentId: "sc-1ai90vp-2",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  position: "absolute",
                  bottom: "60px",
                  right: "40px",
                  borderRadius: "8px",
                  fontSize: "1.6rem",
                  color: "#e9008f",
                  minWidth: "200px",
                  "&.withAnimation": {
                    animationName: "show-message",
                    animationDuration: ".3s",
                    animationIterationCount: 1,
                    animationFillMode: "forwards",
                  },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  right: "10px",
                }),
                t),
                n.elements.NewMinimizedMessages
              );
            }),
            f = a.b.div.withConfig({
              displayName: "BotMinimizedstyled__NewMinimizedMessage",
              componentId: "sc-1ai90vp-3",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  margin: "8px",
                  lineHeight: "18px",
                  background: "white",
                  boxShadow: "0 0 28px rgba(45,99,251,.25)",
                  borderRadius: "10px",
                  padding: "15px 20px",
                  fontWeight: "700",
                  "&:after": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    bottom: "-5px",
                    right: "8px",
                    width: "0",
                    height: "0",
                    border: "14px solid",
                    borderRight: "23px solid",
                    borderColor: " transparent white transparent transparent ",
                  },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  maxWidth: "160px",
                  "&:after": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    bottom: "0px",
                    right: "32px",
                    width: "0",
                    height: "0",
                    border: "14px solid",
                    borderRight: "23px solid",
                    borderColor: " transparent white transparent transparent ",
                  },
                }),
                t),
                n.elements.NewMinimizedMessage
              );
            });
          a.b.img.withConfig({
            displayName: "BotMinimizedstyled__BotIcon",
            componentId: "sc-1ai90vp-4",
          })([".ActionBot &{", "}"], function () {
            return { width: "20px" };
          });
        },
        Ve17: function (e, t, n) {
          (function (e) {
            e.Promise || (e.Promise = n("5+HP").default),
              e.fetch || (e.fetch = n("+TSP"));
          }).call(this, n("pCvA"));
        },
        W0B4: function (e, t, n) {
          e.exports = n("NS33")();
        },
        WE1I: function (e, t) {
          "use strict";
          var n =
              "<[A-Za-z][A-Za-z0-9\\-]*(?:\\s+[a-zA-Z_:][a-zA-Z0-9:._-]*(?:\\s*=\\s*(?:[^\"'=<>`\\u0000-\\u0020]+|'[^']*'|\"[^\"]*\"))?)*\\s*\\/?>",
            r = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
          (t.openCloseTag = new RegExp("^(?:" + n + "|" + r + ")")),
            (t.tag = new RegExp(
              "^(?:" +
                n +
                "|" +
                r +
                "|\x3c!----\x3e|\x3c!--(?:-?[^>-])(?:-?[^-])*--\x3e|<[?].*?[?]>|<![A-Za-z]+\\s+[^>]*>|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>)"
            ));
        },
        WHan: function (e, t, n) {
          "use strict";
          var r,
            o = n("lpWF"),
            i = n("ux2s");
          t.a =
            ((r = {
              "messageInput.textarea.placeholder": {
                pl: "Napisz tutaj swoje pytanie",
                en: "Write your question here.",
                ar: "اكتب سؤالك هنا.",
              },
            }),
            Object(o.a)(i.a, r, window.__actionBot.dictionary || {}));
        },
        WM1S: function (e, t, n) {
          "use strict";
          function r(e, t) {
            (this.file = t),
              (this.offset = {}),
              (this.options = i(this.options)),
              this.setOptions({}),
              (this.inList = !1),
              (this.inBlock = !1),
              (this.inLink = !1),
              (this.atStart = !0),
              (this.toOffset = c(t).toOffset),
              (this.unescape = s(this, "escape")),
              (this.decode = u(this));
          }
          function o(e) {
            var t,
              n = [];
            for (t in e) n.push(t);
            return n;
          }
          var i = n("1hwd"),
            a = n("5MnT"),
            c = n("eq/W"),
            s = n("TevG"),
            u = n("7gIX"),
            l = n("eJG6");
          e.exports = r;
          var f = r.prototype;
          (f.setOptions = n("441o")),
            (f.parse = n("JAS9")),
            (f.options = n("aHIe")),
            (f.exitStart = a("atStart", !0)),
            (f.enterList = a("inList", !1)),
            (f.enterLink = a("inLink", !1)),
            (f.enterBlock = a("inBlock", !1)),
            (f.interruptParagraph = [
              ["thematicBreak"],
              ["atxHeading"],
              ["fencedCode"],
              ["blockquote"],
              ["html"],
              ["setextHeading", { commonmark: !1 }],
              ["definition", { commonmark: !1 }],
              ["footnote", { commonmark: !1 }],
            ]),
            (f.interruptList = [
              ["atxHeading", { pedantic: !1 }],
              ["fencedCode", { pedantic: !1 }],
              ["thematicBreak", { pedantic: !1 }],
              ["definition", { commonmark: !1 }],
              ["footnote", { commonmark: !1 }],
            ]),
            (f.interruptBlockquote = [
              ["indentedCode", { commonmark: !0 }],
              ["fencedCode", { commonmark: !0 }],
              ["atxHeading", { commonmark: !0 }],
              ["setextHeading", { commonmark: !0 }],
              ["thematicBreak", { commonmark: !0 }],
              ["html", { commonmark: !0 }],
              ["list", { commonmark: !0 }],
              ["definition", { commonmark: !1 }],
              ["footnote", { commonmark: !1 }],
            ]),
            (f.blockTokenizers = {
              newline: n("KhCN"),
              indentedCode: n("U1eE"),
              fencedCode: n("f5UB"),
              blockquote: n("c+XX"),
              atxHeading: n("nSJr"),
              thematicBreak: n("t7Gb"),
              list: n("Oy/O"),
              setextHeading: n("flQL"),
              html: n("YSxt"),
              footnote: n("7Wk+"),
              definition: n("8khG"),
              table: n("Nsjb"),
              paragraph: n("fg5I"),
            }),
            (f.inlineTokenizers = {
              escape: n("BEgE"),
              autoLink: n("5JIT"),
              url: n("IPT0"),
              html: n("RYfs"),
              link: n("wTL/"),
              reference: n("oJuM"),
              strong: n("RAL3"),
              emphasis: n("KsPC"),
              deletion: n("O4yG"),
              code: n("/liA"),
              break: n("KeAI"),
              text: n("nKcA"),
            }),
            (f.blockMethods = o(f.blockTokenizers)),
            (f.inlineMethods = o(f.inlineTokenizers)),
            (f.tokenizeBlock = l("block")),
            (f.tokenizeInline = l("inline")),
            (f.tokenizeFactory = l);
        },
        WcAn: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("bS4j"),
              o = n("dL1j"),
              i = n("keud");
            t.a = function (t) {
              function n() {
                u(function (e) {
                  return !e;
                });
              }
              var a = t.onOptionSelect,
                c = Object(i.b)().mainMenuActive,
                s = c.value,
                u = c.set;
              return e(
                r.a,
                {
                  tabIndex: 0,
                  onBlur: function () {
                    return u(!1);
                  },
                },
                e(r.b, { onClick: n, open: s }),
                e(o.a, { open: s, toggleMenu: n, onOptionSelect: a })
              );
            };
          }).call(this, n("hosL").h);
        },
        WhRf: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return i;
          });
          var i = n("UutA").b.iframe.withConfig({
            displayName: "EmbeddedMapstyled__EmbeddedMapContainer",
            componentId: "smh09u-0",
          })([".ActionBot &{", "}"], function (e) {
            return (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      o(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            })(
              {
                height: "17.5rem",
                position: "relative",
                left: "-25px",
                width: "calc(100% + 45px)",
                marginTop: "20px",
                marginBottom: "20px",
                "&.fullscreen": { height: "35rem" },
              },
              e.theme.elements.messages.EmbeddedMapContainer
            );
          });
        },
        XAzd: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r);
              }
              return n;
            }
            function o(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      i(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            }
            function i(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function a() {
              var e,
                t = Object(l.b)().language.value;
              try {
                e = Object(s.b)(p);
              } catch (t) {
                e = Object(f.a)("app");
              }
              var n = {};
              for (var r in e) n[r] = e[r][t];
              return n;
            }
            n.d(t, "b", function () {
              return a;
            }),
              n.d(t, "a", function () {
                return d;
              });
            var c = n("hosL"),
              s = n("QRet"),
              u = n("ux2s"),
              l = n("keud"),
              f = n("c37Q"),
              p = Object(c.createContext)({}),
              d = function (t) {
                var n = t.children,
                  r = t.dictionary;
                return e(p.Provider, { value: o(o({}, u.a), r) }, n);
              };
          }).call(this, n("hosL").h);
        },
        XWQ4: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "k", function () {
              return u;
            }),
            n.d(t, "h", function () {
              return l;
            }),
            n.d(t, "b", function () {
              return f;
            }),
            n.d(t, "g", function () {
              return p;
            }),
            n.d(t, "c", function () {
              return d;
            }),
            n.d(t, "j", function () {
              return h;
            }),
            n.d(t, "d", function () {
              return g;
            }),
            n.d(t, "e", function () {
              return m;
            }),
            n.d(t, "f", function () {
              return b;
            }),
            n.d(t, "i", function () {
              return y;
            });
          var a = n("UutA"),
            c = n("6naU"),
            s = a.b.div.withConfig({
              displayName: "Attachmentstyled__AttachmentContainer",
              componentId: "ad3ede-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.owner;
              return o(
                {
                  display: "flex",
                  justifyContent:
                    t === c.a.agent || t === c.a.bot
                      ? "flex-start"
                      : "flex-end",
                  marginBottom: "10px",
                  marginTop: "8px",
                  position: "relative",
                },
                e.theme.elements.messages.AttachmentContainer
              );
            }),
            u = a.b.div.withConfig({
              displayName: "Attachmentstyled__AttachmentWrapper",
              componentId: "ad3ede-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  float: "right",
                  border: "1px solid lightgray",
                  borderRadius: "15px",
                },
                e.theme.elements.messages.AttachmentWrapper
              );
            }),
            l = a.b.div.withConfig({
              displayName: "Attachmentstyled__AttachmentImageWrapper",
              componentId: "ad3ede-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { float: "right", position: "relative", borderRadius: "15px" },
                e.theme.elements.messages.AttachmentImageWrapper
              );
            }),
            f =
              (a.b.img.withConfig({
                displayName: "Attachmentstyled__AttachmentImage",
                componentId: "ad3ede-3",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  { maxWidth: "15.5rem", maxHeight: "12.5rem" },
                  e.theme.elements.messages.AttachmentImage
                );
              }),
              a.b.div.withConfig({
                displayName: "Attachmentstyled__AttachmentFile",
                componentId: "ad3ede-4",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    padding: "10px",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  },
                  e.theme.elements.messages.AttachmentImage
                );
              })),
            p = a.b.img.withConfig({
              displayName: "Attachmentstyled__AttachmentImageFile",
              componentId: "ad3ede-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  maxHeight: "200px",
                  maxWidth: "230px",
                  minHeight: "80px",
                  minWidth: "100px",
                  borderRadius: "15px",
                },
                e.theme.elements.messages.AttachmentImageFile
              );
            }),
            d = a.b.img.withConfig({
              displayName: "Attachmentstyled__AttachmentFileIcon",
              componentId: "ad3ede-6",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { maxWidth: "15.5rem", maxHeight: "12.5rem" },
                e.theme.elements.messages.AttachmentFileIcon
              );
            }),
            h = a.b.a.withConfig({
              displayName: "Attachmentstyled__AttachmentUrlWrapperComponentA",
              componentId: "ad3ede-7",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { color: "unset", textDecoration: "unset" },
                e.theme.elements.messages.AttachmentUrlWrapperComponentA
              );
            }),
            g = a.b.div.withConfig({
              displayName: "Attachmentstyled__AttachmentFileInfo",
              componentId: "ad3ede-8",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  alignItems: "flex-start",
                  textAlign: "left",
                  minWidth: "110px",
                  justifyContent: "center",
                },
                e.theme.elements.messages.AttachmentFileInfo
              );
            }),
            m = a.b.p.withConfig({
              displayName: "Attachmentstyled__AttachmentFileInfoName",
              componentId: "ad3ede-9",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  fontSize: "13px",
                  marginBottom: void 0 !== e.fileSize ? "5px" : 0,
                  fontWeight: "bold",
                  maxWidth: "170px",
                },
                e.theme.elements.messages.AttachmentFileInfoName
              );
            }),
            b = a.b.p.withConfig({
              displayName: "Attachmentstyled__AttachmentFileInfoSize",
              componentId: "ad3ede-10",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { opacity: 0.5, fontSize: "13px", maxWidth: "170px" },
                e.theme.elements.messages.AttachmentFileInfoSize
              );
            }),
            y = a.b.div.withConfig({
              displayName: "Attachmentstyled__AttachmentSending",
              componentId: "ad3ede-11",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  position: "absolute !important",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#00000066",
                  zIndex: 1,
                  top: 0,
                  left: 0,
                  borderRadius: "15px",
                  "&:after": {
                    content: "''",
                    width: "20px",
                    height: "20px",
                    borderRadius: "100%",
                    border: "3px solid #ffffff66",
                    borderTop: "3px solid white",
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    zIndex: 2,
                    transform: "translate(-50%,-50%)",
                    animationName: "loader",
                    animationIterationCount: "infinite",
                    animationDuration: "1s",
                  },
                },
                e.theme.elements.messages.AttachmentSending
              );
            });
          a.b.div.withConfig({
            displayName: "Attachmentstyled__AttachmentSendingAbort",
            componentId: "ad3ede-12",
          })([".ActionBot &{", "}"], function (e) {
            return o(
              {
                position: "absolute",
                width: "40px",
                height: "40px",
                backgroundColor: "#000000aa",
                zIndex: 3,
                top: "5px",
                right: "5px",
                borderRadius: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "&:before": {
                  content: "''",
                  position: "absolute",
                  width: "15px",
                  height: "1px",
                  backgroundColor: "white",
                  transform: "rotate(135deg)",
                },
                "&:after": {
                  content: "''",
                  position: "absolute",
                  width: "15px",
                  height: "1px",
                  backgroundColor: "white",
                  transform: "rotate(45deg)",
                },
              },
              e.theme.elements.messages.AttachmentSendingAbort
            );
          });
        },
        XeXk: function (e) {
          "use strict";
          function t(e) {
            var t = e || {};
            return t.commonmark ? o : t.gfm ? r : n;
          }
          e.exports = t;
          var n = [
              "\\",
              "`",
              "*",
              "{",
              "}",
              "[",
              "]",
              "(",
              ")",
              "#",
              "+",
              "-",
              ".",
              "!",
              "_",
              ">",
            ],
            r = n.concat(["~", "|"]),
            o = r.concat([
              "\n",
              '"',
              "$",
              "%",
              "&",
              "'",
              ",",
              "/",
              ":",
              ";",
              "<",
              "=",
              "?",
              "@",
              "^",
            ]);
          (t.default = n), (t.gfm = r), (t.commonmark = o);
        },
        XmUT: function (e, t, n) {
          "use strict";
          function r(e, t) {
            function n() {
              return (
                e.children &&
                e.children.map(function (n, o) {
                  return r(n, t, { node: e, props: d }, o);
                })
              );
            }
            var i =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : {},
              c =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : 0,
              l = t.renderers[e.type];
            void 0 === e.position &&
              (e.position = (i.node && i.node.position) || u);
            var f = e.position.start,
              p = [e.type, f.line, f.column, c].join("-");
            if (!s.isValidElementType(l))
              throw new Error(
                "Renderer for type `".concat(
                  e.type,
                  "` not defined or is not renderable"
                )
              );
            var d = o(e, p, t, l, i, c);
            return a.createElement(l, d, d.children || n() || void 0);
          }
          function o(e, t, n, o, s, u) {
            var l,
              f = { key: t },
              p = "string" == typeof o;
            n.sourcePos &&
              e.position &&
              (f["data-sourcepos"] = [
                (l = e.position).start.line,
                ":",
                l.start.column,
                "-",
                l.end.line,
                ":",
                l.end.column,
              ]
                .map(String)
                .join("")),
              n.rawSourcePos && !p && (f.sourcePosition = e.position),
              n.includeNodeIndex &&
                s.node &&
                s.node.children &&
                !p &&
                ((f.index = s.node.children.indexOf(e)),
                (f.parentChildCount = s.node.children.length));
            var d =
              null != e.identifier ? n.definitions[e.identifier] || {} : null;
            switch (e.type) {
              case "root":
                i(f, { className: n.className });
                break;
              case "text":
                (f.nodeKey = t), (f.children = e.value);
                break;
              case "heading":
                f.level = e.depth;
                break;
              case "list":
                (f.start = e.start),
                  (f.ordered = e.ordered),
                  (f.tight = !e.loose),
                  (f.depth = e.depth);
                break;
              case "listItem":
                (f.checked = e.checked),
                  (f.tight = !e.loose),
                  (f.ordered = e.ordered),
                  (f.index = e.index),
                  (f.children = (function (e, t) {
                    if (e.loose) return e.children;
                    if (
                      t.node &&
                      e.index > 0 &&
                      t.node.children[e.index - 1].loose
                    )
                      return e.children;
                    return (function (e) {
                      return e.children.reduce(function (e, t) {
                        return e.concat(
                          "paragraph" === t.type ? t.children || [] : [t]
                        );
                      }, []);
                    })(e);
                  })(e, s).map(function (t, o) {
                    return r(t, n, { node: e, props: f }, o);
                  }));
                break;
              case "definition":
                i(f, { identifier: e.identifier, title: e.title, url: e.url });
                break;
              case "code":
                i(f, { language: e.lang && e.lang.split(/\s/, 1)[0] });
                break;
              case "inlineCode":
                (f.children = e.value), (f.inline = !0);
                break;
              case "link":
                i(f, {
                  title: e.title || void 0,
                  target:
                    "function" == typeof n.linkTarget
                      ? n.linkTarget(e.url, e.children, e.title)
                      : n.linkTarget,
                  href: n.transformLinkUri
                    ? n.transformLinkUri(e.url, e.children, e.title)
                    : e.url,
                });
                break;
              case "image":
                i(f, {
                  alt: e.alt || void 0,
                  title: e.title || void 0,
                  src: n.transformImageUri
                    ? n.transformImageUri(e.url, e.children, e.title, e.alt)
                    : e.url,
                });
                break;
              case "linkReference":
                i(
                  f,
                  c(d, {
                    href: n.transformLinkUri
                      ? n.transformLinkUri(d.href)
                      : d.href,
                  })
                );
                break;
              case "imageReference":
                i(f, {
                  src:
                    n.transformImageUri && d.href
                      ? n.transformImageUri(d.href, e.children, d.title, e.alt)
                      : d.href,
                  title: d.title || void 0,
                  alt: e.alt || void 0,
                });
                break;
              case "table":
              case "tableHead":
              case "tableBody":
                f.columnAlignment = e.align;
                break;
              case "tableRow":
                (f.isHeader = "tableHead" === s.node.type),
                  (f.columnAlignment = s.props.columnAlignment);
                break;
              case "tableCell":
                i(f, {
                  isHeader: s.props.isHeader,
                  align: s.props.columnAlignment[u],
                });
                break;
              case "virtualHtml":
                f.tag = e.tag;
                break;
              case "html":
                (f.isBlock = e.position.start.line !== e.position.end.line),
                  (f.escapeHtml = n.escapeHtml),
                  (f.skipHtml = n.skipHtml);
                break;
              case "parsedHtml":
                var h;
                e.children &&
                  (h = e.children.map(function (t, o) {
                    return r(t, n, { node: e, props: f }, o);
                  })),
                  (f.escapeHtml = n.escapeHtml),
                  (f.skipHtml = n.skipHtml),
                  (f.element = (function (e, t) {
                    var n = e.element;
                    if (Array.isArray(n)) {
                      return a.createElement(a.Fragment || "div", null, n);
                    }
                    if (n.props.children || t) {
                      var r = a.Children.toArray(n.props.children).concat(t);
                      return a.cloneElement(n, null, r);
                    }
                    return a.cloneElement(n, null);
                  })(e, h));
                break;
              default:
                i(
                  f,
                  c(e, { type: void 0, position: void 0, children: void 0 })
                );
            }
            return !p && e.value && (f.value = e.value), f;
          }
          function i(e, t) {
            for (var n in t) void 0 !== t[n] && (e[n] = t[n]);
          }
          var a = n("l8WD"),
            c = n("1hwd"),
            s = n("xVO4"),
            u = {
              start: { line: 1, column: 1, offset: 0 },
              end: { line: 1, column: 1, offset: 0 },
            };
          e.exports = r;
        },
        YLzx: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("ohaA"),
              o = n("ITsB");
            t.a = function (t) {
              var n = t.message,
                i = t.onOptionSelect,
                a = [],
                c = new (0, Object(o.b)().ControlService)();
              return (
                n.content.options.forEach(function (e) {
                  if ("images" === e.label)
                    try {
                      a = JSON.parse(e.value);
                    } catch (e) {
                      console.error(e);
                    }
                }),
                e(
                  r.a,
                  { fullScreen: !1 },
                  a.map(function (t) {
                    return e(
                      r.b,
                      null,
                      e("img", {
                        src: t.url,
                        onLoad: function () {
                          return c.scrollToBottom();
                        },
                        onClick: function () {
                          i(t.title);
                        },
                      })
                    );
                  })
                )
              );
            };
          }).call(this, n("hosL").h);
        },
        YMuc: function (e, t, n) {
          "use strict";
          (function (e, r) {
            var o = n("QRet"),
              i = n("UutA"),
              a = n("4ohi"),
              c = n("keud"),
              s = n("ITsB"),
              u = n("oPgs"),
              l = n("XAzd"),
              f = n("ReYd"),
              p = n("uCBw"),
              d = n("nbD9"),
              h = n("c37Q"),
              g = n("fulh"),
              m = n("LoPn"),
              b = n("nYUH"),
              y = n.n(b),
              v = n("l8WD"),
              O = n("GMTn");
            y.a.polyfill();
            var w = function () {
                function e(e) {
                  try {
                    g(e);
                  } catch (e) {}
                }
                var t = Object(c.b)(),
                  n = t.config,
                  r = n.PROTECTED.agent && n.PROTECTED.agent.available;
                if (!r) return null;
                var i = t.userSentFirstMessage.value,
                  a = t.skipAgentConnection.value,
                  u = Object(s.b)().AgentConnectionService,
                  l = n.PROTECTED.connection.sendMessageToAgent,
                  f = Object(o.k)(!1),
                  h = f[0],
                  g = f[1],
                  m = Object(o.h)(function () {
                    return Object(p.a)({
                      url: l.url,
                      onMessage: u.onMessage,
                      onError: u.onError,
                      onClose: function () {
                        e(!1);
                      },
                      onOpen: function () {
                        e(!0), u.onOpen();
                      },
                    });
                  }, []),
                  b = new u(m);
                return (
                  Object(o.d)(
                    function () {
                      r && h && b.sendUserInfoToAgent();
                    },
                    [h]
                  ),
                  Object(o.d)(
                    function () {
                      r && t.agentHandover.value && b.sendHandoverToAgent();
                    },
                    [t.agentHandover.value]
                  ),
                  Object(o.d)(
                    function () {
                      r &&
                        h &&
                        t.agentLeftChat.value &&
                        b.closeConnectionToAgent();
                    },
                    [t.agentLeftChat.value]
                  ),
                  Object(o.d)(
                    function () {
                      r &&
                        !h &&
                        !1 === a &&
                        !h &&
                        i &&
                        (Object(d.a)().log(
                          "&&& SHOULD OPEN CONNECTION TO AGENT"
                        ),
                        Object(d.a)().log("websocket.isWSOpened", h),
                        b.openConnectionToAgent()),
                        i || t.replyForFirstUserMessage.set(void 0);
                    },
                    [h, i, a]
                  ),
                  null
                );
              },
              x = function (e) {
                var t = e.children,
                  n = Object(c.b)();
                return Object(h.b)("app", n), t;
              },
              _ = function (e) {
                var t = e.children,
                  n = Object(s.b)();
                return Object(h.b)("services", n), t;
              },
              j = function (e) {
                var t = e.children,
                  n = Object(l.b)();
                return Object(h.b)("dictionary", n), t;
              },
              S = function (e) {
                var t = e.children,
                  n = Object(f.b)();
                return Object(h.b)("emoji", n), t;
              },
              k = function (t) {
                var n = t.behavior,
                  i = Object(s.b)().BehaviorService;
                return (
                  Object(o.d)(function () {
                    Object(g.a)();
                  }, []),
                  Object(o.d)(function () {
                    function e(e) {
                      i.dispatchEvent("pageLoad", e);
                    }
                    function t(e) {
                      i.dispatchEvent("formFocus", e);
                    }
                    function r(e) {
                      i.dispatchEvent("formSubmit", e);
                    }
                    new i(n),
                      (window.__actionBot.dispatchEvent = i.dispatchEvent);
                    var o = setTimeout(function () {
                      i.dispatchEvent("pageSpendTime");
                    }, n.pageSpendTime.delay);
                    window.addEventListener("DOMContentLoaded", e);
                    var a = document.getElementsByTagName("form");
                    if (
                      (setTimeout(function () {
                        i.dispatchEvent("load");
                      }, 1e3),
                      a)
                    )
                      for (var c = 0; c < a.length; c++)
                        a[c].addEventListener("focus", t, !0),
                          a[c].addEventListener("submit", r, !0);
                    return function () {
                      if (
                        (window.removeEventListener("DOMContentLoaded", e),
                        clearTimeout(o),
                        a)
                      )
                        for (var n = 0; n < a.length; n++)
                          a[n].removeEventListener("focus", t, !0),
                            a[n].removeEventListener("submit", r, !0);
                    };
                  }, []),
                  e(r, null)
                );
              },
              C = function (e) {
                var t,
                  n = e.theme,
                  r = e.themeExtensions,
                  o = void 0 === r ? [] : r,
                  i = e.children,
                  a = Object(s.b)().ThemeService.getThemeExtension(),
                  c = Object(v.useRef)(null);
                c.current || (c.current = JSON.stringify(n));
                var u =
                  null ==
                  (t = o.find(function (e) {
                    return e.name === a;
                  }))
                    ? void 0
                    : t.theme;
                return (
                  u
                    ? (n = Object(O.a)(n, u))
                    : c.current && (n = Object(O.a)(n, JSON.parse(c.current))),
                  i
                );
              };
            t.a = Object(i.d)(function (t) {
              var n = t.config,
                r = t.services,
                o = t.theme,
                p = t.themeExtensions,
                d = t.dictionary,
                h = t.behavior,
                g = t.MinimizedComponent,
                b = t.MessagesCustomContainer,
                y = t.appStore,
                v = t.emoji,
                O = t.WrapperComponent,
                P = t.components;
              return (
                Object(m.a)(),
                O
                  ? e(
                      O,
                      {
                        config: n,
                        services: r,
                        theme: o,
                        themeExtensions: p,
                        dictionary: d,
                        behavior: h,
                        MinimizedComponent: g,
                        MessagesCustomContainer: b,
                        appStore: y,
                        components: P,
                        emoji: v,
                      },
                      e(
                        f.a,
                        { emoji: v },
                        e(
                          S,
                          null,
                          e(
                            u.a,
                            null,
                            e(w, null),
                            e(k, { behavior: h }),
                            e(a.a, {
                              behavior: h,
                              components: P,
                              MinimizedComponent: g,
                              MessagesCustomContainer: b,
                            })
                          )
                        )
                      )
                    )
                  : e(
                      c.a,
                      { config: n, platformAppStore: y },
                      e(
                        x,
                        null,
                        e(
                          s.a,
                          { services: r },
                          e(
                            _,
                            null,
                            e(
                              f.a,
                              { emoji: v },
                              e(
                                S,
                                null,
                                e(
                                  C,
                                  { themeExtensions: p, theme: o },
                                  e(
                                    i.a,
                                    { theme: o },
                                    e(
                                      l.a,
                                      { dictionary: d },
                                      e(
                                        j,
                                        null,
                                        e(
                                          u.a,
                                          null,
                                          e(w, null),
                                          e(k, { behavior: h }),
                                          e(a.a, {
                                            behavior: h,
                                            components: P,
                                            MinimizedComponent: g,
                                            MessagesCustomContainer: b,
                                          })
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
              );
            });
          }).call(this, n("hosL").h, n("hosL").Fragment);
        },
        YN0Q: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("NFJw"),
              o = n("H1yl"),
              i = n("UvJv"),
              a = n("keud"),
              c = n("nbD9");
            t.a = function (t) {
              var n,
                s,
                u,
                l,
                f,
                p,
                d = t.children,
                h = t.group,
                g = h.owner,
                m = h.messages,
                b = h.withoutAvatar,
                y = h.withoutDate,
                v = h.agentInfo,
                O =
                  (m && m[m.length - 1] && m[m.length - 1].date) || new Date();
              if (!(O instanceof Date))
                try {
                  O = new Date(O);
                } catch (e) {
                  Object(c.a)().log(e);
                }
              var w = Object(a.b)().config.PUBLIC.displayMessage,
                x =
                  (null == (n = w.avatar) ? void 0 : n.enabled) &&
                  !(
                    null != (s = w.avatar) &&
                    null != (u = s.blackList) &&
                    u.includes(g)
                  ),
                _ =
                  (null == (l = w.date) ? void 0 : l.enabled) &&
                  !(
                    null != (f = w.date) &&
                    null != (p = f.blackList) &&
                    p.includes(g)
                  );
              return e(
                r.c,
                { className: g },
                e(
                  r.d,
                  { className: g },
                  x && !b && e(i.a, { owner: g, agentInfo: v }),
                  e(
                    r.b,
                    null,
                    d,
                    _ && !y && e(r.a, { className: g }, Object(o.a)(O))
                  )
                )
              );
            };
          }).call(this, n("hosL").h);
        },
        YSxt: function (e, t, n) {
          "use strict";
          var r = n("WE1I").openCloseTag;
          e.exports = function (e, t, n) {
            for (
              var o,
                i,
                a,
                c,
                s,
                u,
                l,
                f = t.length,
                p = 0,
                d = [
                  [
                    /^<(script|pre|style)(?=(\s|>|$))/i,
                    /<\/(script|pre|style)>/i,
                    !0,
                  ],
                  [/^<!--/, /-->/, !0],
                  [/^<\?/, /\?>/, !0],
                  [/^<![A-Za-z]/, />/, !0],
                  [/^<!\[CDATA\[/, /\]\]>/, !0],
                  [
                    new RegExp(
                      "^</?(" +
                        this.options.blocks.join("|") +
                        ")(?=(\\s|/?>|$))",
                      "i"
                    ),
                    /^$/,
                    !0,
                  ],
                  [new RegExp(r.source + "\\s*$"), /^$/, !1],
                ];
              p < f && ("\t" === (c = t.charAt(p)) || " " === c);

            )
              p++;
            if ("<" === t.charAt(p)) {
              for (
                o = t.indexOf("\n", p + 1),
                  i = t.slice(p, (o = -1 === o ? f : o)),
                  a = -1,
                  s = d.length;
                ++a < s;

              )
                if (d[a][0].test(i)) {
                  u = d[a];
                  break;
                }
              if (u) {
                if (n) return u[2];
                if (((p = o), !u[1].test(i)))
                  for (; p < f; ) {
                    if (
                      ((o = t.indexOf("\n", p + 1)),
                      (i = t.slice(p + 1, (o = -1 === o ? f : o))),
                      u[1].test(i))
                    ) {
                      i && (p = o);
                      break;
                    }
                    p = o;
                  }
                return e((l = t.slice(0, p)))({ type: "html", value: l });
              }
            }
          };
        },
        a0t2: function (e, t, n) {
          "use strict";
          t.a = n.p + "31e3187208e143d025a5a2b854262466.svg";
        },
        aHIe: function (e, t, n) {
          "use strict";
          e.exports = {
            position: !0,
            gfm: !0,
            commonmark: !1,
            footnotes: !1,
            pedantic: !1,
            blocks: n("1Pp1"),
          };
        },
        aTGq: function (e, t, n) {
          "use strict";
          n.d(t, "a", function () {
            return o;
          });
          var r = n("keud");
          n.d(t, "b", function () {
            return r.b;
          });
          var o = function (e) {
            return e;
          };
        },
        aWFM: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(e, t) {
              return (r =
                Object.setPrototypeOf ||
                function (e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            n.d(t, "a", function () {
              return c;
            });
            var o = n("bov0"),
              i = n("ITsB"),
              a = n("keud"),
              c = (function (t) {
                function n() {
                  for (
                    var n, r = arguments.length, o = new Array(r), c = 0;
                    c < r;
                    c++
                  )
                    o[c] = arguments[c];
                  return (
                    ((n =
                      t.call.apply(t, [this].concat(o)) || this).getRenderers =
                      function () {
                        return {
                          link: function (t) {
                            var n = t.href,
                              r = t.children,
                              o = new (Object(i.b)("RedirectService"))(),
                              c = Object(a.b)();
                            return e(
                              "a",
                              {
                                href: n,
                                onClick: function (e) {
                                  n.match(
                                    /^((mailto|callto|tel|skype|sms|fax|):)/g
                                  ) ||
                                    (e.preventDefault(),
                                    c.minimized.set(!0),
                                    setTimeout(function () {
                                      o._saveStore(),
                                        n.match(/(.pdf)$/g) ||
                                        !n.match(/(tasil.omantel.om)/g)
                                          ? window.open(n, "_blank")
                                          : o.redirectTo(n);
                                    }, 0));
                                },
                              },
                              r
                            );
                          },
                        };
                      }),
                    n
                  );
                }
                var o, c;
                return (
                  (c = t),
                  ((o = n).prototype = Object.create(c.prototype)),
                  (o.prototype.constructor = o),
                  r(o, c),
                  n
                );
              })(o.c);
          }).call(this, n("hosL").h);
        },
        ajvC: function (e) {
          "use strict";
          e.exports = function (e) {
            if (e) throw e;
          };
        },
        bNNV: function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              return (r =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            var o = n("BNKq"),
              i = n("2UUl"),
              a = n.n(i),
              c = (n("IO5D"), n("tCvC"), n("hosL")),
              s = n("QRet"),
              u = n("keud");
            t.a = function (t) {
              var n = t.slides,
                i = t.sliderConfig,
                l = t.onOptionSelect,
                f = Object(c.createRef)(),
                p = Object(u.b)().config,
                d = (i || p.PUBLIC.carousel).settings,
                h = Object(s.k)(!1),
                g = h[0],
                m = h[1],
                b = !d.arrows && "hidden",
                y = {
                  beforeChange: function () {
                    m(!0);
                  },
                  afterChange: function () {
                    m(!1);
                  },
                };
              if (n) {
                var v = n.map(function (t) {
                  return e(
                    o.h,
                    {
                      onClick: function () {
                        return (e = t.value), void (g || l(e));
                        var e;
                      },
                    },
                    e(
                      o.a,
                      null,
                      e(o.e, { src: t.icon }),
                      e(o.g, null, t.price)
                    ),
                    e(
                      o.f,
                      null,
                      e("p", null, t.subtitle),
                      e("p", null, e("b", null, t.title))
                    )
                  );
                });
                return e(
                  o.d,
                  null,
                  e(a.a, r({}, d, y, { ref: f }), v),
                  e(
                    o.b,
                    {
                      className: b,
                      onClick: function () {
                        return f.current.slickPrev();
                      },
                    },
                    "<"
                  ),
                  e(
                    o.c,
                    {
                      className: b,
                      onClick: function () {
                        return f.current.slickNext();
                      },
                    },
                    ">"
                  )
                );
              }
            };
          }).call(this, n("hosL").h);
        },
        bO4D: function (e) {
          "use strict";
          e.exports = function (e, n) {
            var r,
              o = t.length,
              i = -1,
              a = -1;
            if (!this.options.gfm) return -1;
            for (; ++i < o; )
              -1 !== (r = e.indexOf(t[i], n)) && (r < a || -1 === a) && (a = r);
            return a;
          };
          var t = ["https://", "http://", "mailto:"];
        },
        bS4j: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return f;
          }),
            n.d(t, "b", function () {
              return p;
            });
          var a = n("UutA"),
            c = n.p + "81afe7820f86f5916c050eefa6fcacc3.svg",
            s = n.p + "706f1f35f96f21ba5c9946513060ee92.svg",
            u = n.p + "127d081bea3b1d62202f17f4de235d3e.svg",
            l = n.p + "5cd232efbc588ac7f8524d849ea7d2ed.svg",
            f = a.b.div.withConfig({
              displayName: "Menustyled__MenuContainer",
              componentId: "sl4n3y-0",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  width: "20px",
                  minWidth: "20px",
                  height: "20px",
                  marginLeft: "10px",
                },
                e.theme.elements.MenuContainer
              );
            }),
            p = a.b.div.withConfig({
              displayName: "Menustyled__MenuIcon",
              componentId: "sl4n3y-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.open;
              return o(
                {
                  backgroundImage: t ? "url(" + s + ")" : "url(" + c + ")",
                  width: "100%",
                  height: "100%",
                  backgroundSize: "contain",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundImage: t ? "url(" + l + ")" : "url(" + u + ")",
                    opacity: "0.8",
                  },
                },
                e.theme.elements.MenuIcon
              );
            });
        },
        "bb/9": function (e, t, n) {
          "use strict";
          function r(e) {
            return (
              (e >= 1 && e <= 8) ||
              11 === e ||
              (e >= 13 && e <= 31) ||
              (e >= 127 && e <= 159) ||
              (e >= 64976 && e <= 65007) ||
              65535 == (65535 & e) ||
              65534 == (65535 & e)
            );
          }
          var o = n("0Q8B"),
            i = n("q8Rk"),
            a = n("Qfee"),
            c = n("pyeF"),
            s = n("w60P"),
            u = n("Ck5b");
          e.exports = function (e, t) {
            var n,
              a,
              c = {};
            for (a in (t || (t = {}), d)) c[a] = null == (n = t[a]) ? d[a] : n;
            return (
              (c.position.indent || c.position.start) &&
                ((c.indent = c.position.indent || []),
                (c.position = c.position.start)),
              (function (e, t) {
                function n() {
                  return { line: Y, column: V, offset: q + (F.offset || 0) };
                }
                function a() {
                  $ &&
                    (J.push($),
                    D && D.call(N, $, { start: I, end: n() }),
                    ($ = ""));
                }
                var c,
                  d,
                  v,
                  O,
                  w,
                  x,
                  _,
                  j,
                  S,
                  k,
                  C,
                  P,
                  A,
                  I,
                  T,
                  E,
                  B = t.additional,
                  M = t.nonTerminated,
                  D = t.text,
                  L = t.reference,
                  R = t.warning,
                  N = t.textContext,
                  z = t.referenceContext,
                  W = t.warningContext,
                  F = t.position,
                  H = t.indent || [],
                  U = e.length,
                  q = 0,
                  G = -1,
                  V = F.column || 1,
                  Y = F.line || 1,
                  $ = "",
                  J = [];
                "string" == typeof B && (B = B.charCodeAt(0));
                (I = n()),
                  R
                    ? function (e, t) {
                        var r = n();
                        (r.column += t), (r.offset += t), R.call(W, y[e], r, e);
                      }
                    : p,
                  q--,
                  U++;
                for (; ++q < U; )
                  if (
                    (10 === w && (V = H[G] || 1), 38 === (w = e.charCodeAt(q)))
                  ) {
                    if (
                      9 === (_ = e.charCodeAt(q + 1)) ||
                      10 === _ ||
                      12 === _ ||
                      32 === _ ||
                      38 === _ ||
                      60 === _ ||
                      _ != _ ||
                      (B && _ === B)
                    ) {
                      ($ += f(w)), V++;
                      continue;
                    }
                    for (
                      k = C = q + 1,
                        E = C,
                        35 === _
                          ? ((E = ++k),
                            88 === (_ = e.charCodeAt(E)) || 120 === _
                              ? ((P = g), (E = ++k))
                              : (P = "decimal"))
                          : (P = h),
                        c = "",
                        S = "",
                        O = "",
                        A = b[P],
                        E--;
                      ++E < U && ((_ = e.charCodeAt(E)), A(_));

                    )
                      (O += f(_)),
                        P === h && l.call(o, O) && ((c = O), (S = o[O]));
                    (v = 59 === e.charCodeAt(E)) &&
                      (E++, (d = P === h && u(O)) && ((c = O), (S = d))),
                      1 + E - C,
                      (v || M) &&
                        O &&
                        (P === h
                          ? ((v && !S) ||
                              (c !== O &&
                                (1 + (E = k + c.length) - k, (v = !1)),
                              v ||
                                (c ? 1 : 3,
                                t.attribute &&
                                  (61 === (_ = e.charCodeAt(E)) || s(_)) &&
                                  (S = null))),
                            (x = S))
                          : ((x = parseInt(O, m[P])),
                            ((K = x) >= 55296 && K <= 57343) || K > 1114111
                              ? (x = f(65533))
                              : x in i
                              ? (x = i[x])
                              : ((j = ""),
                                r(x),
                                x > 65535 &&
                                  ((j += f(((x -= 65536) >>> 10) | 55296)),
                                  (x = 56320 | (1023 & x))),
                                (x = j + f(x))))),
                      x
                        ? (a(),
                          (I = n()),
                          (q = E - 1),
                          (V += E - C + 1),
                          J.push(x),
                          (T = n()).offset++,
                          L &&
                            L.call(
                              z,
                              x,
                              { start: I, end: T },
                              e.slice(C - 1, E)
                            ),
                          (I = T))
                        : ((O = e.slice(C - 1, E)),
                          ($ += O),
                          (V += O.length),
                          (q = E - 1));
                  } else
                    10 === w && (Y++, G++, (V = 0)),
                      w == w ? (($ += f(w)), V++) : a();
                var K;
                return J.join("");
              })(e, c)
            );
          };
          var l = {}.hasOwnProperty,
            f = String.fromCharCode,
            p = Function.prototype,
            d = {
              warning: null,
              reference: null,
              text: null,
              warningContext: null,
              referenceContext: null,
              textContext: null,
              position: {},
              additional: null,
              attribute: !1,
              nonTerminated: !0,
            },
            h = "named",
            g = "hexadecimal",
            m = { hexadecimal: 16, decimal: 10 },
            b = {};
          (b[h] = s), (b.decimal = a), (b[g] = c);
          var y = {
            1: "Named character references must be terminated by a semicolon",
            2: "Numeric character references must be terminated by a semicolon",
            3: "Named character references cannot be empty",
            4: "Numeric character references cannot be empty",
            5: "Named character references must be known",
            6: "Numeric character references cannot be disallowed",
            7: "Numeric character references cannot be outside the permissible Unicode range",
          };
        },
        bbLs: function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              return (r =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            var o = n("fADn"),
              i = n("2UUl"),
              a = n.n(i),
              c = (n("IO5D"), n("tCvC"), n("hosL")),
              s = n("QRet"),
              u = n("keud"),
              l = n("LO0j"),
              f = n.n(l),
              p = n("ITsB");
            t.a = function (t) {
              var n = t.slides,
                i = t.sliderConfig,
                l = t.onOptionSelect,
                d = Object(c.createRef)(),
                h = Object(u.b)().config,
                g = (i || h.PUBLIC.carousel).settings,
                m = Object(s.k)(!1),
                b = m[0],
                y = m[1],
                v = new (Object(p.b)("MarkdownService"))(),
                O = Object(s.k)(!1),
                w = O[0],
                x = O[1],
                _ = Object(s.k)(!0),
                j = _[0],
                S = _[1],
                k = {
                  beforeChange: function () {
                    y(!0);
                  },
                  afterChange: function (e) {
                    y(!1),
                      (function (e) {
                        x(0 != e), S(e != n.length - 1);
                      })(e);
                  },
                };
              if (n) {
                var C = n.map(function (t) {
                  return e(
                    o.h,
                    {
                      onClick: function () {
                        return (e = t.value), void (b || l(e));
                        var e;
                      },
                    },
                    e(
                      o.g,
                      null,
                      e(o.d, { src: t.icon }),
                      e(o.f, null, t.price)
                    ),
                    e(
                      o.e,
                      null,
                      e("p", null, t.subtitle),
                      e("p", null, e("b", null, t.title)),
                      e(f.a, {
                        renderers: v.getRenderers(),
                        source: t.text,
                        escapeHtml: !1,
                      })
                    )
                  );
                });
                return e(
                  o.c,
                  null,
                  e(a.a, r({}, g, k, { ref: d }), C),
                  w &&
                    e(
                      o.a,
                      {
                        onClick: function () {
                          return d.current.slickPrev();
                        },
                      },
                      "<"
                    ),
                  j &&
                    e(
                      o.b,
                      {
                        onClick: function () {
                          return d.current.slickNext();
                        },
                      },
                      ">"
                    )
                );
              }
            };
          }).call(this, n("hosL").h);
        },
        bov0: function (e, t, n) {
          "use strict";
          var r = n("g1Zs");
          n.d(t, "a", function () {
            return r.ActionsService;
          }),
            n.d(t, "b", function () {
              return r.AdapterService;
            }),
            n.d(t, "c", function () {
              return r.MarkdownService;
            });
          n("knbI");
        },
        bz5S: function (e) {
          "use strict";
          e.exports = function (e) {
            var t = "string" == typeof e ? e.charCodeAt(0) : e;
            return (t >= 97 && t <= 122) || (t >= 65 && t <= 90);
          };
        },
        "c+XX": function (e, t, n) {
          "use strict";
          var r = n("VNWY"),
            o = n("xZZo");
          e.exports = function (e, t, n) {
            for (
              var i,
                a,
                c,
                s,
                u,
                l,
                f,
                p,
                d,
                h = this.offset,
                g = this.blockTokenizers,
                m = this.interruptBlockquote,
                b = e.now(),
                y = b.line,
                v = t.length,
                O = [],
                w = [],
                x = [],
                _ = 0;
              _ < v && (" " === (a = t.charAt(_)) || "\t" === a);

            )
              _++;
            if (">" === t.charAt(_)) {
              if (n) return !0;
              for (_ = 0; _ < v; ) {
                for (
                  f = _, p = !1, -1 === (s = t.indexOf("\n", _)) && (s = v);
                  _ < v && (" " === (a = t.charAt(_)) || "\t" === a);

                )
                  _++;
                if (
                  (">" === t.charAt(_)
                    ? (_++, (p = !0), " " === t.charAt(_) && _++)
                    : (_ = f),
                  (u = t.slice(_, s)),
                  !p && !r(u))
                ) {
                  _ = f;
                  break;
                }
                if (!p && ((c = t.slice(_)), o(m, g, this, [e, c, !0]))) break;
                (l = f === _ ? u : t.slice(f, s)),
                  x.push(_ - f),
                  O.push(l),
                  w.push(u),
                  (_ = s + 1);
              }
              for (_ = -1, v = x.length, i = e(O.join("\n")); ++_ < v; )
                (h[y] = (h[y] || 0) + x[_]), y++;
              return (
                (d = this.enterBlock()),
                (w = this.tokenizeBlock(w.join("\n"), b)),
                d(),
                i({ type: "blockquote", children: w })
              );
            }
          };
        },
        c37Q: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a(e, t) {
            var n;
            s = o(o({}, s), {}, (((n = {})[e] = t), n));
          }
          function c(e) {
            return s[e];
          }
          n.d(t, "b", function () {
            return a;
          }),
            n.d(t, "a", function () {
              return c;
            });
          var s = {};
        },
        c5l3: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "c", function () {
            return s;
          }),
            n.d(t, "a", function () {
              return u;
            }),
            n.d(t, "b", function () {
              return l;
            });
          var a = n("UutA"),
            c = n("4hQ3"),
            s = a.b.div.withConfig({
              displayName: "Headerstyled__Title",
              componentId: "sc-1dqhb1f-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  padding: "0 0 0 55px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  lineHeight: "130%",
                  whiteSpace: "pre-wrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  color: n.colors.colorPrimary,
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  padding: "0 40px 0 68px",
                  fontSize: "18px",
                  lineHeight: "110%",
                }),
                t),
                n.elements.HeaderTitle
              );
            }),
            u = a.b.div.withConfig({
              displayName: "Headerstyled__HeaderContainer",
              componentId: "sc-1dqhb1f-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  display: "flex",
                  margin: 0,
                  width: "100%",
                  padding: "5px 20px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  position: "relative",
                  zIndex: "1",
                  minHeight: "60px",
                  boxShadow: "0 5px 10px rgba(0,0,0, .2)",
                  background: "transparent",
                  cursor: "default",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "15px",
                    left: "25px",
                    display: "block",
                    height: "31px",
                    width: "27px",
                    backgroundImage: "url(" + c.a + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                  },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  minHeight: "76px",
                  "&::before": {
                    top: "20px",
                    left: "28px",
                    height: "40px",
                    width: "35px",
                  },
                }),
                t),
                n.elements.HeaderContainer
              );
            }),
            l = a.b.div.withConfig({
              displayName: "Headerstyled__HeaderIconContainer",
              componentId: "sc-1dqhb1f-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "flex", gap: "20px", img: { cursor: "pointer" } },
                e.theme.elements.HeaderIconContainer
              );
            });
        },
        cTMR: function (e) {
          "use strict";
          var t = Object.prototype.toString;
          e.exports = function (e) {
            var n;
            return (
              "[object Object]" === t.call(e) &&
              (null === (n = Object.getPrototypeOf(e)) ||
                n === Object.getPrototypeOf({}))
            );
          };
        },
        "ch1+": function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("QRet"),
              o = n("FaEK");
            t.a = function (t) {
              var n = t.onSelect,
                i = t.isSelected,
                a = t.img,
                c = t.imgSelected,
                s = t.valueSet,
                u = Object(r.k)(!1),
                l = u[1];
              return e(
                o.a,
                {
                  onMouseOver: function () {
                    s || l(!0);
                  },
                  onMouseOut: function () {
                    s || l(!1);
                  },
                  onClick: n,
                },
                e("img", { src: i || u[0] ? c : a })
              );
            };
          }).call(this, n("hosL").h);
        },
        cxG2: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return c;
          }),
            n.d(t, "b", function () {
              return s;
            }),
            n.d(t, "c", function () {
              return u;
            }),
            n.d(t, "d", function () {
              return l;
            }),
            n.d(t, "e", function () {
              return f;
            }),
            n.d(t, "h", function () {
              return p;
            }),
            n.d(t, "f", function () {
              return h;
            }),
            n.d(t, "g", function () {
              return g;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "Calendarstyled__CalendarContainer",
              componentId: "sc-6v9xxz-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme,
                n = e.isDisabled
                  ? o(
                      { cursor: "default", pointerEvents: "none" },
                      t.elements.messages.CalendarContainerDisabled
                    )
                  : {};
              return o(o({}, t.elements.messages.CalendarContainer), n);
            }),
            s = a.b.div.withConfig({
              displayName: "Calendarstyled__CalendarDateContainer",
              componentId: "sc-6v9xxz-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "flex", flexDirection: "row", flexWrap: "nowrap" },
                e.theme.elements.messages.CalendarDateContainer
              );
            }),
            u = a.b.button.withConfig({
              displayName: "Calendarstyled__CalendarDateItem",
              componentId: "sc-6v9xxz-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme,
                n = e.isSelected
                  ? o(
                      {
                        backgroundColor: t.colors.colorSecondary,
                        color: t.colors.colorWhite,
                      },
                      t.elements.messages.CalendarDateItemSelected
                    )
                  : {};
              return o(
                o(
                  {
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: t.colors.colorWhite,
                    color: t.colors.colorSecondary,
                    justifyContent: "center",
                    fontFamily: t.fonts.primary,
                    border: "1px solid " + t.colors.colorSecondary,
                    margin: "5px 6px",
                    height: "50px",
                    width: "50px",
                    textAlign: "center",
                    padding: "5px",
                    fontWeight: "light",
                    borderRadius: "5px",
                    transition: "background-color .3s, color .3s, opacity .3s",
                    "&:not(:disabled):hover": {
                      color: t.colors.colorWhite,
                      backgroundColor: t.colors.colorPrimary,
                      borderColor: t.colors.colorPrimary,
                    },
                  },
                  t.elements.messages.CalendarDateItem
                ),
                n
              );
            }),
            l = a.b.div.withConfig({
              displayName: "Calendarstyled__CalendarHoursContainer",
              componentId: "sc-6v9xxz-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "flex-start",
                },
                e.theme.elements.messages.CalendarHoursContainer
              );
            }),
            f = a.b.button.withConfig({
              displayName: "Calendarstyled__CalendarHoursItem",
              componentId: "sc-6v9xxz-4",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme,
                n = e.isSelected,
                r = e.isInactive
                  ? o(
                      {
                        pointerEvents: "none",
                        cursor: "none",
                        backgroundColor: "gray",
                      },
                      t.elements.messages.CalendarHoursItemInactive
                    )
                  : {},
                i = n
                  ? o(
                      {
                        color: t.colors.colorWhite,
                        backgroundColor: t.colors.colorSecondary,
                        cursor: "none",
                      },
                      t.elements.messages.CalendarHoursItemSelected
                    )
                  : {};
              return o(
                o(
                  o(
                    {
                      border: "1px solid black",
                      margin: "3px",
                      padding: "3px",
                      borderRadius: "5px",
                      width: "48%",
                      cursor: "pointer",
                      height: "40px",
                      lineHeight: "16px",
                      fontFamily: t.fonts.primary,
                      fontWize: "16px",
                      fontWeight: "500",
                      "&:not(:disabled):hover": {
                        color: t.colors.colorWhite,
                        backgroundColor: t.colors.colorPrimary,
                        borderColor: t.colors.colorPrimary,
                      },
                    },
                    t.elements.messages.CalendarHoursItem
                  ),
                  r
                ),
                i
              );
            }),
            p = a.b.div.withConfig({
              displayName: "Calendarstyled__CalendarSelectionDatesContainer",
              componentId: "sc-6v9xxz-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "flex",
                  justifyContent: e.isPrevButtonVisible
                    ? "space-between"
                    : "flex-end",
                  flexDirection: "row",
                  padding: "10px 5px",
                },
                e.theme.elements.messages.CalendarSelectionDatesContainer
              );
            }),
            d = a.b.div.withConfig({
              displayName: "Calendarstyled__CalendarNavigationDates",
              componentId: "sc-6v9xxz-6",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  span: {
                    margin: "0 2px",
                    cursor: "pointer",
                    color: e.isRequestBlocked
                      ? "rgba(29, 29, 78, 0.3) !important"
                      : "black",
                  },
                },
                e.theme.elements.messages.CalendarNavigationDates
              );
            }),
            h = Object(a.b)(d).withConfig({
              displayName: "Calendarstyled__CalendarNextDates",
              componentId: "sc-6v9xxz-7",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.CalendarNextDates);
            }),
            g = Object(a.b)(d).withConfig({
              displayName: "Calendarstyled__CalendarPrevDates",
              componentId: "sc-6v9xxz-8",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.CalendarPrevDates);
            });
        },
        dL1j: function (e, t, n) {
          "use strict";
          (function (e) {
            n("hosL");
            var r = n("vz0d"),
              o = n("keud"),
              i = n("OV23"),
              a = n("ITsB");
            t.a = function (t) {
              var n = t.open,
                c = t.toggleMenu,
                s = t.onOptionSelect,
                u = Object(o.b)(),
                l = new (Object(a.b)("ActionsService"))(),
                f = Object(o.b)().fullScreen.value;
              if (u.mainMenu.value)
                return e(
                  r.c,
                  { open: n, className: f ? "fullscreen" : "" },
                  u.mainMenu.value.map(function (t, n) {
                    return e(
                      r.b,
                      { key: n },
                      e(
                        r.a,
                        {
                          onClick: function () {
                            return (function (e) {
                              var t = e.action,
                                n = e.command;
                              if (t && l.exists(t)) {
                                var r = new i.a({ isAction: !0 });
                                l.getCaseInsensitiveProp(t)(r);
                              } else s(n);
                              c();
                            })(t);
                          },
                        },
                        e("img", { src: t.img }),
                        e("p", null, t.text)
                      )
                    );
                  })
                );
            };
          }).call(this, n("hosL").h);
        },
        dXCb: function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              return (r =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            function o(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r);
              }
              return n;
            }
            function i(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? o(Object(n), !0).forEach(function (t) {
                      a(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : o(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            }
            function a(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            var c = n("Qvh3"),
              s = n("2UUl"),
              u = n.n(s),
              l = (n("IO5D"), n("tCvC"), n("hosL")),
              f = n("QRet"),
              p = n("keud");
            t.a = function (t) {
              var n = t.slides,
                o = t.onOptionSelect,
                a = Object(l.createRef)(),
                s = Object(p.b)().config,
                d = (
                  {
                    settings: i(
                      { variableWidth: !0 },
                      s.PUBLIC.carousel.settings
                    ),
                  } || s.PUBLIC.carousel
                ).settings,
                h = Object(f.k)(!1),
                g = h[0],
                m = h[1],
                b = {
                  beforeChange: function () {
                    m(!0);
                  },
                  afterChange: function () {
                    m(!1);
                  },
                };
              if (n) {
                var y = n.map(function (t) {
                  return e(
                    c.g,
                    {
                      onClick: function () {
                        return (e = t.title), void (g || o(e));
                        var e;
                      },
                    },
                    e(c.a, null, e(c.e, { src: t.image })),
                    e(
                      c.f,
                      null,
                      e("p", null, t.title),
                      e("p", null, e("b", null, t.price))
                    )
                  );
                });
                return e(
                  c.d,
                  null,
                  e(u.a, r({}, d, b, { ref: a }), y),
                  e(
                    c.b,
                    {
                      onClick: function () {
                        return a.current.slickPrev();
                      },
                    },
                    "<"
                  ),
                  e(
                    c.c,
                    {
                      onClick: function () {
                        return a.current.slickNext();
                      },
                    },
                    ">"
                  )
                );
              }
            };
          }).call(this, n("hosL").h);
        },
        dY77: function (e, t, n) {
          "use strict";
          function r() {
            var e = [],
              t = {
                run: function () {
                  function t(c) {
                    var s = e[++n],
                      u = i.call(arguments, 0),
                      l = u.slice(1),
                      f = r.length,
                      p = -1;
                    if (c) a(c);
                    else {
                      for (; ++p < f; ) null == l[p] && (l[p] = r[p]);
                      (r = l),
                        s
                          ? o(s, t).apply(null, r)
                          : a.apply(null, [null].concat(r));
                    }
                  }
                  var n = -1,
                    r = i.call(arguments, 0, -1),
                    a = arguments[arguments.length - 1];
                  if ("function" != typeof a)
                    throw new Error(
                      "Expected function as last argument, not " + a
                    );
                  t.apply(null, [null].concat(r));
                },
                use: function (n) {
                  if ("function" != typeof n)
                    throw new Error("Expected `fn` to be a function, not " + n);
                  return e.push(n), t;
                },
              };
            return t;
          }
          var o = n("Iacx");
          (e.exports = r), (r.wrap = o);
          var i = [].slice;
        },
        "drO/": function (e, t, n) {
          var r = n("jFWS"),
            o = function (e) {
              var t = "",
                n = Object.keys(e);
              return (
                n.forEach(function (o, i) {
                  var a = e[o];
                  (function (e) {
                    return /[height|width]$/.test(e);
                  })((o = r(o))) &&
                    "number" == typeof a &&
                    (a += "px"),
                    (t +=
                      !0 === a
                        ? o
                        : !1 === a
                        ? "not " + o
                        : "(" + o + ": " + a + ")"),
                    i < n.length - 1 && (t += " and ");
                }),
                t
              );
            };
          e.exports = function (e) {
            var t = "";
            return "string" == typeof e
              ? e
              : e instanceof Array
              ? (e.forEach(function (n, r) {
                  (t += o(n)), r < e.length - 1 && (t += ", ");
                }),
                t)
              : o(e);
          };
        },
        e9nE: function (e, t, n) {
          "use strict";
          t.a = n.p + "3c89132ad49b70efecabb18b72314181.svg";
        },
        eDmY: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(t) {
              var n = t.message,
                r = t.isFirstMessage,
                a = n.content,
                h = new (Object(o.b)("MarkdownService"))(),
                g = Object(u.b)(),
                m = Object(l.b)().config,
                b = Object(i.h)(
                  function () {
                    return Object(p.b)();
                  },
                  [a]
                ),
                y = Object(i.h)(
                  function () {
                    return Object(f.a)(a, b);
                  },
                  [a]
                );
              return a
                ? e(
                    s.a,
                    { owner: n.owner },
                    n.owner === d.a.user &&
                      m.PUBLIC.message.showUserIndicator &&
                      r &&
                      e(s.c, null, g["message.text.userIndicator"]),
                    e(
                      s.b,
                      { className: n.owner },
                      e(c.a, {
                        renderers: h.getRenderers(),
                        source: y,
                        escapeHtml: !1,
                      })
                    )
                  )
                : null;
            }
            n.d(t, "a", function () {
              return r;
            });
            var o = n("ITsB"),
              i = (n("hosL"), n("QRet")),
              a = n("LO0j"),
              c = n.n(a),
              s = n("8DMI"),
              u = n("XAzd"),
              l = n("keud"),
              f = n("jRwt"),
              p = n("ReYd"),
              d = n("6naU");
            t.b = r;
          }).call(this, n("hosL").h);
        },
        eJG6: function (e) {
          "use strict";
          function t(e) {
            var t, n;
            return (
              "text" !== e.type ||
              !e.position ||
              (t = e.position.start).line !== (n = e.position.end).line ||
              n.column - t.column === e.value.length
            );
          }
          e.exports = function (e) {
            return function (r, o) {
              function i(e) {
                for (var t = -1, n = e.indexOf("\n"); -1 !== n; )
                  v++, (t = n), (n = e.indexOf("\n", n + 1));
                -1 === t ? (O += e.length) : (O = e.length - t),
                  v in g &&
                    (-1 !== t ? (O += g[v]) : O <= g[v] && (O = g[v] + 1));
              }
              function a() {
                var e = { line: v, column: O };
                return (e.offset = h.toOffset(e)), e;
              }
              function c(e) {
                (this.start = e), (this.end = a());
              }
              function s(e) {
                function o(e, r) {
                  return p(
                    (function (e, r) {
                      var o = r ? r.children : m,
                        i = o[o.length - 1];
                      return (
                        i &&
                          e.type === i.type &&
                          e.type in n &&
                          t(i) &&
                          t(e) &&
                          (e = n[e.type].call(h, i, e)),
                        e !== i && o.push(e),
                        h.atStart && 0 !== m.length && h.exitStart(),
                        e
                      );
                    })(p(e), r),
                    f
                  );
                }
                function s() {
                  var t = o.apply(null, arguments);
                  return (v = d.line), (O = d.column), (r = e + r), t;
                }
                function u() {
                  var t = p({});
                  return (v = d.line), (O = d.column), (r = e + r), t.position;
                }
                var l,
                  f = (function () {
                    var e = [],
                      t = v + 1;
                    return function () {
                      for (var n = v + 1; t < n; ) e.push((g[t] || 0) + 1), t++;
                      return e;
                    };
                  })(),
                  p =
                    ((l = a()),
                    function (e, t) {
                      var n = e.position,
                        r = [],
                        o = n && n.end.line,
                        i = l.line;
                      if (
                        ((e.position = new c(n ? n.start : l)),
                        n && t && n.indent)
                      ) {
                        if (((r = n.indent), o < i)) {
                          for (; ++o < i; ) r.push((g[o] || 0) + 1);
                          r.push(l.column);
                        }
                        t = r.concat(t);
                      }
                      return (e.position.indent = t || []), e;
                    }),
                  d = a();
                return (
                  (function (e) {
                    r.substring(0, e.length) !== e &&
                      h.file.fail(
                        new Error(
                          "Incorrectly eaten value: please report this warning on http://git.io/vg5Ft"
                        ),
                        a()
                      );
                  })(e),
                  (o.reset = s),
                  (s.test = u),
                  (o.test = u),
                  (r = r.substring(e.length)),
                  i(e),
                  (f = f()),
                  o
                );
              }
              var u,
                l,
                f,
                p,
                d,
                h = this,
                g = h.offset,
                m = [],
                b = h[e + "Methods"],
                y = h[e + "Tokenizers"],
                v = o.line,
                O = o.column;
              if (!r) return m;
              for (s.now = a, s.file = h.file, i(""); r; ) {
                for (
                  u = -1, l = b.length, p = !1;
                  ++u < l &&
                  (!(f = y[b[u]]) ||
                    (f.onlyAtStart && !h.atStart) ||
                    (f.notInList && h.inList) ||
                    (f.notInBlock && h.inBlock) ||
                    (f.notInLink && h.inLink) ||
                    ((d = r.length),
                    f.apply(h, [s, r]),
                    !(p = d !== r.length)));

                );
                p || h.file.fail(new Error("Infinite loop"), s.now());
              }
              return (h.eof = a()), m;
            };
          };
          var n = {
            text: function (e, t) {
              return (e.value += t.value), e;
            },
            blockquote: function (e, t) {
              return this.options.commonmark
                ? t
                : ((e.children = e.children.concat(t.children)), e);
            },
          };
        },
        "eq/W": function (e) {
          "use strict";
          function t(e) {
            return function (t) {
              var n = -1,
                r = e.length;
              if (t < 0) return {};
              for (; ++n < r; )
                if (e[n] > t)
                  return {
                    line: n + 1,
                    column: t - (e[n - 1] || 0) + 1,
                    offset: t,
                  };
              return {};
            };
          }
          function n(e) {
            return function (t) {
              var n = t && t.line,
                r = t && t.column;
              return isNaN(n) || isNaN(r) || !(n - 1 in e)
                ? -1
                : (e[n - 2] || 0) + r - 1 || 0;
            };
          }
          e.exports = function (e) {
            var r = (function (e) {
              var t = [],
                n = e.indexOf("\n");
              for (; -1 !== n; ) t.push(n + 1), (n = e.indexOf("\n", n + 1));
              return t.push(e.length + 1), t;
            })(String(e));
            return { toPosition: t(r), toOffset: n(r) };
          };
        },
        f5UB: function (e, t, n) {
          "use strict";
          var r = n("JgMK");
          e.exports = function (e, t, n) {
            var o,
              i,
              a,
              c,
              s,
              u,
              l,
              f,
              p,
              d,
              h,
              g = t.length + 1,
              m = 0,
              b = "";
            if (this.options.gfm) {
              for (; m < g && (" " === (a = t.charAt(m)) || "\t" === a); )
                (b += a), m++;
              if (((d = m), "~" === (a = t.charAt(m)) || "`" === a)) {
                for (
                  m++, i = a, o = 1, b += a;
                  m < g && (a = t.charAt(m)) === i;

                )
                  (b += a), o++, m++;
                if (!(o < 3)) {
                  for (; m < g && (" " === (a = t.charAt(m)) || "\t" === a); )
                    (b += a), m++;
                  for (
                    c = "", s = "";
                    m < g &&
                    "\n" !== (a = t.charAt(m)) &&
                    "~" !== a &&
                    "`" !== a;

                  )
                    " " === a || "\t" === a
                      ? (s += a)
                      : ((c += s + a), (s = "")),
                      m++;
                  if (!(a = t.charAt(m)) || "\n" === a) {
                    if (n) return !0;
                    for (
                      (h = e.now()).column += b.length,
                        h.offset += b.length,
                        b += c,
                        c = this.decode.raw(this.unescape(c), h),
                        s && (b += s),
                        s = "",
                        f = "",
                        p = "",
                        u = "",
                        l = "";
                      m < g;

                    )
                      if (
                        ((u += f),
                        (l += p),
                        (f = ""),
                        (p = ""),
                        "\n" === (a = t.charAt(m)))
                      ) {
                        for (
                          u ? ((f += a), (p += a)) : (b += a), s = "", m++;
                          m < g && " " === (a = t.charAt(m));

                        )
                          (s += a), m++;
                        if (((f += s), (p += s.slice(d)), !(s.length >= 4))) {
                          for (s = ""; m < g && (a = t.charAt(m)) === i; )
                            (s += a), m++;
                          if (((f += s), (p += s), !(s.length < o))) {
                            for (
                              s = "";
                              m < g &&
                              (" " === (a = t.charAt(m)) || "\t" === a);

                            )
                              (f += a), (p += a), m++;
                            if (!a || "\n" === a) break;
                          }
                        }
                      } else (u += a), (p += a), m++;
                    return e((b += u + f))({
                      type: "code",
                      lang: c || null,
                      value: r(l),
                    });
                  }
                }
              }
            }
          };
        },
        fADn: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "h", function () {
            return c;
          }),
            n.d(t, "c", function () {
              return s;
            }),
            n.d(t, "a", function () {
              return l;
            }),
            n.d(t, "b", function () {
              return f;
            }),
            n.d(t, "d", function () {
              return p;
            }),
            n.d(t, "f", function () {
              return d;
            }),
            n.d(t, "g", function () {
              return h;
            }),
            n.d(t, "e", function () {
              return g;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "ModernCarouselstyled__ModernSwipeItem",
              componentId: "sc-153kqua-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  position: "relative",
                  marginRight: "1.2rem",
                  marginLeft: "1.2rem",
                  "&:focus": { outline: "none" },
                  float: "none",
                  margin: "0",
                  borderRadius: "0",
                  border: "none",
                  background: n.colors.colorWhite,
                  color: n.colors.carousel,
                  cursor: "pointer",
                  boxShadow: "0 0 10px " + n.colors.boxShadow,
                  "> div:first-child": {
                    color: n.colors.colorPrimary,
                    fontSize: "20px",
                    fontWeight: "bold",
                    img: { margin: 0 },
                    div: { margin: 0 },
                  },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {}),
                t),
                n.elements.messages.ModernSwipeItem
              );
            }),
            s = a.b.div.withConfig({
              displayName: "ModernCarouselstyled__ModernCarouselContainer",
              componentId: "sc-153kqua-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  position: "relative",
                  left: "-25px",
                  width: "calc(100% + 45px)",
                  margin: "0",
                  paddingBottom: "0",
                  borderRadius: "10px",
                  ".slick-dots": { display: "none !important" },
                  ".slick-slider:before, .slick-slider:after": {
                    content: '""',
                    position: "absolute",
                    zIndex: 10,
                    top: "0",
                    bottom: "0",
                    width: "15px",
                    pointerEvents: "none",
                  },
                  ".slick-slider:before": {
                    left: "0",
                    background:
                      "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                  ".slick-slider:after": {
                    right: "0",
                    background:
                      "linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
                  },
                  marginTop: "10px",
                  ".slick-track": { display: "flex" },
                  ".slick-slide": { height: "auto" },
                  ".slick-slide > div": {
                    margin: "10px 0 10px 10px",
                    height: "calc(100% - 20px)",
                  },
                  ".slick-slide > div > div": {
                    borderRadius: "16px",
                    height: "100%",
                  },
                  ".slick-slide > div > div:hover": {
                    boxShadow: "0 0 0 2px " + t.colors.primary,
                  },
                  "@media (max-width: 576px)": {
                    ".slick-track": { marginLeft: "15px" },
                    ".slick-slide": { maxWidth: "240px !important" },
                  },
                },
                t.elements.messages.ModernCarouselContainer
              );
            }),
            u = a.b.div.withConfig({
              displayName: "ModernCarouselstyled__ModernCarouselButton",
              componentId: "sc-153kqua-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  padding: "5px 15px",
                  borderRadius: "15px",
                  border: t.colors.white,
                  backgroundColor: t.colors.whiteGradient,
                  fontSize: "0.7rem",
                  transition: "background-color .3s, color .3s",
                  position: "absolute",
                  bottom: 0,
                  "&:not(:disabled):hover": {
                    color: t.colors.white,
                    backgroundColor: t.colors.veryLightPink,
                    borderColor: t.colors.veryLightPink,
                    cursor: "pointer",
                  },
                },
                t.elements.messages.ModernCarouselButton
              );
            }),
            l = Object(a.b)(u).withConfig({
              displayName: "ModernCarouselstyled__ModernCarouselButtonLeft",
              componentId: "sc-153kqua-3",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  "@media (max-width: 576px)": { display: "none" },
                  fontSize: 0,
                  background: t.colors.white,
                  height: "36px",
                  borderRadius: "50px",
                  width: "36px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  left: "20px",
                  zIndex: 10,
                  transition: ".3s all",
                  boxShadow: "2px 2px 30px 0 rgba(61, 61, 61, 0.4)",
                  "&:hover": {
                    backgroundColor: t.colors.primary + "!important",
                    transition: ".3s all",
                    "&:after": {
                      borderColor: t.colors.white,
                      transition: "inherit",
                    },
                  },
                  "&:after": {
                    content: '""',
                    transition: "inherit",
                    width: "10px",
                    height: "10px",
                    borderLeft: "2px solid",
                    borderTop: "2px solid",
                    borderColor: t.colors.primary,
                    position: "absolute",
                    transform: "translateY(-50%) rotate(-45deg)",
                    top: "50%",
                    left: "14px",
                  },
                },
                t.elements.messages.ModernCarouselButtonLeft
              );
            }),
            f = Object(a.b)(u).withConfig({
              displayName: "ModernCarouselstyled__ModernCarouselButtonRight",
              componentId: "sc-153kqua-4",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  right: "61px",
                  "@media (max-width: 576px)": { display: "none" },
                  fontSize: 0,
                  background: t.colors.white,
                  height: "36px",
                  borderRadius: "50px",
                  width: "36px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  transition: ".3s all",
                  boxShadow: "2px 2px 30px 0 rgba(61, 61, 61, 0.4)",
                  "&:hover": {
                    transition: ".3s all",
                    backgroundColor: t.colors.primary + "!important",
                    "&:after": {
                      transition: "inherit",
                      borderColor: t.colors.white,
                    },
                  },
                  "&:after": {
                    content: '""',
                    transition: "inherit",
                    width: "10px",
                    height: "10px",
                    borderLeft: "2px solid",
                    borderTop: "2px solid",
                    borderColor: t.colors.primary,
                    position: "absolute",
                    transform: "translateY(-50%) rotate(135deg)",
                    top: "50%",
                    right: "14px",
                  },
                },
                t.elements.messages.ModernCarouselButtonRight
              );
            }),
            p = a.b.img.withConfig({
              displayName: "ModernCarouselstyled__ModernCarouselImage",
              componentId: "sc-153kqua-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "inline !important",
                  margin: "5px 10px 0px 10px",
                  width: "81px",
                  height: "60px",
                  maxHeight: "60px",
                  paddingTop: "8px",
                },
                e.theme.elements.messages.ModernCarouselImage
              );
            }),
            d = a.b.div.withConfig({
              displayName: "ModernCarouselstyled__ModernCarouselValue",
              componentId: "sc-153kqua-6",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  display: "inline",
                  float: "right",
                  margin: "1rem",
                  fontWeight: "bold",
                },
                e.theme.elements.messages.ModernCarouselValue
              );
            }),
            h = a.b.div.withConfig({
              displayName: "ModernCarouselstyled__ModernClickFix",
              componentId: "sc-153kqua-7",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  position: "absolute",
                  left: 0,
                  top: 0,
                  padding: "15px 15px 10px",
                },
                e.theme.elements.messages.ClickFix
              );
            }),
            g = a.b.div.withConfig({
              displayName: "ModernCarouselstyled__ModernCarouselTitle",
              componentId: "sc-153kqua-8",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  float: "center",
                  textAlign: "left",
                  position: "relative",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  fontSize: "17px",
                  padding: "100px 10px 10px",
                  p: { margin: "4px" },
                },
                e.theme.elements.messages.ModernCarouselTitle
              );
            });
        },
        fg5I: function (e, t, n) {
          "use strict";
          var r = n("VNWY"),
            o = n("Qfee"),
            i = n("JgMK"),
            a = n("xZZo");
          e.exports = function (e, t, n) {
            for (
              var c,
                s,
                u,
                l,
                f,
                p = this.options,
                d = p.commonmark,
                h = p.gfm,
                g = this.blockTokenizers,
                m = this.interruptParagraph,
                b = t.indexOf("\n"),
                y = t.length;
              b < y;

            ) {
              if (-1 === b) {
                b = y;
                break;
              }
              if ("\n" === t.charAt(b + 1)) break;
              if (d) {
                for (l = 0, c = b + 1; c < y; ) {
                  if ("\t" === (u = t.charAt(c))) {
                    l = 4;
                    break;
                  }
                  if (" " !== u) break;
                  l++, c++;
                }
                if (l >= 4) {
                  b = t.indexOf("\n", b + 1);
                  continue;
                }
              }
              if (((s = t.slice(b + 1)), a(m, g, this, [e, s, !0]))) break;
              if (
                g.list.call(this, e, s, !0) &&
                (this.inList || d || (h && !o(r.left(s).charAt(0))))
              )
                break;
              if (
                ((c = b),
                -1 !== (b = t.indexOf("\n", b + 1)) && "" === r(t.slice(c, b)))
              ) {
                b = c;
                break;
              }
            }
            return (
              (s = t.slice(0, b)),
              "" === r(s)
                ? (e(s), null)
                : !!n ||
                  ((f = e.now()),
                  e((s = i(s)))({
                    type: "paragraph",
                    children: this.tokenizeInline(s, f),
                  }))
            );
          };
        },
        fgb1: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(e, t) {
              var n =
                ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                e["@@iterator"];
              if (n) return (n = n.call(e)).next.bind(n);
              if (
                Array.isArray(e) ||
                (n = (function (e, t) {
                  if (!e) return;
                  if ("string" == typeof e) return o(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  "Object" === n && e.constructor && (n = e.constructor.name);
                  if ("Map" === n || "Set" === n) return Array.from(e);
                  if (
                    "Arguments" === n ||
                    /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                  )
                    return o(e, t);
                })(e)) ||
                (t && e && "number" == typeof e.length)
              ) {
                n && (e = n);
                var r = 0;
                return function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                };
              }
              throw new TypeError(
                "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            }
            function o(e, t) {
              (null == t || t > e.length) && (t = e.length);
              for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
              return r;
            }
            var i = n("keud"),
              a = n("645H");
            t.a = function (t) {
              var n = t.message,
                o = t.onOptionSelect;
              return e(a.a, {
                message: n,
                onOptionSelect: function (e) {
                  for (
                    var t, n = r(Object(i.b)().messages.value);
                    !(t = n()).done;

                  )
                    for (var a, c = r(t.value.messages); !(a = c()).done; ) {
                      var s = a.value;
                      "onlyoption" === s.type &&
                        (s.isMessageWithActionDone = !0);
                    }
                  Object(i.b)().isInputDisabled.set(!1), o(e);
                },
                isDisabled: n.isMessageWithActionDone,
              });
            };
          }).call(this, n("hosL").h);
        },
        flQL: function (e) {
          "use strict";
          e.exports = function (e, n, r) {
            for (
              var o, i, a, c, s, u = e.now(), l = n.length, f = -1, p = "";
              ++f < l;

            ) {
              if (" " !== (a = n.charAt(f)) || f >= 3) {
                f--;
                break;
              }
              p += a;
            }
            for (o = "", i = ""; ++f < l; ) {
              if ("\n" === (a = n.charAt(f))) {
                f--;
                break;
              }
              " " === a || "\t" === a ? (i += a) : ((o += i + a), (i = ""));
            }
            if (
              ((u.column += p.length),
              (u.offset += p.length),
              (p += o + i),
              (a = n.charAt(++f)),
              (c = n.charAt(++f)),
              "\n" === a && t[c])
            ) {
              for (p += a, i = c, s = t[c]; ++f < l; ) {
                if ((a = n.charAt(f)) !== c) {
                  if ("\n" !== a) return;
                  f--;
                  break;
                }
                i += a;
              }
              return (
                !!r ||
                e(p + i)({
                  type: "heading",
                  depth: s,
                  children: this.tokenizeInline(o, u),
                })
              );
            }
          };
          var t = { "=": 1, "-": 2 };
        },
        fulh: function (e, t, n) {
          "use strict";
          function r() {
            var e = Object(o.b)();
            try {
              window.twemoji &&
                !1 !== e.config.PUBLIC.externalLibs.disableTwemoji &&
                (window.twemoji.parse = function () {
                  console.log('"twemoji" has been disabled by Actionbot');
                });
            } catch (e) {
              console.error(e);
            }
          }
          n.d(t, "a", function () {
            return r;
          });
          var o = n("keud");
        },
        g1Zs: function (e, t, n) {
          "use strict";
          function r(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function o(e) {
            if (void 0 === e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return e;
          }
          function i(e, t) {
            return (i =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function a(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function c(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function s(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function u(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function l(e) {
            var t = [],
              n = new (Object(de.b)("AdapterService"))().mergeGenerics(),
              r = n.check,
              o = (function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2
                    ? s(Object(n), !0).forEach(function (t) {
                        u(e, t, n[t]);
                      })
                    : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(
                        e,
                        Object.getOwnPropertyDescriptors(n)
                      )
                    : s(Object(n)).forEach(function (t) {
                        Object.defineProperty(
                          e,
                          t,
                          Object.getOwnPropertyDescriptor(n, t)
                        );
                      });
                }
                return e;
              })({ form: [] }, n.mergers),
              i = Object.keys(o);
            return (
              e.forEach(function (e) {
                function n() {
                  t.push(e);
                }
                function a() {
                  i.includes(c) && t.push(c);
                }
                var c = e.title;
                r({
                  singleGeneric: e,
                  mergers: o,
                  skip: n,
                  resolveOptionBasedType: me,
                })
                  ? a()
                  : "option" === e.response_type
                  ? (a(),
                    ["form", "formFields", "formDefaults"].includes(c)
                      ? o.form.push(me({ singleGeneric: e }))
                      : n())
                  : n();
              }),
              t.map(function (e) {
                return i.includes(e) && o[e] && o[e].length
                  ? {
                      response_type: "option",
                      merge: o[e],
                      options: [],
                      title: e + "Merge",
                    }
                  : e;
              })
            );
          }
          function f(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function p(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? f(Object(n), !0).forEach(function (t) {
                    d(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : f(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function d(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function h(e) {
            if ("object" == typeof e && e.skills && e.skills["main skill"])
              return e.skills["main skill"].user_defined;
          }
          function g(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function m(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? g(Object(n), !0).forEach(function (t) {
                    b(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : g(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function b(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function y(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function v(e, t) {
            return (v =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function O(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function w(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? O(Object(n), !0).forEach(function (t) {
                    x(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : O(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function x(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function _(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function j(e, t) {
            return (j =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function S(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function k(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? S(Object(n), !0).forEach(function (t) {
                    C(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : S(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function C(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function P(e, t) {
            return (P =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function A() {
            return (A =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function I(e, t) {
            if (null == e) return {};
            var n,
              r,
              o = {},
              i = Object.keys(e);
            for (r = 0; r < i.length; r++)
              t.indexOf((n = i[r])) >= 0 || (o[n] = e[n]);
            return o;
          }
          function T(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function E(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? T(Object(n), !0).forEach(function (t) {
                    B(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : T(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function B(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function M(e, t) {
            return (M =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function D(e, t) {
            return (D =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function L(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function R(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? L(Object(n), !0).forEach(function (t) {
                    N(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : L(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function N(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function z(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function W(e, t) {
            return (W =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function F(e, t) {
            return (F =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function H(e, t) {
            return (H =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function U(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function q(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? U(Object(n), !0).forEach(function (t) {
                    G(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : U(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function G(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function V(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function Y(e, t) {
            return (Y =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function $(e, t) {
            return ($ =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function J(e, t) {
            void 0 === t && (t = "x");
            try {
              var n, r;
              if (!e || 0 === e.length) return "";
              var o = "",
                i = e.match(/(\s|\.|,|\n)/g);
              i && (o = i[i.length - 1] || "");
              var a = e,
                c = (null == (n = e.match(/[\d\S]{1}/)) ? void 0 : n[0]) || "",
                s = (null == (r = e.match(/[\d\S]$/)) ? void 0 : r[0]) || "";
              return (
                (a =
                  (a = a
                    .replace(/[\d\S]/g, t)
                    .replace(new RegExp(t + "{1}"), c)).substring(
                    0,
                    a.length - 1
                  ) + s) + o
              );
            } catch (e) {
              return Object(ue.a)().error(e), "";
            }
          }
          function K(e, t) {
            return (K =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function Q(e, t) {
            return (Q =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function X(e, t) {
            return (X =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function Z(e, t) {
            return (Z =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function ee(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function te(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? ee(Object(n), !0).forEach(function (t) {
                    ne(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : ee(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function ne(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function re(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function oe(e, t) {
            return (oe =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function ie(e, t) {
            return (ie =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function ae(e, t) {
            return (ae =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function ce(e, t) {
            return (ce =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          n.r(t),
            n.d(t, "HistoryService", function () {
              return fe;
            }),
            n.d(t, "ConnectionService", function () {
              return xe;
            }),
            n.d(t, "MessageService", function () {
              return _e;
            }),
            n.d(t, "RequestTemplateService", function () {
              return je;
            }),
            n.d(t, "ControlService", function () {
              return Se.a;
            }),
            n.d(t, "ActionsService", function () {
              return Ie;
            }),
            n.d(t, "SchedulerService", function () {
              return Te;
            }),
            n.d(t, "AgentConnectionService", function () {
              return Ee;
            }),
            n.d(t, "AdapterService", function () {
              return Be;
            }),
            n.d(t, "ButtonMessageService", function () {
              return Me;
            }),
            n.d(t, "RedirectService", function () {
              return Le;
            }),
            n.d(t, "BehaviorService", function () {
              return Re;
            }),
            n.d(t, "AnonymizeService", function () {
              return Ne;
            }),
            n.d(t, "MarkdownService", function () {
              return ze.a;
            }),
            n.d(t, "AttachmentService", function () {
              return Fe;
            }),
            n.d(t, "MenuService", function () {
              return He;
            }),
            n.d(t, "ThemeService", function () {
              return qe;
            }),
            n.d(t, "RemoteConfigService", function () {
              return Ve;
            }),
            n.d(t, "TopicService", function () {
              return Ye;
            }),
            n.d(t, "CalendarService", function () {
              return $e;
            }),
            n.d(t, "ModalService", function () {
              return Je;
            });
          var se = n("knbI"),
            ue = n("nbD9"),
            le = n("svqz"),
            fe = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), i = 0;
                  i < n;
                  i++
                )
                  r[i] = arguments[i];
                return (
                  ((t = e.call.apply(e, [this].concat(r)) || this).historyKey =
                    t.getKey("history")),
                  (t.timeKey = t.getKey("time")),
                  (t.storage = Object(le.a)(
                    t.config.PROTECTED.history.storage
                  )),
                  (t.REDIRECT_HISTORY_TOKEN_KEY =
                    "ab.storage.technical.redirectHistoryToken"),
                  (t.serverSideHistoryConnection = function (e) {
                    var n = e.type,
                      r = e.history,
                      o = e.token,
                      i = t.getAppStore();
                    return new Promise(function (e, t) {
                      return fetch(i.config.PROTECTED.connection.history.url, {
                        method: "POST",
                        body: JSON.stringify({ type: n, history: r, token: o }),
                      })
                        .then(function (e) {
                          return e.json();
                        })
                        .then(e)
                        .catch(t);
                    });
                  }),
                  (t.saveServerSideHistory = function (e) {
                    return t.serverSideHistoryConnection({
                      type: "save",
                      history: e.history,
                    });
                  }),
                  (t.loadServerSideHistory = function () {
                    var e = o(t).REDIRECT_HISTORY_TOKEN_KEY,
                      n = Object(le.a)("cookies");
                    return t
                      .serverSideHistoryConnection({
                        type: "get",
                        token: n.getItem(e),
                      })
                      .then(function (t) {
                        return n.removeItem(e), t;
                      });
                  }),
                  t
                );
              }
              var n, a;
              (a = e),
                ((n = t).prototype = Object.create(a.prototype)),
                (n.prototype.constructor = n),
                i(n, a);
              var c,
                s,
                u,
                l = t.prototype;
              return (
                (l.getKey = function (e) {
                  return this.config.PROTECTED.history.key + (e ? "_" + e : "");
                }),
                (l.saveHistory = function (e) {
                  if (this.isEnabled && e.length)
                    try {
                      this.storage.setItem(this.historyKey, JSON.stringify(e));
                    } catch (e) {
                      Object(ue.a)().error(e);
                    }
                }),
                (l.loadHistory = function () {
                  if (this.isEnabled)
                    try {
                      return JSON.parse(this.storage.getItem(this.historyKey));
                    } catch (e) {
                      return void Object(ue.a)().error(e);
                    }
                }),
                (c = t),
                (s = [
                  {
                    key: "isEnabled",
                    get: function () {
                      return this.config.PROTECTED.history.enabled;
                    },
                  },
                ]) && r(c.prototype, s),
                u && r(c, u),
                t
              );
            })(se.a),
            pe = n("OV23"),
            de = n("ITsB"),
            he = n("keud"),
            ge = n("6naU"),
            me = function (e) {
              function t() {
                try {
                  return p.reduce(function (e, t) {
                    return (e[t.label] = t.value), e;
                  }, {});
                } catch (e) {
                  return {};
                }
              }
              var n,
                r = e.singleGeneric,
                o = e.request,
                i = new (Object(de.b)("AdapterService"))(),
                s = null == (n = r.title) ? void 0 : n.toLowerCase(),
                u = r.description,
                l = Object(he.b)().recipient.value,
                f = new pe.a({ owner: l, type: s }),
                p = (function () {
                  try {
                    return r.options.map(function (e) {
                      var t,
                        n,
                        r = { label: e.label, value: void 0 };
                      return (
                        null != e &&
                          null != (t = e.value) &&
                          null != (n = t.input) &&
                          n.text &&
                          (r.value = e.value.input.text),
                        r
                      );
                    });
                  } catch (e) {
                    return [];
                  }
                })();
              switch (s) {
                case "setforminput":
                case "redirect":
                  (f.isAction = !0), (f.content = t());
                  break;
                case "async":
                  (f.isAction = !0), (f.content = t()), (f.content.request = o);
                  break;
                case "scrollto":
                case "mouseeventelement":
                case "textdirection":
                case "handovertoagent":
                  (f.isAction = !0), (f.content = t());
                  break;
                case "carousel":
                  f.content = { options: p };
                  break;
                case "visitingcard":
                  f.content = t();
                  break;
                case "permanentoption":
                case "permamentoption":
                  (f.type = "permanentoption"),
                    (f.content = { description: u, options: p });
                  break;
                case "imagegallery":
                  (f.type = "imagegallery"),
                    (f.content = { description: u, options: p });
                  break;
                case "onlyoption":
                case "optiononly":
                  (f.type = "onlyoption"),
                    (f.isMessageWithAction = !0),
                    (f.isMessageWithActionDone = !1),
                    (f.content = { description: u, options: p });
                  break;
                case "form":
                  f.content = (function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n = null != arguments[t] ? arguments[t] : {};
                      t % 2
                        ? a(Object(n), !0).forEach(function (t) {
                            c(e, t, n[t]);
                          })
                        : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(
                            e,
                            Object.getOwnPropertyDescriptors(n)
                          )
                        : a(Object(n)).forEach(function (t) {
                            Object.defineProperty(
                              e,
                              t,
                              Object.getOwnPropertyDescriptor(n, t)
                            );
                          });
                    }
                    return e;
                  })({ description: u }, t());
                  break;
                case "formfields":
                  f.content = { fields: t() };
                  break;
                case "formdefaults":
                  f.content = { defaults: t() };
                  break;
                case "formmerge":
                  f.content = (function (e) {
                    var t = {
                        id: "unknown",
                        fields: [],
                        button: "ok",
                        description: void 0,
                      },
                      n = e.find(function (e) {
                        return "form" === e.type;
                      });
                    if (n && n.content) {
                      (t.id = n.content.id),
                        (t.description = n.content.description),
                        (t.button = n.content.button);
                      var r = e.find(function (e) {
                        return "formFields" === e.type;
                      });
                      if (r && r.content) {
                        Object.keys(r.content.fields).forEach(function (e) {
                          t.fields.push({
                            name: r.content.fields[e],
                            displayName: e,
                          });
                        });
                        var o = e.find(function (e) {
                          return "formDefaults" === e.type;
                        });
                        o &&
                          o.content &&
                          Object.keys(o.content.defaults).forEach(function (e) {
                            var n = o.content.defaults[e];
                            t.fields.forEach(function (t) {
                              t.name === e && (t.defaultValue = n);
                            });
                          });
                      }
                    }
                    return t;
                  })(r.merge);
                  break;
                case "setbotinfo":
                  (f.isAction = !0), (f.content = t());
                  break;
                case "youtube":
                case "gif":
                  f.content = t();
                  break;
                case "redirectwithmemory":
                  (f.isAction = !0), (f.content = t());
                  break;
                case "embeddedmap":
                  f.content = t();
                  break;
                case "addcss":
                case "minimizeclient":
                  (f.isAction = !0), (f.content = t());
                  break;
                case "systemmessage":
                  (f.owner = ge.a.system),
                    (f.content = { options: p }),
                    (f.isAction = !0);
                  break;
                case "survey":
                  (f.content = t()), (f.description = u);
                case "attachment":
                  f.content = t();
                  break;
                case "dispatchevent":
                case "setlanguage":
                case "validateform":
                  (f.isAction = !0), (f.content = t());
                  break;
                case "menu":
                  (f.type = "menu"),
                    (f.content = { description: u, options: p });
                  break;
                case "menuopen":
                case "mainmenu":
                case "fullscreen":
                  (f.isAction = !0), (f.content = t());
                  break;
                case "icongrid":
                  (f.type = "icongrid"),
                    (f.content = { description: u, options: p });
                  break;
                case "remoteconfig":
                case "triggerpopup":
                  (f.isAction = !0), (f.content = p);
                  break;
                case "calendar":
                  f.content = t();
                  break;
                case "closeinitialpopup":
                  f.isAction = !0;
                  break;
                case "textwithbuttons":
                  f.content = t();
                  break;
                default:
                  try {
                    i.resolveOptionBasedType({
                      singleGeneric: r,
                      message: f,
                      optionsArray: p,
                      getOptionsAsObject: t,
                    }) ||
                      ((f.content = { title: s, description: u, options: p }),
                      (f.type = "option"));
                  } catch (e) {
                    Object(ue.a)().error(e);
                  }
              }
              return f;
            },
            be = function (e) {
              function t(e) {
                var t = (function (e) {
                  var t = e.response,
                    n = e.singleGeneric,
                    r = Object(de.b)(),
                    o = r.BehaviorService,
                    i = new (0, r.AdapterService)(),
                    a = n.text,
                    c = t.context,
                    s = new pe.a({ owner: ge.a.system, content: "" }),
                    u = !1;
                  switch ((o.dispatchEvent("command", a), a)) {
                    case "connected":
                    case "transfer":
                    case "disconnected":
                    case "closed":
                    case "not_connected":
                    case "agent_data":
                      (s.content = { command: a, context: c }),
                        (s.type = "command"),
                        (s.isAction = !0);
                      break;
                    case "ignore":
                      u = !0;
                      break;
                    default:
                      try {
                        i.resolveCommands({ singleGeneric: n, message: s });
                      } catch (e) {
                        Object(ue.a)().error(e);
                      }
                  }
                  return !u && s;
                })({ response: e.response, singleGeneric: e.singleGeneric });
                t && c.messages.push(t);
              }
              var n,
                r = e.request,
                o = e.response,
                i = Object(he.b)().recipient.value;
              i === ge.a.agent && (n = Object(he.b)().agentInfo.value);
              var a,
                c = new pe.b({ owner: i, messages: [], agentInfo: n }),
                s = [],
                u = 0,
                f = 0;
              return (
                o &&
                  o.output &&
                  o.output.generic &&
                  ((o.output.generic = l(o.output.generic)),
                  o.context &&
                    Object(he.b)().watson.set(function (e) {
                      return p(p({}, e), {}, { context: o.context });
                    }),
                  o.output.generic.forEach(function (e) {
                    var n = e.response_type,
                      l = new pe.a({ owner: i, type: n });
                    switch (n) {
                      case "text":
                        l.content = e.text;
                        break;
                      case "image":
                        l.content = e;
                        break;
                      case "pause":
                        (u += e.time), (f = e.time), (a = e.typing);
                        break;
                      case "suggestion":
                        l.content = {
                          options: e.suggestions.map(function (e) {
                            return { label: e.label, value: e };
                          }),
                          suggestionDescription: e.title,
                        };
                        break;
                      case "option":
                        var d = (function (e) {
                          return me({ singleGeneric: e, request: r });
                        })(e);
                        l = p(p({}, l), d);
                        break;
                      case "command":
                        t({ response: o, singleGeneric: e });
                        break;
                      default:
                        return null;
                    }
                    ["pause", "command"].includes(n) ||
                      (u > 0
                        ? s.push({
                            message: l,
                            typing: a,
                            orginalDelay: f,
                            delay: u,
                          })
                        : c.messages.push(l));
                  })),
                { group: c, delayed: s }
              );
            },
            ye = function (e) {
              return e.response.session_id;
            },
            ve = n("uUgx"),
            Oe = n("LoPn"),
            we = n("XAzd"),
            xe = (function (e) {
              function t() {
                var t;
                return (
                  ((t = e.call(this) || this).connection =
                    t.config.PROTECTED.connection),
                  (t.sessionInvalidCode = 404),
                  (t.sessionInvalidError = "Invalid Session"),
                  (t.maxReconnects = 3),
                  (t.reconnectCount = 0),
                  (t.dictionary = Object(we.b)()),
                  (t.prepareMessagesForRedirect = function (e) {
                    var n,
                      r = e.group,
                      o = e.delayed,
                      i = t.getAppStore(),
                      a = 0,
                      c = { messages: void 0 },
                      s = [],
                      u = function () {
                        c.messages ||
                          (c = new pe.b({
                            owner: i.recipient.value,
                            messages: [],
                          }));
                      };
                    if (
                      (r &&
                        r.messages &&
                        (r.messages = r.messages
                          .map(function (e) {
                            if (n) u(), c.messages.push(e);
                            else {
                              if ("redirectwithmemory" !== e.type.toLowerCase())
                                return e;
                              u(), (n = e);
                            }
                          })
                          .filter(function (e) {
                            return e;
                          })),
                      (o = o
                        .map(function (e) {
                          if (n) (e.delay = e.delay - a), s.push(e);
                          else {
                            if (
                              "redirectwithmemory" !==
                              e.message.type.toLowerCase()
                            )
                              return e;
                            (a = e.delay), (n = e);
                          }
                        })
                        .filter(function (e) {
                          return e;
                        })),
                      i.messagesAfterRedirect.set(function (e) {
                        var t = e.group,
                          n = e.delayed;
                        return (
                          n.splice(0, n.length),
                          (t = m(m({}, t), c)),
                          (n = [].concat(n, s)),
                          m(m({}, e), {}, { group: t, delayed: n })
                        );
                      }),
                      n)
                    )
                      if ("number" == typeof n.delay) {
                        var l = n.delay,
                          f = n.message;
                        i.thinking.set(!0),
                          setTimeout(function () {
                            i.thinking.set(!1),
                              t.services.messageService.addMessage(f);
                          }, l);
                      } else
                        setTimeout(function () {
                          t.services.messageService.addMessage(n);
                        }, 1e3);
                    return { group: r, delayed: o };
                  }),
                  (t.processMessages = function (e) {
                    setTimeout(function () {
                      var n = t.prepareMessagesForRedirect(e),
                        r = n.delayed;
                      t.services.messageService.addMessageGroup(n.group),
                        r.length && t.resolveDelayedMessages(r),
                        Object(he.b)().incognito.set(void 0);
                    }, 0);
                  }),
                  (t.saveInDataLayer = function (e) {
                    t.getAppStore().analytics.value &&
                      ((window.dataLayer = window.dataLayer || []),
                      window.dataLayer.push({
                        event: "watsonResponse",
                        intent: e.output.intents[0],
                        responses: e.output.generic,
                      }));
                    return e;
                  }),
                  (t._prepareRequest = function (e) {
                    var n = e.text,
                      r = e.context,
                      o = e.bypass_watson,
                      i = t.getAppStore(),
                      a = i.recipient.isAgent();
                    i.waitingForAgent.value &&
                      !r &&
                      ((n = ""),
                      (r = new ve.a({ eventData: { waitingForAgent: !0 } })));
                    var c = {};
                    if (
                      i.config.PROTECTED.agent &&
                      i.config.PROTECTED.agent.available &&
                      ((c = { bypass_watson: void 0 === o ? a : o }),
                      i.agentConnection.value)
                    ) {
                      var s = i.agentConnection.value,
                        u = s.room_id,
                        l = s.websocket_session_id;
                      c = m(
                        m({}, c),
                        {},
                        { room_id: u, websocket_session_id: l }
                      );
                    }
                    var f = "";
                    try {
                      "string" == typeof n
                        ? (f = n.replace(/(\r\n|\n|\r)/, ""))
                        : "object" == typeof n && (f = n[i.language.value]);
                    } catch (e) {
                      Object(ue.a)().error(e),
                        Object(ue.a)().log({ text: n, context: r });
                    }
                    var p = m(
                      m(
                        {
                          input: { text: f },
                          context: void 0,
                          uid: Object(Oe.b)(),
                        },
                        c
                      ),
                      t.config.PROTECTED.connection.extraPayloadData
                    );
                    return (
                      r && (p.context = r),
                      p.context || delete p.context,
                      JSON.stringify(p)
                    );
                  }),
                  (t._isSuccess = function (e) {
                    return !(
                      e.code === t.sessionInvalidCode &&
                      e.error === t.sessionInvalidError
                    );
                  }),
                  (t._isSessionValid = function (e) {
                    var n = e.result,
                      r = e.request;
                    if (t._isSuccess(n)) return (t.reconnectCount = 0), n;
                    if (t.reconnectCount < t.maxReconnects)
                      return t.getSessionId().then(function () {
                        return (
                          t.reconnectCount++,
                          t.sendMessage({ request: r }).catch(console.error)
                        );
                      });
                    var o = new pe.a({
                      owner: ge.a.system,
                      type: "text",
                      content: t.dictionary.connection_error,
                    });
                    t.services.messageService.addMessage(o),
                      (t.reconnectCount = 0);
                  }),
                  (t._isSessionNotExpired = function (e) {
                    var n = e.result,
                      r = t.getAppStore().sessionId;
                    return (
                      r.value !== n.session_id &&
                        n.session_id &&
                        (0, r.set)(n.session_id),
                      n
                    );
                  }),
                  (t.getSessionId = function () {
                    var e,
                      n = t.connection.getSessionId,
                      r = n.url,
                      o = n.withWelcomeMessage,
                      i = n.forceGetSession,
                      a = n.options,
                      c = t.getAppStore().sessionId,
                      s = c.set,
                      u = c.value,
                      l = t.getAppStore().messages.value,
                      f = (t.getAppStore(), null),
                      p = null,
                      d =
                        t.services.requestTemplateService.welcomeMessageByLanguage();
                    o
                      ? ((p = m(
                          m({}, a),
                          {},
                          {
                            body: t._prepareRequest({
                              text: d.text,
                              context: d.context,
                            }),
                          }
                        )),
                        t.handleFirstMessage(d))
                      : (p = m(
                          m({}, a),
                          {},
                          {
                            body: JSON.stringify(
                              m(
                                { context: new ve.a({}) },
                                t.config.PROTECTED.connection.extraPayloadData
                              )
                            ),
                          }
                        ));
                    var g =
                      null == (e = JSON.parse(p.body)) ? void 0 : e.context;
                    if (g) {
                      var b = h(g);
                      if (null != b && b.topic)
                        new (0, Object(de.b)().TopicService)().clearTopic();
                    }
                    return (
                      (p = t.includeIdentifiers(p)),
                      !i && u && l.length
                        ? new Promise(function (e) {
                            return e({ sessionIdFromStore: u });
                          })
                        : fetch(r, p || a)
                            .then(function (e) {
                              return e.json();
                            })
                            .then(t.extractRoomId)
                            .then(function (e) {
                              return (
                                (f = t.convertResponseSessionByAdapter({
                                  response: e,
                                })),
                                s(f),
                                e
                              );
                            })
                            .then(function (e) {
                              return t.convertResponseMessageByAdapter({
                                request: null,
                                response: e,
                              });
                            })
                            .then(t.processMessages)
                            .then(function () {
                              setTimeout(function () {
                                Object(he.b)().minimizeAvailable.set(!0);
                              }, 300);
                            })
                            .then(function () {
                              return f;
                            })
                            .then(function () {
                              setTimeout(function () {
                                Object(he.b)().minimizeAvailable.set(!0);
                              }, 300);
                            })
                            .catch(function (e) {
                              Object(ue.a)().error("getSessionId Error:", e);
                            })
                    );
                  }),
                  (t.resolveDelayedMessages = function (e) {
                    var n = t.getAppStore().thinking;
                    setTimeout(function () {
                      e.forEach(function (e) {
                        setTimeout(function () {
                          e.typing && n.set(!0);
                        }, e.delay - e.orginalDelay),
                          setTimeout(function () {
                            n.set(!1),
                              t.services.messageService.addMessage(e.message);
                          }, e.delay);
                      });
                    }, 2e3);
                  }),
                  (t.handleSkipAgentConnection = function (e) {
                    try {
                      var n =
                        e.context.skills["main skill"].user_defined
                          .skipAgentConnection;
                      "boolean" == typeof n &&
                        t.getAppStore().skipAgentConnection.set(n);
                    } catch (e) {}
                    return e;
                  }),
                  (t.handleFirstMessage = function (e) {
                    var n = e.text,
                      r = e.context;
                    try {
                      var o = t.getAppStore().userSentFirstMessage.value,
                        i = !0,
                        a = !o;
                      try {
                        i =
                          !r.skills["main skill"].user_defined.eventData
                            .eventName && !n.includes("$$");
                      } catch (e) {}
                      Object(ue.a)().log("isNotCommand", i, {
                        text: n,
                        context: r,
                      }),
                        a &&
                          i &&
                          ((window.__actionBot.initMessage = n),
                          t.getAppStore().userSentFirstMessage.set(!0));
                    } catch (e) {
                      Object(ue.a)().error("catched", e);
                    }
                  }),
                  (t.extractRoomId = function (e) {
                    var n = e.room_id;
                    return (
                      n &&
                        t.getAppStore().agentConnection.set(function (e) {
                          return m(m({}, e), {}, { room_id: n });
                        }),
                      e
                    );
                  }),
                  (t.sendMessage = function (e) {
                    var n = e.text,
                      r = e.context,
                      o = void 0 === r ? new ve.a({}) : r,
                      i = e.request,
                      a = e.incognito,
                      c = e.bypass_watson;
                    return new Promise(function (e, r) {
                      (window.__actionBot.initMessage = n),
                        t.getAppStore().incognito.set(a),
                        t.handleFirstMessage({ text: n, context: o });
                      var s,
                        u = t.connection.sendMessage,
                        l = u.url,
                        f = u.options,
                        p = Object(he.b)().sessionId.value,
                        d =
                          i ||
                          m(
                            m({}, f),
                            {},
                            {
                              body: t._prepareRequest({
                                text: n,
                                context: o,
                                bypass_watson: c,
                              }),
                            }
                          );
                      i = t.includeIdentifiers(i || d);
                      var g = function (c) {
                        if (c) {
                          if (
                            ((l = (function (e, t) {
                              if ("object" == typeof t) {
                                for (var n in t) {
                                  e = e.replace("{" + n + "}", t[n]);
                                }
                                return e;
                              }
                              return e;
                            })(l, { SESSION_ID: c, LANG: "en" })),
                            h(o).topic)
                          )
                            new (0, Object(de.b)().TopicService)().clearTopic();
                          fetch(l, d)
                            .then(function (e) {
                              return (s = e.json());
                            })
                            .then(t.extractRoomId)
                            .then(t.handleSkipAgentConnection)
                            .then(function (e) {
                              return t._isSessionValid({
                                result: e,
                                request: i,
                              });
                            })
                            .then(function (e) {
                              return t._isSessionNotExpired({ result: e });
                            })
                            .then(function (e) {
                              return t.saveInDataLayer(e);
                            })
                            .then(function (e) {
                              return t.convertResponseMessageByAdapter({
                                request: d,
                                response: e,
                              });
                            })
                            .then(t.processMessages)
                            .then(function (e) {
                              return e;
                            })
                            .then(function (t) {
                              e({
                                url: l,
                                requestOptions: d,
                                response: s,
                                result: t,
                              });
                            })
                            .catch(function (e) {
                              Object(ue.a)().error(e);
                              var n = new pe.a({
                                owner: ge.a.system,
                                type: "text",
                                content: t.dictionary.connection_error,
                              });
                              t.services.messageService.addMessage(n),
                                r({
                                  url: l,
                                  requestOptions: d,
                                  response: s,
                                  error: e,
                                });
                            });
                        } else
                          Object(ue.a)().warn(
                            "message not send due to invalid sessionId",
                            c,
                            {
                              text: n,
                              context: o,
                              request: i,
                              incognito: a,
                            }
                          );
                      };
                      p
                        ? setTimeout(function () {
                            g(p);
                          }, 0)
                        : setTimeout(function () {
                            t.getSessionId().then(g);
                          }, 0);
                    });
                  }),
                  (window.__actionBot.sendMessage = function (e) {
                    var n = new (t.getServices("MessageService"))(),
                      r = new pe.a({
                        owner: ge.a.user,
                        type: "text",
                        content: e.text,
                      });
                    t.getAppStore().incognito.set(e.incognito),
                      n.addMessage(r),
                      t.sendMessage(e).catch(console.error);
                  }),
                  t
                );
              }
              var n, r;
              (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                v(n, r);
              var o,
                i,
                a,
                c = t.prototype;
              return (
                (c.convertResponseMessageByAdapter = function (e) {
                  var t = e.response,
                    n = this.adapters.sendMessage({
                      request: e.request,
                      response: t,
                    }),
                    r = this.getAppStore(),
                    o = r.replyForFirstUserMessage,
                    i = r.userSentFirstMessage.value;
                  if (((window.__actionBot.initResponse = t), !o.value && i)) {
                    var a = n.group.messages;
                    Object(ue.a)().log({ response: t, messages: a }),
                      o.set({ response: t, messages: a });
                  }
                  return n;
                }),
                (c.convertResponseSessionByAdapter = function (e) {
                  return this.adapters.getSessionId({ response: e.response });
                }),
                (c.includeIdentifiers = function (e) {
                  var t = e.body,
                    n = {
                      uid: Object(Oe.b)(),
                      room_id: (function () {
                        try {
                          return Object(he.b)().agentConnection.value.room_id;
                        } catch (e) {}
                      })(),
                    };
                  if ("string" == typeof t)
                    try {
                      e.body = JSON.stringify(m(m({}, JSON.parse(t)), n));
                    } catch (e) {}
                  else "object" == typeof t && (e.body = m(m({}, t), n));
                  return e;
                }),
                (c.getWelcomeMessage = function () {
                  var e =
                    this.services.requestTemplateService.welcomeMessageByLanguage();
                  this.sendMessage(e).catch(console.error);
                }),
                (c.sendEvent = function (e, t) {
                  var n = new ve.a({ eventData: m({ eventName: e }, t) });
                  this.sendMessage({ context: n });
                }),
                (o = t),
                (i = [
                  {
                    key: "services",
                    get: function () {
                      var e = this.getServices("RequestTemplateService"),
                        t = this.getServices("MessageService");
                      return {
                        requestTemplateService: new e(),
                        messageService: new t(),
                      };
                    },
                  },
                  {
                    key: "adapters",
                    get: function () {
                      return { sendMessage: be, getSessionId: ye };
                    },
                  },
                ]) && y(o.prototype, i),
                a && y(o, a),
                t
              );
            })(se.a);
          xe.switchRecipientTo = function (e) {
            void 0 === e && (e = ge.a.bot), Object(he.b)().recipient.set(e);
          };
          var _e = (function (e) {
              function t() {
                var t;
                return (
                  ((t = e.call(this) || this).removeMessagesOverLimit =
                    function () {
                      var e = t.getAppStore(),
                        n = e.config.PROTECTED.messagesLimit;
                      (n && "number" == typeof n) || (n = 150),
                        t.getAppStore().messages.value.reduce(function (e, t) {
                          return [].concat(e, t.messages);
                        }, []).length > n &&
                          e.messages.set(function (e) {
                            return e.splice(0, 1), e;
                          });
                    }),
                  (t.editMessageById = function (e, n) {
                    e &&
                      t.getAppStore().messages.set(function (t) {
                        return t.map(function (t) {
                          return (
                            t.messages.forEach(function (t) {
                              return t.id === e ? n(t) : t;
                            }),
                            t
                          );
                        });
                      });
                  }),
                  (t.editGroupByMessageId = function (e, n) {
                    e &&
                      t.getAppStore().messages.set(function (t) {
                        return t.map(function (t) {
                          return t.messages.some(function (t) {
                            return t.id === e;
                          })
                            ? n(t)
                            : t;
                        });
                      });
                  }),
                  (t.removeMessageById = function (e) {
                    if (e) {
                      var n = t.getAppStore();
                      n.messages.set(function (t) {
                        for (var n = 0; n < t.length; n++) {
                          var r = t[n].messages.findIndex(function (t) {
                            return t.id === e;
                          });
                          if (~r) {
                            t[n].messages.splice(r, 1);
                            break;
                          }
                        }
                        return t;
                      }),
                        n._forceRerender();
                    }
                  }),
                  t
                );
              }
              var n, r;
              (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                j(n, r);
              var o,
                i,
                a,
                c = t.prototype;
              return (
                (c._handleActionMessage = function (e) {
                  var t = new (this.getServices("ActionsService"))();
                  e &&
                    (e.isAction ||
                      (e.isMessageWithAction && !e.isMessageWithActionDone)) &&
                    t.handleActionFromMessage(e);
                }),
                (c._handleActionMessages = function (e) {
                  var t = this;
                  e &&
                    e.length &&
                    e.forEach(function (e) {
                      t._handleActionMessage(e);
                    });
                }),
                (c.setMessage = function (e) {
                  this.getAppStore().messages.set(function (t) {
                    return t.splice(0, t.length), [].concat(t, e);
                  });
                }),
                (c.addMessage = function (e) {
                  var t = this;
                  setTimeout(function () {
                    function n(e) {
                      return new pe.b({ messages: [e], owner: e.owner });
                    }
                    var r = t.getAppStore();
                    if (e)
                      if (
                        (t
                          .getServices("BehaviorService")
                          .dispatchEvent("addMessage", e),
                        e.isAction)
                      )
                        t._handleActionMessage(e);
                      else {
                        e.isMessageWithAction &&
                          !e.isMessageWithActionDone &&
                          t._handleActionMessage(e);
                        var o = e.owner;
                        r.messages.set(function (t) {
                          var i = r.incognito;
                          if (o === ge.a.user && i.isForInput()) return t;
                          if (o !== ge.a.user && i.isForOutput()) return t;
                          var a = t[t.length - 1];
                          try {
                            return a && a.owner === o
                              ? ((a.messages = [].concat(a.messages, [e])),
                                t.splice(t.length - 1, 1),
                                [].concat(t, [a]))
                              : [].concat(t, [n(e)]);
                          } catch (n) {
                            return (
                              Object(ue.a)().error("Message not added", n, e), t
                            );
                          }
                        });
                      }
                  }, 0);
                }),
                (c.addMessageGroup = function (e) {
                  var t = this.getAppStore();
                  if (e && e.messages) {
                    this.getServices("BehaviorService").dispatchEvent(
                      "addMessageGroup",
                      e
                    );
                    var n = [],
                      r = new pe.b(w(w({}, e), {}, { messages: [] }));
                    e.messages.forEach(function (e) {
                      e.isMessageWithAction &&
                        !e.isMessageWithActionDone &&
                        n.push(e),
                        e.isAction ? n.push(e) : r.messages.push(e);
                    }),
                      this._handleActionMessages(n),
                      r.messages.length &&
                        t.messages.set(function (e) {
                          var n = r.owner,
                            o = t.incognito;
                          if (n === ge.a.user && o.isForInput()) return e;
                          if (n !== ge.a.user && o.isForOutput()) return e;
                          var i = e[e.length - 1];
                          try {
                            return i && i.owner === n
                              ? ((i.messages = [].concat(
                                  i.messages,
                                  r.messages
                                )),
                                e.splice(-1, 1),
                                [].concat(e, [i]))
                              : [].concat(e, [r]);
                          } catch (t) {
                            return (
                              Object(ue.a)().error(
                                "MessageGroup not added",
                                t,
                                r
                              ),
                              e
                            );
                          }
                        });
                  }
                }),
                (c.setInitialPopup = function (e) {
                  var t = this.getAppStore();
                  try {
                    t.initialPopup.set(JSON.parse(e));
                  } catch (e) {
                    console.error(e);
                  }
                }),
                (o = t),
                (i = [
                  {
                    key: "messages",
                    get: function () {
                      return this.getAppStore().messages.value;
                    },
                  },
                ]) && _(o.prototype, i),
                a && _(o, a),
                t
              );
            })(se.a),
            je = (function (e) {
              function t() {
                return e.apply(this, arguments) || this;
              }
              var n, r;
              (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                P(n, r);
              var o = t.prototype;
              return (
                (o.welcomeMessageByLanguage = function () {
                  var e = Object(he.b)().config.PUBLIC.welcomeMessage,
                    t = new ve.a({ eventData: k({}, e.context) });
                  return { text: e.text || "", context: t };
                }),
                (o.submitContextMessage = function (e) {
                  return {
                    text: "$$formEvent$$",
                    context: new ve.a({
                      eventData: {
                        eventName: e.type,
                        formId: e.target.id,
                        inputName: document.activeElement.getAttribute("value"),
                        value: e.target.value,
                      },
                    }),
                  };
                }),
                (o.loadContextMessage = function (e) {
                  return {
                    text: "$$windowEvent$$",
                    context: new ve.a({
                      eventData: {
                        eventName: e.type,
                        url: e.target.URL,
                        oldUrl: document.referrer,
                      },
                    }),
                  };
                }),
                (o.focusContextMessage = function (e) {
                  return {
                    text: "$$formEvent$$",
                    context: new ve.a({
                      eventData: {
                        eventName: e.type,
                        formId: e.target.form.id,
                        inputName: e.target.name ? e.target.name : e.target.id,
                        value: e.target.value,
                      },
                    }),
                  };
                }),
                (o.pageSpendTimeContextMessage = function () {
                  return {
                    text: "",
                    context: new ve.a({ eventData: { pageSpendTime: !0 } }),
                  };
                }),
                t
              );
            })(se.a),
            Se = n("6t2U"),
            ke = ["query"],
            Ce = ["cta"],
            Pe = ["formId"],
            Ae = ["eventName"],
            Ie = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t = e.call.apply(e, [this].concat(r)) || this).async =
                    function (e) {
                      var n = t.getServices(),
                        r = n.SchedulerService,
                        o = new (0, n.ConnectionService)(),
                        i = e.content,
                        a = i.request;
                      new r({
                        timeout: i.time,
                        callback: function () {
                          o.sendMessage({ request: a }).catch(console.error);
                        },
                      });
                    }),
                  (t.setLanguage = function (e) {
                    var n = e.content.language;
                    try {
                      t.getAppStore().language.set(n);
                    } catch (e) {
                      console.error("Error: setLanguage", { language: n }, e);
                    }
                  }),
                  (t.textDirection = function (e) {
                    var n = t.getServices(),
                      r = e.content.direction;
                    new (0, n.ControlService)().changeRtl("rtl" === r);
                  }),
                  (t.onlyOption = function () {
                    t.getAppStore().isInputDisabled.set(!0);
                  }),
                  (t.handoverToAgent = function () {
                    var e = t.getAppStore();
                    e.agentHandover.set(!0), e.waitingForAgent.set(!0);
                  }),
                  (t.extractAgentInfoFromContext = function (e) {
                    var n = e.content && e.content.context;
                    if (n)
                      try {
                        var r = h(n).agentInfo;
                        if (r) {
                          var o = r.agent,
                            i = r.agentName,
                            a = r.agentNameFrom,
                            c = r.agentNameTo,
                            s = r.agentAvatar,
                            u = {
                              agent: o,
                              name: i,
                              nameFrom: a,
                              nameTo: c,
                              avatar: s,
                            };
                          return (
                            Object.entries(u).forEach(function (e) {
                              e[1] || delete u[e[0]];
                            }),
                            Object.keys(u).length &&
                              t.getAppStore().agentInfo.set(function (e) {
                                return E(E({}, e), u);
                              }),
                            {
                              name: i,
                              nameFrom: a,
                              nameTo: c,
                              avatar: s,
                              agent: o,
                            }
                          );
                        }
                        return;
                      } catch (e) {
                        Object(ue.a)().error(e);
                      }
                  }),
                  (t.agentConnectionConnected = function () {
                    t
                      .getServices("ConnectionService")
                      .switchRecipientTo(ge.a.agent),
                      t.getAppStore().waitingForAgent.set(!1);
                  }),
                  (t.agentConnectionTransfered = function (e) {
                    return t.extractAgentInfoFromContext(e);
                  }),
                  (t.agentConnectionAgentData = function (e) {
                    return t.extractAgentInfoFromContext(e);
                  }),
                  (t.agentConnectionDisconnected = function () {
                    t
                      .getServices("ConnectionService")
                      .switchRecipientTo(ge.a.bot),
                      Object(ue.a)().log(
                        "@@@@@@@@@@ agentConnectionDisconnected"
                      );
                  }),
                  (t.agentConnectionClosed = function () {
                    t
                      .getServices()
                      .ConnectionService.switchRecipientTo(ge.a.bot),
                      t.getAppStore().agentLeftChat.set(!0),
                      t.getAppStore().userSentFirstMessage.set(!1),
                      t.getAppStore().agentConnection.set(function (e) {
                        return (
                          delete e.websocket_session_id, delete e.room_id, e
                        );
                      }),
                      t.getAppStore().replyForFirstUserMessage.set(null),
                      t.getAppStore().waitingForAgent.set(!1),
                      Object(ue.a)().log("@@@@@@@@@@ agentConnectionClosed");
                  }),
                  (t.agentNotConnected = function () {
                    t.getAppStore().waitingForAgent.set(!1),
                      Object(ue.a)().log("@@@@@@@@@@ agentNotConnected");
                  }),
                  (t.setBotInfo = function (e) {
                    var n = e.content;
                    t.getAppStore().botInfo.set(function (e) {
                      return E(E({}, e), n);
                    });
                  }),
                  (t.redirect = function (e) {
                    var n = e.content,
                      r = n.url,
                      o = n.newTab;
                    new (t.getServices("RedirectService"))().redirectTo(r, {
                      newTab: o,
                    });
                  }),
                  (t.redirectWithMemory = function (e) {
                    var n = e.content,
                      r = n.url,
                      o = n.newTab,
                      i = n.storage;
                    new (t.getServices(
                      "RedirectService"
                    ))().redirectWithMemoryTo(r, {
                      newTab: o,
                      storage: i,
                    });
                  }),
                  (t.addcss = function (e) {
                    var t = e.content,
                      n = t.query,
                      r = I(t, ke);
                    try {
                      var o = document.querySelector(n);
                      if (o) for (var i in r) o.style[i] = r[i];
                    } catch (e) {
                      Object(ue.a)().error(e);
                    }
                  }),
                  (t.minimizeclient = function (e) {
                    var t =
                      "true" === e.content.minimize ? "minimize" : "maximize";
                    setTimeout(function () {
                      window.__actionBot[t]();
                    }, 0);
                  }),
                  (t.systemmessage = function (e) {
                    var n = new (t.getServices("MessageService"))();
                    e.content &&
                      Array.isArray(e.content.options) &&
                      e.content.options.map(function (e) {
                        var t = new pe.a({
                          owner: ge.a.system,
                          type: "text",
                          content: e.value,
                        });
                        n.addMessage(t);
                      });
                  }),
                  (t.command = function (e) {
                    var n = new (t.getServices("ConnectionService"))(),
                      r = e.content.command,
                      o = "connected" === r,
                      i = "disconnected" === r,
                      a = "not_connected" === r,
                      c = "transfer" === r,
                      s = "agent_data" === r;
                    "closed" === r && t.agentConnectionClosed(),
                      a && t.agentNotConnected(),
                      i && t.agentConnectionDisconnected(),
                      o && t.agentConnectionConnected(e);
                    var u = {};
                    if (s) {
                      var l = (t.agentConnectionAgentData(e) || {}).name;
                      l && (u = { agentName: l });
                    }
                    if (c) {
                      var f = t.agentConnectionTransfered(e) || {};
                      u = {
                        agentName: f.name,
                        agentNameFrom: f.nameFrom,
                        agentNameTo: f.nameTo,
                      };
                    }
                    var p = { agentInfo: {} };
                    Object.entries(u).forEach(function (e) {
                      e[1] || delete u[e[0]];
                    }),
                      Object.keys(u).length
                        ? (p.agentInfo = u)
                        : delete p.agentInfo;
                    var d = new ve.a(E({ eventData: { eventName: r } }, p));
                    n.sendMessage({
                      text: "",
                      incognito: "input",
                      context: d,
                      bypass_watson: !1,
                    }).catch(console.error);
                  }),
                  (t.validateForm = function (e) {
                    var t = e.content,
                      n = t.cta,
                      r = I(t, Ce),
                      o = {
                        notEmpty: function (e) {
                          return !!e.input;
                        },
                        gt: function (e) {
                          var t = e.input,
                            n = e.validatorValue;
                          try {
                            return parseInt(t) > n;
                          } catch (e) {
                            return console.error(e), !1;
                          }
                        },
                        lt: function (e) {
                          var t = e.input,
                            n = e.validatorValue;
                          try {
                            return parseInt(t) < n;
                          } catch (e) {
                            return console.error(e), !1;
                          }
                        },
                      };
                    window.actionbotValidateFormInterval = setInterval(
                      function () {
                        function e() {
                          var e = { allOk: !0 };
                          return (
                            Object.entries(i).forEach(function (t) {
                              var n = t[0],
                                r = t[1],
                                i = (function (e, t) {
                                  var n = !0;
                                  return (
                                    Object.entries(t).forEach(function (t) {
                                      o[t[0]]({
                                        input: e,
                                        validatorValue: t[1],
                                      }) || (n = !1);
                                    }),
                                    n
                                  );
                                })(r.el.value, r.validators);
                              (e[n] = i), i || (e.allOk = !1);
                            }),
                            Object(ue.a)().log({ fieldsStatus: e }),
                            e
                          );
                        }
                        var t = document.querySelector(n),
                          i = {};
                        if (t) {
                          clearInterval(window.actionbotValidateFormInterval);
                          var a = t.parentNode,
                            c = t.cloneNode(!0);
                          (c.onclick = void 0),
                            a.insertBefore(c, t.nextSibling),
                            (t.style.display = "none"),
                            Object.entries(r).forEach(function (e) {
                              var t = e[0],
                                n = e[1];
                              try {
                                var r = JSON.parse(n);
                                i[t] = {
                                  el: document.querySelector(r[0]),
                                  validators: r[1],
                                };
                              } catch (e) {
                                console.error(e);
                              }
                            }),
                            c.addEventListener("click", function () {
                              var n = e(),
                                r = new (0, Object(de.b)().ConnectionService)();
                              if (n.allOk)
                                r
                                  .sendMessage({
                                    text: "$$validation_success$$",
                                    incognito: "input",
                                  })
                                  .catch(console.error),
                                  t.click();
                              else {
                                var o = new ve.a({ validation: n });
                                r.sendMessage({
                                  text: "$$validation_failed$$",
                                  incognito: "input",
                                  context: o,
                                }).catch(console.error);
                              }
                            });
                        }
                      },
                      1e3
                    );
                  }),
                  (t.mainmenu = function (e) {
                    new (t.getServices("MenuService"))().saveMenuList(e);
                  }),
                  (t.menuopen = function () {
                    new (t.getServices("MenuService"))().openMenu();
                  }),
                  (t.remoteconfig = function (e) {
                    new (t.getServices("RemoteConfigService"))().saveAndApply(
                      e
                    );
                  }),
                  (t.fullscreen = function (e) {
                    var n = new (0, t.getServices().ThemeService)(),
                      r = e.content.active;
                    void 0 !== r && n.setFullScreen("true" === r);
                  }),
                  (t.triggerpopup = function (e) {
                    var n = new (t.getServices("MessageService"))(),
                      r = e.content.find(function (e) {
                        return "popup" === e.label;
                      });
                    n.setInitialPopup(r.value);
                  }),
                  (t.closeinitialpopup = function () {
                    t.getAppStore().initialPopup.set(null);
                  }),
                  t
                );
              }
              var n, r;
              (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                M(n, r);
              var o = t.prototype;
              return (
                (o.setFormInput = function (e) {
                  function t(e, t) {
                    try {
                      var n = e.value;
                      e.value = t;
                      var r = new Event("input", { bubbles: !0 });
                      r.simulated = !0;
                      var o = e._valueTracker;
                      o && o.setValue(n), e.dispatchEvent(r);
                    } catch (e) {
                      Object(ue.a)().error(e);
                    }
                  }
                  function n(e, n) {
                    "object" == typeof e &&
                      t(e, "checkbox" === e.type ? "true" === n : n);
                  }
                  var r = e.content,
                    o = r.formId,
                    i = I(r, Pe);
                  for (var a in i)
                    try {
                      var c = a.split(";"),
                        s = document.querySelectorAll(
                          o ? "form#" + o + " " + c[0] : c[0]
                        ),
                        u = i[a];
                      if (s && 1 === c.length) n(s[0], u);
                      else if (s && c.length > 1) {
                        n(s[c[1]], u);
                      }
                    } catch (e) {
                      Object(ue.a)().error(e);
                    }
                }),
                (o.scrollTo = function (e) {
                  var t = e.content.query;
                  try {
                    var n = document.querySelector(t);
                    n &&
                      setTimeout(function () {
                        n.scrollIntoView({ behavior: "smooth" });
                      }, 100);
                  } catch (e) {
                    Object(ue.a)().error(e);
                  }
                }),
                (o.mouseEventElement = function (e) {
                  var t = A({}, e.content);
                  for (var n in t)
                    try {
                      var r = document.querySelector(n);
                      if (r) return r[t[n]](), null;
                    } catch (e) {
                      Object(ue.a)().error(e);
                    }
                }),
                (o.exists = function (e) {
                  try {
                    return "function" == typeof this.getCaseInsensitiveProp(e);
                  } catch (e) {
                    return !1;
                  }
                }),
                (o.handleActionFromMessage = function (e) {
                  var t = e.type;
                  return this.exists(t)
                    ? (this.getServices("BehaviorService").dispatchEvent(
                        "action",
                        {
                          actionName: t,
                          message: e,
                        }
                      ),
                      this.getCaseInsensitiveProp(t)(e))
                    : function () {
                        Object(ue.a)().error(t + " action not exists");
                      };
                }),
                (o.dispatchEvent = function (e) {
                  var t = e.content,
                    n = t.eventName,
                    r = I(t, Ae),
                    o = document.createEvent("Event");
                  o.initEvent(n, !0, !0),
                    (o.data = r),
                    document.dispatchEvent(o);
                }),
                t
              );
            })(se.a),
            Te = (function (e) {
              function t(t) {
                var n,
                  r = t.timeout,
                  o = t.callback;
                (n = e.call(this) || this)._scheduler = void 0;
                try {
                  var i = parseInt(r);
                  "number" == typeof i &&
                    (n._scheduler = setTimeout(function () {
                      "function" == typeof o && o();
                    }, 1e3 * i));
                } catch (e) {
                  Object(ue.a)().error(e);
                }
                return n;
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                D(n, r),
                (t.prototype.closeScheduler = function () {
                  clearTimeout(this._scheduler);
                }),
                t
              );
            })(se.a),
            Ee = (function (e) {
              function t(n) {
                var r;
                return (
                  ((r = e.call(this) || this).getWebSocket = void 0),
                  (r.openConnectionToAgent = function () {
                    try {
                      r.getWebSocket().openWS(),
                        Object(he.b)().agentLeftChat.set(!1);
                    } catch (e) {
                      Object(ue.a)().error("catched", e);
                    }
                  }),
                  (r.sendUserInfoToAgent = function (e) {
                    var n = void 0 === e ? {} : e,
                      o = n.escalate,
                      i = n.prefix,
                      a = void 0 === i ? "" : i,
                      c = n.handover,
                      s = setInterval(function () {
                        if (r.getAppStore().replyForFirstUserMessage.value) {
                          var e, n;
                          clearInterval(s);
                          var i = Object(he.b)().config.PROTECTED.connection
                              .sendMessageToAgent,
                            u = {
                              departament: i.department,
                              queueDepartament: i.queueDepartment,
                            },
                            l = Object(he.b)().agentConnection.value || {},
                            f = l.room_id,
                            p = l.websocket_session_id,
                            d = Object(he.b)().sessionId.value;
                          Object(ue.a)().log("sendUserInfoToAgent", f, p, d);
                          var h = R(
                            R({}, u),
                            {},
                            {
                              initResponse: void 0,
                              name: a + t.usernameVisibleToAgent,
                              escalate: o,
                              prefix: a,
                              handover: c,
                              room_id: f,
                              websocket_session_id: p,
                              session_id: d,
                              initMessage: window.__actionBot.initMessage,
                              uid: Object(Oe.b)(),
                              watson: Object(he.b)().watson.value,
                            }
                          );
                          (window.__actionBot.initMessage = ""),
                            null !=
                              (e = Object(he.b)().config.PROTECTED
                                .connection) &&
                              null != (n = e.sendMessageToAgent) &&
                              n.sendInitResponse &&
                              ((h.initResponse =
                                window.__actionBot.initResponse),
                              setTimeout(function () {
                                window.__actionBot.initResponse = "";
                              }, 1e3)),
                            r.getWebSocket().sendWS(JSON.stringify(h)),
                            r.pingWs();
                        }
                      }, 1e3);
                  }),
                  (r.sendHandoverToAgent = function () {
                    var e = setInterval(function () {
                      r.getAppStore().replyForFirstUserMessage.value &&
                        (clearInterval(e),
                        r.sendUserInfoToAgent({
                          escalate: !0,
                          prefix: "🚩 ",
                          handover: "chatbotHandover",
                        }));
                    }, 1e3);
                  }),
                  (r.pingWs = function () {
                    (window.__actionBot = R({}, window.__actionBot)),
                      (window.__actionBot.pingInterval = setInterval(
                        function () {
                          if (
                            r.getWebSocket().isWSOpened &&
                            t.websocketSessionId
                          ) {
                            var e = Object(he.b)().agentConnection.value || {},
                              n = e.websocket_session_id,
                              o = e.room_id,
                              i = Object(he.b)().sessionId.value,
                              a = Object(Oe.b)();
                            r.getWebSocket().sendWS(
                              JSON.stringify({
                                ping: n,
                                websocket_session_id: n,
                                session_id: i,
                                room_id: o,
                                uid: a,
                              })
                            );
                          }
                        },
                        3e4
                      ));
                  }),
                  (r.closeConnectionToAgent = function () {
                    r.getWebSocket().closeWS(),
                      r.getAppStore().agentHandover.set(!1);
                    try {
                      clearInterval(window.__actionBot.pingInterval);
                    } catch (e) {
                      Object(ue.a)().error(e);
                    }
                  }),
                  (r.getWebSocket = n),
                  r
                );
              }
              var n, r, o, i, a;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                W(n, r),
                (o = t),
                (a = [
                  {
                    key: "usernameVisibleToAgent",
                    get: function () {
                      var e = Object(he.b)();
                      return (
                        e.usernameVisibleToAgent.value ||
                        t.generateUsername(e.config)
                      );
                    },
                  },
                  {
                    key: "websocketSessionId",
                    get: function () {
                      var e = Object(he.b)().agentConnection.value;
                      return e && e.websocket_session_id;
                    },
                  },
                ]),
                (i = null) && z(o.prototype, i),
                a && z(o, a),
                t
              );
            })(se.a);
          (Ee.generateUsername = function (e) {
            var t = "",
              n = String(Math.random()).substr(-4, 4);
            e.PROTECTED.agent &&
              e.PROTECTED.agent.usernameVisibleToAgent &&
              (t = e.PROTECTED.agent.usernameVisibleToAgent);
            var r = t + " (" + n + ")";
            return Object(he.b)().usernameVisibleToAgent.set(r), r;
          }),
            (Ee.onOpen = function () {}),
            (Ee.onClose = function () {}),
            (Ee.onError = function () {}),
            (Ee.onMessage = function (e) {
              var t = {};
              try {
                t = JSON.parse(e.data);
              } catch (e) {
                Object(ue.a)().error(e);
              }
              if (t.pong && t.websocket_session_id) {
                var n = Object(he.b)().agentConnection.value
                  .websocket_session_id;
                t.websocket_session_id !== n &&
                  Object(he.b)().agentConnection.set(function (e) {
                    return R(
                      R({}, e),
                      {},
                      { websocket_session_id: t.websocket_session_id }
                    );
                  });
              }
              if (t.context) {
                var r = Object(he.b)();
                if (r.waitingForAgent.value) {
                  var o = h(t.context);
                  (!o.eventData ||
                    (o.eventData && !o.eventData.waitingForAgent)) &&
                    r.waitingForAgent.set(!1);
                }
                r.watson.set(function (e) {
                  return R(R({}, e), {}, { context: t.context });
                });
              }
              if (t.enabled)
                Object(he.b)().agentConnection.set(function (e) {
                  return R(R({}, e), t);
                }),
                  t.websocket_session_id &&
                    Object(he.b)().agentConnection.set(function (e) {
                      return R(
                        R({}, e),
                        {},
                        { websocket_session_id: t.websocket_session_id }
                      );
                    });
              else {
                var i = new (0, Object(de.b)().ConnectionService)();
                i.saveInDataLayer(t);
                var a = i.convertResponseMessageByAdapter({ response: t });
                i.processMessages(a);
              }
            });
          var Be = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t =
                    e.call.apply(e, [this].concat(r)) ||
                    this).resolveOptionBasedType = function () {
                    return null;
                  }),
                  (t.resolveCommands = function () {}),
                  (t.getMessage = function () {
                    return null;
                  }),
                  (t.mergeGenerics = function () {
                    return {
                      mergers: {},
                      check: function () {
                        return null;
                      },
                    };
                  }),
                  t
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                F(n, r),
                t
              );
            })(se.a),
            Me = (function (e) {
              function t(t) {
                var n,
                  r = t.message;
                return (
                  ((n = e.call(this) || this).message = void 0),
                  (n.onClick = function () {}),
                  (n.message = r),
                  n
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                H(n, r),
                t
              );
            })(se.a),
            De = "ab.storage.technical.tempRedirectStorageType",
            Le = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t =
                    e.call.apply(e, [this].concat(r)) ||
                    this).tempRedirectStorageType = function () {
                    return {
                      get: function () {
                        return Object(le.a)("cookies").getItem(De);
                      },
                      set: function (e) {
                        return Object(le.a)("cookies").setItem(De, e);
                      },
                      remove: function () {
                        return Object(le.a)("cookies").removeItem(De);
                      },
                    };
                  }),
                  (t.getStorage = function () {
                    var e = t.tempRedirectStorageType().get();
                    [
                      "localStorage",
                      "sessionStorage",
                      "cookies",
                      "cookiesExpired",
                      "server",
                    ].includes(e) || (e = void 0);
                    var n = t.getAppStore().config.PUBLIC.persistKeys,
                      r = n.redirectStorage,
                      o = n[r].storage || "localStorage",
                      i = Object(le.a)(e || o);
                    return (
                      Object(ue.a)().log("_store", e, i, r),
                      {
                        storageName: o,
                        persistKeys: n,
                        redirectStorageKey: r,
                        storage: i,
                      }
                    );
                  }),
                  (t._store = function () {
                    var e = t.getStorage(),
                      n = e.redirectStorageKey,
                      r = e.storage;
                    return {
                      set: function (e) {
                        var t = e;
                        "object" == typeof t && (t = JSON.stringify(e)),
                          Object(ue.a)().log("_store.set", t),
                          r.setItem(n, t);
                      },
                      get: function () {
                        var e = r.getItem(n);
                        Object(ue.a)().log("_store.get", e);
                        try {
                          return JSON.parse(e);
                        } catch (t) {
                          return e;
                        }
                      },
                      clear: function () {
                        r.removeItem(n), t.tempRedirectStorageType().remove();
                      },
                    };
                  }),
                  (t._saveStore = function (e) {
                    var n = t.getAppStore(),
                      r = t.getStorage(),
                      o = r.storageName,
                      i = r.persistKeys,
                      a = r.redirectStorageKey,
                      c = new (t.getServices("HistoryService"))(),
                      s =
                        n.config.PROTECTED.store
                          .preventSavingStoreToBrowserStorageWhenRedirectKeys,
                      u = void 0 === s ? [] : s,
                      l = {},
                      f = !1;
                    Object(ue.a)().log("_saveStore", {
                      store: n,
                      persistKeys: i,
                      redirectStorageKey: a,
                      preventSavingStoreToBrowserStorageWhenRedirectKeys: u,
                    });
                    try {
                      ["cookies", "cookiesExpired"].includes(o) && (f = !0);
                    } catch (e) {}
                    return (
                      Object.keys(n).forEach(function (e) {
                        if (!u.includes(e)) {
                          if (f) {
                            if ("messages" === e) {
                              var t = n.messages.value;
                              return void (
                                t.length && (l.messages = [t[t.length - 1]])
                              );
                            }
                            if ("agentConnection" === e) {
                              var r = n.agentConnection.value;
                              return void (
                                r &&
                                (l.agentConnection = {
                                  room_id: r.room_id,
                                  websocket_session_id: r.websocket_session_id,
                                })
                              );
                            }
                          }
                          l[e] = n[e].value;
                        }
                      }),
                      t._store().set(l),
                      new Promise(function (t, n) {
                        "server" === e
                          ? c
                              .saveServerSideHistory({ history: l })
                              .then(t)
                              .catch(n)
                          : t(void 0);
                      })
                    );
                  }),
                  (t._loadStore = function () {
                    function e(e) {
                      Object(ue.a)().log("_loadStore", { store: r, data: e }),
                        Object.keys(r).forEach(function (t) {
                          var n = e[t],
                            o = r[t];
                          try {
                            n &&
                              ("object" == typeof n
                                ? Array.isArray(n)
                                  ? o.set(function (e) {
                                      return (
                                        e.splice(0, e.length), [].concat(e, n)
                                      );
                                    })
                                  : o.set(function (e) {
                                      return q(q({}, e), n);
                                    })
                                : o.set(n));
                          } catch (e) {
                            Object(ue.a)().error(e, "cant load store ", t);
                          }
                        });
                    }
                    var n = new (t.getServices("HistoryService"))(),
                      r = t.getAppStore(),
                      o = function (e) {
                        setTimeout(function () {
                          t._store().clear(), null == e || e();
                        }, 1e3);
                      };
                    return new Promise(function (r, i) {
                      if ("server" === t.lastRedirectMode)
                        n.loadServerSideHistory()
                          .then(function (t) {
                            var n = JSON.parse(t.history);
                            e(n),
                              o(function () {
                                return r(n);
                              });
                          })
                          .catch(i);
                      else {
                        var a = t._store().get();
                        a && e(a),
                          o(function () {
                            return r(a);
                          });
                      }
                    });
                  }),
                  (t._showMessagesAfterRedirect = function () {
                    Object(ue.a)().log("_showMessagesAfterRedirect");
                    var e = t.getAppStore().messagesAfterRedirect,
                      n = new (t.getServices("ConnectionService"))();
                    setTimeout(function () {
                      n.processMessages(e.value),
                        e.set({ group: void 0, delayed: [] });
                    }, 0);
                  }),
                  (t.redirectTo = function (e, n) {
                    void 0 === n && (n = {}),
                      Object(ue.a)().log("redirectTo", { url: e, params: n });
                    try {
                      window.__actionBot.websocket.closeWS();
                    } catch (e) {}
                    setTimeout(function () {
                      if (
                        (t
                          .getServices("BehaviorService")
                          .dispatchEvent("redirect", e),
                        n && n.newTab)
                      )
                        window.open(e, "_blank") || window.location.replace(e);
                      else if (n && n.withMemory) {
                        var r = new URL(window.location.href),
                          o = new URL(e);
                        r.host === o.host && r.pathname === o.pathname
                          ? (window.location.assign(e), t.checkRedirectStatus())
                          : window.location.assign(e);
                      } else window.location.assign(e);
                    }, 1e3);
                  }),
                  (t.redirectWithMemoryTo = function (e, n) {
                    void 0 === n && (n = {});
                    var r = new (t.getServices("HistoryService"))();
                    Object(ue.a)().log("redirectWithMemoryTo", {
                      url: e,
                      params: n,
                    }),
                      n &&
                        n.storage &&
                        t.tempRedirectStorageType().set(n.storage),
                      t._saveStore(n.storage).then(function (o) {
                        Object(ue.a)().log({ r: o });
                        var i = null == o ? void 0 : o.token;
                        Object(ue.a)().log("token", i),
                          i &&
                            Object(le.a)("cookies").setItem(
                              r.REDIRECT_HISTORY_TOKEN_KEY,
                              i
                            ),
                          setTimeout(function () {
                            t.redirectTo(
                              e,
                              q(q({}, n), {}, { withMemory: !0 })
                            );
                          }, 200);
                      });
                  }),
                  (t.checkRedirectStatus = function () {
                    var e = !!t.lastRedirectMode;
                    return (
                      Object(ue.a)().log("checkRedirectStatus", {
                        wasRedirected: e,
                      }),
                      e &&
                        t._loadStore().then(function () {
                          setTimeout(function () {
                            t._showMessagesAfterRedirect(),
                              new (t.getServices(
                                "ControlService"
                              ))().scrollToBottom();
                          }, 0);
                        }),
                      e
                    );
                  }),
                  t
                );
              }
              var n, r, o, i, a;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                Y(n, r),
                (o = t),
                (i = [
                  {
                    key: "lastRedirectMode",
                    get: function () {
                      var e = new (this.getServices("HistoryService"))();
                      return Object(le.a)("cookies").getItem(
                        e.REDIRECT_HISTORY_TOKEN_KEY
                      )
                        ? "server"
                        : this._store().get()
                        ? "local"
                        : null;
                    },
                  },
                ]) && V(o.prototype, i),
                a && V(o, a),
                t
              );
            })(se.a),
            Re = (function (e) {
              function t(n) {
                var r;
                return (
                  ((r = e.call(this) || this).behavior = void 0),
                  (r.events = void 0),
                  (r.handleInactivity = function () {
                    var e = r.behavior.inactivity;
                    if ("object" == typeof e) {
                      var t = r.getAppStore,
                        n = r.getServices;
                      Object.keys(e).forEach(function (r) {
                        var o = e[r],
                          i = o.delay,
                          a = o.callback,
                          c = void 0 === a ? function () {} : a,
                          s = setTimeout(
                            function () {
                              t().messages.value.some(function (e) {
                                return e.owner === ge.a.user;
                              }) ||
                                c({
                                  getAppStore: t,
                                  getServices: n,
                                  models: {
                                    Message: pe.a,
                                    MessagesGroup: pe.b,
                                  },
                                }),
                                clearTimeout(s);
                            },
                            void 0 === i ? 0 : i
                          );
                      });
                    }
                  }),
                  (r.registerEvents = function () {
                    window.__actionBot.events ||
                      ((window.__actionBot.events = {}),
                      Object.keys(r.events).forEach(function (e) {
                        function n() {
                          var t = window.__actionBot.events[e];
                          i(t.data),
                            setTimeout(function () {
                              t.data = void 0;
                            });
                        }
                        var o = t.getEvent(e),
                          i = r.events[e];
                        if (i) {
                          var a = new Event(o);
                          window.__actionBot.events[e] ||
                            ((window.__actionBot.events[e] = a),
                            document.removeEventListener(o, n, !1),
                            document.addEventListener(o, n, !1));
                        }
                      }));
                  }),
                  n &&
                    ((r.behavior = n),
                    (r.events = n.events),
                    r.handleInactivity(),
                    r.registerEvents()),
                  r
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                $(n, r),
                t
              );
            })(se.a);
          (Re.getEvent = function (e) {
            return "ab.event." + e;
          }),
            (Re.dispatchEvent = function (e, t) {
              var n = window.__actionBot.events && window.__actionBot.events[e];
              n && (t && (n.data = t), document.dispatchEvent(n));
            });
          var Ne = (function (e) {
            function t() {
              for (
                var n, r = arguments.length, o = new Array(r), i = 0;
                i < r;
                i++
              )
                o[i] = arguments[i];
              return (
                ((n = e.call.apply(e, [this].concat(o)) || this).anonymizers = {
                  phone: {
                    description: "Phone number",
                    regExp:
                      /[\(]?[+]?([0-9]{2,3})?[\)]?[\s]?[0-9]{2,3}[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{2,3}/gm,
                    valueToSend: function () {
                      return t.getAnonymizedVariableName("phone").toSend;
                    },
                    valueToShow: function (e) {
                      try {
                        return J(e[0].trim());
                      } catch (e) {
                        return Object(ue.a)().error(e), "";
                      }
                    },
                  },
                }),
                (n.doAnonymizationOnMessage = function (e) {
                  var r = e.text,
                    o = n.getAppStore().config.PROTECTED.anonymize,
                    i = { anonymizedText: r, values: {} };
                  if (!o) return null;
                  var a = n.anonymizers;
                  return (
                    Object.keys(a).forEach(function (e) {
                      if (a[e]) {
                        var n,
                          r = a[e],
                          o =
                            t.getAnonymizedVariableName(
                              "nameAndSurname"
                            ).placeholdersRegExp;
                        n =
                          "function" == typeof r.regExp
                            ? r.regExp(i.anonymizedText.replace(o, ""))
                            : i.anonymizedText.replace(o, "").match(r.regExp);
                        var c = t.getAnonymizedVariableName(e).placeholder;
                        Array.isArray(n) &&
                          n.forEach(function (t) {
                            (i.anonymizedText = i.anonymizedText.replace(t, c)),
                              i.values[e] ||
                                (i.values[e] = {
                                  valueToSend: [],
                                  valueToShow: [],
                                }),
                              i.values[e].valueToSend.push(
                                r.valueToSend([t], i.anonymizedText)
                              ),
                              i.values[e].valueToShow.push(
                                r.valueToShow([t], i.anonymizedText)
                              );
                          });
                      }
                    }),
                    i
                  );
                }),
                n
              );
            }
            var n, r;
            return (
              (r = e),
              ((n = t).prototype = Object.create(r.prototype)),
              (n.prototype.constructor = n),
              K(n, r),
              t
            );
          })(se.a);
          Ne.getAnonymizedVariableName = function (e) {
            return {
              placeholder: " __anonymized_" + e + "__ ",
              placeholdersRegExp: /([__anonymized_][\S]+__)/g,
              toSend: " $$anonymized_" + e + "$$ ",
            };
          };
          var ze = n("hMUN"),
            We = n("UJrE"),
            Fe = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t = e.call.apply(e, [this].concat(r)) || this).onError =
                    function (e) {
                      var n = Object(we.b)(),
                        r = new (0, t.getServices().MessageService)();
                      console.error(e);
                      var o = new pe.a({
                        type: "text",
                        owner: ge.a.system,
                        content: n["upload.error.not_sent"],
                      });
                      r.addMessage(o);
                    }),
                  (t.onIncorrectFileType = function () {
                    var e = Object(we.b)();
                    new (0, t.getServices().MessageService)().addMessage(
                      new pe.a({
                        type: "text",
                        owner: ge.a.system,
                        content: e["upload.error.not_supported_format"],
                      })
                    );
                  }),
                  (t.fileTypes = We.a),
                  t
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                Q(n, r),
                t
              );
            })(se.a),
            He = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t =
                    e.call.apply(e, [this].concat(r)) || this).saveMenuList =
                    function (e) {
                      var t = Object(he.b)();
                      try {
                        t.mainMenu.set(JSON.parse(e.content.menuList));
                      } catch (e) {
                        console.error(e);
                      }
                    }),
                  (t.openMenu = function () {
                    Object(he.b)().mainMenuActive.set(!0);
                  }),
                  t
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                X(n, r),
                t
              );
            })(se.a),
            Ue = n("J9Ds"),
            qe = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t =
                    e.call.apply(e, [this].concat(r)) ||
                    this).getMobileBreakpoint = function () {
                    var e,
                      t = 576,
                      n = null == (e = Ue.a.breakpoints) ? void 0 : e.mobile;
                    if (n) {
                      var r = n.replace(/\D/, "");
                      r && (t = parseInt(r));
                    }
                    return t;
                  }),
                  (t.setFullScreen = function (e) {
                    Object(he.b)().fullScreen.set(e);
                  }),
                  t
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                Z(n, r),
                t
              );
            })(se.a);
          (qe.getThemeExtension = function () {
            return Object(he.b)().themeExtension.value;
          }),
            (qe.setThemeExtension = function (e) {
              Object(he.b)().themeExtension.set(e);
            });
          var Ge = n("5Twf"),
            Ve = (function (e) {
              function t() {
                return e.apply(this, arguments) || this;
              }
              var n, r;
              (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                oe(n, r);
              var o,
                i,
                a,
                c = t.prototype;
              return (
                (c.setData = function (e) {
                  this.getAppStore().remoteConfig.set(function (t) {
                    return te(te({}, t), {}, { data: e });
                  });
                }),
                (c.saveAndApply = function (e) {
                  if (
                    this.isEnabled &&
                    Array.isArray(null == e ? void 0 : e.content)
                  ) {
                    var t = e.content;
                    this.setData(t), this.apply(t);
                  }
                }),
                (c.apply = function (e) {
                  if (this.isEnabled) {
                    if (!e) this.remoteConfig.data;
                    if (Array.isArray(e)) {
                      var t = new (0, this.getServices().MenuService)();
                      e.forEach(function (e) {
                        var n = e.value;
                        switch (e.label.toLowerCase()) {
                          case "mainmenu":
                            t.saveMenuList(
                              new Ge.a({ content: { menuList: n } })
                            );
                          case "initialpopup":
                            var r = Object(he.b)();
                            try {
                              r.initialPopup.set(JSON.parse(n));
                            } catch (e) {
                              console.error(e);
                            }
                          default:
                            return;
                        }
                      });
                    }
                  }
                }),
                (o = t),
                (i = [
                  {
                    key: "isEnabled",
                    get: function () {
                      var e;
                      return !(
                        null == (e = this.config.PROTECTED.remoteConfig) ||
                        !e.enabled
                      );
                    },
                  },
                  {
                    key: "isLoadingActive",
                    get: function () {
                      var e, t;
                      return !(
                        !this.isEnabled ||
                        (null != (e = this.getAppStore().remoteConfig.value) &&
                          null != (t = e.data) &&
                          t.length)
                      );
                    },
                  },
                  {
                    key: "remoteConfig",
                    get: function () {
                      return this.getAppStore().remoteConfig.value;
                    },
                  },
                ]) && re(o.prototype, i),
                a && re(o, a),
                t
              );
            })(se.a),
            Ye = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t = e.call.apply(e, [this].concat(r)) || this).createTopic =
                    function (e) {
                      return "ab_topic=" + btoa(e).replace(/=/g, "");
                    }),
                  (t.getTopic = function () {
                    var e = new URL(window.location.href).searchParams.get(
                      "ab_topic"
                    );
                    if (!e) return null;
                    try {
                      return atob(e);
                    } catch (e) {
                      return (
                        console.error("Error during decoding b64 topic.", e),
                        null
                      );
                    }
                  }),
                  (t.clearTopic = function () {
                    var e = new URL(window.location.href);
                    e.searchParams.delete("ab_topic"),
                      history.replaceState(null, null, e);
                  }),
                  t
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                ie(n, r),
                t
              );
            })(se.a),
            $e = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t = e.call.apply(e, [this].concat(r)) || this).types = {
                    testReservation: {
                      mode: "all",
                      get: function () {
                        return new Promise(function (e) {
                          return e;
                        });
                      },
                    },
                  }),
                  (t.requestsThreshold = 500),
                  (t.handle = function (e) {
                    var n;
                    return t.types[null == (n = e.content) ? void 0 : n.type];
                  }),
                  (t.onSelectDate = void 0),
                  (t.onSelectTime = void 0),
                  (t.getNextDates = void 0),
                  (t.getPrevDates = void 0),
                  t
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                ae(n, r),
                t
              );
            })(se.a),
            Je = (function (e) {
              function t() {
                for (
                  var t, n = arguments.length, r = new Array(n), o = 0;
                  o < n;
                  o++
                )
                  r[o] = arguments[o];
                return (
                  ((t = e.call.apply(e, [this].concat(r)) || this).Modals = {}),
                  (t.getModalComponentByName = function (e) {
                    return t.Modals[e];
                  }),
                  (t.showModal = function (e) {
                    t.getAppStore().modal.set(e);
                  }),
                  (t.hideModal = function () {
                    t.getAppStore().modal.set(null);
                  }),
                  t
                );
              }
              var n, r;
              return (
                (r = e),
                ((n = t).prototype = Object.create(r.prototype)),
                (n.prototype.constructor = n),
                ce(n, r),
                t
              );
            })(se.a);
        },
        gGz3: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "c", function () {
              return u;
            }),
            n.d(t, "b", function () {
              return l;
            }),
            n.d(t, "d", function () {
              return f;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = a.b.button.withConfig({
              displayName: "Optionstyled__OptionButton",
              componentId: "sc-9ayua6-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                (((t = {
                  flex: "0 calc(50% - 10px)",
                  margin: "2px 5px",
                  padding: "5px 15px",
                  borderRadius: "15px",
                  fontFamily: n.fonts.primary,
                  border: "1px solid " + n.colors.colorSecondary,
                  backgroundColor: n.colors.colorWhite,
                  color: n.colors.colorSecondary,
                  boxShadow: "0 0 10px " + n.colors.boxShadow,
                  fontSize: "14px",
                  fontWeight: "light",
                  transition: "background-color .3s, color .3s, opacity .3s",
                  "&:not(:disabled):hover": {
                    color: n.colors.colorWhite,
                    backgroundColor: n.colors.colorPrimary,
                    borderColor: n.colors.colorPrimary,
                  },
                  "&:disabled": { opacity: ".6" },
                  "&:not(:disabled)": { cursor: "pointer" },
                })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  flex: "0 calc(50% - 30px)",
                  margin: "5px 15px",
                  fontSize: "18px",
                }),
                t),
                n.elements.messages.OptionButton
              );
            }),
            u = a.b.div.withConfig({
              displayName: "Optionstyled__OptionTitle",
              componentId: "sc-9ayua6-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  marginBottom: "1rem",
                  fontWeight: "bold",
                  marginTop: "10px",
                  fontSize: "16px",
                  color: t.colors.colorSecondary,
                  flex: "0 100%",
                },
                t.elements.messages.OptionTitle
              );
            }),
            l = Object(a.b)(c.a).withConfig({
              displayName: "Optionstyled__OptionContainer",
              componentId: "sc-9ayua6-2",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.OptionContainer);
            }),
            f = Object(a.b)(c.b).withConfig({
              displayName: "Optionstyled__OptionWrapper",
              componentId: "sc-9ayua6-3",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  marginRight: "25%",
                  backgroundColor: t.colors.veryLightPink,
                  display: "flex",
                  flexWrap: "wrap",
                  margin: "0",
                  padding: "10px 0",
                  width: "100%",
                  borderRadius: "0",
                  background: "transparent",
                },
                t.elements.messages.OptionWrapper
              );
            });
        },
        gsyY: function (e, t, n) {
          "use strict";
          var r = n("1hwd"),
            o = n("wfEq");
          e.exports = function (e) {
            function t(t) {
              return e.apply(this, t);
            }
            function n() {
              return this instanceof n
                ? e.apply(this, arguments)
                : new t(arguments);
            }
            var i, a, c;
            for (a in (o(n, e), o(t, n), (i = n.prototype)))
              (c = i[a]) &&
                "object" == typeof c &&
                (i[a] = "concat" in c ? c.concat() : r(c));
            return n;
          };
        },
        gxcY: function (e, t, n) {
          "use strict";
          var r = n("BN5T"),
            o =
              /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i,
            i = /^<(\/?)([a-z]+)\s*>$/;
          e.exports = function (e) {
            var t, n;
            return (
              r(
                e,
                "html",
                function (e, r, a) {
                  n !== a && ((t = []), (n = a));
                  var c = (function (e) {
                    var t = e.value.match(o);
                    return !!t && t[1];
                  })(e);
                  if (c)
                    return (
                      a.children.splice(r, 1, {
                        type: "virtualHtml",
                        tag: c,
                        position: e.position,
                      }),
                      !0
                    );
                  var s = (function (e) {
                    var t = e.value.match(i);
                    return !!t && { tag: t[2], opening: !t[1], node: e };
                  })(e);
                  if (!s) return !0;
                  var u = (function (e, t) {
                    for (var n = e.length; n--; )
                      if (e[n].tag === t) return e.splice(n, 1)[0];
                    return !1;
                  })(t, s.tag);
                  return (
                    u
                      ? a.children.splice(
                          r,
                          0,
                          (function (e, t, n) {
                            var r = n.children.indexOf(e.node),
                              o = n.children.indexOf(t.node);
                            return {
                              type: "virtualHtml",
                              children: n.children
                                .splice(r, o - r + 1)
                                .slice(1, -1),
                              tag: e.tag,
                              position: {
                                start: e.node.position.start,
                                end: t.node.position.end,
                                indent: [],
                              },
                            };
                          })(s, u, a)
                        )
                      : s.opening || t.push(s),
                    !0
                  );
                },
                !0
              ),
              e
            );
          };
        },
        h0R3: function (e, t, n) {
          "use strict";
          (function (t) {
            function r(e) {
              var n, o, i;
              if (e) {
                if ("string" == typeof e || u(e)) e = { contents: e };
                else if ("message" in e && "messages" in e) return e;
              } else e = {};
              if (!(this instanceof r)) return new r(e);
              for (
                this.data = {},
                  this.messages = [],
                  this.history = [],
                  this.cwd = t.cwd(),
                  o = -1,
                  i = p.length;
                ++o < i;

              )
                l.call(e, (n = p[o])) && (this[n] = e[n]);
              for (n in e) -1 === p.indexOf(n) && (this[n] = e[n]);
            }
            function o(e, t) {
              if (-1 !== e.indexOf(c.sep))
                throw new Error(
                  "`" + t + "` cannot be a path: did not expect `" + c.sep + "`"
                );
            }
            function i(e, t) {
              if (!e) throw new Error("`" + t + "` cannot be empty");
            }
            function a(e, t) {
              if (!e)
                throw new Error(
                  "Setting `" + t + "` requires `path` to be set too"
                );
            }
            var c = n("R8iU"),
              s = n("o+jJ"),
              u = n("EbX1");
            e.exports = r;
            var l = {}.hasOwnProperty,
              f = r.prototype;
            f.toString = function (e) {
              var t = this.contents || "";
              return u(t) ? t.toString(e) : String(t);
            };
            var p = [
              "history",
              "path",
              "basename",
              "stem",
              "extname",
              "dirname",
            ];
            Object.defineProperty(f, "path", {
              get: function () {
                return this.history[this.history.length - 1];
              },
              set: function (e) {
                i(e, "path"), e !== this.path && this.history.push(e);
              },
            }),
              Object.defineProperty(f, "dirname", {
                get: function () {
                  return "string" == typeof this.path
                    ? c.dirname(this.path)
                    : void 0;
                },
                set: function (e) {
                  a(this.path, "dirname"),
                    (this.path = c.join(e || "", this.basename));
                },
              }),
              Object.defineProperty(f, "basename", {
                get: function () {
                  return "string" == typeof this.path
                    ? c.basename(this.path)
                    : void 0;
                },
                set: function (e) {
                  i(e, "basename"),
                    o(e, "basename"),
                    (this.path = c.join(this.dirname || "", e));
                },
              }),
              Object.defineProperty(f, "extname", {
                get: function () {
                  return "string" == typeof this.path
                    ? c.extname(this.path)
                    : void 0;
                },
                set: function (e) {
                  var t = e || "";
                  if ((o(t, "extname"), a(this.path, "extname"), t)) {
                    if ("." !== t.charAt(0))
                      throw new Error("`extname` must start with `.`");
                    if (-1 !== t.indexOf(".", 1))
                      throw new Error("`extname` cannot contain multiple dots");
                  }
                  this.path = s(this.path, t);
                },
              }),
              Object.defineProperty(f, "stem", {
                get: function () {
                  return "string" == typeof this.path
                    ? c.basename(this.path, this.extname)
                    : void 0;
                },
                set: function (e) {
                  i(e, "stem"),
                    o(e, "stem"),
                    (this.path = c.join(
                      this.dirname || "",
                      e + (this.extname || "")
                    ));
                },
              });
          }).call(this, n("5IsQ"));
        },
        hMUN: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(e, t) {
              return (r =
                Object.setPrototypeOf ||
                function (e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
            }
            n.d(t, "a", function () {
              return i;
            });
            var o = n("keud"),
              i = (function (t) {
                function n() {
                  for (
                    var n, r = arguments.length, i = new Array(r), a = 0;
                    a < r;
                    a++
                  )
                    i[a] = arguments[a];
                  return (
                    ((n =
                      t.call.apply(t, [this].concat(i)) || this).getRenderers =
                      function () {
                        return {
                          link: function (t) {
                            var r = t.href,
                              i = t.children,
                              a = new (n.getServices("RedirectService"))(),
                              c = Object(o.b)().config.PUBLIC.links,
                              s = c.newTabWhenRegexpNotMatch,
                              u = c.openPdfInNewTab && r.match(/(.pdf)$/g),
                              l = s && !r.match(new RegExp(s, "g"));
                            return e(
                              "a",
                              {
                                href: r,
                                onClick: function (e) {
                                  r.match(
                                    /^((mailto|callto|tel|skype|sms|fax|):)/g
                                  ) ||
                                    (e.preventDefault(),
                                    setTimeout(function () {
                                      a._saveStore(),
                                        u || l
                                          ? window.open(r, "_blank")
                                          : a.redirectTo(r);
                                    }, 0));
                                },
                              },
                              i
                            );
                          },
                        };
                      }),
                    n
                  );
                }
                var i, a;
                return (
                  (a = t),
                  ((i = n).prototype = Object.create(a.prototype)),
                  (i.prototype.constructor = i),
                  r(i, a),
                  n
                );
              })(n("knbI").a);
          }).call(this, n("hosL").h);
        },
        hosL: function (e, t, n) {
          "use strict";
          function r(e, t) {
            for (var n in t) e[n] = t[n];
            return e;
          }
          function o(e) {
            var t = e.parentNode;
            t && t.removeChild(e);
          }
          function i(e, t, n) {
            var r,
              o,
              i,
              c = {};
            for (i in t)
              "key" == i ? (r = t[i]) : "ref" == i ? (o = t[i]) : (c[i] = t[i]);
            if (
              (arguments.length > 2 &&
                (c.children = arguments.length > 3 ? E.call(arguments, 2) : n),
              "function" == typeof e && null != e.defaultProps)
            )
              for (i in e.defaultProps)
                void 0 === c[i] && (c[i] = e.defaultProps[i]);
            return a(e, c, r, o, null);
          }
          function a(e, t, n, r, o) {
            var i = {
              type: e,
              props: t,
              key: n,
              ref: r,
              __k: null,
              __: null,
              __b: 0,
              __e: null,
              __d: void 0,
              __c: null,
              __h: null,
              constructor: void 0,
              __v: null == o ? ++M : o,
            };
            return null != B.vnode && B.vnode(i), i;
          }
          function c() {
            return { current: null };
          }
          function s(e) {
            return e.children;
          }
          function u(e, t) {
            (this.props = e), (this.context = t);
          }
          function l(e, t) {
            if (null == t)
              return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
            for (var n; t < e.__k.length; t++)
              if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
            return "function" == typeof e.type ? l(e) : null;
          }
          function f(e) {
            var t, n;
            if (null != (e = e.__) && null != e.__c) {
              for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
                if (null != (n = e.__k[t]) && null != n.__e) {
                  e.__e = e.__c.base = n.__e;
                  break;
                }
              return f(e);
            }
          }
          function p(e) {
            ((!e.__d && (e.__d = !0) && L.push(e) && !d.__r++) ||
              N !== B.debounceRendering) &&
              ((N = B.debounceRendering) || R)(d);
          }
          function d() {
            for (var e; (d.__r = L.length); )
              (e = L.sort(function (e, t) {
                return e.__v.__b - t.__v.__b;
              })),
                (L = []),
                e.some(function (e) {
                  var t, n, o, i, a, c;
                  e.__d &&
                    ((a = (i = (t = e).__v).__e),
                    (c = t.__P) &&
                      ((n = []),
                      ((o = r({}, i)).__v = i.__v + 1),
                      x(
                        c,
                        i,
                        o,
                        t.__n,
                        void 0 !== c.ownerSVGElement,
                        null != i.__h ? [a] : null,
                        n,
                        null == a ? l(i) : a,
                        i.__h
                      ),
                      _(n, i),
                      i.__e != a && f(i)));
                });
          }
          function h(e, t, n, r, o, i, c, u, f, p) {
            var d,
              h,
              m,
              y,
              v,
              O,
              w,
              _ = (r && r.__k) || F,
              j = _.length;
            for (n.__k = [], d = 0; d < t.length; d++)
              if (
                null !=
                (y = n.__k[d] =
                  null == (y = t[d]) || "boolean" == typeof y
                    ? null
                    : "string" == typeof y ||
                      "number" == typeof y ||
                      "bigint" == typeof y
                    ? a(null, y, null, null, y)
                    : Array.isArray(y)
                    ? a(s, { children: y }, null, null, null)
                    : y.__b > 0
                    ? a(y.type, y.props, y.key, null, y.__v)
                    : y)
              ) {
                if (
                  ((y.__ = n),
                  (y.__b = n.__b + 1),
                  null === (m = _[d]) ||
                    (m && y.key == m.key && y.type === m.type))
                )
                  _[d] = void 0;
                else
                  for (h = 0; h < j; h++) {
                    if ((m = _[h]) && y.key == m.key && y.type === m.type) {
                      _[h] = void 0;
                      break;
                    }
                    m = null;
                  }
                x(e, y, (m = m || W), o, i, c, u, f, p),
                  (v = y.__e),
                  (h = y.ref) &&
                    m.ref != h &&
                    (w || (w = []),
                    m.ref && w.push(m.ref, null, y),
                    w.push(h, y.__c || v, y)),
                  null != v
                    ? (null == O && (O = v),
                      "function" == typeof y.type &&
                      null != y.__k &&
                      y.__k === m.__k
                        ? (y.__d = f = g(y, f, e))
                        : (f = b(e, y, m, _, v, f)),
                      p || "option" !== n.type
                        ? "function" == typeof n.type && (n.__d = f)
                        : (e.value = ""))
                    : f && m.__e == f && f.parentNode != e && (f = l(m));
              }
            for (n.__e = O, d = j; d--; )
              null != _[d] &&
                ("function" == typeof n.type &&
                  null != _[d].__e &&
                  _[d].__e == n.__d &&
                  (n.__d = l(r, d + 1)),
                k(_[d], _[d]));
            if (w) for (d = 0; d < w.length; d++) S(w[d], w[++d], w[++d]);
          }
          function g(e, t, n) {
            var r, o;
            for (r = 0; r < e.__k.length; r++)
              (o = e.__k[r]) &&
                ((o.__ = e),
                (t =
                  "function" == typeof o.type
                    ? g(o, t, n)
                    : b(n, o, o, e.__k, o.__e, t)));
            return t;
          }
          function m(e, t) {
            return (
              (t = t || []),
              null == e ||
                "boolean" == typeof e ||
                (Array.isArray(e)
                  ? e.some(function (e) {
                      m(e, t);
                    })
                  : t.push(e)),
              t
            );
          }
          function b(e, t, n, r, o, i) {
            var a, c, s;
            if (void 0 !== t.__d) (a = t.__d), (t.__d = void 0);
            else if (null == n || o != i || null == o.parentNode)
              e: if (null == i || i.parentNode !== e)
                e.appendChild(o), (a = null);
              else {
                for (c = i, s = 0; (c = c.nextSibling) && s < r.length; s += 2)
                  if (c == o) break e;
                e.insertBefore(o, i), (a = i);
              }
            return void 0 !== a ? a : o.nextSibling;
          }
          function y(e, t, n) {
            "-" === t[0]
              ? e.setProperty(t, n)
              : (e[t] =
                  null == n
                    ? ""
                    : "number" != typeof n || H.test(t)
                    ? n
                    : n + "px");
          }
          function v(e, t, n, r, o) {
            var i;
            e: if ("style" === t)
              if ("string" == typeof n) e.style.cssText = n;
              else {
                if (("string" == typeof r && (e.style.cssText = r = ""), r))
                  for (t in r) (n && t in n) || y(e.style, t, "");
                if (n) for (t in n) (r && n[t] === r[t]) || y(e.style, t, n[t]);
              }
            else if ("o" === t[0] && "n" === t[1])
              (i = t !== (t = t.replace(/Capture$/, ""))),
                (t =
                  t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2)),
                e.l || (e.l = {}),
                (e.l[t + i] = n),
                n
                  ? r || e.addEventListener(t, i ? w : O, i)
                  : e.removeEventListener(t, i ? w : O, i);
            else if ("dangerouslySetInnerHTML" !== t) {
              if (o) t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
              else if (
                "href" !== t &&
                "list" !== t &&
                "form" !== t &&
                "tabIndex" !== t &&
                "download" !== t &&
                t in e
              )
                try {
                  e[t] = null == n ? "" : n;
                  break e;
                } catch (e) {}
              "function" == typeof n ||
                (null != n && (!1 !== n || ("a" === t[0] && "r" === t[1]))
                  ? e.setAttribute(t, n)
                  : e.removeAttribute(t));
            }
          }
          function O(e) {
            this.l[e.type + !1](B.event ? B.event(e) : e);
          }
          function w(e) {
            this.l[e.type + !0](B.event ? B.event(e) : e);
          }
          function x(e, t, n, o, i, a, c, l, f) {
            var p,
              d,
              g,
              m,
              b,
              y,
              v,
              O,
              w,
              x,
              _,
              S = t.type;
            if (void 0 !== t.constructor) return null;
            null != n.__h &&
              ((f = n.__h), (l = t.__e = n.__e), (t.__h = null), (a = [l])),
              (p = B.__b) && p(t);
            try {
              e: if ("function" == typeof S) {
                if (
                  ((O = t.props),
                  (w = (p = S.contextType) && o[p.__c]),
                  (x = p ? (w ? w.props.value : p.__) : o),
                  n.__c
                    ? (v = (d = t.__c = n.__c).__ = d.__E)
                    : ("prototype" in S && S.prototype.render
                        ? (t.__c = d = new S(O, x))
                        : ((t.__c = d = new u(O, x)),
                          (d.constructor = S),
                          (d.render = C)),
                      w && w.sub(d),
                      (d.props = O),
                      d.state || (d.state = {}),
                      (d.context = x),
                      (d.__n = o),
                      (g = d.__d = !0),
                      (d.__h = [])),
                  null == d.__s && (d.__s = d.state),
                  null != S.getDerivedStateFromProps &&
                    (d.__s == d.state && (d.__s = r({}, d.__s)),
                    r(d.__s, S.getDerivedStateFromProps(O, d.__s))),
                  (m = d.props),
                  (b = d.state),
                  g)
                )
                  null == S.getDerivedStateFromProps &&
                    null != d.componentWillMount &&
                    d.componentWillMount(),
                    null != d.componentDidMount &&
                      d.__h.push(d.componentDidMount);
                else {
                  if (
                    (null == S.getDerivedStateFromProps &&
                      O !== m &&
                      null != d.componentWillReceiveProps &&
                      d.componentWillReceiveProps(O, x),
                    (!d.__e &&
                      null != d.shouldComponentUpdate &&
                      !1 === d.shouldComponentUpdate(O, d.__s, x)) ||
                      t.__v === n.__v)
                  ) {
                    (d.props = O),
                      (d.state = d.__s),
                      t.__v !== n.__v && (d.__d = !1),
                      (d.__v = t),
                      (t.__e = n.__e),
                      (t.__k = n.__k),
                      t.__k.forEach(function (e) {
                        e && (e.__ = t);
                      }),
                      d.__h.length && c.push(d);
                    break e;
                  }
                  null != d.componentWillUpdate &&
                    d.componentWillUpdate(O, d.__s, x),
                    null != d.componentDidUpdate &&
                      d.__h.push(function () {
                        d.componentDidUpdate(m, b, y);
                      });
                }
                (d.context = x),
                  (d.props = O),
                  (d.state = d.__s),
                  (p = B.__r) && p(t),
                  (d.__d = !1),
                  (d.__v = t),
                  (d.__P = e),
                  (p = d.render(d.props, d.state, d.context)),
                  (d.state = d.__s),
                  null != d.getChildContext &&
                    (o = r(r({}, o), d.getChildContext())),
                  g ||
                    null == d.getSnapshotBeforeUpdate ||
                    (y = d.getSnapshotBeforeUpdate(m, b)),
                  (_ =
                    null != p && p.type === s && null == p.key
                      ? p.props.children
                      : p),
                  h(e, Array.isArray(_) ? _ : [_], t, n, o, i, a, c, l, f),
                  (d.base = t.__e),
                  (t.__h = null),
                  d.__h.length && c.push(d),
                  v && (d.__E = d.__ = null),
                  (d.__e = !1);
              } else
                null == a && t.__v === n.__v
                  ? ((t.__k = n.__k), (t.__e = n.__e))
                  : (t.__e = j(n.__e, t, n, o, i, a, c, f));
              (p = B.diffed) && p(t);
            } catch (e) {
              (t.__v = null),
                (f || null != a) &&
                  ((t.__e = l), (t.__h = !!f), (a[a.indexOf(l)] = null)),
                B.__e(e, t, n);
            }
          }
          function _(e, t) {
            B.__c && B.__c(t, e),
              e.some(function (t) {
                try {
                  (e = t.__h),
                    (t.__h = []),
                    e.some(function (e) {
                      e.call(t);
                    });
                } catch (e) {
                  B.__e(e, t.__v);
                }
              });
          }
          function j(e, t, n, r, i, a, c, s) {
            var u,
              f,
              p,
              d = n.props,
              g = t.props,
              m = t.type,
              b = 0;
            if (("svg" === m && (i = !0), null != a))
              for (; b < a.length; b++)
                if (
                  (u = a[b]) &&
                  (u === e || (m ? u.localName == m : 3 == u.nodeType))
                ) {
                  (e = u), (a[b] = null);
                  break;
                }
            if (null == e) {
              if (null === m) return document.createTextNode(g);
              (e = i
                ? document.createElementNS("http://www.w3.org/2000/svg", m)
                : document.createElement(m, g.is && g)),
                (a = null),
                (s = !1);
            }
            if (null === m) d === g || (s && e.data === g) || (e.data = g);
            else {
              if (
                ((a = a && E.call(e.childNodes)),
                (f = (d = n.props || W).dangerouslySetInnerHTML),
                (p = g.dangerouslySetInnerHTML),
                !s)
              ) {
                if (null != a)
                  for (d = {}, b = 0; b < e.attributes.length; b++)
                    d[e.attributes[b].name] = e.attributes[b].value;
                (p || f) &&
                  ((p &&
                    ((f && p.__html == f.__html) ||
                      p.__html === e.innerHTML)) ||
                    (e.innerHTML = (p && p.__html) || ""));
              }
              if (
                ((function (e, t, n, r, o) {
                  var i;
                  for (i in n)
                    "children" === i ||
                      "key" === i ||
                      i in t ||
                      v(e, i, null, n[i], r);
                  for (i in t)
                    (o && "function" != typeof t[i]) ||
                      "children" === i ||
                      "key" === i ||
                      "value" === i ||
                      "checked" === i ||
                      n[i] === t[i] ||
                      v(e, i, t[i], n[i], r);
                })(e, g, d, i, s),
                p)
              )
                t.__k = [];
              else if (
                ((b = t.props.children),
                h(
                  e,
                  Array.isArray(b) ? b : [b],
                  t,
                  n,
                  r,
                  i && "foreignObject" !== m,
                  a,
                  c,
                  a ? a[0] : n.__k && l(n, 0),
                  s
                ),
                null != a)
              )
                for (b = a.length; b--; ) null != a[b] && o(a[b]);
              s ||
                ("value" in g &&
                  void 0 !== (b = g.value) &&
                  (b !== e.value || ("progress" === m && !b)) &&
                  v(e, "value", b, d.value, !1),
                "checked" in g &&
                  void 0 !== (b = g.checked) &&
                  b !== e.checked &&
                  v(e, "checked", b, d.checked, !1));
            }
            return e;
          }
          function S(e, t, n) {
            try {
              "function" == typeof e ? e(t) : (e.current = t);
            } catch (e) {
              B.__e(e, n);
            }
          }
          function k(e, t, n) {
            var r, i;
            if (
              (B.unmount && B.unmount(e),
              (r = e.ref) &&
                ((r.current && r.current !== e.__e) || S(r, null, t)),
              null != (r = e.__c))
            ) {
              if (r.componentWillUnmount)
                try {
                  r.componentWillUnmount();
                } catch (e) {
                  B.__e(e, t);
                }
              r.base = r.__P = null;
            }
            if ((r = e.__k))
              for (i = 0; i < r.length; i++)
                r[i] && k(r[i], t, "function" != typeof e.type);
            n || null == e.__e || o(e.__e), (e.__e = e.__d = void 0);
          }
          function C(e, t, n) {
            return this.constructor(e, n);
          }
          function P(e, t, n) {
            var r, o, a;
            B.__ && B.__(e, t),
              (o = (r = "function" == typeof n) ? null : (n && n.__k) || t.__k),
              (a = []),
              x(
                t,
                (e = ((!r && n) || t).__k = i(s, null, [e])),
                o || W,
                W,
                void 0 !== t.ownerSVGElement,
                !r && n
                  ? [n]
                  : o
                  ? null
                  : t.firstChild
                  ? E.call(t.childNodes)
                  : null,
                a,
                !r && n ? n : o ? o.__e : t.firstChild,
                r
              ),
              _(a, e);
          }
          function A(e, t) {
            P(e, t, A);
          }
          function I(e, t, n) {
            var o,
              i,
              c,
              s = r({}, e.props);
            for (c in t)
              "key" == c ? (o = t[c]) : "ref" == c ? (i = t[c]) : (s[c] = t[c]);
            return (
              arguments.length > 2 &&
                (s.children = arguments.length > 3 ? E.call(arguments, 2) : n),
              a(e.type, s, o || e.key, i || e.ref, null)
            );
          }
          function T(e, t) {
            var n = {
              __c: (t = "__cC" + z++),
              __: e,
              Consumer: function (e, t) {
                return e.children(t);
              },
              Provider: function (e) {
                var n, r;
                return (
                  this.getChildContext ||
                    ((n = []),
                    ((r = {})[t] = this),
                    (this.getChildContext = function () {
                      return r;
                    }),
                    (this.shouldComponentUpdate = function (e) {
                      this.props.value !== e.value && n.some(p);
                    }),
                    (this.sub = function (e) {
                      n.push(e);
                      var t = e.componentWillUnmount;
                      e.componentWillUnmount = function () {
                        n.splice(n.indexOf(e), 1), t && t.call(e);
                      };
                    })),
                  e.children
                );
              },
            };
            return (n.Provider.__ = n.Consumer.contextType = n);
          }
          n.r(t),
            n.d(t, "render", function () {
              return P;
            }),
            n.d(t, "hydrate", function () {
              return A;
            }),
            n.d(t, "createElement", function () {
              return i;
            }),
            n.d(t, "h", function () {
              return i;
            }),
            n.d(t, "Fragment", function () {
              return s;
            }),
            n.d(t, "createRef", function () {
              return c;
            }),
            n.d(t, "isValidElement", function () {
              return D;
            }),
            n.d(t, "Component", function () {
              return u;
            }),
            n.d(t, "cloneElement", function () {
              return I;
            }),
            n.d(t, "createContext", function () {
              return T;
            }),
            n.d(t, "toChildArray", function () {
              return m;
            }),
            n.d(t, "options", function () {
              return B;
            });
          var E,
            B,
            M,
            D,
            L,
            R,
            N,
            z,
            W = {},
            F = [],
            H =
              /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
          (E = F.slice),
            (B = {
              __e: function (e, t) {
                for (var n, r, o; (t = t.__); )
                  if ((n = t.__c) && !n.__)
                    try {
                      if (
                        ((r = n.constructor) &&
                          null != r.getDerivedStateFromError &&
                          (n.setState(r.getDerivedStateFromError(e)),
                          (o = n.__d)),
                        null != n.componentDidCatch &&
                          (n.componentDidCatch(e), (o = n.__d)),
                        o)
                      )
                        return (n.__E = n);
                    } catch (t) {
                      e = t;
                    }
                throw e;
              },
            }),
            (M = 0),
            (D = function (e) {
              return null != e && void 0 === e.constructor;
            }),
            (u.prototype.setState = function (e, t) {
              var n;
              (n =
                null != this.__s && this.__s !== this.state
                  ? this.__s
                  : (this.__s = r({}, this.state))),
                "function" == typeof e && (e = e(r({}, n), this.props)),
                e && r(n, e),
                null != e && this.__v && (t && this.__h.push(t), p(this));
            }),
            (u.prototype.forceUpdate = function (e) {
              this.__v && ((this.__e = !0), e && this.__h.push(e), p(this));
            }),
            (u.prototype.render = s),
            (L = []),
            (R =
              "function" == typeof Promise
                ? Promise.prototype.then.bind(Promise.resolve())
                : setTimeout),
            (d.__r = 0),
            (z = 0);
        },
        htCv: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("hosL"),
              o = n("QRet"),
              i = n("eDmY"),
              a = n("4Zz8"),
              c = n("645H"),
              s = n("RiBJ"),
              u = n("A6/w"),
              l = n("ITsB"),
              f = n("keud"),
              p = n("lsAJ"),
              d = n("MIYG"),
              h = n("fgb1"),
              g = n("RzIh"),
              m = n("YLzx"),
              b = n("rMjy"),
              y = n("2DlW"),
              v = n("YN0Q"),
              O = n("T1QE"),
              w = n("FYFc"),
              x = n("UWqJ"),
              _ = n("3rof"),
              j = n("qCZp"),
              S = n("kRaY"),
              k = n("1khK"),
              C = n("mseD"),
              P = n("nbD9"),
              A = n("6naU"),
              I = n("82qt"),
              T = n("xF2S"),
              E = n("td52"),
              B = function (e) {
                return e.children;
              };
            t.a = function (t) {
              var n = t.onOptionSelect,
                M = t.MessagesCustomContainer,
                D = void 0 === M ? B : M,
                L = t.components,
                R = Object(l.b)(),
                N = R.MessageService,
                z = R.ControlService,
                W = R.HistoryService,
                F = R.AdapterService,
                H = R.RemoteConfigService,
                U = Object(f.b)(),
                q = new N(),
                G = new z(),
                V = new W(),
                Y = new F(),
                $ = new H(),
                J = q.messages,
                K = Object(r.createRef)(),
                Q = J[J.length - 1],
                X = Q ? Q.messages : [];
              Object(o.d)(
                function () {
                  G.scrollToBottom();
                },
                [J, X, U.thinking]
              ),
                Object(o.d)(
                  function () {
                    V.saveHistory(J);
                  },
                  [J]
                ),
                U.scrollToBottomRef.value ||
                  Object(o.d)(
                    function () {
                      G.registerScrollToBottomRef(K);
                    },
                    [K]
                  );
              var Z = Object(f.b)().fullScreen.value;
              return e(
                D,
                null,
                e(
                  u.c,
                  {
                    innerRef: function (e) {
                      return (K = e);
                    },
                    className: Z ? "fullscreen" : "",
                  },
                  $.isLoadingActive
                    ? e(I.a, null)
                    : (function () {
                        if (J) {
                          var t = [];
                          J.forEach(function (r, o) {
                            var s = r.isLastGroup,
                              u = [];
                            r.messages.forEach(function (t, o) {
                              var l = t.id;
                              switch (t.type) {
                                case "text":
                                  u.push(
                                    e(L.Text || i.a, {
                                      message: t,
                                      key: l,
                                      isFirstMessage: 0 === o,
                                    })
                                  );
                                  break;
                                case "image":
                                  u.push(
                                    e(L.Image || a.a, { message: t, key: l })
                                  );
                                  break;
                                case "option":
                                  u.push(
                                    e(L.Option || c.a, {
                                      message: t,
                                      onOptionSelect: n,
                                      isDisabled: !s,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "onlyoption":
                                  u.push(
                                    e(L.OnlyOption || h.a, {
                                      message: t,
                                      onOptionSelect: n,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "permanentoption":
                                  u.push(
                                    e(L.PermanentOption || g.a, {
                                      message: t,
                                      onOptionSelect: n,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "carousel":
                                  u.push(
                                    e(L.Carousel || p.a, {
                                      message: t,
                                      onOptionSelect: n,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "imagegallery":
                                  u.push(
                                    e(L.ImageGallery || m.a, {
                                      onOptionSelect: n,
                                      message: t,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "visitingcard":
                                  u.push(
                                    e(L.VisitingCard || d.a, {
                                      message: t,
                                      onOptionSelects: n,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "formmerge":
                                  u.push(
                                    e(L.Form || b.a, { message: t, key: l })
                                  );
                                  break;
                                case "suggestion":
                                  u.push(
                                    e(L.Suggestion || y.a, {
                                      message: t,
                                      isDisabled: !s,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "youtube":
                                  u.push(
                                    e(L.YouTube || O.a, { message: t, key: l })
                                  );
                                  break;
                                case "gif":
                                  u.push(
                                    e(L.Gif || w.a, { message: t, key: l })
                                  );
                                  break;
                                case "button":
                                  u.push(
                                    e(L.Button || x.a, { message: t, key: l })
                                  );
                                  break;
                                case "embeddedmap":
                                  u.push(
                                    e(L.EmbeddedMap || _.a, {
                                      message: t,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "survey":
                                  u.push(
                                    e(L.Survey || j.a, {
                                      onSelect: n,
                                      message: t,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "attachment":
                                  u.push(
                                    e(L.Attachment || S.a, {
                                      message: t,
                                      key: l,
                                    })
                                  );
                                  break;
                                case "menu":
                                  var f = L.MessageMenu || k.a;
                                  (r.withoutAvatar = !0),
                                    (r.withoutDate = !0),
                                    u.push(e(f, { onOptionSelect: n, key: l }));
                                  break;
                                case "icongrid":
                                  u.push(
                                    e(L.IconGrid || C.a, { message: t, key: l })
                                  );
                                  break;
                                case "calendar":
                                  u.push(
                                    e(L.Calendar || T.a, {
                                      message: t,
                                      key: l,
                                      isDisabled: !s,
                                    })
                                  );
                                  break;
                                case "textwithbuttons":
                                  return (
                                    u.push(e(E.a, { key: l, message: t })), u
                                  );
                                default:
                                  try {
                                    Y.getMessage({
                                      message: t,
                                      messagesComponents: u,
                                      onOptionSelect: n,
                                    }) ||
                                      Object(P.a)().log(
                                        "Unexpected response type"
                                      );
                                  } catch (e) {
                                    Object(P.a)().error(e);
                                  }
                              }
                            }),
                              t.push(
                                e(
                                  v.a,
                                  { group: r, key: "messagesGroup-" + o },
                                  u
                                )
                              );
                          });
                          return [
                            t,
                            U.thinking.value &&
                              e(
                                v.a,
                                {
                                  group: {
                                    owner: U.recipient.value,
                                    withoutAvatar: (function () {
                                      return (
                                        !U.config.PUBLIC.thinkingAvatar ||
                                        (!!(
                                          U.messages &&
                                          U.messages.value &&
                                          U.messages.value.length > 0
                                        ) &&
                                          U.messages.value[
                                            U.messages.value.length - 1
                                          ].owner !== A.a.user)
                                      );
                                    })(),
                                  },
                                },
                                e(s.a, null)
                              ),
                          ];
                        }
                        return [];
                      })()
                )
              );
            };
          }).call(this, n("hosL").h);
        },
        iWpb: function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function i(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? o(n, !0).forEach(function (t) {
                    a(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : o(n).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function a(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.canUseDOM =
              t.slidesOnLeft =
              t.slidesOnRight =
              t.siblingDirection =
              t.getTotalSlides =
              t.getPostClones =
              t.getPreClones =
              t.getTrackLeft =
              t.getTrackAnimateCSS =
              t.getTrackCSS =
              t.checkSpecKeys =
              t.getSlideCount =
              t.checkNavigable =
              t.getNavigableIndexes =
              t.swipeEnd =
              t.swipeMove =
              t.swipeStart =
              t.keyHandler =
              t.changeSlide =
              t.slideHandler =
              t.initializedState =
              t.extractObject =
              t.canGoNext =
              t.getSwipeDirection =
              t.getHeight =
              t.getWidth =
              t.lazySlidesOnRight =
              t.lazySlidesOnLeft =
              t.lazyEndIndex =
              t.lazyStartIndex =
              t.getRequiredLazySlides =
              t.getOnDemandLazySlides =
                void 0);
          var c = r(n("l8WD")),
            s = r(n("l8WD")),
            u = function (e) {
              for (var t = [], n = l(e), r = f(e), o = n; o < r; o++)
                e.lazyLoadedList.indexOf(o) < 0 && t.push(o);
              return t;
            };
          t.getOnDemandLazySlides = u;
          t.getRequiredLazySlides = function (e) {
            for (var t = [], n = l(e), r = f(e), o = n; o < r; o++) t.push(o);
            return t;
          };
          var l = function (e) {
            return e.currentSlide - p(e);
          };
          t.lazyStartIndex = l;
          var f = function (e) {
            return e.currentSlide + d(e);
          };
          t.lazyEndIndex = f;
          var p = function (e) {
            return e.centerMode
              ? Math.floor(e.slidesToShow / 2) +
                  (parseInt(e.centerPadding) > 0 ? 1 : 0)
              : 0;
          };
          t.lazySlidesOnLeft = p;
          var d = function (e) {
            return e.centerMode
              ? Math.floor((e.slidesToShow - 1) / 2) +
                  1 +
                  (parseInt(e.centerPadding) > 0 ? 1 : 0)
              : e.slidesToShow;
          };
          t.lazySlidesOnRight = d;
          var h = function (e) {
            return (e && e.offsetWidth) || 0;
          };
          t.getWidth = h;
          var g = function (e) {
            return (e && e.offsetHeight) || 0;
          };
          t.getHeight = g;
          var m = function (e) {
            var t,
              n,
              r,
              o,
              i =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return (
              (t = e.startX - e.curX),
              (n = e.startY - e.curY),
              (r = Math.atan2(n, t)),
              (o = Math.round((180 * r) / Math.PI)) < 0 &&
                (o = 360 - Math.abs(o)),
              (o <= 45 && o >= 0) || (o <= 360 && o >= 315)
                ? "left"
                : o >= 135 && o <= 225
                ? "right"
                : !0 === i
                ? o >= 35 && o <= 135
                  ? "up"
                  : "down"
                : "vertical"
            );
          };
          t.getSwipeDirection = m;
          var b = function (e) {
            var t = !0;
            return (
              e.infinite ||
                (((e.centerMode && e.currentSlide >= e.slideCount - 1) ||
                  e.slideCount <= e.slidesToShow ||
                  e.currentSlide >= e.slideCount - e.slidesToShow) &&
                  (t = !1)),
              t
            );
          };
          t.canGoNext = b;
          t.extractObject = function (e, t) {
            var n = {};
            return (
              t.forEach(function (t) {
                return (n[t] = e[t]);
              }),
              n
            );
          };
          t.initializedState = function (e) {
            var t,
              n = c.default.Children.count(e.children),
              r = Math.ceil(h(s.default.findDOMNode(e.listRef))),
              o = Math.ceil(h(s.default.findDOMNode(e.trackRef)));
            if (e.vertical) t = r;
            else {
              var i = e.centerMode && 2 * parseInt(e.centerPadding);
              "string" == typeof e.centerPadding &&
                "%" === e.centerPadding.slice(-1) &&
                (i *= r / 100),
                (t = Math.ceil((r - i) / e.slidesToShow));
            }
            var a =
                s.default.findDOMNode(e.listRef) &&
                g(
                  s.default
                    .findDOMNode(e.listRef)
                    .querySelector('[data-index="0"]')
                ),
              l = a * e.slidesToShow,
              f = void 0 === e.currentSlide ? e.initialSlide : e.currentSlide;
            e.rtl && void 0 === e.currentSlide && (f = n - 1 - e.initialSlide);
            var p = e.lazyLoadedList || [],
              d = u({ currentSlide: f, lazyLoadedList: p });
            p.concat(d);
            var m = {
              slideCount: n,
              slideWidth: t,
              listWidth: r,
              trackWidth: o,
              currentSlide: f,
              slideHeight: a,
              listHeight: l,
              lazyLoadedList: p,
            };
            return (
              null === e.autoplaying &&
                e.autoplay &&
                (m.autoplaying = "playing"),
              m
            );
          };
          t.slideHandler = function (e) {
            var t = e.infinite,
              n = e.index,
              r = e.slideCount,
              o = e.lazyLoadedList,
              a = e.lazyLoad,
              c = e.currentSlide,
              s = e.centerMode,
              l = e.slidesToScroll,
              f = e.slidesToShow,
              p = e.useCSS;
            if (e.waitForAnimate && e.animating) return {};
            var d,
              h,
              g,
              m = n,
              y = {},
              v = {};
            if (e.fade) {
              if (!t && (n < 0 || n >= r)) return {};
              n < 0 ? (m = n + r) : n >= r && (m = n - r),
                a && o.indexOf(m) < 0 && o.push(m),
                (y = { animating: !0, currentSlide: m, lazyLoadedList: o }),
                (v = { animating: !1 });
            } else
              (d = m),
                m < 0
                  ? ((d = m + r), t ? r % l != 0 && (d = r - (r % l)) : (d = 0))
                  : !b(e) && m > c
                  ? (m = d = c)
                  : s && m >= r
                  ? ((m = t ? r : r - 1), (d = t ? 0 : r - 1))
                  : m >= r &&
                    ((d = m - r), t ? r % l != 0 && (d = 0) : (d = r - f)),
                (h = j(i({}, e, { slideIndex: m }))),
                (g = j(i({}, e, { slideIndex: d }))),
                t || (h === g && (m = d), (h = g)),
                a && o.concat(u(i({}, e, { currentSlide: m }))),
                p
                  ? ((y = {
                      animating: !0,
                      currentSlide: d,
                      trackStyle: _(i({}, e, { left: h })),
                      lazyLoadedList: o,
                    }),
                    (v = {
                      animating: !1,
                      currentSlide: d,
                      trackStyle: x(i({}, e, { left: g })),
                      swipeLeft: null,
                    }))
                  : (y = {
                      currentSlide: d,
                      trackStyle: x(i({}, e, { left: g })),
                      lazyLoadedList: o,
                    });
            return { state: y, nextState: v };
          };
          t.changeSlide = function (e, t) {
            var n,
              r,
              o,
              a,
              c = e.slidesToScroll,
              s = e.slideCount,
              u = e.currentSlide,
              l = e.lazyLoad,
              f = e.infinite;
            if (((n = s % c != 0 ? 0 : (s - u) % c), "previous" === t.message))
              (a = u - (o = 0 === n ? c : e.slidesToShow - n)),
                l && !f && (a = -1 === (r = u - o) ? s - 1 : r);
            else if ("next" === t.message)
              (a = u + (o = 0 === n ? c : n)),
                l && !f && (a = ((u + c) % s) + n);
            else if ("dots" === t.message) {
              if ((a = t.index * t.slidesToScroll) === t.currentSlide)
                return null;
            } else if ("children" === t.message) {
              if ((a = t.index) === t.currentSlide) return null;
              if (f) {
                var p = P(i({}, e, { targetSlide: a }));
                a > t.currentSlide && "left" === p
                  ? (a -= s)
                  : a < t.currentSlide && "right" === p && (a += s);
              }
            } else if (
              "index" === t.message &&
              (a = Number(t.index)) === t.currentSlide
            )
              return null;
            return a;
          };
          t.keyHandler = function (e, t, n) {
            return e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !t
              ? ""
              : 37 === e.keyCode
              ? n
                ? "next"
                : "previous"
              : 39 === e.keyCode
              ? n
                ? "previous"
                : "next"
              : "";
          };
          t.swipeStart = function (e, t, n) {
            return (
              "IMG" === e.target.tagName && e.preventDefault(),
              !t || (!n && -1 !== e.type.indexOf("mouse"))
                ? ""
                : {
                    dragging: !0,
                    touchObject: {
                      startX: e.touches ? e.touches[0].pageX : e.clientX,
                      startY: e.touches ? e.touches[0].pageY : e.clientY,
                      curX: e.touches ? e.touches[0].pageX : e.clientX,
                      curY: e.touches ? e.touches[0].pageY : e.clientY,
                    },
                  }
            );
          };
          t.swipeMove = function (e, t) {
            var n = t.vertical,
              r = t.swipeToSlide,
              o = t.verticalSwiping,
              a = t.rtl,
              c = t.currentSlide,
              s = t.edgeFriction,
              u = t.edgeDragged,
              l = t.onEdge,
              f = t.swiped,
              p = t.swiping,
              d = t.slideCount,
              h = t.slidesToScroll,
              g = t.infinite,
              y = t.touchObject,
              v = t.swipeEvent,
              O = t.listHeight,
              w = t.listWidth;
            if (!t.scrolling) {
              if (t.animating) return e.preventDefault();
              n && r && o && e.preventDefault();
              var _,
                S = {},
                k = j(t);
              (y.curX = e.touches ? e.touches[0].pageX : e.clientX),
                (y.curY = e.touches ? e.touches[0].pageY : e.clientY),
                (y.swipeLength = Math.round(
                  Math.sqrt(Math.pow(y.curX - y.startX, 2))
                ));
              var C = Math.round(Math.sqrt(Math.pow(y.curY - y.startY, 2)));
              if (!o && !p && C > 10) return { scrolling: !0 };
              o && (y.swipeLength = C);
              var P = (a ? -1 : 1) * (y.curX > y.startX ? 1 : -1);
              o && (P = y.curY > y.startY ? 1 : -1);
              var A = Math.ceil(d / h),
                I = m(t.touchObject, o),
                T = y.swipeLength;
              return (
                g ||
                  (((0 === c && "right" === I) ||
                    (c + 1 >= A && "left" === I) ||
                    (!b(t) && "left" === I)) &&
                    ((T = y.swipeLength * s),
                    !1 === u && l && (l(I), (S.edgeDragged = !0)))),
                !f && v && (v(I), (S.swiped = !0)),
                (_ = n ? k + T * (O / w) * P : a ? k - T * P : k + T * P),
                o && (_ = k + T * P),
                (S = i({}, S, {
                  touchObject: y,
                  swipeLeft: _,
                  trackStyle: x(i({}, t, { left: _ })),
                })),
                Math.abs(y.curX - y.startX) < 0.8 * Math.abs(y.curY - y.startY)
                  ? S
                  : (y.swipeLength > 10 &&
                      ((S.swiping = !0), e.preventDefault()),
                    S)
              );
            }
          };
          t.swipeEnd = function (e, t) {
            var n = t.touchObject,
              r = t.listWidth,
              o = t.touchThreshold,
              a = t.verticalSwiping,
              c = t.listHeight,
              s = t.currentSlide,
              u = t.swipeToSlide,
              l = t.scrolling,
              f = t.onSwipe;
            if (!t.dragging) return t.swipe && e.preventDefault(), {};
            var p = a ? c / o : r / o,
              d = m(n, a),
              h = {
                dragging: !1,
                edgeDragged: !1,
                scrolling: !1,
                swiping: !1,
                swiped: !1,
                swipeLeft: null,
                touchObject: {},
              };
            if (l) return h;
            if (!n.swipeLength) return h;
            if (n.swipeLength > p) {
              var g, b;
              switch ((e.preventDefault(), f && f(d), d)) {
                case "left":
                case "up":
                  (b = s + O(t)),
                    (g = u ? v(t, b) : b),
                    (h.currentDirection = 0);
                  break;
                case "right":
                case "down":
                  (b = s - O(t)),
                    (g = u ? v(t, b) : b),
                    (h.currentDirection = 1);
                  break;
                default:
                  g = s;
              }
              h.triggerSlideHandler = g;
            } else {
              var y = j(t);
              h.trackStyle = _(i({}, t, { left: y }));
            }
            return h;
          };
          var y = function (e) {
            for (
              var t = e.infinite ? 2 * e.slideCount : e.slideCount,
                n = e.infinite ? -1 * e.slidesToShow : 0,
                r = e.infinite ? -1 * e.slidesToShow : 0,
                o = [];
              n < t;

            )
              o.push(n),
                (n = r + e.slidesToScroll),
                (r += Math.min(e.slidesToScroll, e.slidesToShow));
            return o;
          };
          t.getNavigableIndexes = y;
          var v = function (e, t) {
            var n = y(e),
              r = 0;
            if (t > n[n.length - 1]) t = n[n.length - 1];
            else
              for (var o in n) {
                if (t < n[o]) {
                  t = r;
                  break;
                }
                r = n[o];
              }
            return t;
          };
          t.checkNavigable = v;
          var O = function (e) {
            var t = e.centerMode
              ? e.slideWidth * Math.floor(e.slidesToShow / 2)
              : 0;
            if (e.swipeToSlide) {
              var n,
                r = s.default
                  .findDOMNode(e.listRef)
                  .querySelectorAll(".slick-slide");
              return (
                Array.from(r).every(function (r) {
                  if (e.vertical) {
                    if (r.offsetTop + g(r) / 2 > -1 * e.swipeLeft)
                      return (n = r), !1;
                  } else if (r.offsetLeft - t + h(r) / 2 > -1 * e.swipeLeft) return (n = r), !1;
                  return !0;
                }),
                n
                  ? Math.abs(
                      n.dataset.index -
                        (!0 === e.rtl
                          ? e.slideCount - e.currentSlide
                          : e.currentSlide)
                    ) || 1
                  : 0
              );
            }
            return e.slidesToScroll;
          };
          t.getSlideCount = O;
          var w = function (e, t) {
            return t.reduce(function (t, n) {
              return t && e.hasOwnProperty(n);
            }, !0)
              ? null
              : console.error("Keys Missing:", e);
          };
          t.checkSpecKeys = w;
          var x = function (e) {
            var t, n;
            w(e, [
              "left",
              "variableWidth",
              "slideCount",
              "slidesToShow",
              "slideWidth",
            ]),
              e.vertical
                ? (n = (e.slideCount + 2 * e.slidesToShow) * e.slideHeight)
                : (t = C(e) * e.slideWidth);
            var r = { opacity: 1, transition: "", WebkitTransition: "" };
            e.useTransform
              ? (r = i({}, r, {
                  WebkitTransform: e.vertical
                    ? "translate3d(0px, " + e.left + "px, 0px)"
                    : "translate3d(" + e.left + "px, 0px, 0px)",
                  transform: e.vertical
                    ? "translate3d(0px, " + e.left + "px, 0px)"
                    : "translate3d(" + e.left + "px, 0px, 0px)",
                  msTransform: e.vertical
                    ? "translateY(" + e.left + "px)"
                    : "translateX(" + e.left + "px)",
                }))
              : e.vertical
              ? (r.top = e.left)
              : (r.left = e.left);
            return (
              e.fade && (r = { opacity: 1 }),
              t && (r.width = t),
              n && (r.height = n),
              window &&
                !window.addEventListener &&
                window.attachEvent &&
                (e.vertical
                  ? (r.marginTop = e.left + "px")
                  : (r.marginLeft = e.left + "px")),
              r
            );
          };
          t.getTrackCSS = x;
          var _ = function (e) {
            w(e, [
              "left",
              "variableWidth",
              "slideCount",
              "slidesToShow",
              "slideWidth",
              "speed",
              "cssEase",
            ]);
            var t = x(e);
            return (
              e.useTransform
                ? ((t.WebkitTransition =
                    "-webkit-transform " + e.speed + "ms " + e.cssEase),
                  (t.transition = "transform " + e.speed + "ms " + e.cssEase))
                : (t.transition = e.vertical
                    ? "top " + e.speed + "ms " + e.cssEase
                    : "left " + e.speed + "ms " + e.cssEase),
              t
            );
          };
          t.getTrackAnimateCSS = _;
          var j = function (e) {
            if (e.unslick) return 0;
            w(e, [
              "slideIndex",
              "trackRef",
              "infinite",
              "centerMode",
              "slideCount",
              "slidesToShow",
              "slidesToScroll",
              "slideWidth",
              "listWidth",
              "variableWidth",
              "slideHeight",
            ]);
            var t,
              n,
              r = e.slideIndex,
              o = e.trackRef,
              i = e.infinite,
              a = e.centerMode,
              c = e.slideCount,
              u = e.slidesToShow,
              l = e.slidesToScroll,
              f = e.slideWidth,
              p = e.listWidth,
              d = e.variableWidth,
              h = e.slideHeight,
              g = e.vertical;
            if (e.fade || 1 === e.slideCount) return 0;
            var m = 0;
            if (
              (i
                ? ((m = -S(e)),
                  c % l != 0 &&
                    r + l > c &&
                    (m = -(r > c ? u - (r - c) : c % l)),
                  a && (m += parseInt(u / 2)))
                : (c % l != 0 && r + l > c && (m = u - (c % l)),
                  a && (m = parseInt(u / 2))),
              (t = g ? r * h * -1 + m * h : r * f * -1 + m * f),
              !0 === d)
            ) {
              var b,
                y = s.default.findDOMNode(o);
              if (
                ((b = r + S(e)),
                (t = (n = y && y.childNodes[b]) ? -1 * n.offsetLeft : 0),
                !0 === a)
              ) {
                (b = i ? r + S(e) : r), (n = y && y.children[b]), (t = 0);
                for (var v = 0; v < b; v++)
                  t -= y && y.children[v] && y.children[v].offsetWidth;
                (t -= parseInt(e.centerPadding)),
                  (t += n && (p - n.offsetWidth) / 2);
              }
            }
            return t;
          };
          t.getTrackLeft = j;
          var S = function (e) {
            return e.unslick || !e.infinite
              ? 0
              : e.variableWidth
              ? e.slideCount
              : e.slidesToShow + (e.centerMode ? 1 : 0);
          };
          t.getPreClones = S;
          var k = function (e) {
            return e.unslick || !e.infinite ? 0 : e.slideCount;
          };
          t.getPostClones = k;
          var C = function (e) {
            return 1 === e.slideCount ? 1 : S(e) + e.slideCount + k(e);
          };
          t.getTotalSlides = C;
          var P = function (e) {
            return e.targetSlide > e.currentSlide
              ? e.targetSlide > e.currentSlide + A(e)
                ? "left"
                : "right"
              : e.targetSlide < e.currentSlide - I(e)
              ? "right"
              : "left";
          };
          t.siblingDirection = P;
          var A = function (e) {
            var t = e.slidesToShow,
              n = e.rtl;
            if (e.centerMode) {
              var r = (t - 1) / 2 + 1;
              return (
                parseInt(e.centerPadding) > 0 && (r += 1),
                n && t % 2 == 0 && (r += 1),
                r
              );
            }
            return n ? 0 : t - 1;
          };
          t.slidesOnRight = A;
          var I = function (e) {
            var t = e.slidesToShow,
              n = e.rtl;
            if (e.centerMode) {
              var r = (t - 1) / 2 + 1;
              return (
                parseInt(e.centerPadding) > 0 && (r += 1),
                n || t % 2 != 0 || (r += 1),
                r
              );
            }
            return n ? t - 1 : 0;
          };
          t.slidesOnLeft = I;
          t.canUseDOM = function () {
            return !(
              "undefined" == typeof window ||
              !window.document ||
              !window.document.createElement
            );
          };
        },
        iXzu: function (e, t, n) {
          "use strict";
          n.r(t),
            function (e) {
              function n(e) {
                return parseFloat(e) || 0;
              }
              function r(e) {
                for (var t = [], r = 1; r < arguments.length; r++)
                  t[r - 1] = arguments[r];
                return t.reduce(function (t, r) {
                  return t + n(e["border-" + r + "-width"]);
                }, 0);
              }
              function o(e) {
                var t = e.clientWidth,
                  o = e.clientHeight;
                if (!t && !o) return m;
                var i = g(e).getComputedStyle(e),
                  c = (function (e) {
                    for (
                      var t = {}, r = 0, o = ["top", "right", "bottom", "left"];
                      r < o.length;
                      r++
                    ) {
                      var i = o[r];
                      t[i] = n(e["padding-" + i]);
                    }
                    return t;
                  })(i),
                  s = c.left + c.right,
                  u = c.top + c.bottom,
                  l = n(i.width),
                  f = n(i.height);
                if (
                  ("border-box" === i.boxSizing &&
                    (Math.round(l + s) !== t &&
                      (l -= r(i, "left", "right") + s),
                    Math.round(f + u) !== o &&
                      (f -= r(i, "top", "bottom") + u)),
                  !(function (e) {
                    return e === g(e).document.documentElement;
                  })(e))
                ) {
                  var p = Math.round(l + s) - t,
                    d = Math.round(f + u) - o;
                  1 !== Math.abs(p) && (l -= p), 1 !== Math.abs(d) && (f -= d);
                }
                return a(c.left, c.top, l, f);
              }
              function i(e) {
                return s
                  ? b(e)
                    ? (function (e) {
                        var t = e.getBBox();
                        return a(0, 0, t.width, t.height);
                      })(e)
                    : o(e)
                  : m;
              }
              function a(e, t, n, r) {
                return { x: e, y: t, width: n, height: r };
              }
              var c = (function () {
                  function e(e, t) {
                    var n = -1;
                    return (
                      e.some(function (e, r) {
                        return e[0] === t && ((n = r), !0);
                      }),
                      n
                    );
                  }
                  return "undefined" != typeof Map
                    ? Map
                    : (function () {
                        function t() {
                          this.__entries__ = [];
                        }
                        return (
                          Object.defineProperty(t.prototype, "size", {
                            get: function () {
                              return this.__entries__.length;
                            },
                            enumerable: !0,
                            configurable: !0,
                          }),
                          (t.prototype.get = function (t) {
                            var n = e(this.__entries__, t),
                              r = this.__entries__[n];
                            return r && r[1];
                          }),
                          (t.prototype.set = function (t, n) {
                            var r = e(this.__entries__, t);
                            ~r
                              ? (this.__entries__[r][1] = n)
                              : this.__entries__.push([t, n]);
                          }),
                          (t.prototype.delete = function (t) {
                            var n = this.__entries__,
                              r = e(n, t);
                            ~r && n.splice(r, 1);
                          }),
                          (t.prototype.has = function (t) {
                            return !!~e(this.__entries__, t);
                          }),
                          (t.prototype.clear = function () {
                            this.__entries__.splice(0);
                          }),
                          (t.prototype.forEach = function (e, t) {
                            void 0 === t && (t = null);
                            for (
                              var n = 0, r = this.__entries__;
                              n < r.length;
                              n++
                            ) {
                              var o = r[n];
                              e.call(t, o[1], o[0]);
                            }
                          }),
                          t
                        );
                      })();
                })(),
                s =
                  "undefined" != typeof window &&
                  "undefined" != typeof document &&
                  window.document === document,
                u =
                  void 0 !== e && e.Math === Math
                    ? e
                    : "undefined" != typeof self && self.Math === Math
                    ? self
                    : "undefined" != typeof window && window.Math === Math
                    ? window
                    : Function("return this")(),
                l =
                  "function" == typeof requestAnimationFrame
                    ? requestAnimationFrame.bind(u)
                    : function (e) {
                        return setTimeout(function () {
                          return e(Date.now());
                        }, 1e3 / 60);
                      },
                f = [
                  "top",
                  "right",
                  "bottom",
                  "left",
                  "width",
                  "height",
                  "size",
                  "weight",
                ],
                p = "undefined" != typeof MutationObserver,
                d = (function () {
                  function e() {
                    (this.connected_ = !1),
                      (this.mutationEventsAdded_ = !1),
                      (this.mutationsObserver_ = null),
                      (this.observers_ = []),
                      (this.onTransitionEnd_ =
                        this.onTransitionEnd_.bind(this)),
                      (this.refresh = (function (e, t) {
                        function n() {
                          i && ((i = !1), e()), a && o();
                        }
                        function r() {
                          l(n);
                        }
                        function o() {
                          var e = Date.now();
                          if (i) {
                            if (e - c < 2) return;
                            a = !0;
                          } else (i = !0), (a = !1), setTimeout(r, t);
                          c = e;
                        }
                        var i = !1,
                          a = !1,
                          c = 0;
                        return o;
                      })(this.refresh.bind(this), 20));
                  }
                  return (
                    (e.prototype.addObserver = function (e) {
                      ~this.observers_.indexOf(e) || this.observers_.push(e),
                        this.connected_ || this.connect_();
                    }),
                    (e.prototype.removeObserver = function (e) {
                      var t = this.observers_,
                        n = t.indexOf(e);
                      ~n && t.splice(n, 1),
                        !t.length && this.connected_ && this.disconnect_();
                    }),
                    (e.prototype.refresh = function () {
                      this.updateObservers_() && this.refresh();
                    }),
                    (e.prototype.updateObservers_ = function () {
                      var e = this.observers_.filter(function (e) {
                        return e.gatherActive(), e.hasActive();
                      });
                      return (
                        e.forEach(function (e) {
                          return e.broadcastActive();
                        }),
                        e.length > 0
                      );
                    }),
                    (e.prototype.connect_ = function () {
                      s &&
                        !this.connected_ &&
                        (document.addEventListener(
                          "transitionend",
                          this.onTransitionEnd_
                        ),
                        window.addEventListener("resize", this.refresh),
                        p
                          ? ((this.mutationsObserver_ = new MutationObserver(
                              this.refresh
                            )),
                            this.mutationsObserver_.observe(document, {
                              attributes: !0,
                              childList: !0,
                              characterData: !0,
                              subtree: !0,
                            }))
                          : (document.addEventListener(
                              "DOMSubtreeModified",
                              this.refresh
                            ),
                            (this.mutationEventsAdded_ = !0)),
                        (this.connected_ = !0));
                    }),
                    (e.prototype.disconnect_ = function () {
                      s &&
                        this.connected_ &&
                        (document.removeEventListener(
                          "transitionend",
                          this.onTransitionEnd_
                        ),
                        window.removeEventListener("resize", this.refresh),
                        this.mutationsObserver_ &&
                          this.mutationsObserver_.disconnect(),
                        this.mutationEventsAdded_ &&
                          document.removeEventListener(
                            "DOMSubtreeModified",
                            this.refresh
                          ),
                        (this.mutationsObserver_ = null),
                        (this.mutationEventsAdded_ = !1),
                        (this.connected_ = !1));
                    }),
                    (e.prototype.onTransitionEnd_ = function (e) {
                      var t = e.propertyName,
                        n = void 0 === t ? "" : t;
                      f.some(function (e) {
                        return !!~n.indexOf(e);
                      }) && this.refresh();
                    }),
                    (e.getInstance = function () {
                      return (
                        this.instance_ || (this.instance_ = new e()),
                        this.instance_
                      );
                    }),
                    (e.instance_ = null),
                    e
                  );
                })(),
                h = function (e, t) {
                  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
                    var o = r[n];
                    Object.defineProperty(e, o, {
                      value: t[o],
                      enumerable: !1,
                      writable: !1,
                      configurable: !0,
                    });
                  }
                  return e;
                },
                g = function (e) {
                  return (
                    (e && e.ownerDocument && e.ownerDocument.defaultView) || u
                  );
                },
                m = a(0, 0, 0, 0),
                b =
                  "undefined" != typeof SVGGraphicsElement
                    ? function (e) {
                        return e instanceof g(e).SVGGraphicsElement;
                      }
                    : function (e) {
                        return (
                          e instanceof g(e).SVGElement &&
                          "function" == typeof e.getBBox
                        );
                      },
                y = (function () {
                  function e(e) {
                    (this.broadcastWidth = 0),
                      (this.broadcastHeight = 0),
                      (this.contentRect_ = a(0, 0, 0, 0)),
                      (this.target = e);
                  }
                  return (
                    (e.prototype.isActive = function () {
                      var e = i(this.target);
                      return (
                        (this.contentRect_ = e),
                        e.width !== this.broadcastWidth ||
                          e.height !== this.broadcastHeight
                      );
                    }),
                    (e.prototype.broadcastRect = function () {
                      var e = this.contentRect_;
                      return (
                        (this.broadcastWidth = e.width),
                        (this.broadcastHeight = e.height),
                        e
                      );
                    }),
                    e
                  );
                })(),
                v = function (e, t) {
                  var n,
                    r,
                    o,
                    i,
                    a,
                    c,
                    s,
                    u =
                      ((r = (n = t).x),
                      (o = n.y),
                      (i = n.width),
                      (a = n.height),
                      (c =
                        "undefined" != typeof DOMRectReadOnly
                          ? DOMRectReadOnly
                          : Object),
                      (s = Object.create(c.prototype)),
                      h(s, {
                        x: r,
                        y: o,
                        width: i,
                        height: a,
                        top: o,
                        right: r + i,
                        bottom: a + o,
                        left: r,
                      }),
                      s);
                  h(this, { target: e, contentRect: u });
                },
                O = (function () {
                  function e(e, t, n) {
                    if (
                      ((this.activeObservations_ = []),
                      (this.observations_ = new c()),
                      "function" != typeof e)
                    )
                      throw new TypeError(
                        "The callback provided as parameter 1 is not a function."
                      );
                    (this.callback_ = e),
                      (this.controller_ = t),
                      (this.callbackCtx_ = n);
                  }
                  return (
                    (e.prototype.observe = function (e) {
                      if (!arguments.length)
                        throw new TypeError(
                          "1 argument required, but only 0 present."
                        );
                      if (
                        "undefined" != typeof Element &&
                        Element instanceof Object
                      ) {
                        if (!(e instanceof g(e).Element))
                          throw new TypeError(
                            'parameter 1 is not of type "Element".'
                          );
                        var t = this.observations_;
                        t.has(e) ||
                          (t.set(e, new y(e)),
                          this.controller_.addObserver(this),
                          this.controller_.refresh());
                      }
                    }),
                    (e.prototype.unobserve = function (e) {
                      if (!arguments.length)
                        throw new TypeError(
                          "1 argument required, but only 0 present."
                        );
                      if (
                        "undefined" != typeof Element &&
                        Element instanceof Object
                      ) {
                        if (!(e instanceof g(e).Element))
                          throw new TypeError(
                            'parameter 1 is not of type "Element".'
                          );
                        var t = this.observations_;
                        t.has(e) &&
                          (t.delete(e),
                          t.size || this.controller_.removeObserver(this));
                      }
                    }),
                    (e.prototype.disconnect = function () {
                      this.clearActive(),
                        this.observations_.clear(),
                        this.controller_.removeObserver(this);
                    }),
                    (e.prototype.gatherActive = function () {
                      var e = this;
                      this.clearActive(),
                        this.observations_.forEach(function (t) {
                          t.isActive() && e.activeObservations_.push(t);
                        });
                    }),
                    (e.prototype.broadcastActive = function () {
                      if (this.hasActive()) {
                        var e = this.callbackCtx_,
                          t = this.activeObservations_.map(function (e) {
                            return new v(e.target, e.broadcastRect());
                          });
                        this.callback_.call(e, t, e), this.clearActive();
                      }
                    }),
                    (e.prototype.clearActive = function () {
                      this.activeObservations_.splice(0);
                    }),
                    (e.prototype.hasActive = function () {
                      return this.activeObservations_.length > 0;
                    }),
                    e
                  );
                })(),
                w = "undefined" != typeof WeakMap ? new WeakMap() : new c(),
                x = function e(t) {
                  if (!(this instanceof e))
                    throw new TypeError("Cannot call a class as a function.");
                  if (!arguments.length)
                    throw new TypeError(
                      "1 argument required, but only 0 present."
                    );
                  var n = d.getInstance(),
                    r = new O(t, n, this);
                  w.set(this, r);
                };
              ["observe", "unobserve", "disconnect"].forEach(function (e) {
                x.prototype[e] = function () {
                  var t;
                  return (t = w.get(this))[e].apply(t, arguments);
                };
              }),
                (t.default =
                  void 0 !== u.ResizeObserver ? u.ResizeObserver : x);
            }.call(this, n("pCvA"));
        },
        "j+JB": function (e) {
          "use strict";
          e.exports = function (e, t) {
            for (var n = e.indexOf("\n", t); n > t && " " === e.charAt(n - 1); )
              n--;
            return n;
          };
        },
        j5Tj: function (e, t, n) {
          "use strict";
          (function (e, r) {
            function o(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r);
              }
              return n;
            }
            function i(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? o(Object(n), !0).forEach(function (t) {
                      a(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : o(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            }
            function a(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            var c = n("E/r5"),
              s = n("keud"),
              u = n("ITsB"),
              l = n("OV23"),
              f = n("UJrE"),
              p = n("x6i8"),
              d = n("nbD9"),
              h = n("XAzd"),
              g = n("6naU");
            t.a = function () {
              function t(e) {
                function t(e, t) {
                  y.onError(e, t);
                }
                try {
                  if (
                    !(function (e) {
                      return Object.values(v).includes(e.type);
                    })(e)
                  )
                    return void y.onIncorrectFileType();
                  if (e.size <= j)
                    if (k) {
                      var r,
                        a = new FormData();
                      a.append("file", e), a.append("filename", e.name);
                      try {
                        a.append(
                          "rid",
                          Object(s.b)().agentConnection.value.websocket_session
                            .room_id
                        );
                      } catch (e) {
                        a.append(
                          "rid",
                          Object(s.b)().agentConnection.value.room_id
                        );
                      }
                      var c = new AbortController(),
                        u = c.signal,
                        f = !!S && o.PROTECTED.connection.uploadFile.url,
                        h = new l.a({
                          type: "attachment",
                          owner: g.a.user,
                          content: {
                            sending: !0,
                            file: { name: e.name, type: e.type, size: e.size },
                          },
                        });
                      (window.__actionBot = i(
                        i({}, window.__actionBot),
                        {},
                        {
                          attachments: i(
                            i({}, window.__actionBot.attachments),
                            {},
                            ((r = {}),
                            (r[h.id] = {
                              abort: function () {
                                c.abort(),
                                  b.removeMessageById(h.id),
                                  delete window.__actionBot.attachments[h.id];
                              },
                            }),
                            r)
                          ),
                        }
                      )),
                        ((m = e),
                        new Promise(function (e, t) {
                          if (m.type.includes("image")) {
                            var n = new Image();
                            (n.onload = function () {
                              var t = n.height > 175 ? 175 / n.height : 1,
                                r = n.width * t,
                                o = n.height * t,
                                i = document.createElement("canvas"),
                                a = i.getContext("2d");
                              (i.width = r),
                                (i.height = o),
                                a.drawImage(n, 0, 0, r, o),
                                e(i.toDataURL());
                            }),
                              (n.src = URL.createObjectURL(m));
                          } else t();
                        }))
                          .then(function (e) {
                            h.content.file.base64 = e;
                          })
                          .finally(function () {
                            b.addMessage(h),
                              f &&
                                fetch(f, { signal: u, method: "POST", body: a })
                                  .then(function (e) {
                                    if (e && e.ok) {
                                      n = e.body.getReader();
                                      var r = setInterval(function () {
                                        n.read().then(function (e) {
                                          e.done &&
                                            (clearInterval(r),
                                            b.editMessageById(
                                              h.id,
                                              function (e) {
                                                return (
                                                  (e.content.sending = !1), e
                                                );
                                              }
                                            ));
                                        });
                                      }, 10);
                                    } else t(e, h);
                                  })
                                  .catch(function (e) {
                                    t(e);
                                  });
                          });
                    } else Object(d.a)().error("not connected to agent");
                  else
                    b.addMessage(
                      new l.a({
                        type: "text",
                        owner: g.a.user,
                        content: O["upload.error.file_to_big"] + Object(p.a)(j),
                      })
                    );
                } catch (e) {
                  Object(d.a)().error(e);
                }
                var m;
              }
              var n,
                o = Object(s.b)().config,
                a = Object(u.b)(),
                m = a.AttachmentService,
                b = new (0, a.MessageService)(),
                y = new m(),
                v = y.fileTypes,
                O = Object(h.b)(),
                w = Object.values(f.a).join(", "),
                x = o.PROTECTED.connection.uploadFile,
                _ = x.maxFileSize,
                j = void 0 === _ ? 2097152 : _,
                S = x.enabled,
                k = !!Object(s.b)().recipient.isAgent();
              return S && k
                ? e(
                    r,
                    null,
                    e(c.b, {
                      accept: w,
                      type: "file",
                      id: "actionbot-input-file",
                      onChange: function (e) {
                        e.target.files.length && t(e.target.files[0]);
                      },
                    }),
                    e(c.a, {
                      onClick: function () {
                        document.getElementById("actionbot-input-file").click();
                      },
                    })
                  )
                : null;
            };
          }).call(this, n("hosL").h, n("hosL").Fragment);
        },
        jAGx: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "c", function () {
            return s;
          }),
            n.d(t, "h", function () {
              return u;
            }),
            n.d(t, "e", function () {
              return l;
            }),
            n.d(t, "b", function () {
              return f;
            }),
            n.d(t, "g", function () {
              return p;
            }),
            n.d(t, "f", function () {
              return d;
            }),
            n.d(t, "d", function () {
              return h;
            }),
            n.d(t, "a", function () {
              return g;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = Object(a.b)(c.a).withConfig({
              displayName: "Formstyled__FormContainer",
              componentId: "sc-13ylyr9-0",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.FormContainer);
            }),
            u = Object(a.b)(c.b).withConfig({
              displayName: "Formstyled__FormWrapper",
              componentId: "sc-13ylyr9-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  display: "inline-block",
                  marginRight: "25%",
                  backgroundColor: t.colors.veryLightPink,
                },
                t.elements.messages.FormWrapper
              );
            }),
            l = a.b.div.withConfig({
              displayName: "Formstyled__FormHeader",
              componentId: "sc-13ylyr9-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { fontWeight: "bold", marginBottom: ".5rem" },
                e.theme.elements.messages.FormHeader
              );
            }),
            f = a.b.button.withConfig({
              displayName: "Formstyled__FormButton",
              componentId: "sc-13ylyr9-3",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  padding: "5px 15px",
                  borderRadius: "15px",
                  border: t.colors.white,
                  backgroundColor: t.colors.whiteGradient,
                  transition: "background-color .3s, color .3s",
                  bottom: 0,
                  marginTop: ".5rem",
                  float: "right",
                  "&:not(:disabled):hover": {
                    color: t.colors.white,
                    backgroundColor: t.colors.veryLightPink,
                    borderColor: t.colors.veryLightPink,
                    cursor: "pointer",
                  },
                },
                t.elements.messages.FormButton
              );
            }),
            p = a.b.label.withConfig({
              displayName: "Formstyled__FormLabel",
              componentId: "sc-13ylyr9-4",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "block" },
                e.theme.elements.messages.FormLabel
              );
            }),
            d = a.b.input.withConfig({
              displayName: "Formstyled__FormInput",
              componentId: "sc-13ylyr9-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "block" },
                e.theme.elements.messages.FormInput
              );
            }),
            h = a.b.div.withConfig({
              displayName: "Formstyled__FormFields",
              componentId: "sc-13ylyr9-6",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { display: "block", margin: "8px 0" },
                e.theme.elements.messages.FormFields
              );
            }),
            g = a.b.form.withConfig({
              displayName: "Formstyled__Form",
              componentId: "sc-13ylyr9-7",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.Form);
            });
        },
        jFWS: function (e) {
          e.exports = function (e) {
            return e
              .replace(/[A-Z]/g, function (e) {
                return "-" + e.toLowerCase();
              })
              .toLowerCase();
          };
        },
        jRwt: function (e, t) {
          "use strict";
          t.a = function (e, t) {
            try {
              var n = e.match(/:(.*?):/g);
              n &&
                n.forEach(function (n) {
                  var r = t[n.replace(/:/g, "")];
                  r && (e = e.replace(n, r));
                });
            } catch (e) {}
            return e;
          };
        },
        jffb: function (e, t, n) {
          (function (t) {
            function n(e) {
              var t = typeof e;
              return !!e && ("object" == t || "function" == t);
            }
            function r(e) {
              if ("number" == typeof e) return e;
              if (
                (function (e) {
                  return (
                    "symbol" == typeof e ||
                    ((function (e) {
                      return !!e && "object" == typeof e;
                    })(e) &&
                      "[object Symbol]" == f.call(e))
                  );
                })(e)
              )
                return NaN;
              if (n(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = n(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(o, "");
              var r = a.test(e);
              return r || c.test(e)
                ? s(e.slice(2), r ? 2 : 8)
                : i.test(e)
                ? NaN
                : +e;
            }
            var o = /^\s+|\s+$/g,
              i = /^[-+]0x[0-9a-f]+$/i,
              a = /^0b[01]+$/i,
              c = /^0o[0-7]+$/i,
              s = parseInt,
              u =
                "object" == typeof self &&
                self &&
                self.Object === Object &&
                self,
              l =
                ("object" == typeof t && t && t.Object === Object && t) ||
                u ||
                Function("return this")(),
              f = Object.prototype.toString,
              p = Math.max,
              d = Math.min,
              h = function () {
                return l.Date.now();
              };
            e.exports = function (e, t, o) {
              function i(t) {
                var n = f,
                  r = g;
                return (f = g = void 0), (O = t), (b = e.apply(r, n));
              }
              function a(e) {
                return (O = e), (y = setTimeout(s, t)), w ? i(e) : b;
              }
              function c(e) {
                var n = e - v;
                return void 0 === v || n >= t || n < 0 || (x && e - O >= m);
              }
              function s() {
                var e = h();
                if (c(e)) return u(e);
                y = setTimeout(
                  s,
                  (function (e) {
                    var n = t - (e - v);
                    return x ? d(n, m - (e - O)) : n;
                  })(e)
                );
              }
              function u(e) {
                return (y = void 0), _ && f ? i(e) : ((f = g = void 0), b);
              }
              function l() {
                var e = h(),
                  n = c(e);
                if (((f = arguments), (g = this), (v = e), n)) {
                  if (void 0 === y) return a(v);
                  if (x) return (y = setTimeout(s, t)), i(v);
                }
                return void 0 === y && (y = setTimeout(s, t)), b;
              }
              var f,
                g,
                m,
                b,
                y,
                v,
                O = 0,
                w = !1,
                x = !1,
                _ = !0;
              if ("function" != typeof e)
                throw new TypeError("Expected a function");
              return (
                (t = r(t) || 0),
                n(o) &&
                  ((w = !!o.leading),
                  (m = (x = "maxWait" in o) ? p(r(o.maxWait) || 0, t) : m),
                  (_ = "trailing" in o ? !!o.trailing : _)),
                (l.cancel = function () {
                  void 0 !== y && clearTimeout(y),
                    (O = 0),
                    (f = v = g = y = void 0);
                }),
                (l.flush = function () {
                  return void 0 === y ? b : u(h());
                }),
                l
              );
            };
          }).call(this, n("pCvA"));
        },
        k6Jz: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object(o.k)(t);
            return [].concat(n, [e]);
          }
          n.d(t, "a", function () {
            return r;
          });
          var o = n("QRet");
        },
        kKSO: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "e", function () {
            return s;
          }),
            n.d(t, "f", function () {
              return u;
            }),
            n.d(t, "c", function () {
              return l;
            }),
            n.d(t, "a", function () {
              return f;
            }),
            n.d(t, "d", function () {
              return p;
            }),
            n.d(t, "b", function () {
              return d;
            }),
            n.d(t, "g", function () {
              return h;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = Object(a.b)(c.a).withConfig({
              displayName: "TextWithButtonsstyled__TextContainer",
              componentId: "sc-1y3ygp4-0",
            })([".ActionBot &{", "}"], function (e) {
              return o({}, e.theme.elements.messages.TextContainer);
            }),
            u = Object(a.b)(c.b).withConfig({
              displayName: "TextWithButtonsstyled__TextWrapper",
              componentId: "sc-1y3ygp4-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                o(
                  (((t = {
                    backgroundColor: n.colors.veryLightPink,
                    a: { wordBreak: "break-word" },
                    padding: "4px 20px",
                    borderRadius: "10px",
                    color: n.colors.colorSecondary,
                    background: n.colors.colorWhite,
                    boxShadow: "0 0 18px " + n.colors.boxShadow,
                    fontSize: "15px",
                    fontWeight: "light",
                    lineHeight: "130%",
                    maxWidth: "90%",
                    p: {
                      textAlign: "left",
                      overflowWrap: "anywhere",
                      margin: "10px 0",
                    },
                  })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                    fontSize: "18px",
                  }),
                  t),
                  n.elements.messages.TextWrapper
                ),
                n.elements.messages.TextWithButtonsTextWrapper
              );
            }),
            l = a.b.div.withConfig({
              displayName: "TextWithButtonsstyled__TextButton",
              componentId: "sc-1y3ygp4-2",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme,
                n = e.isAnyButtonActive,
                r = e.isButtonActive
                  ? {
                      "&:hover": n
                        ? {}
                        : {
                            span: o(
                              { color: t.colors.colorPrimary },
                              t.elements.messages.TextButtonIsButtonActiveHover
                            ),
                          },
                    }
                  : o(
                      { filter: "saturate(0)" },
                      t.elements.messages.TextButtonButtonInactive
                    ),
                i = n
                  ? o(
                      { cursor: "default" },
                      t.elements.messages.TextButtonIsAnyButtonActive
                    )
                  : o(
                      { cursor: "pointer" },
                      t.elements.messages.TextButtonIsAnyButtonInactive
                    );
              return o(
                o(
                  o(
                    {
                      width: "100%",
                      height: "40px",
                      backgroundColor: t.colors.colorWhite,
                      display: "flex",
                      alignItems: "center",
                      margin: "0 auto",
                      marginTop: "10px",
                      borderRadius: "4px",
                      fontSize: "14px",
                      justifyContent: "center",
                      cursor: "pointer",
                      border: "solid 1px " + t.colors.colorPrimary,
                      fontFamily: t.fonts.primaryFont,
                      "&:hover": { backgroundColor: t.colors.colorWhite },
                      "&:active": {
                        border: "solid 1px " + t.colors.colorPrimary,
                      },
                    },
                    r
                  ),
                  i
                ),
                t.elements.messages.TextWithButtonsTextButton
              );
            }),
            f = a.b.span.withConfig({
              displayName: "TextWithButtonsstyled__ButtonContent",
              componentId: "sc-1y3ygp4-3",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  display: "block !important",
                  fontWeight: "bold !important",
                  color: t.colors.colorPrimary + " !important",
                },
                t.elements.messages.TextWithButtonsButtonContent
              );
            }),
            p = a.b.div.withConfig({
              displayName: "TextWithButtonsstyled__TextButtonList",
              componentId: "sc-1y3ygp4-4",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme,
                n = e.isAnyButtonActive,
                r = e.isButtonActive
                  ? {
                      "&:hover": n
                        ? {}
                        : {
                            span: o(
                              {
                                textDecoration: "underline",
                                color: t.colors.colorPrimary,
                              },
                              t.elements.messages
                                .TextButtonListIsButtonActiveHover
                            ),
                          },
                    }
                  : o(
                      { filter: "saturate(0)" },
                      t.elements.messages.TextButtonListButtonInactive
                    ),
                i = n
                  ? o(
                      { cursor: "default" },
                      t.elements.messages.TextButtonListIsAnyButtonActive
                    )
                  : o(
                      { cursor: "pointer" },
                      t.elements.messages.TextButtonListIsAnyButtonInactive
                    );
              return o(
                o(
                  o(
                    {
                      width: "fit-content",
                      marginTop: "10px",
                      borderRadius: "4px",
                      fontSize: "13px",
                      fontFamily: t.fonts.primaryFont,
                    },
                    r
                  ),
                  i
                ),
                t.elements.messages.TextWithButtonsTextButtonList
              );
            }),
            d = a.b.div.withConfig({
              displayName: "TextWithButtonsstyled__ButtonWrapper",
              componentId: "sc-1y3ygp4-5",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { width: "100%", marginBottom: "15px" },
                e.theme.elements.messages.TextWithButtonsButtonWrapper
              );
            }),
            h = a.b.div.withConfig({
              displayName: "TextWithButtonsstyled__UserIndicator",
              componentId: "sc-1y3ygp4-6",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  fontSize: "13px",
                  color: t.colors.colorBlack,
                  marginBottom: "4px",
                },
                t.elements.messages.TextWithButtonsUserIndicator
              );
            });
        },
        kRaY: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("XWQ4"),
              o = n("UJrE"),
              i = n("x6i8"),
              a = n("/ce7"),
              c = n("q12C"),
              s = n("mfxB"),
              u = n("yOi5"),
              l = n("Df/I"),
              f = n("keud");
            t.a = function (t) {
              function n() {
                var e,
                  t = y.type;
                return (
                  Object.keys(w).forEach(function (n) {
                    w[n].includes(t) && (e = n);
                  }),
                  e
                );
              }
              function p(e) {
                return n() === e;
              }
              var d,
                h,
                g = t.message,
                m = g.owner,
                b = g.content,
                y = b.file,
                v = b.sending,
                O = Object(f.b)(),
                w = {
                  image: [o.a.png, o.a.jpg, o.a.jpeg, o.a.gif],
                  pdf: [o.a.pdf],
                  word: [o.a.doc, o.a.docx, o.a.odt],
                  text: [o.a.txt, o.a.xml],
                  compressed: [o.a.zip, o.a.rar],
                  excel: [o.a.csv, o.a.xls, o.a.xlsx],
                },
                x = function () {
                  return !!v && e(r.i, null);
                };
              return e(
                r.a,
                { owner: m },
                !p("image") &&
                  e(
                    r.k,
                    null,
                    e(
                      function (t) {
                        var n = t.children;
                        return y.url
                          ? e(
                              r.j,
                              {
                                download: y.name,
                                href: y.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                              n
                            )
                          : n;
                      },
                      null,
                      e(
                        r.b,
                        null,
                        e(r.c, {
                          src:
                            ((d = n()),
                            (h = {
                              pdf: a.a,
                              word: c.a,
                              text: s.a,
                              compressed: u.a,
                              excel: l.a,
                            }),
                            h[d] ? h[d] : h.text),
                        }),
                        e(
                          r.d,
                          null,
                          e(r.e, null, y.name),
                          !!(function () {
                            try {
                              return O.config.PROTECTED.connection.uploadFile
                                .showFileSize;
                            } catch (e) {
                              return !1;
                            }
                          })() &&
                            !!y.size &&
                            e(r.f, null, Object(i.a)(y.size))
                        ),
                        e(x, null)
                      )
                    )
                  ),
                p("image") &&
                  e(r.h, null, e(r.g, { src: y.base64 }), e(x, null))
              );
            };
          }).call(this, n("hosL").h);
        },
        kd9Q: function (e) {
          e.exports = {
            isFunction: function (e) {
              return "function" == typeof e;
            },
            isArray: function (e) {
              return "[object Array]" === Object.prototype.toString.apply(e);
            },
            each: function (e, t) {
              for (var n = 0, r = e.length; n < r && !1 !== t(e[n], n); n++);
            },
          };
        },
        keud: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r);
              }
              return n;
            }
            function o(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      i(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            }
            function i(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function a() {
              try {
                return Object(s.b)(v);
              } catch (e) {
                return Object(m.a)("app");
              }
            }
            n.d(t, "b", function () {
              return a;
            }),
              n.d(t, "a", function () {
                return O;
              });
            var c = n("hosL"),
              s = n("QRet"),
              u = n("JODt"),
              l = n("rOKC"),
              f = n("svqz"),
              p = n("k6Jz"),
              d = n("UFfw"),
              h = n("ITsB"),
              g = n("lpWF"),
              m = n("c37Q"),
              b = n("6naU"),
              y = n("QJ8L"),
              v = Object(c.createContext)({}),
              O = function (t) {
                function n(e) {
                  var t = y.a.sessionStorage,
                    n = c.PUBLIC.persistKeys[e];
                  return (
                    (t =
                      "object" == typeof n && n.storage
                        ? n.storage
                        : c.PROTECTED.history.storage),
                    Object(f.a)(t)
                  );
                }
                function r(e) {
                  var t = e[2];
                  return {
                    value: e[0],
                    set: function (r) {
                      function o(e) {
                        n(t).setItem(t, JSON.stringify(e));
                      }
                      return t
                        ? "function" == typeof r
                          ? e[1](function (e) {
                              var t = r(e);
                              return o(t), t;
                            })
                          : (o(r), e[1](r))
                        : e[1](r);
                    },
                  };
                }
                function i(e, t) {
                  void 0 === t && (t = void 0);
                  var r = n(e).getItem(e);
                  if (!r) return t;
                  try {
                    return "undefined" == r ? void 0 : JSON.parse(r);
                  } catch (e) {
                    return r;
                  }
                }
                var a = t.children,
                  c = t.config,
                  m = t.platformAppStore,
                  O =
                    void 0 === m
                      ? function () {
                          return null;
                        }
                      : m,
                  w = Object(s.k)(
                    Object(g.a)(c, { PUBLIC: window.__actionBot.config.PUBLIC })
                  ),
                  x = w[0],
                  _ = w[1],
                  j = Object(l.a)(c.PROTECTED.projectId),
                  S = Object(p.a)(j.sessionId, i(j.sessionId)),
                  k = Object(s.k)(!1),
                  C = Object(s.k)([]),
                  P = Object(s.k)(null),
                  A = Object(s.k)(void 0),
                  I = Object(p.a)(
                    j.language,
                    i(j.language, c.PUBLIC.language || Object(d.a)())
                  ),
                  T =
                    "auto" === c.PUBLIC.rtl
                      ? Object(s.k)(Object(u.a)(I[0]))
                      : Object(s.k)(i(j.rtl, c.PUBLIC.rtl)),
                  E = Object(s.k)(b.a.bot),
                  B = Object(p.a)(j.agentConnection, i(j.agentConnection)),
                  M = Object(p.a)(
                    j.agentInfo,
                    i(j.agentInfo, c.PUBLIC.displayMessage.default.agent)
                  ),
                  D = Object(p.a)(
                    j.botInfo,
                    i(j.botInfo, c.PUBLIC.displayMessage.default.bot)
                  ),
                  L = Object(s.k)(!1),
                  R = Object(s.k)(!1),
                  N = Object(p.a)(
                    j.usernameVisibleToAgent,
                    i(j.usernameVisibleToAgent)
                  );
                "auto" === c.PUBLIC.rtl
                  ? Object(s.k)(Object(u.a)())
                  : Object(s.k)(i(j.rtl, c.PUBLIC.rtl));
                var z,
                  W = Object(s.k)(!1),
                  F = Object(s.k)({ group: void 0, delayed: [] }),
                  H = Object(s.k)(""),
                  U = { unreadCount: 0, unreadMessages: [] };
                if (c.PROTECTED.history.enabled) {
                  var q = j.unread;
                  z = Object(p.a)(q, i(q, U));
                } else z = Object(s.k)(U);
                var G = Object(s.k)(c.PUBLIC.minimized),
                  V = Object(s.k)(
                    !c.PUBLIC.minimizeAvailableOnlyAfterFirstResponse
                  ),
                  Y = Object(s.k)(c.PROTECTED.sendMessageThreshold),
                  $ = Object(s.k)(c.PUBLIC.analytics),
                  J = Object(s.k)(!1),
                  K = Object(s.k)(!1),
                  Q = Object(s.k)(!1),
                  X = Object(s.k)(!1),
                  Z = Object(s.k)(c.PROTECTED.agent.defaultSkipAgentConnection),
                  ee = Object(s.k)(""),
                  te = Object(s.k)(null),
                  ne = Object(s.k)(!1),
                  re = Object(s.k)(null),
                  oe = Object(p.a)(j.initialPopupSeen, i(j.initialPopupSeen)),
                  ie = Object(p.a)(j.themeExtension, i(j.themeExtension)),
                  ae = Object(s.k)({ context: {} }),
                  ce = Object(s.k)(!1),
                  se = Object(p.a)(
                    j.remoteConfig,
                    i(j.remoteConfig, { data: [] })
                  ),
                  ue = O({
                    useState: s.k,
                    useStateWithKey: p.a,
                    appStoreElement: r,
                    persistValue: i,
                  }),
                  le = Object(s.k)(!1);
                return (
                  Object(s.d)(
                    function () {
                      setTimeout(function () {
                        new (Object(h.b)(
                          "MessageService"
                        ))().removeMessagesOverLimit();
                      }, 0);
                    },
                    [C[0]]
                  ),
                  Object(s.d)(
                    function () {
                      _(function (e) {
                        return Object(g.a)(e, c, {
                          PUBLIC: window.__actionBot.config.PUBLIC,
                        });
                      });
                    },
                    [c]
                  ),
                  e(
                    v.Provider,
                    {
                      value: o(
                        {
                          config: x,
                          sessionId: r(S),
                          thinking: r(k),
                          messages: r(C),
                          modal: r(P),
                          scrollToBottomRef: r(A),
                          rtl: r(T),
                          recipient: o(
                            o({}, r(E)),
                            {},
                            {
                              isAgent: function () {
                                return E[0] === b.a.agent;
                              },
                              isBot: function () {
                                return E[0] === b.a.bot;
                              },
                            }
                          ),
                          agentConnection: r(B),
                          agentInfo: r(M),
                          botInfo: r(D),
                          agentHandover: r(L),
                          agentLeftChat: r(R),
                          usernameVisibleToAgent: r(N),
                          language: r(I),
                          isInputDisabled: r(W),
                          messagesAfterRedirect: r(F),
                          incognito: o(
                            o({}, r(H)),
                            {},
                            {
                              isForInput: function () {
                                return ["input", "both"].includes(H[0]);
                              },
                              isForOutput: function () {
                                return ["output", "both"].includes(H[0]);
                              },
                            }
                          ),
                          unread: r(z),
                          minimized: r(G),
                          minimizeAvailable: r(V),
                          analytics: r($),
                          waitingForAgent: r(J),
                          sendMessageThreshold: r(Y),
                          anonymize: r(K),
                          userSentFirstMessage: r(Q),
                          replyForFirstUserMessage: r(X),
                          skipAgentConnection: r(Z),
                          input: r(ee),
                          mainMenu: r(te),
                          mainMenuActive: r(ne),
                          initialPopup: r(re),
                          initialPopupSeen: r(oe),
                          watson: r(ae),
                          fullScreen: r(ce),
                          remoteConfig: r(se),
                          themeExtension: r(ie),
                          _forceRerender: function () {
                            return le[1](function (e) {
                              return !e;
                            });
                          },
                        },
                        ue
                      ),
                    },
                    a
                  )
                );
              };
          }).call(this, n("hosL").h);
        },
        knbI: function (e, t, n) {
          "use strict";
          n.d(t, "a", function () {
            return i;
          });
          var r = n("keud"),
            o = n("ITsB"),
            i = function () {
              (this.config = void 0),
                (this.getAppStore = void 0),
                (this.getServices = void 0),
                (this.getCaseInsensitiveProp = void 0),
                (this.config = Object(r.b)().config),
                (this.getAppStore = r.b),
                (this.getServices = o.b),
                (this.getCaseInsensitiveProp = function (e) {
                  var t = e.toLowerCase();
                  for (var n in this) {
                    if (t === n.toLowerCase()) return this[n];
                  }
                });
            };
        },
        kqyo: function (e) {
          "use strict";
          e.exports = function (e, t, n) {
            function r(e) {
              var i;
              return (
                (t && e.type !== t) || (i = n(e, o.concat())),
                e.children && !1 !== i
                  ? (function (e, t) {
                      var n,
                        i = e.length,
                        a = -1;
                      o.push(t);
                      for (; ++a < i; )
                        if ((n = e[a]) && !1 === r(n)) return !1;
                      return o.pop(), !0;
                    })(e.children, e)
                  : i
              );
            }
            var o = [];
            "function" == typeof t && ((n = t), (t = null)), r(e);
          };
        },
        l8WD: function (e, t, n) {
          "use strict";
          function r(e, t) {
            for (var n in t) e[n] = t[n];
            return e;
          }
          function o(e, t) {
            for (var n in e) if ("__source" !== n && !(n in t)) return !0;
            for (var r in t) if ("__source" !== r && e[r] !== t[r]) return !0;
            return !1;
          }
          function i(e) {
            this.props = e;
          }
          function a(e, t) {
            function n(e) {
              var n = this.props.ref,
                r = n == e.ref;
              return (
                !r && n && (n.call ? n(null) : (n.current = null)),
                t ? !t(this.props, e) || !r : o(this.props, e)
              );
            }
            function r(t) {
              return (
                (this.shouldComponentUpdate = n), Object(k.createElement)(e, t)
              );
            }
            return (
              (r.displayName = "Memo(" + (e.displayName || e.name) + ")"),
              (r.prototype.isReactComponent = !0),
              (r.__f = !0),
              r
            );
          }
          function c(e) {
            function t(t, n) {
              var o = r({}, t);
              return (
                delete o.ref,
                e(
                  o,
                  (n = t.ref || n) && ("object" != typeof n || "current" in n)
                    ? n
                    : null
                )
              );
            }
            return (
              (t.$$typeof = P),
              (t.render = t),
              (t.prototype.isReactComponent = t.__f = !0),
              (t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")"),
              t
            );
          }
          function s() {
            (this.__u = 0), (this.t = null), (this.__b = null);
          }
          function u(e) {
            var t = e.__.__c;
            return t && t.__e && t.__e(e);
          }
          function l(e) {
            function t(t) {
              if (
                (n ||
                  (n = e()).then(
                    function (e) {
                      r = e.default || e;
                    },
                    function (e) {
                      o = e;
                    }
                  ),
                o)
              )
                throw o;
              if (!r) throw n;
              return Object(k.createElement)(r, t);
            }
            var n, r, o;
            return (t.displayName = "Lazy"), (t.__f = !0), t;
          }
          function f() {
            (this.u = null), (this.o = null);
          }
          function p(e) {
            return (
              (this.getChildContext = function () {
                return e.context;
              }),
              e.children
            );
          }
          function d(e) {
            var t = this,
              n = e.i;
            (t.componentWillUnmount = function () {
              Object(k.render)(null, t.l), (t.l = null), (t.i = null);
            }),
              t.i && t.i !== n && t.componentWillUnmount(),
              e.__v
                ? (t.l ||
                    ((t.i = n),
                    (t.l = {
                      nodeType: 1,
                      parentNode: n,
                      childNodes: [],
                      appendChild: function (e) {
                        this.childNodes.push(e), t.i.appendChild(e);
                      },
                      insertBefore: function (e) {
                        this.childNodes.push(e), t.i.appendChild(e);
                      },
                      removeChild: function (e) {
                        this.childNodes.splice(
                          this.childNodes.indexOf(e) >>> 1,
                          1
                        ),
                          t.i.removeChild(e);
                      },
                    })),
                  Object(k.render)(
                    Object(k.createElement)(p, { context: t.context }, e.__v),
                    t.l
                  ))
                : t.l && t.componentWillUnmount();
          }
          function h(e, t) {
            return Object(k.createElement)(d, { __v: e, i: t });
          }
          function g(e, t, n) {
            return (
              null == t.__k && (t.textContent = ""),
              Object(k.render)(e, t),
              "function" == typeof n && n(),
              e ? e.__c : null
            );
          }
          function m(e, t, n) {
            return (
              Object(k.hydrate)(e, t),
              "function" == typeof n && n(),
              e ? e.__c : null
            );
          }
          function b() {}
          function y() {
            return this.cancelBubble;
          }
          function v() {
            return this.defaultPrevented;
          }
          function O(e) {
            return k.createElement.bind(null, e);
          }
          function w(e) {
            return !!e && e.$$typeof === M;
          }
          function x(e) {
            return w(e) ? k.cloneElement.apply(null, arguments) : e;
          }
          function _(e) {
            return !!e.__k && (Object(k.render)(null, e), !0);
          }
          function j(e) {
            return (e && (e.base || (1 === e.nodeType && e))) || null;
          }
          n.r(t),
            n.d(t, "version", function () {
              return U;
            }),
            n.d(t, "Children", function () {
              return I;
            }),
            n.d(t, "render", function () {
              return g;
            }),
            n.d(t, "hydrate", function () {
              return m;
            }),
            n.d(t, "unmountComponentAtNode", function () {
              return _;
            }),
            n.d(t, "createPortal", function () {
              return h;
            }),
            n.d(t, "createFactory", function () {
              return O;
            }),
            n.d(t, "cloneElement", function () {
              return x;
            }),
            n.d(t, "isValidElement", function () {
              return w;
            }),
            n.d(t, "findDOMNode", function () {
              return j;
            }),
            n.d(t, "PureComponent", function () {
              return i;
            }),
            n.d(t, "memo", function () {
              return a;
            }),
            n.d(t, "forwardRef", function () {
              return c;
            }),
            n.d(t, "flushSync", function () {
              return G;
            }),
            n.d(t, "unstable_batchedUpdates", function () {
              return q;
            }),
            n.d(t, "StrictMode", function () {
              return V;
            }),
            n.d(t, "Suspense", function () {
              return s;
            }),
            n.d(t, "SuspenseList", function () {
              return f;
            }),
            n.d(t, "lazy", function () {
              return l;
            }),
            n.d(
              t,
              "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED",
              function () {
                return H;
              }
            );
          var S = n("QRet");
          n.d(t, "useState", function () {
            return S.k;
          }),
            n.d(t, "useReducer", function () {
              return S.i;
            }),
            n.d(t, "useEffect", function () {
              return S.d;
            }),
            n.d(t, "useLayoutEffect", function () {
              return S.g;
            }),
            n.d(t, "useRef", function () {
              return S.j;
            }),
            n.d(t, "useImperativeHandle", function () {
              return S.f;
            }),
            n.d(t, "useMemo", function () {
              return S.h;
            }),
            n.d(t, "useCallback", function () {
              return S.a;
            }),
            n.d(t, "useContext", function () {
              return S.b;
            }),
            n.d(t, "useDebugValue", function () {
              return S.c;
            }),
            n.d(t, "useErrorBoundary", function () {
              return S.e;
            });
          var k = n("hosL");
          n.d(t, "createElement", function () {
            return k.createElement;
          }),
            n.d(t, "createContext", function () {
              return k.createContext;
            }),
            n.d(t, "createRef", function () {
              return k.createRef;
            }),
            n.d(t, "Fragment", function () {
              return k.Fragment;
            }),
            n.d(t, "Component", function () {
              return k.Component;
            }),
            ((i.prototype = new k.Component()).isPureReactComponent = !0),
            (i.prototype.shouldComponentUpdate = function (e, t) {
              return o(this.props, e) || o(this.state, t);
            });
          var C = k.options.__b;
          k.options.__b = function (e) {
            e.type &&
              e.type.__f &&
              e.ref &&
              ((e.props.ref = e.ref), (e.ref = null)),
              C && C(e);
          };
          var P =
              ("undefined" != typeof Symbol &&
                Symbol.for &&
                Symbol.for("react.forward_ref")) ||
              3911,
            A = function (e, t) {
              return null == e
                ? null
                : Object(k.toChildArray)(Object(k.toChildArray)(e).map(t));
            },
            I = {
              map: A,
              forEach: A,
              count: function (e) {
                return e ? Object(k.toChildArray)(e).length : 0;
              },
              only: function (e) {
                var t = Object(k.toChildArray)(e);
                if (1 !== t.length) throw "Children.only";
                return t[0];
              },
              toArray: k.toChildArray,
            },
            T = k.options.__e;
          k.options.__e = function (e, t, n) {
            if (e.then)
              for (var r, o = t; (o = o.__); )
                if ((r = o.__c) && r.__c)
                  return (
                    null == t.__e && ((t.__e = n.__e), (t.__k = n.__k)),
                    r.__c(e, t)
                  );
            T(e, t, n);
          };
          var E = k.options.unmount;
          (k.options.unmount = function (e) {
            var t = e.__c;
            t && t.__R && t.__R(),
              t && !0 === e.__h && (e.type = null),
              E && E(e);
          }),
            ((s.prototype = new k.Component()).__c = function (e, t) {
              var n = t.__c,
                r = this;
              null == r.t && (r.t = []), r.t.push(n);
              var o = u(r.__v),
                i = !1,
                a = function () {
                  i || ((i = !0), (n.__R = null), o ? o(c) : c());
                };
              n.__R = a;
              var c = function () {
                  if (!--r.__u) {
                    if (r.state.__e) {
                      var e = r.state.__e;
                      r.__v.__k[0] = (function e(t, n, r) {
                        return (
                          t &&
                            ((t.__v = null),
                            (t.__k =
                              t.__k &&
                              t.__k.map(function (t) {
                                return e(t, n, r);
                              })),
                            t.__c &&
                              t.__c.__P === n &&
                              (t.__e && r.insertBefore(t.__e, t.__d),
                              (t.__c.__e = !0),
                              (t.__c.__P = r))),
                          t
                        );
                      })(e, e.__c.__P, e.__c.__O);
                    }
                    var t;
                    for (r.setState({ __e: (r.__b = null) }); (t = r.t.pop()); )
                      t.forceUpdate();
                  }
                },
                s = !0 === t.__h;
              r.__u++ || s || r.setState({ __e: (r.__b = r.__v.__k[0]) }),
                e.then(a, a);
            }),
            (s.prototype.componentWillUnmount = function () {
              this.t = [];
            }),
            (s.prototype.render = function (e, t) {
              if (this.__b) {
                if (this.__v.__k) {
                  var n = document.createElement("div"),
                    o = this.__v.__k[0].__c;
                  this.__v.__k[0] = (function e(t, n, o) {
                    return (
                      t &&
                        (t.__c &&
                          t.__c.__H &&
                          (t.__c.__H.__.forEach(function (e) {
                            "function" == typeof e.__c && e.__c();
                          }),
                          (t.__c.__H = null)),
                        null != (t = r({}, t)).__c &&
                          (t.__c.__P === o && (t.__c.__P = n), (t.__c = null)),
                        (t.__k =
                          t.__k &&
                          t.__k.map(function (t) {
                            return e(t, n, o);
                          }))),
                      t
                    );
                  })(this.__b, n, (o.__O = o.__P));
                }
                this.__b = null;
              }
              var i =
                t.__e && Object(k.createElement)(k.Fragment, null, e.fallback);
              return (
                i && (i.__h = null),
                [
                  Object(k.createElement)(
                    k.Fragment,
                    null,
                    t.__e ? null : e.children
                  ),
                  i,
                ]
              );
            });
          var B = function (e, t, n) {
            if (
              (++n[1] === n[0] && e.o.delete(t),
              e.props.revealOrder &&
                ("t" !== e.props.revealOrder[0] || !e.o.size))
            )
              for (n = e.u; n; ) {
                for (; n.length > 3; ) n.pop()();
                if (n[1] < n[0]) break;
                e.u = n = n[2];
              }
          };
          ((f.prototype = new k.Component()).__e = function (e) {
            var t = this,
              n = u(t.__v),
              r = t.o.get(e);
            return (
              r[0]++,
              function (o) {
                var i = function () {
                  t.props.revealOrder ? (r.push(o), B(t, e, r)) : o();
                };
                n ? n(i) : i();
              }
            );
          }),
            (f.prototype.render = function (e) {
              (this.u = null), (this.o = new Map());
              var t = Object(k.toChildArray)(e.children);
              e.revealOrder && "b" === e.revealOrder[0] && t.reverse();
              for (var n = t.length; n--; )
                this.o.set(t[n], (this.u = [1, 0, this.u]));
              return e.children;
            }),
            (f.prototype.componentDidUpdate = f.prototype.componentDidMount =
              function () {
                var e = this;
                this.o.forEach(function (t, n) {
                  B(e, n, t);
                });
              });
          var M =
              ("undefined" != typeof Symbol &&
                Symbol.for &&
                Symbol.for("react.element")) ||
              60103,
            D =
              /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
            L = function (e) {
              return (
                "undefined" != typeof Symbol && "symbol" == typeof Symbol()
                  ? /fil|che|rad/i
                  : /fil|che|ra/i
              ).test(e);
            };
          (k.Component.prototype.isReactComponent = {}),
            [
              "componentWillMount",
              "componentWillReceiveProps",
              "componentWillUpdate",
            ].forEach(function (e) {
              Object.defineProperty(k.Component.prototype, e, {
                configurable: !0,
                get: function () {
                  return this["UNSAFE_" + e];
                },
                set: function (t) {
                  Object.defineProperty(this, e, {
                    configurable: !0,
                    writable: !0,
                    value: t,
                  });
                },
              });
            });
          var R = k.options.event;
          k.options.event = function (e) {
            return (
              R && (e = R(e)),
              (e.persist = b),
              (e.isPropagationStopped = y),
              (e.isDefaultPrevented = v),
              (e.nativeEvent = e)
            );
          };
          var N,
            z = {
              configurable: !0,
              get: function () {
                return this.class;
              },
            },
            W = k.options.vnode;
          k.options.vnode = function (e) {
            var t = e.type,
              n = e.props,
              r = n;
            if ("string" == typeof t) {
              for (var o in ((r = {}), n)) {
                var i = n[o];
                ("value" === o && "defaultValue" in n && null == i) ||
                  ("defaultValue" === o && "value" in n && null == n.value
                    ? (o = "value")
                    : "download" === o && !0 === i
                    ? (i = "")
                    : /ondoubleclick/i.test(o)
                    ? (o = "ondblclick")
                    : /^onchange(textarea|input)/i.test(o + t) && !L(n.type)
                    ? (o = "oninput")
                    : /^on(Ani|Tra|Tou|BeforeInp)/.test(o)
                    ? (o = o.toLowerCase())
                    : D.test(o)
                    ? (o = o.replace(/[A-Z0-9]/, "-$&").toLowerCase())
                    : null === i && (i = void 0),
                  (r[o] = i));
              }
              "select" == t &&
                r.multiple &&
                Array.isArray(r.value) &&
                (r.value = Object(k.toChildArray)(n.children).forEach(function (
                  e
                ) {
                  e.props.selected = -1 != r.value.indexOf(e.props.value);
                })),
                "select" == t &&
                  null != r.defaultValue &&
                  (r.value = Object(k.toChildArray)(n.children).forEach(
                    function (e) {
                      e.props.selected = r.multiple
                        ? -1 != r.defaultValue.indexOf(e.props.value)
                        : r.defaultValue == e.props.value;
                    }
                  )),
                (e.props = r);
            }
            t &&
              n.class != n.className &&
              ((z.enumerable = "className" in n),
              null != n.className && (r.class = n.className),
              Object.defineProperty(r, "className", z)),
              (e.$$typeof = M),
              W && W(e);
          };
          var F = k.options.__r;
          k.options.__r = function (e) {
            F && F(e), (N = e.__c);
          };
          var H = {
              ReactCurrentDispatcher: {
                current: {
                  readContext: function (e) {
                    return N.__n[e.__c].props.value;
                  },
                },
              },
            },
            U = "17.0.2",
            q = function (e, t) {
              return e(t);
            },
            G = function (e, t) {
              return e(t);
            },
            V = k.Fragment;
          t.default = {
            useState: S.k,
            useReducer: S.i,
            useEffect: S.d,
            useLayoutEffect: S.g,
            useRef: S.j,
            useImperativeHandle: S.f,
            useMemo: S.h,
            useCallback: S.a,
            useContext: S.b,
            useDebugValue: S.c,
            version: "17.0.2",
            Children: I,
            render: g,
            hydrate: m,
            unmountComponentAtNode: _,
            createPortal: h,
            createElement: k.createElement,
            createContext: k.createContext,
            createFactory: O,
            cloneElement: x,
            createRef: k.createRef,
            Fragment: k.Fragment,
            isValidElement: w,
            findDOMNode: j,
            Component: k.Component,
            PureComponent: i,
            memo: a,
            forwardRef: c,
            flushSync: G,
            unstable_batchedUpdates: q,
            StrictMode: k.Fragment,
            Suspense: s,
            SuspenseList: f,
            lazy: l,
            __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: H,
          };
        },
        lKdC: function (e, t, n) {
          "use strict";
          (function (e, r) {
            function o() {
              var t = new (Object(a.b)("ModalService"))(),
                n = Object(i.b)().modal.value,
                o = t.getModalComponentByName(n);
              return e(r, null, !!o && e(o, null));
            }
            n.d(t, "a", function () {
              return o;
            });
            var i = n("keud"),
              a = n("ITsB");
          }).call(this, n("hosL").h, n("hosL").Fragment);
        },
        lUS9: function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o() {
            return (o =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function i(e, t) {
            if (null == e) return {};
            var n,
              r,
              o = (function (e, t) {
                if (null == e) return {};
                var n,
                  r,
                  o = {},
                  i = Object.keys(e);
                for (r = 0; r < i.length; r++)
                  t.indexOf((n = i[r])) >= 0 || (o[n] = e[n]);
                return o;
              })(e, t);
            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);
              for (r = 0; r < i.length; r++)
                t.indexOf((n = i[r])) >= 0 ||
                  (Object.prototype.propertyIsEnumerable.call(e, n) &&
                    (o[n] = e[n]));
            }
            return o;
          }
          function a(e) {
            return (a =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function c(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function s(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? c(n, !0).forEach(function (t) {
                    d(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : c(n).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function u(e, t) {
            return !t || ("object" !== a(t) && "function" != typeof t)
              ? f(e)
              : t;
          }
          function l(e) {
            return (l = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          function f(e) {
            if (void 0 === e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return e;
          }
          function p(e, t) {
            return (p =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function d(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.InnerSlider = void 0);
          var h = r(n("l8WD")),
            g = r(n("l8WD")),
            m = r(n("NgIc")),
            b = r(n("jffb")),
            y = r(n("8Jek")),
            v = n("iWpb"),
            O = n("wMKW"),
            w = n("6oRp"),
            x = n("BoRb"),
            _ = r(n("iXzu"));
          t.InnerSlider = (function (e) {
            function t(e) {
              var n;
              return (
                d(
                  f((n = u(this, l(t).call(this, e)))),
                  "listRefHandler",
                  function (e) {
                    return (n.list = e);
                  }
                ),
                d(f(n), "trackRefHandler", function (e) {
                  return (n.track = e);
                }),
                d(f(n), "adaptHeight", function () {
                  if (n.props.adaptiveHeight && n.list) {
                    var e = n.list.querySelector(
                      '[data-index="'.concat(n.state.currentSlide, '"]')
                    );
                    n.list.style.height = (0, v.getHeight)(e) + "px";
                  }
                }),
                d(f(n), "UNSAFE_componentWillMount", function () {
                  if (
                    (n.ssrInit(),
                    n.props.onInit && n.props.onInit(),
                    n.props.lazyLoad)
                  ) {
                    var e = (0, v.getOnDemandLazySlides)(
                      s({}, n.props, {}, n.state)
                    );
                    e.length > 0 &&
                      (n.setState(function (t) {
                        return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                      }),
                      n.props.onLazyLoad && n.props.onLazyLoad(e));
                  }
                }),
                d(f(n), "componentDidMount", function () {
                  var e = s({ listRef: n.list, trackRef: n.track }, n.props);
                  n.updateState(e, !0, function () {
                    n.adaptHeight(), n.props.autoplay && n.autoPlay("update");
                  }),
                    "progressive" === n.props.lazyLoad &&
                      (n.lazyLoadTimer = setInterval(
                        n.progressiveLazyLoad,
                        1e3
                      )),
                    (n.ro = new _.default(function () {
                      n.state.animating
                        ? (n.onWindowResized(!1),
                          n.callbackTimers.push(
                            setTimeout(function () {
                              return n.onWindowResized();
                            }, n.props.speed)
                          ))
                        : n.onWindowResized();
                    })),
                    n.ro.observe(n.list),
                    Array.prototype.forEach.call(
                      document.querySelectorAll(".slick-slide"),
                      function (e) {
                        (e.onfocus = n.props.pauseOnFocus
                          ? n.onSlideFocus
                          : null),
                          (e.onblur = n.props.pauseOnFocus
                            ? n.onSlideBlur
                            : null);
                      }
                    ),
                    window.addEventListener
                      ? window.addEventListener("resize", n.onWindowResized)
                      : window.attachEvent("onresize", n.onWindowResized);
                }),
                d(f(n), "componentWillUnmount", function () {
                  n.animationEndCallback &&
                    clearTimeout(n.animationEndCallback),
                    n.lazyLoadTimer && clearInterval(n.lazyLoadTimer),
                    n.callbackTimers.length &&
                      (n.callbackTimers.forEach(function (e) {
                        return clearTimeout(e);
                      }),
                      (n.callbackTimers = [])),
                    window.addEventListener
                      ? window.removeEventListener("resize", n.onWindowResized)
                      : window.detachEvent("onresize", n.onWindowResized),
                    n.autoplayTimer && clearInterval(n.autoplayTimer),
                    n.ro.disconnect();
                }),
                d(f(n), "UNSAFE_componentWillReceiveProps", function (e) {
                  for (
                    var t = s(
                        { listRef: n.list, trackRef: n.track },
                        e,
                        {},
                        n.state
                      ),
                      r = !1,
                      o = 0,
                      i = Object.keys(n.props);
                    o < i.length;
                    o++
                  ) {
                    var c = i[o];
                    if (!e.hasOwnProperty(c)) {
                      r = !0;
                      break;
                    }
                    if (
                      "object" !== a(e[c]) &&
                      "function" != typeof e[c] &&
                      e[c] !== n.props[c]
                    ) {
                      r = !0;
                      break;
                    }
                  }
                  n.updateState(t, r, function () {
                    n.state.currentSlide >=
                      h.default.Children.count(e.children) &&
                      n.changeSlide({
                        message: "index",
                        index:
                          h.default.Children.count(e.children) - e.slidesToShow,
                        currentSlide: n.state.currentSlide,
                      }),
                      e.autoplay ? n.autoPlay("update") : n.pause("paused");
                  });
                }),
                d(f(n), "componentDidUpdate", function () {
                  if (
                    (n.checkImagesLoad(),
                    n.props.onReInit && n.props.onReInit(),
                    n.props.lazyLoad)
                  ) {
                    var e = (0, v.getOnDemandLazySlides)(
                      s({}, n.props, {}, n.state)
                    );
                    e.length > 0 &&
                      (n.setState(function (t) {
                        return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                      }),
                      n.props.onLazyLoad && n.props.onLazyLoad(e));
                  }
                  n.adaptHeight();
                }),
                d(f(n), "onWindowResized", function (e) {
                  n.debouncedResize && n.debouncedResize.cancel(),
                    (n.debouncedResize = (0, b.default)(function () {
                      return n.resizeWindow(e);
                    }, 50)),
                    n.debouncedResize();
                }),
                d(f(n), "resizeWindow", function () {
                  var e =
                    !(arguments.length > 0 && void 0 !== arguments[0]) ||
                    arguments[0];
                  if (g.default.findDOMNode(n.track)) {
                    var t = s(
                      { listRef: n.list, trackRef: n.track },
                      n.props,
                      {},
                      n.state
                    );
                    n.updateState(t, e, function () {
                      n.props.autoplay
                        ? n.autoPlay("update")
                        : n.pause("paused");
                    }),
                      n.setState({ animating: !1 }),
                      clearTimeout(n.animationEndCallback),
                      delete n.animationEndCallback;
                  }
                }),
                d(f(n), "updateState", function (e, t, r) {
                  var o = (0, v.initializedState)(e);
                  (e = s({}, e, {}, o, { slideIndex: o.currentSlide })),
                    (e = s({}, e, { left: (0, v.getTrackLeft)(e) }));
                  var i = (0, v.getTrackCSS)(e);
                  (t ||
                    h.default.Children.count(n.props.children) !==
                      h.default.Children.count(e.children)) &&
                    (o.trackStyle = i),
                    n.setState(o, r);
                }),
                d(f(n), "ssrInit", function () {
                  if (n.props.variableWidth) {
                    var e = 0,
                      t = 0,
                      r = [],
                      o = (0, v.getPreClones)(
                        s({}, n.props, {}, n.state, {
                          slideCount: n.props.children.length,
                        })
                      ),
                      i = (0, v.getPostClones)(
                        s({}, n.props, {}, n.state, {
                          slideCount: n.props.children.length,
                        })
                      );
                    n.props.children.forEach(function (t) {
                      r.push(t.props.style.width), (e += t.props.style.width);
                    });
                    for (var a = 0; a < o; a++)
                      (t += r[r.length - 1 - a]), (e += r[r.length - 1 - a]);
                    for (var c = 0; c < i; c++) e += r[c];
                    for (var u = 0; u < n.state.currentSlide; u++) t += r[u];
                    var l = { width: e + "px", left: -t + "px" };
                    if (n.props.centerMode) {
                      var f = "".concat(r[n.state.currentSlide], "px");
                      l.left = "calc("
                        .concat(l.left, " + (100% - ")
                        .concat(f, ") / 2 ) ");
                    }
                    n.setState({ trackStyle: l });
                  } else {
                    var p = h.default.Children.count(n.props.children),
                      d = s({}, n.props, {}, n.state, { slideCount: p }),
                      g = (0, v.getPreClones)(d) + (0, v.getPostClones)(d) + p,
                      m = (100 / n.props.slidesToShow) * g,
                      b = 100 / g,
                      y =
                        (-b *
                          ((0, v.getPreClones)(d) + n.state.currentSlide) *
                          m) /
                        100;
                    n.props.centerMode && (y += (100 - (b * m) / 100) / 2),
                      n.setState({
                        slideWidth: b + "%",
                        trackStyle: { width: m + "%", left: y + "%" },
                      });
                  }
                }),
                d(f(n), "checkImagesLoad", function () {
                  var e = n.list.querySelectorAll(".slick-slide img"),
                    t = e.length,
                    r = 0;
                  Array.prototype.forEach.call(e, function (e) {
                    var o = function () {
                      return ++r && r >= t && n.onWindowResized();
                    };
                    if (e.onclick) {
                      var i = e.onclick;
                      e.onclick = function () {
                        i(), e.parentNode.focus();
                      };
                    } else
                      e.onclick = function () {
                        return e.parentNode.focus();
                      };
                    e.onload ||
                      (n.props.lazyLoad
                        ? (e.onload = function () {
                            n.adaptHeight(),
                              n.callbackTimers.push(
                                setTimeout(n.onWindowResized, n.props.speed)
                              );
                          })
                        : ((e.onload = o),
                          (e.onerror = function () {
                            o(),
                              n.props.onLazyLoadError &&
                                n.props.onLazyLoadError();
                          })));
                  });
                }),
                d(f(n), "progressiveLazyLoad", function () {
                  for (
                    var e = [],
                      t = s({}, n.props, {}, n.state),
                      r = n.state.currentSlide;
                    r < n.state.slideCount + (0, v.getPostClones)(t);
                    r++
                  )
                    if (n.state.lazyLoadedList.indexOf(r) < 0) {
                      e.push(r);
                      break;
                    }
                  for (
                    var o = n.state.currentSlide - 1;
                    o >= -(0, v.getPreClones)(t);
                    o--
                  )
                    if (n.state.lazyLoadedList.indexOf(o) < 0) {
                      e.push(o);
                      break;
                    }
                  e.length > 0
                    ? (n.setState(function (t) {
                        return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                      }),
                      n.props.onLazyLoad && n.props.onLazyLoad(e))
                    : n.lazyLoadTimer &&
                      (clearInterval(n.lazyLoadTimer), delete n.lazyLoadTimer);
                }),
                d(f(n), "slideHandler", function (e) {
                  var t =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1],
                    r = n.props,
                    o = r.asNavFor,
                    a = r.beforeChange,
                    c = r.onLazyLoad,
                    u = r.speed,
                    l = r.afterChange,
                    f = n.state.currentSlide,
                    p = (0, v.slideHandler)(
                      s({ index: e }, n.props, {}, n.state, {
                        trackRef: n.track,
                        useCSS: n.props.useCSS && !t,
                      })
                    ),
                    d = p.state,
                    h = p.nextState;
                  if (d) {
                    a && a(f, d.currentSlide);
                    var g = d.lazyLoadedList.filter(function (e) {
                      return n.state.lazyLoadedList.indexOf(e) < 0;
                    });
                    c && g.length > 0 && c(g),
                      n.setState(d, function () {
                        o && o.innerSlider.slideHandler(e),
                          h &&
                            (n.animationEndCallback = setTimeout(function () {
                              var e = h.animating,
                                t = i(h, ["animating"]);
                              n.setState(t, function () {
                                n.callbackTimers.push(
                                  setTimeout(function () {
                                    return n.setState({ animating: e });
                                  }, 10)
                                ),
                                  l && l(d.currentSlide),
                                  delete n.animationEndCallback;
                              });
                            }, u));
                      });
                  }
                }),
                d(f(n), "changeSlide", function (e) {
                  var t =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1],
                    r = s({}, n.props, {}, n.state),
                    o = (0, v.changeSlide)(r, e);
                  (0 === o || o) &&
                    (!0 === t ? n.slideHandler(o, t) : n.slideHandler(o));
                }),
                d(f(n), "clickHandler", function (e) {
                  !1 === n.clickable &&
                    (e.stopPropagation(), e.preventDefault()),
                    (n.clickable = !0);
                }),
                d(f(n), "keyHandler", function (e) {
                  var t = (0, v.keyHandler)(
                    e,
                    n.props.accessibility,
                    n.props.rtl
                  );
                  "" !== t && n.changeSlide({ message: t });
                }),
                d(f(n), "selectHandler", function (e) {
                  n.changeSlide(e);
                }),
                d(f(n), "disableBodyScroll", function () {
                  window.ontouchmove = function (e) {
                    (e = e || window.event).preventDefault &&
                      e.preventDefault(),
                      (e.returnValue = !1);
                  };
                }),
                d(f(n), "enableBodyScroll", function () {
                  window.ontouchmove = null;
                }),
                d(f(n), "swipeStart", function (e) {
                  n.props.verticalSwiping && n.disableBodyScroll();
                  var t = (0, v.swipeStart)(
                    e,
                    n.props.swipe,
                    n.props.draggable
                  );
                  "" !== t && n.setState(t);
                }),
                d(f(n), "swipeMove", function (e) {
                  var t = (0, v.swipeMove)(
                    e,
                    s({}, n.props, {}, n.state, {
                      trackRef: n.track,
                      listRef: n.list,
                      slideIndex: n.state.currentSlide,
                    })
                  );
                  t && (t.swiping && (n.clickable = !1), n.setState(t));
                }),
                d(f(n), "swipeEnd", function (e) {
                  var t = (0, v.swipeEnd)(
                    e,
                    s({}, n.props, {}, n.state, {
                      trackRef: n.track,
                      listRef: n.list,
                      slideIndex: n.state.currentSlide,
                    })
                  );
                  if (t) {
                    var r = t.triggerSlideHandler;
                    delete t.triggerSlideHandler,
                      n.setState(t),
                      void 0 !== r &&
                        (n.slideHandler(r),
                        n.props.verticalSwiping && n.enableBodyScroll());
                  }
                }),
                d(f(n), "slickPrev", function () {
                  n.callbackTimers.push(
                    setTimeout(function () {
                      return n.changeSlide({ message: "previous" });
                    }, 0)
                  );
                }),
                d(f(n), "slickNext", function () {
                  n.callbackTimers.push(
                    setTimeout(function () {
                      return n.changeSlide({ message: "next" });
                    }, 0)
                  );
                }),
                d(f(n), "slickGoTo", function (e) {
                  var t =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1];
                  if (((e = Number(e)), isNaN(e))) return "";
                  n.callbackTimers.push(
                    setTimeout(function () {
                      return n.changeSlide(
                        {
                          message: "index",
                          index: e,
                          currentSlide: n.state.currentSlide,
                        },
                        t
                      );
                    }, 0)
                  );
                }),
                d(f(n), "play", function () {
                  var e;
                  if (n.props.rtl)
                    e = n.state.currentSlide - n.props.slidesToScroll;
                  else {
                    if (!(0, v.canGoNext)(s({}, n.props, {}, n.state)))
                      return !1;
                    e = n.state.currentSlide + n.props.slidesToScroll;
                  }
                  n.slideHandler(e);
                }),
                d(f(n), "autoPlay", function (e) {
                  n.autoplayTimer && clearInterval(n.autoplayTimer);
                  var t = n.state.autoplaying;
                  if ("update" === e) {
                    if ("hovered" === t || "focused" === t || "paused" === t)
                      return;
                  } else if ("leave" === e) {
                    if ("paused" === t || "focused" === t) return;
                  } else if (
                    "blur" === e &&
                    ("paused" === t || "hovered" === t)
                  )
                    return;
                  (n.autoplayTimer = setInterval(
                    n.play,
                    n.props.autoplaySpeed + 50
                  )),
                    n.setState({ autoplaying: "playing" });
                }),
                d(f(n), "pause", function (e) {
                  n.autoplayTimer &&
                    (clearInterval(n.autoplayTimer), (n.autoplayTimer = null));
                  var t = n.state.autoplaying;
                  "paused" === e
                    ? n.setState({ autoplaying: "paused" })
                    : "focused" === e
                    ? ("hovered" !== t && "playing" !== t) ||
                      n.setState({ autoplaying: "focused" })
                    : "playing" === t && n.setState({ autoplaying: "hovered" });
                }),
                d(f(n), "onDotsOver", function () {
                  return n.props.autoplay && n.pause("hovered");
                }),
                d(f(n), "onDotsLeave", function () {
                  return (
                    n.props.autoplay &&
                    "hovered" === n.state.autoplaying &&
                    n.autoPlay("leave")
                  );
                }),
                d(f(n), "onTrackOver", function () {
                  return n.props.autoplay && n.pause("hovered");
                }),
                d(f(n), "onTrackLeave", function () {
                  return (
                    n.props.autoplay &&
                    "hovered" === n.state.autoplaying &&
                    n.autoPlay("leave")
                  );
                }),
                d(f(n), "onSlideFocus", function () {
                  return n.props.autoplay && n.pause("focused");
                }),
                d(f(n), "onSlideBlur", function () {
                  return (
                    n.props.autoplay &&
                    "focused" === n.state.autoplaying &&
                    n.autoPlay("blur")
                  );
                }),
                d(f(n), "render", function () {
                  var e,
                    t,
                    r,
                    i = (0, y.default)("slick-slider", n.props.className, {
                      "slick-vertical": n.props.vertical,
                      "slick-initialized": !0,
                    }),
                    a = s({}, n.props, {}, n.state),
                    c = (0, v.extractObject)(a, [
                      "fade",
                      "cssEase",
                      "speed",
                      "infinite",
                      "centerMode",
                      "focusOnSelect",
                      "currentSlide",
                      "lazyLoad",
                      "lazyLoadedList",
                      "rtl",
                      "slideWidth",
                      "slideHeight",
                      "listHeight",
                      "vertical",
                      "slidesToShow",
                      "slidesToScroll",
                      "slideCount",
                      "trackStyle",
                      "variableWidth",
                      "unslick",
                      "centerPadding",
                    ]),
                    u = n.props.pauseOnHover;
                  if (
                    ((c = s({}, c, {
                      onMouseEnter: u ? n.onTrackOver : null,
                      onMouseLeave: u ? n.onTrackLeave : null,
                      onMouseOver: u ? n.onTrackOver : null,
                      focusOnSelect: n.props.focusOnSelect
                        ? n.selectHandler
                        : null,
                    })),
                    !0 === n.props.dots &&
                      n.state.slideCount >= n.props.slidesToShow)
                  ) {
                    var l = (0, v.extractObject)(a, [
                        "dotsClass",
                        "slideCount",
                        "slidesToShow",
                        "currentSlide",
                        "slidesToScroll",
                        "clickHandler",
                        "children",
                        "customPaging",
                        "infinite",
                        "appendDots",
                      ]),
                      f = n.props.pauseOnDotsHover;
                    (l = s({}, l, {
                      clickHandler: n.changeSlide,
                      onMouseEnter: f ? n.onDotsLeave : null,
                      onMouseOver: f ? n.onDotsOver : null,
                      onMouseLeave: f ? n.onDotsLeave : null,
                    })),
                      (e = h.default.createElement(w.Dots, l));
                  }
                  var p = (0, v.extractObject)(a, [
                    "infinite",
                    "centerMode",
                    "currentSlide",
                    "slideCount",
                    "slidesToShow",
                    "prevArrow",
                    "nextArrow",
                  ]);
                  (p.clickHandler = n.changeSlide),
                    n.props.arrows &&
                      ((t = h.default.createElement(x.PrevArrow, p)),
                      (r = h.default.createElement(x.NextArrow, p)));
                  var d = null;
                  n.props.vertical && (d = { height: n.state.listHeight });
                  var g = null;
                  !1 === n.props.vertical
                    ? !0 === n.props.centerMode &&
                      (g = { padding: "0px " + n.props.centerPadding })
                    : !0 === n.props.centerMode &&
                      (g = { padding: n.props.centerPadding + " 0px" });
                  var m = s({}, d, {}, g),
                    b = n.props.touchMove,
                    _ = {
                      className: "slick-list",
                      style: m,
                      onClick: n.clickHandler,
                      onMouseDown: b ? n.swipeStart : null,
                      onMouseMove: n.state.dragging && b ? n.swipeMove : null,
                      onMouseUp: b ? n.swipeEnd : null,
                      onMouseLeave: n.state.dragging && b ? n.swipeEnd : null,
                      onTouchStart: b ? n.swipeStart : null,
                      onTouchMove: n.state.dragging && b ? n.swipeMove : null,
                      onTouchEnd: b ? n.swipeEnd : null,
                      onTouchCancel: n.state.dragging && b ? n.swipeEnd : null,
                      onKeyDown: n.props.accessibility ? n.keyHandler : null,
                    },
                    j = { className: i, dir: "ltr", style: n.props.style };
                  return (
                    n.props.unslick &&
                      ((_ = { className: "slick-list" }),
                      (j = { className: i })),
                    h.default.createElement(
                      "div",
                      j,
                      n.props.unslick ? "" : t,
                      h.default.createElement(
                        "div",
                        o({ ref: n.listRefHandler }, _),
                        h.default.createElement(
                          O.Track,
                          o({ ref: n.trackRefHandler }, c),
                          n.props.children
                        )
                      ),
                      n.props.unslick ? "" : r,
                      n.props.unslick ? "" : e
                    )
                  );
                }),
                (n.list = null),
                (n.track = null),
                (n.state = s({}, m.default, {
                  currentSlide: n.props.initialSlide,
                  slideCount: h.default.Children.count(n.props.children),
                })),
                (n.callbackTimers = []),
                (n.clickable = !0),
                (n.debouncedResize = null),
                n
              );
            }
            return (
              (function (e, t) {
                if ("function" != typeof t && null !== t)
                  throw new TypeError(
                    "Super expression must either be null or a function"
                  );
                (e.prototype = Object.create(t && t.prototype, {
                  constructor: { value: e, writable: !0, configurable: !0 },
                })),
                  t && p(e, t);
              })(t, e),
              t
            );
          })(h.default.Component);
        },
        lpWF: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
              t[n] = arguments[n];
            var r = function (e) {
              return e && null != e && "object" == typeof e;
            };
            t = t.filter(r);
            try {
              return t.reduce(function (e, t) {
                return (
                  Object.keys(t).forEach(function (n) {
                    var o = e[n],
                      i = t[n];
                    if (Array.isArray(o) && Array.isArray(i)) {
                      var c = Array.from(new Set([].concat(o, i)));
                      e[n] = c;
                    } else e[n] = r(o) && r(i) ? a(o, i) : i;
                  }),
                  e
                );
              }, {});
            } catch (e) {
              return (
                console.error(e, { objects: t }),
                t.reduce(function (e, t) {
                  return o(o({}, e), t);
                })
              );
            }
          }
          n.d(t, "a", function () {
            return a;
          });
        },
        lsAJ: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("bNNV"),
              o = n("dXCb"),
              i = n("bbLs"),
              a = n("uGjU"),
              c = n("nbD9"),
              s = n("/Px3");
            t.a = function (t) {
              var n,
                u,
                l = t.message,
                f = t.onOptionSelect,
                p = [];
              try {
                l.content.options.forEach(function (e) {
                  "type" === e.label && (n = e.value),
                    "config" === e.label && (u = JSON.parse(e.value)),
                    "slide" === e.label && (p = p.concat(JSON.parse(e.value)));
                });
              } catch (e) {
                return Object(c.a)().error(e), null;
              }
              return (function () {
                switch (n) {
                  case "shop":
                    return e(o.a, {
                      slides: p,
                      sliderConfig: u,
                      onOptionSelect: f,
                    });
                  case "modern":
                    return e(i.a, {
                      slides: p,
                      sliderConfig: u,
                      onOptionSelect: f,
                    });
                  case "postcard":
                    return e(a.a, {
                      slides: p,
                      sliderConfig: u,
                      onOptionSelect: f,
                    });
                  case "withButtons":
                    return e(s.a, {
                      slides: p,
                      sliderConfig: u,
                      onOptionSelect: f,
                    });
                  default:
                    return e(r.a, {
                      slides: p,
                      sliderConfig: u,
                      onOptionSelect: f,
                    });
                }
              })();
            };
          }).call(this, n("hosL").h);
        },
        mCI7: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "c", function () {
            return c;
          }),
            n.d(t, "a", function () {
              return s;
            }),
            n.d(t, "b", function () {
              return u;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "IconGridstyled__IconGridContainer",
              componentId: "ud8tp6-0",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  width: "100%",
                  borderRadius: "16px",
                  backgroundColor: "#fff",
                  boxShadow: "0 0 18px #cccccc",
                  padding: "20px 12px",
                  margin: "5px 0",
                  fontSize: "17px",
                  fontFamily: "Barlow",
                  fontWeight: "bold",
                  color: "#0a1246",
                },
                e.theme.elements.messages.IconGrid.IconGridContainer
              );
            }),
            s =
              (a.b.p.withConfig({
                displayName: "IconGridstyled__GridLabel",
                componentId: "ud8tp6-1",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    fontSize: "17px",
                    fontFamily: "Barlow",
                    fontWeight: "bold",
                    color: "#0a1246",
                  },
                  e.theme.elements.messages.IconGrid.GridLabel
                );
              }),
              a.b.div.withConfig({
                displayName: "IconGridstyled__GridContainer",
                componentId: "ud8tp6-2",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    width: "100%",
                    display: "grid",
                    margin: "30px 0 10px 0",
                    padding: "0 10px",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    columnGap: "10px",
                    rowGap: "30px",
                  },
                  e.theme.elements.messages.IconGrid.GridContainer
                );
              })),
            u = a.b.div.withConfig({
              displayName: "IconGridstyled__GridItem",
              componentId: "ud8tp6-3",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  fontSize: "13px",
                  fontFamily: "Barlow",
                  fontWeight: "normal",
                  textAlign: "center",
                  color: "#0a1246",
                  img: { width: "62.5%", height: "auto" },
                  p: { marginTop: "5px" },
                },
                e.theme.elements.messages.IconGrid.GridItem
              );
            });
        },
        mNya: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "c", function () {
            return c;
          }),
            n.d(t, "b", function () {
              return s;
            }),
            n.d(t, "a", function () {
              return u;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "MessageMenustyled__MenuContainer",
              componentId: "sc-1n6tnh1-0",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  marginBottom: "10px",
                },
                e.theme.elements.messages.MessageMenu.MenuContainer
              );
            }),
            s = a.b.div.withConfig({
              displayName: "MessageMenustyled__MenuBoxContainer",
              componentId: "sc-1n6tnh1-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { flex: "calc(50% - 5px)" },
                e.theme.elements.messages.MessageMenu.MenuBoxContainer
              );
            }),
            u = a.b.div.withConfig({
              displayName: "MessageMenustyled__MenuBox",
              componentId: "sc-1n6tnh1-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  boxShadow: "0 0 20px 0 #cdc8ec",
                  padding: "15px",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  img: { width: "auto", height: "25px", marginRight: "5px" },
                  p: {
                    color: "#0a1246",
                    fontFamily: "Barlow",
                    fontSize: "14px",
                    fontWeight: "600",
                    textAlign: "left",
                  },
                  "&:hover": { opacity: "0.7" },
                },
                e.theme.elements.messages.MessageMenu.MenuBox
              );
            });
        },
        mdyV: function (e, t, n) {
          "use strict";
          n.r(t);
          var r = n("hosL"),
            o = r.h,
            i = r.render,
            a = r.hydrate,
            c = function (e) {
              return e && e.default ? e.default : e;
            },
            s = function (e) {
              return "/" === e[e.length - 1] ? e : e + "/";
            };
          if ("function" == typeof c(n("/hs+"))) {
            var u =
              document.getElementById("preact_root") ||
              document.body.firstElementChild;
            0,
              (function () {
                var e = c(n("/hs+")),
                  t = {},
                  r = document.querySelector('[type="__PREACT_CLI_DATA__"]');
                r &&
                  (t = JSON.parse(decodeURI(r.innerHTML)).preRenderData || t);
                var l = { preRenderData: t },
                  f = t.url ? s(t.url) : "",
                  p = a && f === s(location.pathname);
                u = (p ? a : i)(o(e, { CLI_DATA: l }), document.body, u);
              })();
          }
        },
        mfxB: function (e, t, n) {
          "use strict";
          t.a = n.p + "e88326217d6e3845eb1354846374525b.svg";
        },
        mseD: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("mCI7");
            t.a = function (t) {
              var n = t.message;
              if (n.content && Array.isArray(n.content.options)) {
                var o = [],
                  i = "";
                try {
                  n.content.options.forEach(function (e) {
                    "icons" === e.label && (o = JSON.parse(e.value)),
                      "label" === e.label && (i = e.value);
                  });
                } catch (e) {
                  console.error(e);
                }
                var a = o.map(function (t) {
                  return e(
                    r.b,
                    null,
                    e("img", { src: t.img }),
                    e("p", null, t.label)
                  );
                });
                return e(r.c, null, e("p", null, i), e(r.a, null, a));
              }
            };
          }).call(this, n("hosL").h);
        },
        n0FH: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return i;
          });
          var i = n("UutA").b.div.withConfig({
            displayName: "ActionIconstyled__ActionIcon",
            componentId: "ez5zeg-0",
          })([".ActionBot &{", "}"], function (e) {
            var t,
              n = e.theme;
            return (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      o(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            })(
              (((t = {
                cursor: "pointer",
                transition: "opacity 0.3s",
                "&:hover": { opacity: 1 },
                position: "relative",
                display: "block",
                width: "15px",
                height: "15px",
                opacity: 1,
                img: { display: "none" },
                "&:after": {
                  content: '"\\d7"',
                  position: "absolute",
                  top: "1px",
                  left: "-8px",
                  color: n.colors.colorPrimary,
                  fontSize: "46px",
                  lineHeight: "15px",
                  fontWeight: "normal",
                  transition: "color .3s",
                },
                "&:hover:after": { color: n.colors.colorSecondary },
              })["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                width: "25px",
                height: "25px",
                "&:after": { fontSize: "60px" },
              }),
              t),
              n.elements.ActionIcon
            );
          });
        },
        nKcA: function (e) {
          "use strict";
          e.exports = function (e, t, n) {
            var r, o, i, a, c, s, u, l, f, p;
            if (n) return !0;
            for (
              a = (r = this.inlineMethods).length,
                o = this.inlineTokenizers,
                i = -1,
                f = t.length;
              ++i < a;

            )
              "text" !== (l = r[i]) &&
                o[l] &&
                ((u = o[l].locator) ||
                  e.file.fail("Missing locator: `" + l + "`"),
                -1 !== (s = u.call(this, t, 1)) && s < f && (f = s));
            (c = t.slice(0, f)),
              (p = e.now()),
              this.decode(c, p, function (t, n, r) {
                e(r || t)({ type: "text", value: t });
              });
          };
        },
        nSJr: function (e) {
          "use strict";
          e.exports = function (e, t, n) {
            for (
              var r,
                o,
                i,
                a = this.options,
                c = t.length + 1,
                s = -1,
                u = e.now(),
                l = "",
                f = "";
              ++s < c;

            ) {
              if (" " !== (r = t.charAt(s)) && "\t" !== r) {
                s--;
                break;
              }
              l += r;
            }
            for (i = 0; ++s <= c; ) {
              if ("#" !== (r = t.charAt(s))) {
                s--;
                break;
              }
              (l += r), i++;
            }
            if (!(i > 6) && i && (a.pedantic || "#" !== t.charAt(s + 1))) {
              for (c = t.length + 1, o = ""; ++s < c; ) {
                if (" " !== (r = t.charAt(s)) && "\t" !== r) {
                  s--;
                  break;
                }
                o += r;
              }
              if (a.pedantic || 0 !== o.length || !r || "\n" === r) {
                if (n) return !0;
                for (
                  l += o, o = "", f = "";
                  ++s < c && (r = t.charAt(s)) && "\n" !== r;

                )
                  if (" " === r || "\t" === r || "#" === r) {
                    for (; " " === r || "\t" === r; )
                      (o += r), (r = t.charAt(++s));
                    for (; "#" === r; ) (o += r), (r = t.charAt(++s));
                    for (; " " === r || "\t" === r; )
                      (o += r), (r = t.charAt(++s));
                    s--;
                  } else (f += o + r), (o = "");
                return (
                  (u.column += l.length),
                  (u.offset += l.length),
                  e((l += f + o))({
                    type: "heading",
                    depth: i,
                    children: this.tokenizeInline(f, u),
                  })
                );
              }
            }
          };
        },
        nYUH: function (e) {
          !(function () {
            "use strict";
            e.exports = {
              polyfill: function () {
                function e(e, t) {
                  (this.scrollLeft = e), (this.scrollTop = t);
                }
                function t(e) {
                  if (
                    null === e ||
                    "object" != typeof e ||
                    void 0 === e.behavior ||
                    "auto" === e.behavior ||
                    "instant" === e.behavior
                  )
                    return !0;
                  if ("object" == typeof e && "smooth" === e.behavior)
                    return !1;
                  throw new TypeError(
                    "behavior member of ScrollOptions " +
                      e.behavior +
                      " is not a valid value for enumeration ScrollBehavior."
                  );
                }
                function n(e, t) {
                  return "Y" === t
                    ? e.clientHeight + h < e.scrollHeight
                    : "X" === t
                    ? e.clientWidth + h < e.scrollWidth
                    : void 0;
                }
                function r(e, t) {
                  var n = s.getComputedStyle(e, null)["overflow" + t];
                  return "auto" === n || "scroll" === n;
                }
                function o(e) {
                  var t = n(e, "Y") && r(e, "Y"),
                    o = n(e, "X") && r(e, "X");
                  return t || o;
                }
                function i(e) {
                  for (; e !== u.body && !1 === o(e); )
                    e = e.parentNode || e.host;
                  return e;
                }
                function a(e) {
                  var t,
                    n,
                    r,
                    o = (d() - e.startTime) / 468;
                  (o = o > 1 ? 1 : o),
                    (t = 0.5 * (1 - Math.cos(Math.PI * o))),
                    e.method.call(
                      e.scrollable,
                      (n = e.startX + (e.x - e.startX) * t),
                      (r = e.startY + (e.y - e.startY) * t)
                    ),
                    (n === e.x && r === e.y) ||
                      s.requestAnimationFrame(a.bind(s, e));
                }
                function c(t, n, r) {
                  var o,
                    i,
                    c,
                    l,
                    f = d();
                  t === u.body
                    ? ((o = s),
                      (i = s.scrollX || s.pageXOffset),
                      (c = s.scrollY || s.pageYOffset),
                      (l = p.scroll))
                    : ((o = t), (i = t.scrollLeft), (c = t.scrollTop), (l = e)),
                    a({
                      scrollable: o,
                      method: l,
                      startTime: f,
                      startX: i,
                      startY: c,
                      x: n,
                      y: r,
                    });
                }
                var s = window,
                  u = document;
                if (
                  !("scrollBehavior" in u.documentElement.style) ||
                  !0 === s.__forceSmoothScrollPolyfill__
                ) {
                  var l,
                    f = s.HTMLElement || s.Element,
                    p = {
                      scroll: s.scroll || s.scrollTo,
                      scrollBy: s.scrollBy,
                      elementScroll: f.prototype.scroll || e,
                      scrollIntoView: f.prototype.scrollIntoView,
                    },
                    d =
                      s.performance && s.performance.now
                        ? s.performance.now.bind(s.performance)
                        : Date.now,
                    h =
                      ((l = s.navigator.userAgent),
                      new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(
                        l
                      )
                        ? 1
                        : 0);
                  (s.scroll = s.scrollTo =
                    function () {
                      void 0 !== arguments[0] &&
                        (!0 !== t(arguments[0])
                          ? c.call(
                              s,
                              u.body,
                              void 0 !== arguments[0].left
                                ? ~~arguments[0].left
                                : s.scrollX || s.pageXOffset,
                              void 0 !== arguments[0].top
                                ? ~~arguments[0].top
                                : s.scrollY || s.pageYOffset
                            )
                          : p.scroll.call(
                              s,
                              void 0 !== arguments[0].left
                                ? arguments[0].left
                                : "object" != typeof arguments[0]
                                ? arguments[0]
                                : s.scrollX || s.pageXOffset,
                              void 0 !== arguments[0].top
                                ? arguments[0].top
                                : void 0 !== arguments[1]
                                ? arguments[1]
                                : s.scrollY || s.pageYOffset
                            ));
                    }),
                    (s.scrollBy = function () {
                      void 0 !== arguments[0] &&
                        (t(arguments[0])
                          ? p.scrollBy.call(
                              s,
                              void 0 !== arguments[0].left
                                ? arguments[0].left
                                : "object" != typeof arguments[0]
                                ? arguments[0]
                                : 0,
                              void 0 !== arguments[0].top
                                ? arguments[0].top
                                : void 0 !== arguments[1]
                                ? arguments[1]
                                : 0
                            )
                          : c.call(
                              s,
                              u.body,
                              ~~arguments[0].left +
                                (s.scrollX || s.pageXOffset),
                              ~~arguments[0].top + (s.scrollY || s.pageYOffset)
                            ));
                    }),
                    (f.prototype.scroll = f.prototype.scrollTo =
                      function () {
                        if (void 0 !== arguments[0])
                          if (!0 !== t(arguments[0])) {
                            var e = arguments[0].left,
                              n = arguments[0].top;
                            c.call(
                              this,
                              this,
                              void 0 === e ? this.scrollLeft : ~~e,
                              void 0 === n ? this.scrollTop : ~~n
                            );
                          } else {
                            if (
                              "number" == typeof arguments[0] &&
                              void 0 === arguments[1]
                            )
                              throw new SyntaxError(
                                "Value could not be converted"
                              );
                            p.elementScroll.call(
                              this,
                              void 0 !== arguments[0].left
                                ? ~~arguments[0].left
                                : "object" != typeof arguments[0]
                                ? ~~arguments[0]
                                : this.scrollLeft,
                              void 0 !== arguments[0].top
                                ? ~~arguments[0].top
                                : void 0 !== arguments[1]
                                ? ~~arguments[1]
                                : this.scrollTop
                            );
                          }
                      }),
                    (f.prototype.scrollBy = function () {
                      void 0 !== arguments[0] &&
                        (!0 !== t(arguments[0])
                          ? this.scroll({
                              left: ~~arguments[0].left + this.scrollLeft,
                              top: ~~arguments[0].top + this.scrollTop,
                              behavior: arguments[0].behavior,
                            })
                          : p.elementScroll.call(
                              this,
                              void 0 !== arguments[0].left
                                ? ~~arguments[0].left + this.scrollLeft
                                : ~~arguments[0] + this.scrollLeft,
                              void 0 !== arguments[0].top
                                ? ~~arguments[0].top + this.scrollTop
                                : ~~arguments[1] + this.scrollTop
                            ));
                    }),
                    (f.prototype.scrollIntoView = function () {
                      if (!0 !== t(arguments[0])) {
                        var e = i(this),
                          n = e.getBoundingClientRect(),
                          r = this.getBoundingClientRect();
                        e !== u.body
                          ? (c.call(
                              this,
                              e,
                              e.scrollLeft + r.left - n.left,
                              e.scrollTop + r.top - n.top
                            ),
                            "fixed" !== s.getComputedStyle(e).position &&
                              s.scrollBy({
                                left: n.left,
                                top: n.top,
                                behavior: "smooth",
                              }))
                          : s.scrollBy({
                              left: r.left,
                              top: r.top,
                              behavior: "smooth",
                            });
                      } else
                        p.scrollIntoView.call(
                          this,
                          void 0 === arguments[0] || arguments[0]
                        );
                    });
                }
              },
            };
          })();
        },
        nbD9: function (e, t, n) {
          "use strict";
          function r() {
            function e() {}
            var t = { log: e, error: e, warn: e, info: e };
            try {
              return Object(o.b)().config.PROTECTED.debug ? console : t;
            } catch (e) {
              return t;
            }
          }
          n.d(t, "a", function () {
            return r;
          });
          var o = n("keud");
        },
        "o+jJ": function (e, t, n) {
          "use strict";
          var r = n("R8iU");
          e.exports = function (e, t) {
            if ("string" != typeof e) return e;
            if (0 === e.length) return e;
            var n = r.basename(e, r.extname(e)) + t;
            return r.join(r.dirname(e), n);
          };
        },
        oJuM: function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              i,
              c,
              s,
              u,
              l,
              f,
              p,
              d = t.charAt(0),
              h = 0,
              g = t.length,
              m = "",
              b = "",
              y = "link",
              v = "shortcut";
            if (
              ("!" === d && ((y = "image"), (b = d), (d = t.charAt(++h))),
              "[" === d)
            ) {
              if (
                (h++,
                (b += d),
                (l = ""),
                this.options.footnotes && "^" === t.charAt(h))
              ) {
                if ("image" === y) return;
                (b += "^"), h++, (y = "footnote");
              }
              for (p = 0; h < g; ) {
                if ("[" === (d = t.charAt(h))) (f = !0), p++;
                else if ("]" === d) {
                  if (!p) break;
                  p--;
                }
                "\\" === d && ((l += "\\"), (d = t.charAt(++h))), (l += d), h++;
              }
              if (((m = l), (r = l), "]" === (d = t.charAt(h)))) {
                for (h++, m += d, l = ""; h < g && ((d = t.charAt(h)), o(d)); )
                  (l += d), h++;
                if (((d = t.charAt(h)), "footnote" !== y && "[" === d)) {
                  for (
                    i = "", l += d, h++;
                    h < g && "[" !== (d = t.charAt(h)) && "]" !== d;

                  )
                    "\\" === d && ((i += "\\"), (d = t.charAt(++h))),
                      (i += d),
                      h++;
                  "]" === (d = t.charAt(h))
                    ? ((v = i ? "full" : "collapsed"), (l += i + d), h++)
                    : (i = ""),
                    (m += l),
                    (l = "");
                } else {
                  if (!r) return;
                  i = r;
                }
                if ("full" === v || !f)
                  return (
                    (m = b + m),
                    "link" === y && this.inLink
                      ? null
                      : !!n ||
                        ("footnote" === y && -1 !== r.indexOf(" ")
                          ? e(m)({
                              type: "footnote",
                              children: this.tokenizeInline(r, e.now()),
                            })
                          : (((c = e.now()).column += b.length),
                            (c.offset += b.length),
                            (s = {
                              type: y + "Reference",
                              identifier: a((i = "full" === v ? i : r)),
                            }),
                            ("link" !== y && "image" !== y) ||
                              (s.referenceType = v),
                            "link" === y
                              ? ((u = this.enterLink()),
                                (s.children = this.tokenizeInline(r, c)),
                                u())
                              : "image" === y &&
                                (s.alt =
                                  this.decode.raw(this.unescape(r), c) || null),
                            e(m)(s)))
                  );
              }
            }
          }
          var o = n("U/Op"),
            i = n("qDxq"),
            a = n("QYzD");
          (e.exports = r), (r.locator = i);
        },
        oPgs: function (e, t, n) {
          "use strict";
          var r = n("keud"),
            o = n("ITsB"),
            i = n("nbD9");
          t.a = function (e) {
            var t = e.children,
              n = Object(r.b)(),
              a = Object(o.b)();
            return (
              Object(i.a)().log({ store: n }),
              Object(i.a)().log({ services: a }),
              t
            );
          };
        },
        oXdV: function (e, t, n) {
          "use strict";
          var r, o;
          !(function (e) {
            (e.action = "action"),
              (e.command = "command"),
              (e.messagesChanged = "messagesChanged"),
              (e.load = "load"),
              (e.minimize = "minimize"),
              (e.maximize = "maximize"),
              (e.addMessage = "addMessage"),
              (e.addMessageGroup = "addMessageGroup"),
              (e.redirect = "redirect"),
              (e.pageSpendTime = "pageSpendTime"),
              (e.pageLoad = "pageLoad"),
              (e.formFocus = "formFocus"),
              (e.formSubmit = "formSubmit");
          })(r || (r = {}));
          var i,
            a,
            c = {
              inactivity: {},
              events:
                ((o = {}),
                (o[r.action] = function () {}),
                (o[r.command] = function () {}),
                (o[r.messagesChanged] = function () {}),
                (o[r.load] = function () {}),
                (o[r.minimize] = function () {}),
                (o[r.maximize] = function () {}),
                (o[r.addMessage] = function () {}),
                (o[r.addMessageGroup] = function () {}),
                (o[r.redirect] = function () {}),
                (o[r.pageSpendTime] = function () {}),
                (o[r.pageLoad] = function () {}),
                (o[r.formFocus] = function () {}),
                (o[r.formSubmit] = function () {}),
                o),
              pageSpendTime: {},
            },
            s = n("lpWF");
          t.a =
            ((i = { inactivity: {}, events: {} }),
            (a = window.__actionBot && window.__actionBot.behavior),
            Object(s.a)(c, i, a || {}));
        },
        ohaA: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "b", function () {
              return u;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = Object(a.b)(c.a).withConfig({
              displayName: "ImageGallerystyled__ImageContainer",
              componentId: "sc-14tswdq-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                o(
                  o(
                    {
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gridColumnGap: "15px",
                      marginTop: "0",
                    },
                    e.fullScreen
                      ? {
                          position: "fixed",
                          left: 0,
                          top: 0,
                          width: "100vw",
                          height: "100vh",
                          justifyContent: "center",
                          backgroundColor: "black",
                          overflow: "auto",
                          zIndex: 999999999999,
                          borderRadius: 0,
                        }
                      : {}
                  ),
                  t.elements.messages.ImageContainer
                ),
                t.elements.messages.ImageFullScreen
              );
            }),
            u = Object(a.b)(c.b).withConfig({
              displayName: "ImageGallerystyled__ImageWrapper",
              componentId: "sc-14tswdq-1",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                o(
                  {
                    backgroundColor: t.colors.veryLightPink,
                    padding: "0",
                    width: "100%",
                    maxWidth: "initial",
                    borderRadius: "2px",
                    overflow: "hidden",
                    cursor: "pointer",
                    background: "transparent",
                  },
                  t.elements.messages.ImageWrapper
                ),
                {},
                { img: { width: "100%" } }
              );
            });
          a.b.img.withConfig({
            displayName: "ImageGallerystyled__Image",
            componentId: "sc-14tswdq-2",
          })([".ActionBot &{", "}"], function (e) {
            return o(
              { width: "100%", maxWidth: "initial", maxHeight: "initial" },
              e.theme.elements.messages.Image
            );
          });
        },
        p4DT: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "b", function () {
              return u;
            });
          var a = n("UutA"),
            c = n("A6/w"),
            s = Object(a.b)(c.a).withConfig({
              displayName: "Thinkingstyled__ThinkingContainer",
              componentId: "fj4gr3-0",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { alignItems: "flex-start", marginTop: "0" },
                e.theme.elements.messages.ThinkingContainer
              );
            }),
            u = Object(a.b)(c.b).withConfig({
              displayName: "Thinkingstyled__ThinkingMessage",
              componentId: "fj4gr3-1",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme;
              return o(
                {
                  backgroundColor: n.colors.veryLightPink,
                  height: "32px",
                  "&:after":
                    ((t = {
                      content: '""',
                      display: "inline-block",
                      animation: "dotty steps(1, end) 1s infinite",
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginLeft: "12px",
                    }),
                    (t["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                      marginLeft: "15px",
                    }),
                    t),
                  "*": { display: "none" },
                  minWidth: "60px",
                  minheight: "32px",
                  borderRadius: "0 10px 10px 15px",
                  color: n.colors.colorPrimary,
                  background: n.colors.colorWhite,
                  boxShadow: "0 0 10px " + n.colors.boxShadow,
                },
                n.elements.messages.ThinkingMessage
              );
            });
        },
        pCvA: function (e) {
          var t;
          t = (function () {
            return this;
          })();
          try {
            t = t || new Function("return this")();
          } catch (e) {
            "object" == typeof window && (t = window);
          }
          e.exports = t;
        },
        pZBa: function (e) {
          "use strict";
          e.exports = function (e, t) {
            var n = e.indexOf("**", t),
              r = e.indexOf("__", t);
            return -1 === r ? n : -1 === n || r < n ? r : n;
          };
        },
        pyeF: function (e) {
          "use strict";
          e.exports = function (e) {
            var t = "string" == typeof e ? e.charCodeAt(0) : e;
            return (
              (t >= 97 && t <= 102) ||
              (t >= 65 && t <= 70) ||
              (t >= 48 && t <= 57)
            );
          };
        },
        q12C: function (e, t, n) {
          "use strict";
          t.a = n.p + "3de3452a78401da003a4cd5f5170a12d.svg";
        },
        q8Rk: function (e) {
          e.exports = JSON.parse(
            '{"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}'
          );
        },
        q8xz: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return s;
          }),
            n.d(t, "b", function () {
              return u;
            });
          var a = n("UutA"),
            c = n("keud"),
            s = a.b.div.withConfig({
              displayName: "ActionBotstyled__BotWindow",
              componentId: "sc-1tw7qpp-0",
            })([".ActionBot &{", "}"], function (e) {
              var t = e.theme;
              return o(
                {
                  direction: Object(c.b)().rtl.value ? "rtl" : "ltr",
                  position: "fixed",
                  right: "5vw",
                  bottom: "5vh",
                  maxWidth: "50%",
                  maxHeight: "90vh",
                  display: "flex",
                  flexDirection: "column",
                  alignContent: "space-between",
                  fontFamily: t.fonts.primary,
                  "&.fullscreen": {
                    width: "100%",
                    height: "100vh",
                    maxWidth: "100%",
                    maxHeight: "100vh",
                    top: 0,
                    left: 0,
                    borderRadius: 0,
                  },
                  "&.minimized": { display: "none" },
                  "& *": { boxSizing: "border-box" },
                  borderRadius: "20px",
                  overflow: "hidden",
                  background: t.colors.colorWhite,
                  boxShadow: "0 0 20px " + t.colors.mainShadow,
                  "p, ul, ol, li, span": {
                    fontFamily: t.fonts.primaryFont,
                    fontSize: "inherit",
                    fontWeight: "inherit",
                    lineHeight: "inherit",
                    color: "inherit",
                  },
                  zIndex: 1e3,
                  width: "320px",
                  height: "620px",
                  "@media (max-width: 576px)": {
                    position: "fixed",
                    top: "0",
                    left: "0",
                    right: "0",
                    width: "100%",
                    height: "100%",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    transform: "none",
                    borderRadius: "0",
                  },
                  "&.rtl": {
                    ".scroll--content": {
                      marginRight: "0",
                      "> div > div.bot > div.bot > div.bot": {
                        right: "10px",
                        left: "auto",
                      },
                      "> div > div.user > div.user > div.user": {
                        right: "auto",
                        left: "10px",
                      },
                    },
                    ".scroll--bar": { right: "auto", left: "0" },
                    "> div:first-child": {
                      "&:before": { left: "auto", right: "15px" },
                      "> div:first-child": { padding: "0 55px 0 0" },
                    },
                    iframe: { left: "auto", right: "-20px" },
                  },
                },
                t.elements.BotWindow
              );
            }),
            u =
              (a.b.img.withConfig({
                displayName: "ActionBotstyled__BotIcon",
                componentId: "sc-1tw7qpp-1",
              })([".ActionBot &{", "}"], function (e) {
                return o(
                  {
                    position: "fixed",
                    bottom: "5vh",
                    right: "5vw",
                    cursor: "pointer",
                    transition: "opacity .3s",
                    "&:hover": { opacity: 0.75 },
                  },
                  e.theme.elements.BotIcon
                );
              }),
              a.b.div.withConfig({
                displayName: "ActionBotstyled__RootContainer",
                componentId: "sc-1tw7qpp-2",
              })([".ActionBot &{}"]));
        },
        qCZp: function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              return (r =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            var o = n("QRet"),
              i = n("FaEK"),
              a = n("ch1+"),
              c = n("CtzJ"),
              s = n("CqQT"),
              u = n("SrYG"),
              l = n("K/5M"),
              f = ["position"],
              p = {
                thumbUp: {
                  component: a.a,
                  props: { img: c.a, imgSelected: s.a },
                },
                thumbDown: {
                  component: a.a,
                  props: { img: u.a, imgSelected: l.a },
                },
              };
            t.a = function (t) {
              function n(e) {
                void 0 === b && (y(e), s(e));
              }
              var a,
                c = t.message,
                s = t.onSelect,
                u = c.content,
                l = u.position,
                d = void 0 === l ? "left" : l,
                h = (function (e, t) {
                  if (null == e) return {};
                  var n,
                    r,
                    o = {},
                    i = Object.keys(e);
                  for (r = 0; r < i.length; r++)
                    t.indexOf((n = i[r])) >= 0 || (o[n] = e[n]);
                  return o;
                })(u, f),
                g = c.description,
                m = Object(o.k)(void 0),
                b = m[0],
                y = m[1];
              return e(
                i.b,
                { position: d },
                e(i.c, null, g),
                e(
                  "div",
                  null,
                  ((a = []),
                  "object" == typeof h &&
                    Object.keys(h).forEach(function (t) {
                      if (p[t]) {
                        var o = h[t],
                          i = p[t];
                        a.push(
                          e(
                            i.component,
                            r(
                              {
                                key: "survey-item" + t,
                                isSelected: o === b,
                                onSelect: function () {
                                  return n(o);
                                },
                              },
                              i.props,
                              { valueSet: void 0 !== b }
                            )
                          )
                        );
                      }
                    }),
                  a)
                )
              );
            };
          }).call(this, n("hosL").h);
        },
        qDxq: function (e) {
          "use strict";
          e.exports = function (e, t) {
            var n = e.indexOf("[", t),
              r = e.indexOf("![", t);
            return -1 === r || n < r ? n : r;
          };
        },
        qj14: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return i;
          });
          var i = n("UutA").b.div.withConfig({
            displayName: "PoweredBystyled__PoweredBy",
            componentId: "wrguea-0",
          })([".ActionBot &{", "}"], function (e) {
            var t = e.theme;
            return (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      o(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            })(
              {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "10px",
                fontFamily: t.fonts.primary,
                color: "#aeaeae",
                height: "27px",
                lineHeight: "28px",
                backgroundColor: "#fff",
                width: "100%",
                borderTop: "1px solid #f4f7ff",
                a: {
                  color: "#a4a3a5",
                  textDecoration: "none",
                  fontWeight: "bold",
                  paddingLeft: "3px",
                },
                "@media (max-width: 576px)": { display: "none" },
              },
              t.elements.PoweredBy
            );
          });
        },
        rMjy: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r);
              }
              return n;
            }
            function o(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      i(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            }
            function i(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            var a = n("QRet"),
              c = n("jAGx"),
              s = n("uUgx"),
              u = n("ITsB");
            t.a = function (t) {
              var n = t.message,
                r = new (Object(u.b)("MessageService"))(),
                i = n.content,
                l = i.id,
                f = i.description,
                p = i.button,
                d = i.fields,
                h = d.reduce(function (e, t) {
                  var n;
                  return o(
                    o({}, e),
                    {},
                    (((n = {})[t.name] = t.defaultValue), n)
                  );
                }, {}),
                g = Object(a.k)(h),
                m = g[0],
                b = g[1],
                y = n.isSent;
              return e(
                c.c,
                { owner: n.owner },
                e(
                  c.h,
                  null,
                  f && e(c.e, null, f),
                  e(
                    c.a,
                    { id: l },
                    d.map(function (t) {
                      var n = t.name;
                      return e(
                        c.d,
                        null,
                        e(c.g, null, t.displayName),
                        e(c.f, {
                          disabled: y,
                          onChange: function (e) {
                            return (function (e) {
                              var t = e.name,
                                n = e.event.target.value;
                              b(function (e) {
                                var r;
                                return o(o({}, e), {}, (((r = {})[t] = n), r));
                              });
                            })({ name: n, event: e });
                          },
                          id: n,
                          value: m[n],
                        })
                      );
                    })
                  ),
                  e(
                    c.b,
                    {
                      onClick: function () {
                        var e,
                          t = new (0, Object(u.b)().ConnectionService)();
                        r.editMessageById(n.id, function (e) {
                          return (e.isSent = !0), e;
                        });
                        var o = new s.a({ forms: ((e = {}), (e[l] = m), e) });
                        t.sendMessage({ text: "", context: o }).catch(
                          console.error
                        );
                      },
                      disabled: y,
                    },
                    p
                  )
                )
              );
            };
          }).call(this, n("hosL").h);
        },
        rOKC: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function i(e) {
            var t,
              n = {
                rtl: "ab.storage." + e + ".rtl",
                agentConnection: "ab.storage." + e + ".agentConnection",
                agentInfo: "ab.storage." + e + ".agentInfo",
                botInfo: "ab.storage." + e + ".botInfo",
                usernameVisibleToAgent:
                  "ab.storage." + e + ".usernameVisibleToAgent",
                language: "ab.storage." + e + ".language",
                unread: "ab.storage." + e + ".unread",
                sessionId: "ab.storage." + e + ".sessionId",
                redirectStorage: "ab.storage." + e + ".redirectStorage",
                remoteConfig: "ab.storage." + e + ".remoteConfig",
                initialPopupSeen: "ab.storage." + e + ".initialPopupSeen",
                themeExtension: "ab.storage." + e + ".themeExtension",
              };
            return (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? r(Object(n), !0).forEach(function (t) {
                      o(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : r(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            })(
              (((t = {})[n.rtl] = { storage: "localStorage" }),
              (t[n.redirectStorage] = { storage: "localStorage" }),
              (t[n.language] = { storage: "localStorage" }),
              (t[n.agentInfo] = { storage: "localStorage" }),
              (t[n.botInfo] = { storage: "localStorage" }),
              (t[n.usernameVisibleToAgent] = { storage: "localStorage" }),
              (t[n.agentConnection] = { storage: "localStorage" }),
              (t[n.sessionId] = { storage: "sessionStorage" }),
              (t[n.unread] = { storage: "localStorage" }),
              (t[n.remoteConfig] = { storage: "sessionStorage" }),
              (t[n.initialPopupSeen] = { storage: "sessionStorage" }),
              t),
              n
            );
          }
          n.d(t, "a", function () {
            return i;
          });
        },
        "sWw+": function (e) {
          "use strict";
          var t = Object.prototype.hasOwnProperty,
            n = Object.prototype.toString,
            r = Object.defineProperty,
            o = Object.getOwnPropertyDescriptor,
            i = function (e) {
              return "function" == typeof Array.isArray
                ? Array.isArray(e)
                : "[object Array]" === n.call(e);
            },
            a = function (e) {
              if (!e || "[object Object]" !== n.call(e)) return !1;
              var r,
                o = t.call(e, "constructor"),
                i =
                  e.constructor &&
                  e.constructor.prototype &&
                  t.call(e.constructor.prototype, "isPrototypeOf");
              if (e.constructor && !o && !i) return !1;
              for (r in e);
              return void 0 === r || t.call(e, r);
            },
            c = function (e, t) {
              r && "__proto__" === t.name
                ? r(e, t.name, {
                    enumerable: !0,
                    configurable: !0,
                    value: t.newValue,
                    writable: !0,
                  })
                : (e[t.name] = t.newValue);
            },
            s = function (e, n) {
              if ("__proto__" === n) {
                if (!t.call(e, n)) return;
                if (o) return o(e, n).value;
              }
              return e[n];
            };
          e.exports = function e() {
            var t,
              n,
              r,
              o,
              u,
              l,
              f = arguments[0],
              p = 1,
              d = arguments.length,
              h = !1;
            for (
              "boolean" == typeof f &&
                ((h = f), (f = arguments[1] || {}), (p = 2)),
                (null == f ||
                  ("object" != typeof f && "function" != typeof f)) &&
                  (f = {});
              p < d;
              ++p
            )
              if (null != (t = arguments[p]))
                for (n in t)
                  (r = s(f, n)),
                    f !== (o = s(t, n)) &&
                      (h && o && (a(o) || (u = i(o)))
                        ? (u
                            ? ((u = !1), (l = r && i(r) ? r : []))
                            : (l = r && a(r) ? r : {}),
                          c(f, { name: n, newValue: e(h, l, o) }))
                        : void 0 !== o && c(f, { name: n, newValue: o }));
            return f;
          };
        },
        svqz: function (e, t) {
          "use strict";
          function n(e) {
            function t(e) {
              return (
                e.itemName +
                "=" +
                e.itemValue +
                "; expires=" +
                e.expirationDate +
                "; path=/; domain=" +
                e.domain
              );
            }
            var n;
            n = e.expiresAfterReload
              ? "Thu Jan 1 2000 00:00:00"
              : "Thu Jan 1 2099 00:00:00";
            var r = window.location.hostname;
            return {
              getItem: function (e) {
                return Object.fromEntries(
                  document.cookie.split("; ").map(function (e) {
                    var t = e.split("=");
                    return [t[0], t.slice(1).join("=")];
                  })
                )[e];
              },
              setItem: function (e, o) {
                return (document.cookie = t({
                  itemName: e,
                  itemValue: o,
                  expirationDate: n,
                  domain: r,
                }));
              },
              removeItem: function (e) {
                document.cookie = t({
                  itemName: e,
                  itemValue: "",
                  expirationDate: "Thu Jan 1 2000 00:00:00",
                  domain: r,
                });
              },
            };
          }
          t.a = function (e) {
            switch ((void 0 === e && (e = "sessionStorage"), e)) {
              case "localStorage":
                return localStorage;
              case "cookiesExpired":
                return n({ expiresAfterReload: !0 });
              case "cookies":
                return n({ expiresAfterReload: !1 });
              default:
                return sessionStorage;
            }
          };
        },
        t0TX: function (e) {
          e.exports = JSON.parse('{"version":"0.17.8"}');
        },
        t7Gb: function (e) {
          "use strict";
          e.exports = function (e, t, n) {
            for (
              var r, o, i, a, c = -1, s = t.length + 1, u = "";
              ++c < s && ("\t" === (r = t.charAt(c)) || " " === r);

            )
              u += r;
            if ("*" === r || "-" === r || "_" === r)
              for (o = r, u += r, i = 1, a = ""; ++c < s; )
                if ((r = t.charAt(c)) === o) i++, (u += a + o), (a = "");
                else {
                  if (" " !== r)
                    return i >= 3 && (!r || "\n" === r)
                      ? ((u += a), !!n || e(u)({ type: "thematicBreak" }))
                      : void 0;
                  a += r;
                }
          };
        },
        tCvC: function () {},
        tJXC: function (e, t, n) {
          function r() {
            if (!window.matchMedia)
              throw new Error(
                "matchMedia not present, legacy browsers require a polyfill"
              );
            (this.queries = {}),
              (this.browserIsIncapable =
                !window.matchMedia("only all").matches);
          }
          var o = n("w24S"),
            i = n("kd9Q"),
            a = i.each,
            c = i.isFunction,
            s = i.isArray;
          (r.prototype = {
            constructor: r,
            register: function (e, t, n) {
              var r = this.queries;
              return (
                r[e] || (r[e] = new o(e, n && this.browserIsIncapable)),
                c(t) && (t = { match: t }),
                s(t) || (t = [t]),
                a(t, function (t) {
                  c(t) && (t = { match: t }), r[e].addHandler(t);
                }),
                this
              );
            },
            unregister: function (e, t) {
              var n = this.queries[e];
              return (
                n &&
                  (t
                    ? n.removeHandler(t)
                    : (n.clear(), delete this.queries[e])),
                this
              );
            },
          }),
            (e.exports = r);
        },
        "tMe+": function () {},
        td52: function (e, t, n) {
          "use strict";
          (function (e) {
            function r(t) {
              var n = t.message,
                r = n.content,
                a = n.owner,
                l = r.text,
                f = r.buttons,
                p = r.type,
                d = r.permanent,
                h = new (Object(i.b)("MarkdownService"))(),
                g = Object(u.b)();
              return e(
                s.e,
                { owner: a },
                "user" == a && e(s.g, null, g["message.text.userIndicator"]),
                e(
                  s.f,
                  { className: a },
                  e(c.a, {
                    renderers: h.getRenderers(),
                    source: l,
                    escapeHtml: !1,
                  }),
                  e(o, { buttons: f, type: p, permanent: d })
                )
              );
            }
            function o(t) {
              var n = t.buttons,
                r = t.type,
                o = t.permanent,
                a = Object(i.b)(),
                c = a.ConnectionService,
                u = a.MessageService,
                h = new (0, a.ActionsService)(),
                g = new c(),
                m = new u(),
                b = JSON.parse(n),
                y = "true" === o,
                v = Object(p.k)(-1),
                O = v[0],
                w = v[1],
                x = b.map(function (t, n) {
                  var o = t.action,
                    i = t.buttonText,
                    a = t.message,
                    c = (function (e, t) {
                      if (null == e) return {};
                      var n,
                        r,
                        o = {},
                        i = Object.keys(e);
                      for (r = 0; r < i.length; r++)
                        t.indexOf((n = i[r])) >= 0 || (o[n] = e[n]);
                      return o;
                    })(t, d),
                    u = -1 !== O && !y;
                  return e(
                    "list" === r ? s.d : s.c,
                    {
                      isButtonActive: O === n || y || -1 === O,
                      isAnyButtonActive: u,
                      onClick: function () {
                        if (!u)
                          if ((w(n), o && h.exists(o))) {
                            var e = new l.a({ isAction: !0, content: c });
                            h.getCaseInsensitiveProp(o)(e);
                          } else if (a) {
                            var t = new l.a({
                              owner: f.a.user,
                              content: a,
                              type: "text",
                            });
                            m.addMessage(t), g.sendMessage({ text: a });
                          }
                      },
                      key: n,
                    },
                    e(s.a, null, i)
                  );
                });
              return e(s.b, null, x);
            }
            n.d(t, "a", function () {
              return r;
            });
            var i = n("ITsB"),
              a = n("LO0j"),
              c = n.n(a),
              s = n("kKSO"),
              u = n("XAzd"),
              l = n("OV23"),
              f = n("6naU"),
              p = n("QRet"),
              d = ["action", "buttonText", "message"];
          }).call(this, n("hosL").h);
        },
        uCBw: function (e, t, n) {
          "use strict";
          function r(e) {
            function t() {
              return p.current;
            }
            var n = e.url,
              r = e.onOpen,
              i = void 0 === r ? function () {} : r,
              a = e.onClose,
              c = void 0 === a ? function () {} : a,
              s = e.onMessage,
              u = void 0 === s ? function () {} : s,
              l = e.onError,
              f = void 0 === l ? function () {} : l;
            if (!n) return null;
            var p = Object(o.j)(
              (function e() {
                var t = new WebSocket(n);
                return (
                  (t.isWSOpened = function () {
                    return t.readyState === t.OPEN;
                  }),
                  (t.sendWS = function (e) {
                    t.send(e);
                  }),
                  (t.onclose = c),
                  (t.onopen = i),
                  (t.onmessage = u),
                  (t.onerror = f),
                  (t.closeWS = function () {
                    t.close();
                  }),
                  (t.openWS = function () {
                    p.current = e();
                  }),
                  t
                );
              })()
            );
            return (window.__actionBot.getWebSocket = t), t;
          }
          n.d(t, "a", function () {
            return r;
          });
          var o = n("QRet");
        },
        uGjU: function (e, t, n) {
          "use strict";
          (function (e) {
            function r() {
              return (r =
                Object.assign ||
                function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      Object.prototype.hasOwnProperty.call(n, r) &&
                        (e[r] = n[r]);
                  }
                  return e;
                }).apply(this, arguments);
            }
            function o(e, t) {
              var n = Object.keys(e);
              if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t &&
                  (r = r.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                  })),
                  n.push.apply(n, r);
              }
              return n;
            }
            function i(e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? o(Object(n), !0).forEach(function (t) {
                      a(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n)
                    )
                  : o(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t)
                      );
                    });
              }
              return e;
            }
            function a(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            var c = n("8xtm"),
              s = n("2UUl"),
              u = n.n(s),
              l = (n("IO5D"), n("tCvC"), n("hosL")),
              f = n("QRet"),
              p = n("keud"),
              d = n("LO0j"),
              h = n.n(d),
              g = n("ITsB"),
              m = n("OV23");
            t.a = function (t) {
              var n = t.slides,
                o = t.sliderConfig,
                a = t.onOptionSelect,
                s = Object(l.createRef)(),
                d = Object(p.b)().config,
                b = (o || d.PUBLIC.carousel).settings,
                y = Object(f.k)(!1),
                v = y[0],
                O = y[1],
                w = new (Object(g.b)("MarkdownService"))(),
                x = Object(f.k)(!1),
                _ = x[0],
                j = x[1],
                S = Object(f.k)(!0),
                k = S[0],
                C = S[1],
                P = {
                  beforeChange: function () {
                    O(!0);
                  },
                  afterChange: function (e) {
                    O(!1),
                      (function (e) {
                        j(0 != e), C(e != n.length - 1);
                      })(e);
                  },
                };
              if (n) {
                var A = n.map(function (t) {
                  return e(
                    c.g,
                    null,
                    e(c.e, { src: t.icon }),
                    e(
                      c.f,
                      null,
                      e(h.a, {
                        renderers: w.getRenderers(),
                        source: t.text,
                        escapeHtml: !1,
                      })
                    ),
                    e(c.a, {
                      onClick: function () {
                        return (function (e, t) {
                          if ("redirect" == t.action) {
                            var n = new (Object(g.b)("ActionsService"))(),
                              r = new m.a({ content: i({ url: t.value }, t) });
                            n.redirectWithMemory(r);
                          } else v || a(t.value);
                        })(0, t);
                      },
                    })
                  );
                });
                return e(
                  c.d,
                  null,
                  e(u.a, r({}, b, P, { ref: s }), A),
                  _ &&
                    e(
                      c.b,
                      {
                        onClick: function () {
                          return s.current.slickPrev();
                        },
                      },
                      "<"
                    ),
                  k &&
                    e(
                      c.c,
                      {
                        onClick: function () {
                          return s.current.slickNext();
                        },
                      },
                      ">"
                    )
                );
              }
            };
          }).call(this, n("hosL").h);
        },
        uUgx: function (e, t, n) {
          "use strict";
          function r() {
            try {
              return Object(c.b)().config.PUBLIC.language || Object(s.a)();
            } catch (e) {
              return Object(s.a)();
            }
          }
          function o(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function i(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? o(Object(n), !0).forEach(function (t) {
                    a(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : o(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function a(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "a", function () {
            return l;
          });
          var c = n("keud"),
            s = n("UFfw"),
            u = n("ITsB"),
            l = function (e) {
              this.skills = void 0;
              var t = new (0, Object(u.b)().TopicService)().getTopic(),
                n = Object(c.b)();
              this.skills = {
                "main skill": {
                  user_defined: i(
                    {
                      source: n.config.PROTECTED.connection.watsonSource,
                      lang: r() || "en",
                      url: window.location.href.substr(0, 1024),
                      topic: t,
                    },
                    e
                  ),
                },
              };
            };
        },
        "ucf/": function (e, t, n) {
          "use strict";
          function r() {}
          function o(e, t, n) {
            var r, o, a;
            "string" == typeof t && ((n = t), (t = null)),
              (r = (function (e) {
                var t,
                  n = [null, null];
                "string" == typeof e &&
                  (-1 === (t = e.indexOf(":"))
                    ? (n[1] = e)
                    : ((n[0] = e.slice(0, t)), (n[1] = e.slice(t + 1))));
                return n;
              })(n)),
              (o = i(t) || "1:1"),
              (a = {
                start: { line: null, column: null },
                end: { line: null, column: null },
              }),
              t && t.position && (t = t.position),
              t && (t.start ? ((a = t), (t = t.start)) : (a.start = t)),
              e.stack && ((this.stack = e.stack), (e = e.message)),
              (this.message = e),
              (this.name = o),
              (this.reason = e),
              (this.line = t ? t.line : null),
              (this.column = t ? t.column : null),
              (this.location = a),
              (this.source = r[0]),
              (this.ruleId = r[1]);
          }
          var i = n("zHeK");
          (e.exports = o), (r.prototype = Error.prototype);
          var a = (o.prototype = new r());
          (a.file = ""),
            (a.name = ""),
            (a.reason = ""),
            (a.message = ""),
            (a.stack = ""),
            (a.fatal = null),
            (a.column = null),
            (a.line = null);
        },
        unVz: function (e, t, n) {
          var r = n("kqyo");
          e.exports = function () {
            return function (e) {
              return (
                r(e, "list", function (e, t) {
                  var n,
                    r,
                    o = 0;
                  for (n = 0, r = t.length; n < r; n++)
                    "list" === t[n].type && (o += 1);
                  for (n = 0, r = e.children.length; n < r; n++) {
                    var i = e.children[n];
                    (i.index = n), (i.ordered = e.ordered);
                  }
                  e.depth = o;
                }),
                e
              );
            };
          };
        },
        ut2F: function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("Me7t"),
              o = n("ICoq"),
              i = n("J9Ds"),
              a = n("WHan"),
              c = n("oXdV"),
              s = n("9J4p"),
              u = n("QRet"),
              l = n("L16Z"),
              f = (n("Khqb"), n("ITsB")),
              p = n("keud"),
              d = n("3xEr");
            t.a = function () {
              Object(u.d)(function () {
                function e() {
                  var e = sessionStorage.getItem("lastAfterLoginValue"),
                    n = sessionStorage.getItem("AFTER_LOGIN");
                  n && (n = n.replaceAll('"', "")),
                    (e = "undefined" == e ? void 0 : JSON.parse(e)) !=
                      (n = "undefined" == e ? void 0 : JSON.parse(n)) &&
                      (sessionStorage.setItem(
                        "lastAfterLoginValue",
                        JSON.parse(n)
                      ),
                      t.sessionId.set(void 0),
                      i.storage.removeItem(i.historyKey),
                      t.messages.set(function (e) {
                        return (e.length = 0), [].concat(e);
                      }),
                      setTimeout(function () {
                        o.getSessionId();
                      }, 0));
                }
                var t = Object(p.b)(),
                  n = Object(f.b)(),
                  r = n.HistoryService,
                  o = new (0, n.ConnectionService)(),
                  i = new r();
                return (
                  setInterval(e, 1e3),
                  (window.loggedInStatusInterval = setInterval(e, 1e3)),
                  function () {
                    return clearInterval(window.loggedInStatusInterval);
                  }
                );
              }, []);
              var t = window.location.pathname;
              return e(
                "div",
                null,
                "/" == t ||
                  t.indexOf("knowmore") > -1 ||
                  t.indexOf("benefits") > -1 ||
                  t.indexOf("tipsandtricks") > -1 ||
                  t.indexOf("pricing") > -1 ||
                  t.indexOf("tasilplus") > -1 ||
                  t.indexOf("faq") > -1 ||
                  t.indexOf("aboutus") > -1 ||
                  t.indexOf("terms") > -1 ||
                  t.indexOf("loginpage") > -1 ||
                  t.indexOf("userregistration") > -1
                  ? e(r.a, {
                      theme: i.a,
                      config: o.a,
                      services: l,
                      dictionary: a.a,
                      behavior: c.a,
                      appStore: s.a,
                      MinimizedComponent: d.a,
                    })
                  : null
              );
            };
          }).call(this, n("hosL").h);
        },
        ux2s: function (e, t) {
          "use strict";
          t.a = {
            "messageInput.textarea.placeholder": {
              pl: "Napisz tutaj swoje pytanie",
              en: "Write your question here.",
              ar: "اكتب سؤالك هنا.",
            },
            "message.text.userIndicator": { pl: "Ty", en: "You", ar: "أنت" },
            "agent.status.not_connected": {
              pl: "Przepraszam, nikogo tam nie ma. Zacznijmy od nowa, a agent dołączy, gdy tylko będzie mógł.",
              en: "Sorry, nobody is there. Let's start over and the agent will join as soon as he can.",
              ar: "آسف ، لا أحد هناك. لنبدأ من جديد وسينضم الوكيل بأسرع ما يمكن.",
            },
            "upload.error.not_supported_format": {
              pl: "Proszę załadować plik we wspieranym formacie: ",
              en: "Please use one of supported formats: ",
              ar: "الرجاء استخدام أحد التنسيقات المدعومة:",
            },
            "upload.error.file_to_big": {
              pl: "Plik jest za duży, maksymalny rozmiar pliku to: ",
              en: "File is too big. Max file size is: ",
              ar: "الملف كبير جدا. الحجم الأقصى للملف هو:",
            },
            "upload.error.not_sent": {
              pl: "Plik nie został wysłany",
              en: "File not sent",
              ar: "لم يتم إرسال الملف",
            },
            "busy_indicator.text": {
              pl: "Wczytywanie...",
              en: "Loading...",
              ar: "تحميل...",
            },
            connection_error: {
              pl: "Coś poszło nie tak",
              en: "Something gone wrong",
              ar: "حدث خطأ ما",
            },
          };
        },
        uydO: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function a() {
            function e(e) {
              m(function (t) {
                return o(o({}, t), {}, { unreadCount: e });
              });
            }
            function t(e) {
              m(function (t) {
                var n,
                  r = t.unreadMessages;
                return (
                  r.splice(0, r.length),
                  (n = e ? [].concat(r, e) : r),
                  o(o({}, t), {}, { unreadMessages: n })
                );
              });
            }
            function n(e) {
              !(function (e) {
                t(e);
              })(
                h().unreadMessages.filter(function (t) {
                  return !e.includes(t.id);
                })
              );
            }
            function r(e) {
              return e && e.owner !== l.a.user;
            }
            function i(e) {
              var t = e.map(function (e) {
                  return e.id;
                }),
                r = setTimeout(function () {
                  n(t), clearTimeout(r);
                }, d);
            }
            function a(t) {
              var n = t.filter(function (e) {
                return "text" === e.type;
              });
              e(h().unreadCount + n.length),
                (function (e) {
                  e.length &&
                    m(function (t) {
                      return o(
                        o({}, t),
                        {},
                        { unreadMessages: [].concat(t.unreadMessages, e) }
                      );
                    });
                })(n),
                i(n);
            }
            var f = Object(s.b)(),
              p = f.config.PUBLIC.unread;
            if (!p.enabled) return null;
            var d = p.messageVisiblityDuration,
              h = function () {
                return Object(s.b)().unread.value;
              },
              g = h().unreadMessages,
              m = f.unread.set;
            Object(c.d)(function () {
              function n() {
                return Object(s.b)().minimized.value;
              }
              function o(e) {
                if (n()) {
                  var t = e.data;
                  if (r(t)) a([t]);
                }
              }
              function c(e) {
                if (n()) {
                  var t = e.data;
                  if (r(t)) a(t.messages);
                }
              }
              function l() {
                e(0), t();
              }
              g && i(g);
              var f = Object(u.b)("BehaviorService"),
                p = f.getEvent("addMessage"),
                d = f.getEvent("addMessageGroup"),
                h = f.getEvent("maximize");
              return (
                document.addEventListener(p, o),
                document.addEventListener(d, c),
                document.addEventListener(h, l),
                function () {
                  removeEventListener(p, o),
                    removeEventListener(d, c),
                    removeEventListener(h, l);
                }
              );
            }, []);
          }
          n.d(t, "a", function () {
            return a;
          });
          var c = n("QRet"),
            s = n("keud"),
            u = n("ITsB"),
            l = n("6naU");
        },
        vz0d: function (e, t, n) {
          "use strict";
          function r(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function o(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? r(Object(n), !0).forEach(function (t) {
                    i(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : r(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function i(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          n.d(t, "c", function () {
            return c;
          }),
            n.d(t, "b", function () {
              return s;
            }),
            n.d(t, "a", function () {
              return u;
            });
          var a = n("UutA"),
            c = a.b.div.withConfig({
              displayName: "MenuModalstyled__MenuModal",
              componentId: "sc-1jcc3dj-0",
            })([".ActionBot &{", "}"], function (e) {
              var t,
                n = e.theme,
                r = e.open;
              return o(
                (((t = {
                  width: "100%",
                  transform: r ? "scale(1)" : "scale(0)",
                  transformOrigin: "bottom left",
                  opacity: r ? "1" : "0",
                  position: "absolute",
                  right: "0",
                  bottom: "80px",
                  padding: "37px 18px 18px 18px",
                  boxShadow: "0 -5px 10px -5px #cdc8ec",
                  backgroundColor: "#fff",
                  transition: "all .2s",
                  margin: "38px, 18px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  zIndex: "1000",
                  maxHeight: "calc(100% - 150px)",
                  overflowY: "auto",
                  scrollbarWidth: "thin",
                })[
                  "@media (min-width: " + n.fullscreenParams.baseWidth + "px)"
                ] = {
                  "&.fullscreen": {
                    paddingLeft:
                      "calc(50% - (" +
                      n.fullscreenParams.baseWidth / 2 +
                      "px - 30px))",
                    paddingRight:
                      "calc(50% - (" +
                      n.fullscreenParams.baseWidth / 2 +
                      "px - 20px))",
                  },
                }),
                (t["@media (max-width: " + n.breakpoints.mobile + ")"] = {
                  bottom: "90px",
                }),
                t),
                n.elements.MenuModal
              );
            }),
            s = a.b.div.withConfig({
              displayName: "MenuModalstyled__MenuBoxContainer",
              componentId: "sc-1jcc3dj-1",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                { flex: "calc(50% - 5px)", alignItems: "stretch" },
                e.theme.elements.MenuBoxContainer
              );
            }),
            u = a.b.div.withConfig({
              displayName: "MenuModalstyled__MenuBox",
              componentId: "sc-1jcc3dj-2",
            })([".ActionBot &{", "}"], function (e) {
              return o(
                {
                  boxShadow: "0 0 20px 0 #cdc8ec",
                  padding: "15px",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  height: "100%",
                  img: { width: "auto", height: "25px", marginRight: "5px" },
                  p: {
                    color: "#0a1246",
                    fontFamily: "Barlow",
                    fontSize: "14px",
                    fontWeight: "600",
                    textAlign: "left",
                  },
                  "&:hover": { opacity: "0.7" },
                },
                e.theme.elements.MenuBox
              );
            });
        },
        w24S: function (e, t, n) {
          function r(e, t) {
            (this.query = e),
              (this.isUnconditional = t),
              (this.handlers = []),
              (this.mql = window.matchMedia(e));
            var n = this;
            (this.listener = function (e) {
              (n.mql = e.currentTarget || e), n.assess();
            }),
              this.mql.addListener(this.listener);
          }
          var o = n("L7zD"),
            i = n("kd9Q").each;
          (r.prototype = {
            constuctor: r,
            addHandler: function (e) {
              var t = new o(e);
              this.handlers.push(t), this.matches() && t.on();
            },
            removeHandler: function (e) {
              var t = this.handlers;
              i(t, function (n, r) {
                if (n.equals(e)) return n.destroy(), !t.splice(r, 1);
              });
            },
            matches: function () {
              return this.mql.matches || this.isUnconditional;
            },
            clear: function () {
              i(this.handlers, function (e) {
                e.destroy();
              }),
                this.mql.removeListener(this.listener),
                (this.handlers.length = 0);
            },
            assess: function () {
              var e = this.matches() ? "on" : "off";
              i(this.handlers, function (t) {
                t[e]();
              });
            },
          }),
            (e.exports = r);
        },
        w60P: function (e, t, n) {
          "use strict";
          var r = n("bz5S"),
            o = n("Qfee");
          e.exports = function (e) {
            return r(e) || o(e);
          };
        },
        w6Nv: function (e, t, n) {
          "use strict";
          function r(e) {
            return (
              "function" == typeof e &&
              (function (e) {
                var t;
                for (t in e) return !0;
                return !1;
              })(e.prototype)
            );
          }
          function o(e, t) {
            if ("function" != typeof t)
              throw new Error("Cannot `" + e + "` without `Parser`");
          }
          function i(e, t) {
            if ("function" != typeof t)
              throw new Error("Cannot `" + e + "` without `Compiler`");
          }
          function a(e, t) {
            if (t)
              throw new Error(
                [
                  "Cannot invoke `" +
                    e +
                    "` on a frozen processor.\nCreate a new ",
                  "processor first, by invoking it: use `processor()` instead of ",
                  "`processor`.",
                ].join("")
              );
          }
          function c(e) {
            if (!e || !d(e.type))
              throw new Error("Expected node, got `" + e + "`");
          }
          function s(e, t, n) {
            if (!n)
              throw new Error(
                "`" + e + "` finished async. Use `" + t + "` instead"
              );
          }
          var u = n("sWw+"),
            l = n("ajvC"),
            f = n("2sHR"),
            p = n("dY77"),
            d = n("Bk45"),
            h = n("cTMR");
          e.exports = (function e() {
            function t() {
              for (var t = e(), n = w.length, r = -1; ++r < n; )
                t.use.apply(null, w[r]);
              return t.data(u(!0, {}, _)), t;
            }
            function n() {
              var e, n, r, o;
              if (j) return t;
              for (; ++S < w.length; )
                (n = (e = w[S])[0]),
                  null,
                  !1 !== (r = e[1]) &&
                    (!0 === r && (e[1] = void 0),
                    "function" == typeof (o = n.apply(t, e.slice(1))) &&
                      x.use(o));
              return (j = !0), (S = 1 / 0), t;
            }
            function y(e) {
              for (var t, n = w.length, r = -1; ++r < n; )
                if ((t = w[r])[0] === e) return t;
            }
            function v(e, t, r) {
              function o(n, o) {
                x.run(e, f(t), function (t, i, a) {
                  (i = i || e), t ? o(t) : n ? n(i) : r(null, i, a);
                });
              }
              if (
                (c(e),
                n(),
                r || "function" != typeof t || ((r = t), (t = null)),
                !r)
              )
                return new Promise(o);
              o(null, r);
            }
            function O(e, r) {
              function a(n, o) {
                var i = f(e);
                b.run(t, { file: i }, function (e) {
                  e ? o(e) : n ? n(i) : r(null, i);
                });
              }
              if ((n(), o("process", t.Parser), i("process", t.Compiler), !r))
                return new Promise(a);
              a(null, r);
            }
            var w = [],
              x = p(),
              _ = {},
              j = !1,
              S = -1;
            return (
              (t.data = function (e, n) {
                return d(e)
                  ? 2 === arguments.length
                    ? (a("data", j), (_[e] = n), t)
                    : (m.call(_, e) && _[e]) || null
                  : e
                  ? (a("data", j), (_ = e), t)
                  : _;
              }),
              (t.freeze = n),
              (t.attachers = w),
              (t.use = function (e) {
                function n(e) {
                  o(e.plugins), e.settings && (c = u(c || {}, e.settings));
                }
                function r(e) {
                  if ("function" == typeof e) i(e);
                  else {
                    if ("object" != typeof e)
                      throw new Error("Expected usable value, not `" + e + "`");
                    "length" in e ? i.apply(null, e) : n(e);
                  }
                }
                function o(e) {
                  var t, n;
                  if (null == e);
                  else {
                    if ("object" != typeof e || !("length" in e))
                      throw new Error(
                        "Expected a list of plugins, not `" + e + "`"
                      );
                    for (t = e.length, n = -1; ++n < t; ) r(e[n]);
                  }
                }
                function i(e, t) {
                  var n = y(e);
                  n
                    ? (h(n[1]) && h(t) && (t = u(n[1], t)), (n[1] = t))
                    : w.push(g.call(arguments));
                }
                var c;
                if ((a("use", j), null == e));
                else if ("function" == typeof e) i.apply(null, arguments);
                else {
                  if ("object" != typeof e)
                    throw new Error("Expected usable value, not `" + e + "`");
                  "length" in e ? o(e) : n(e);
                }
                return c && (_.settings = u(_.settings || {}, c)), t;
              }),
              (t.parse = function (e) {
                var i,
                  a = f(e);
                return (
                  n(),
                  o("parse", (i = t.Parser)),
                  r(i) ? new i(String(a), a).parse() : i(String(a), a)
                );
              }),
              (t.stringify = function (e, o) {
                var a,
                  s = f(o);
                return (
                  n(),
                  i("stringify", (a = t.Compiler)),
                  c(e),
                  r(a) ? new a(e, s).compile() : a(e, s)
                );
              }),
              (t.run = v),
              (t.runSync = function (e, t) {
                var n,
                  r = !1;
                return (
                  v(e, t, function (e, t) {
                    (r = !0), l(e), (n = t);
                  }),
                  s("runSync", "run", r),
                  n
                );
              }),
              (t.process = O),
              (t.processSync = function (e) {
                var r,
                  a = !1;
                return (
                  n(),
                  o("processSync", t.Parser),
                  i("processSync", t.Compiler),
                  O((r = f(e)), function (e) {
                    (a = !0), l(e);
                  }),
                  s("processSync", "process", a),
                  r
                );
              }),
              t
            );
          })().freeze();
          var g = [].slice,
            m = {}.hasOwnProperty,
            b = p()
              .use(function (e, t) {
                t.tree = e.parse(t.file);
              })
              .use(function (e, t, n) {
                e.run(t.tree, t.file, function (e, r, o) {
                  e ? n(e) : ((t.tree = r), (t.file = o), n());
                });
              })
              .use(function (e, t) {
                t.file.contents = e.stringify(t.tree, t.file);
              });
        },
        wMKW: function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            return (o =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function i() {
            return (i =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }).apply(this, arguments);
          }
          function a(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          function c(e, t) {
            return !t || ("object" !== o(t) && "function" != typeof t)
              ? (function (e) {
                  if (void 0 === e)
                    throw new ReferenceError(
                      "this hasn't been initialised - super() hasn't been called"
                    );
                  return e;
                })(e)
              : t;
          }
          function s(e) {
            return (s = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          function u(e, t) {
            return (u =
              Object.setPrototypeOf ||
              function (e, t) {
                return (e.__proto__ = t), e;
              })(e, t);
          }
          function l(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function f(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? l(n, !0).forEach(function (t) {
                    p(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : l(n).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          }
          function p(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.Track = void 0);
          var d = r(n("l8WD")),
            h = r(n("8Jek")),
            g = n("iWpb"),
            m = function (e) {
              var t, n, r, o, i;
              return (
                (r =
                  (i = e.rtl ? e.slideCount - 1 - e.index : e.index) < 0 ||
                  i >= e.slideCount),
                e.centerMode
                  ? ((o = Math.floor(e.slidesToShow / 2)),
                    (n = (i - e.currentSlide) % e.slideCount == 0),
                    i > e.currentSlide - o - 1 &&
                      i <= e.currentSlide + o &&
                      (t = !0))
                  : (t =
                      e.currentSlide <= i &&
                      i < e.currentSlide + e.slidesToShow),
                {
                  "slick-slide": !0,
                  "slick-active": t,
                  "slick-center": n,
                  "slick-cloned": r,
                  "slick-current": i === e.currentSlide,
                }
              );
            },
            b = function (e, t) {
              return e.key || t;
            },
            y = function (e) {
              var t,
                n = [],
                r = [],
                o = [],
                i = d.default.Children.count(e.children),
                a = (0, g.lazyStartIndex)(e),
                c = (0, g.lazyEndIndex)(e);
              return (
                d.default.Children.forEach(e.children, function (s, u) {
                  var l,
                    p = {
                      message: "children",
                      index: u,
                      slidesToScroll: e.slidesToScroll,
                      currentSlide: e.currentSlide,
                    };
                  l =
                    !e.lazyLoad ||
                    (e.lazyLoad && e.lazyLoadedList.indexOf(u) >= 0)
                      ? s
                      : d.default.createElement("div", null);
                  var y = (function (e) {
                      var t = {};
                      return (
                        (void 0 !== e.variableWidth &&
                          !1 !== e.variableWidth) ||
                          (t.width = e.slideWidth),
                        e.fade &&
                          ((t.position = "relative"),
                          e.vertical
                            ? (t.top = -e.index * parseInt(e.slideHeight))
                            : (t.left = -e.index * parseInt(e.slideWidth)),
                          (t.opacity = e.currentSlide === e.index ? 1 : 0),
                          (t.transition =
                            "opacity " +
                            e.speed +
                            "ms " +
                            e.cssEase +
                            ", visibility " +
                            e.speed +
                            "ms " +
                            e.cssEase)),
                        t
                      );
                    })(f({}, e, { index: u })),
                    v = l.props.className || "",
                    O = m(f({}, e, { index: u }));
                  if (
                    (n.push(
                      d.default.cloneElement(l, {
                        key: "original" + b(l, u),
                        "data-index": u,
                        className: (0, h.default)(O, v),
                        tabIndex: "-1",
                        "aria-hidden": !O["slick-active"],
                        style: f(
                          { outline: "none" },
                          l.props.style || {},
                          {},
                          y
                        ),
                        onClick: function (t) {
                          l.props && l.props.onClick && l.props.onClick(t),
                            e.focusOnSelect && e.focusOnSelect(p);
                        },
                      })
                    ),
                    e.infinite && !1 === e.fade)
                  ) {
                    var w = i - u;
                    w <= (0, g.getPreClones)(e) &&
                      i !== e.slidesToShow &&
                      ((t = -w) >= a && (l = s),
                      (O = m(f({}, e, { index: t }))),
                      r.push(
                        d.default.cloneElement(l, {
                          key: "precloned" + b(l, t),
                          "data-index": t,
                          tabIndex: "-1",
                          className: (0, h.default)(O, v),
                          "aria-hidden": !O["slick-active"],
                          style: f({}, l.props.style || {}, {}, y),
                          onClick: function (t) {
                            l.props && l.props.onClick && l.props.onClick(t),
                              e.focusOnSelect && e.focusOnSelect(p);
                          },
                        })
                      )),
                      i !== e.slidesToShow &&
                        ((t = i + u) < c && (l = s),
                        (O = m(f({}, e, { index: t }))),
                        o.push(
                          d.default.cloneElement(l, {
                            key: "postcloned" + b(l, t),
                            "data-index": t,
                            tabIndex: "-1",
                            className: (0, h.default)(O, v),
                            "aria-hidden": !O["slick-active"],
                            style: f({}, l.props.style || {}, {}, y),
                            onClick: function (t) {
                              l.props && l.props.onClick && l.props.onClick(t),
                                e.focusOnSelect && e.focusOnSelect(p);
                            },
                          })
                        ));
                  }
                }),
                e.rtl ? r.concat(n, o).reverse() : r.concat(n, o)
              );
            };
          t.Track = (function (e) {
            function t() {
              return c(this, s(t).apply(this, arguments));
            }
            var n, r, o;
            return (
              (function (e, t) {
                if ("function" != typeof t && null !== t)
                  throw new TypeError(
                    "Super expression must either be null or a function"
                  );
                (e.prototype = Object.create(t && t.prototype, {
                  constructor: { value: e, writable: !0, configurable: !0 },
                })),
                  t && u(e, t);
              })(t, e),
              (n = t),
              (r = [
                {
                  key: "render",
                  value: function () {
                    var e = y(this.props),
                      t = this.props;
                    return d.default.createElement(
                      "div",
                      i(
                        {
                          className: "slick-track",
                          style: this.props.trackStyle,
                        },
                        {
                          onMouseEnter: t.onMouseEnter,
                          onMouseOver: t.onMouseOver,
                          onMouseLeave: t.onMouseLeave,
                        }
                      ),
                      e
                    );
                  },
                },
              ]) && a(n.prototype, r),
              o && a(n, o),
              t
            );
          })(d.default.PureComponent);
        },
        "wTL/": function (e, t, n) {
          "use strict";
          function r(e, t, n) {
            var r,
              i,
              u,
              l,
              f,
              p,
              d,
              h,
              g,
              m,
              b,
              y,
              v,
              O,
              w,
              x,
              _,
              j,
              S,
              k = "",
              C = 0,
              P = t.charAt(0),
              A = this.options.pedantic,
              I = this.options.commonmark,
              T = this.options.gfm;
            if (
              ("!" === P && ((g = !0), (k = P), (P = t.charAt(++C))),
              "[" === P && (g || !this.inLink))
            ) {
              for (
                k += P,
                  w = "",
                  C++,
                  y = t.length,
                  O = 0,
                  (_ = e.now()).column += C,
                  _.offset += C;
                C < y;

              ) {
                if (((p = P = t.charAt(C)), "`" === P)) {
                  for (i = 1; "`" === t.charAt(C + 1); ) (p += P), C++, i++;
                  u ? i >= u && (u = 0) : (u = i);
                } else if ("\\" === P) C++, (p += t.charAt(C));
                else if ((u && !T) || "[" !== P) {
                  if ((!u || T) && "]" === P) {
                    if (!O) {
                      if (!A)
                        for (; C < y && ((P = t.charAt(C + 1)), o(P)); )
                          (p += P), C++;
                      if ("(" !== t.charAt(C + 1)) return;
                      (p += "("), (r = !0), C++;
                      break;
                    }
                    O--;
                  }
                } else O++;
                (w += p), (p = ""), C++;
              }
              if (r) {
                for (
                  m = w, k += w + p, C++;
                  C < y && ((P = t.charAt(C)), o(P));

                )
                  (k += P), C++;
                if (
                  ((P = t.charAt(C)),
                  (h = I ? s : c),
                  (w = ""),
                  (l = k),
                  "<" === P)
                ) {
                  for (C++, l += "<"; C < y && ">" !== (P = t.charAt(C)); ) {
                    if (I && "\n" === P) return;
                    (w += P), C++;
                  }
                  if (">" !== t.charAt(C)) return;
                  (k += "<" + w + ">"), (x = w), C++;
                } else {
                  for (
                    P = null, p = "";
                    C < y && ((P = t.charAt(C)), !p || !a.call(h, P));

                  ) {
                    if (o(P)) {
                      if (!A) break;
                      p += P;
                    } else {
                      if ("(" === P) O++;
                      else if (")" === P) {
                        if (0 === O) break;
                        O--;
                      }
                      (w += p),
                        (p = ""),
                        "\\" === P && ((w += "\\"), (P = t.charAt(++C))),
                        (w += P);
                    }
                    C++;
                  }
                  (x = w), (C = (k += w).length);
                }
                for (w = ""; C < y && ((P = t.charAt(C)), o(P)); )
                  (w += P), C++;
                if (((P = t.charAt(C)), (k += w), w && a.call(h, P)))
                  if ((C++, (w = ""), (b = h[P]), (f = k += P), I)) {
                    for (; C < y && (P = t.charAt(C)) !== b; )
                      "\\" === P && ((w += "\\"), (P = t.charAt(++C))),
                        C++,
                        (w += P);
                    if ((P = t.charAt(C)) !== b) return;
                    for (
                      v = w, k += w + P, C++;
                      C < y && ((P = t.charAt(C)), o(P));

                    )
                      (k += P), C++;
                  } else
                    for (p = ""; C < y; ) {
                      if ((P = t.charAt(C)) === b)
                        d && ((w += b + p), (p = "")), (d = !0);
                      else if (d) {
                        if (")" === P) {
                          (k += w + b + p), (v = w);
                          break;
                        }
                        o(P)
                          ? (p += P)
                          : ((w += b + p + P), (p = ""), (d = !1));
                      } else w += P;
                      C++;
                    }
                if (")" === t.charAt(C))
                  return (
                    !!n ||
                    ((k += ")"),
                    (x = this.decode.raw(this.unescape(x), e(l).test().end, {
                      nonTerminated: !1,
                    })),
                    v &&
                      ((f = e(f).test().end),
                      (v = this.decode.raw(this.unescape(v), f))),
                    (S = {
                      type: g ? "image" : "link",
                      title: v || null,
                      url: x,
                    }),
                    g
                      ? (S.alt = this.decode.raw(this.unescape(m), _) || null)
                      : ((j = this.enterLink()),
                        (S.children = this.tokenizeInline(m, _)),
                        j()),
                    e(k)(S))
                  );
              }
            }
          }
          var o = n("U/Op"),
            i = n("qDxq");
          (e.exports = r), (r.locator = i);
          var a = {}.hasOwnProperty,
            c = { '"': '"', "'": "'" },
            s = { '"': '"', "'": "'", "(": ")" };
        },
        wfEq: function (e) {
          e.exports =
            "function" == typeof Object.create
              ? function (e, t) {
                  t &&
                    ((e.super_ = t),
                    (e.prototype = Object.create(t.prototype, {
                      constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                      },
                    })));
                }
              : function (e, t) {
                  if (t) {
                    e.super_ = t;
                    var n = function () {};
                    (n.prototype = t.prototype),
                      (e.prototype = new n()),
                      (e.prototype.constructor = e);
                  }
                };
        },
        x6i8: function (e, t, n) {
          "use strict";
          function r(e) {
            function t(e) {
              return e.toFixed(1);
            }
            var n = e / 1024,
              r = n / 1024;
            return n < 1 ? e + " B" : r < 1 ? t(n) + " KB" : t(r) + " MB";
          }
          n.d(t, "a", function () {
            return r;
          });
        },
        xF2S: function (e, t, n) {
          "use strict";
          (function (e, r) {
            var o = n("82qt"),
              i = n("5Twf"),
              a = n("6t2U"),
              c = n("ITsB"),
              s = n("6naU"),
              u = n("QRet"),
              l = n("cxG2");
            t.a = function (t) {
              function n(e) {
                E(null), A(e);
              }
              function f() {
                var t = null == S ? void 0 : S.data;
                return e(
                  r,
                  null,
                  null == t
                    ? void 0
                    : t
                        .filter(function (e) {
                          return e.date === P;
                        })
                        .map(function (t) {
                          var n = t.hours;
                          return null == n
                            ? void 0
                            : n.map(function (t) {
                                return e(
                                  l.e,
                                  {
                                    isInactive: t.avaliable,
                                    isSelected: t.from === T,
                                    onClick: function () {
                                      return (
                                        !m &&
                                        (E((e = t.from)),
                                        void O.addMessage(
                                          new i.a({
                                            owner: s.a.user,
                                            content: P + ", " + e,
                                            type: "text",
                                          })
                                        ))
                                      );
                                      var e;
                                    },
                                  },
                                  t.from,
                                  " ",
                                  t.to ? " - " + t.to : ""
                                );
                              });
                        })
                );
              }
              function p() {
                return !(
                  (n =
                    null == S || null == (e = S.data) || null == (t = e[0])
                      ? void 0
                      : t.date) <= new Date().toISOString().split("T")[0] ||
                  n == R
                );
                var e, t, n;
              }
              function d() {
                return S;
              }
              var h,
                g = t.message,
                m = t.isDisabled,
                b = Object(c.b)(),
                y = b.MessageService,
                v = new (0, b.CalendarService)(),
                O = new y(),
                w = v.handle(g),
                x = w.mode,
                _ = w.get,
                j = Object(u.k)(null),
                S = j[0],
                k = j[1],
                C = Object(u.k)(null),
                P = C[0],
                A = C[1],
                I = Object(u.k)(null),
                T = I[0],
                E = I[1],
                B = Object(u.k)(null),
                M = B[0],
                D = B[1],
                L = Object(u.k)(null),
                R = L[0],
                N = L[1],
                z = Object(u.k)(!1),
                W = z[0],
                F = z[1];
              return (
                Object(u.d)(
                  function () {
                    F(!0),
                      _(g, { startDate: M }).then(function (e) {
                        var t, r;
                        k(e.returnData);
                        var o = null == (t = e.returnData) ? void 0 : t.data,
                          i = null == o || null == (r = o[0]) ? void 0 : r.date;
                        i && n(i),
                          i && !R && N(i),
                          setTimeout(function () {
                            F(!1);
                          }, v.requestsThreshold);
                      });
                  },
                  [M]
                ),
                Object(u.d)(
                  function () {
                    f(), P && v.onSelectDate({ mode: x, date: P });
                  },
                  [P]
                ),
                Object(u.d)(
                  function () {
                    T && v.onSelectTime({ mode: x, date: P, time: T });
                  },
                  [T]
                ),
                Object(u.d)(
                  function () {
                    new a.a().scrollToBottom();
                  },
                  [S, P]
                ),
                e(
                  l.a,
                  { isDisabled: m },
                  !m && !d() && e(o.a, null),
                  d() &&
                    e(
                      r,
                      null,
                      e(
                        l.h,
                        { isPrevButtonVisible: p() },
                        p() &&
                          e(
                            l.g,
                            {
                              isRequestBlocked: W,
                              onClick: function () {
                                return (
                                  !m &&
                                  !W &&
                                  (function () {
                                    var e,
                                      t = null == S ? void 0 : S.data,
                                      n =
                                        null == t || null == (e = t[0])
                                          ? void 0
                                          : e.date;
                                    if (n) {
                                      var r = new Date(n);
                                      r.setDate(r.getDate() - (t.length + 1)),
                                        D(r);
                                    }
                                  })()
                                );
                              },
                            },
                            e("span", null, "<"),
                            e("span", null, "Poprzednie dni")
                          ),
                        e(
                          l.f,
                          {
                            isRequestBlocked: W,
                            onClick: function () {
                              return (
                                !m &&
                                !W &&
                                (function () {
                                  var e,
                                    t = null == S ? void 0 : S.data,
                                    n =
                                      null == t ||
                                      null ==
                                        (e =
                                          t[
                                            (null == t ? void 0 : t.length) - 1
                                          ])
                                        ? void 0
                                        : e.date;
                                  if (n) {
                                    var r = new Date(n);
                                    r.setDate(r.getDate() + 1), D(r);
                                  }
                                })()
                              );
                            },
                          },
                          e("span", null, "Nastepne dni"),
                          e("span", null, ">")
                        )
                      ),
                      e(
                        l.b,
                        null,
                        ((h = null == S ? void 0 : S.data),
                        R && !P && n(R),
                        e(
                          r,
                          null,
                          null == h
                            ? void 0
                            : h.map(function (t) {
                                var r = t.date;
                                return e(
                                  l.c,
                                  {
                                    isSelected: r === P,
                                    onClick: function () {
                                      return !m && n(r);
                                    },
                                  },
                                  e(
                                    "p",
                                    null,
                                    ["Nd", "Pn", "Wt", "Śr", "Czw", "Pt", "So"][
                                      new Date(r).getUTCDay()
                                    ]
                                  ),
                                  e("span", null, new Date(r).getUTCDate())
                                );
                              })
                        ))
                      ),
                      e(l.d, null, f())
                    )
                )
              );
            };
          }).call(this, n("hosL").h, n("hosL").Fragment);
        },
        xVO4: function (e, t, n) {
          "use strict";
          e.exports = n("9K2m");
        },
        xZZo: function (e) {
          "use strict";
          e.exports = function (e, t, n, r) {
            for (
              var o,
                i,
                a,
                c,
                s,
                u,
                l = ["pedantic", "commonmark"],
                f = l.length,
                p = e.length,
                d = -1;
              ++d < p;

            ) {
              for (i = (o = e[d])[1] || {}, a = o[0], c = -1, u = !1; ++c < f; )
                if (void 0 !== i[(s = l[c])] && i[s] !== n.options[s]) {
                  u = !0;
                  break;
                }
              if (!u && t[a].apply(n, r)) return !0;
            }
            return !1;
          };
        },
        "y10/": function (e, t, n) {
          "use strict";
          (function (e) {
            var r = n("QRet"),
              o = n("VVj+"),
              i = n("aTGq");
            t.a = function (t) {
              var n = t.className,
                a = t.minimized,
                c = t.maximize,
                s = Object(i.b)().unread.value,
                u = s.unreadCount,
                l = s.unreadMessages,
                f = Object(r.h)(
                  function () {
                    return function () {
                      if (l.length && a)
                        return e(
                          o.c,
                          null,
                          l.map(function (t) {
                            if ("text" === t.type)
                              return e(o.b, { key: t.id }, t.content);
                          })
                        );
                    };
                  },
                  [l]
                );
              return e(
                o.a,
                { onClick: c, className: n },
                e(f, null),
                e(o.d, { unreadCount: u }, u)
              );
            };
          }).call(this, n("hosL").h);
        },
        yAYQ: function (e, t, n) {
          "use strict";
          function r(e) {
            var t = o(a);
            (t.prototype.options = i(
              t.prototype.options,
              this.data("settings"),
              e
            )),
              (this.Parser = t);
          }
          var o = n("gsyY"),
            i = n("1hwd"),
            a = n("WM1S");
          (e.exports = r), (r.Parser = a);
        },
        yOi5: function (e, t, n) {
          "use strict";
          t.a = n.p + "ad7f1c1085667d4ce8c9f44782638a83.svg";
        },
        yYTt: function (e) {
          "use strict";
          e.exports = function (e, t) {
            return e.indexOf("<", t);
          };
        },
        zHeK: function (e) {
          "use strict";
          function t(e) {
            return (
              (e && "object" == typeof e) || (e = {}),
              r(e.line) + ":" + r(e.column)
            );
          }
          function n(e) {
            return (
              (e && "object" == typeof e) || (e = {}),
              t(e.start) + "-" + t(e.end)
            );
          }
          function r(e) {
            return e && "number" == typeof e ? e : 1;
          }
          var o = {}.hasOwnProperty;
          e.exports = function (e) {
            return e && "object" == typeof e
              ? o.call(e, "position") || o.call(e, "type")
                ? n(e.position)
                : o.call(e, "start") || o.call(e, "end")
                ? n(e)
                : o.call(e, "line") || o.call(e, "column")
                ? t(e)
                : null
              : null;
          };
        },
      });
    });
  }
}

